const allEmoji = [
  {
    "web-scraper-order": "1666026991-1546",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩸 Drop of Blood",
    "people-href": "https://emojipedia.org/drop-of-blood/",
    emojiName: "🩸 Drop of Blood",
    description:
      "A red drop of blood. May be used to talk about bleeding, injury, blood donation, or menstruation.",
    emoji: "🩸",
  },
  {
    "web-scraper-order": "1666026994-1549",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💼 Briefcase",
    "people-href": "https://emojipedia.org/briefcase/",
    emojiName: "💼 Briefcase",
    description:
      "A place to store notes and other office materials. Primarily used by older people.",
    emoji: "💼",
  },
  {
    "web-scraper-order": "1666026997-1552",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💍 Ring",
    "people-href": "https://emojipedia.org/ring/",
    emojiName: "💍 Ring",
    description:
      "A ring with displaying a gem stone of some kind on the top, most likely a diamond. This piece of jewellery is often associated with a proposal and subsequent engagement to be married.",
    emoji: "💍",
  },
  {
    "web-scraper-order": "1666026999-1554",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💄 Lipstick",
    "people-href": "https://emojipedia.org/lipstick/",
    emojiName: "💄 Lipstick",
    description:
      "Lipstick shown with the lid removed. Displays in a shade of red on most platforms, except WhatsApp and Twitter which have a more a pinkish color.",
    emoji: "💄",
  },
  {
    "web-scraper-order": "1666027002-1558",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "⛑️ Rescue Worker’s Helmet",
    "people-href": "https://emojipedia.org/rescue-workers-helmet/",
    emojiName: "⛑️ Rescue Worker’s Helmet",
    description:
      "A construction helmet, which is worn by the construction worker emoji in some emoji sets.",
    emoji: "⛑️",
  },
  {
    "web-scraper-order": "1666027005-1561",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🪖 Military Helmet",
    "people-href": "https://emojipedia.org/military-helmet/",
    emojiName: "🪖 Military Helmet",
    description:
      "A round military helmet with a chinstrap. All platforms depict a green helmet, with some designs featuring a green camouflage pattern.",
    emoji: "🪖",
  },
  {
    "web-scraper-order": "1666027007-1563",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧢 Billed Cap",
    "people-href": "https://emojipedia.org/billed-cap/",
    emojiName: "🧢 Billed Cap",
    description:
      "Billed Cap was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧢",
  },
  {
    "web-scraper-order": "1666027010-1566",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎓 Graduation Cap",
    "people-href": "https://emojipedia.org/graduation-cap/",
    emojiName: "🎓 Graduation Cap",
    description:
      "A graduation cap, worn on the head of students graduating from college or university. Known in some locations as a mortar board with tassel.",
    emoji: "🎓",
  },
  {
    "web-scraper-order": "1666027012-1568",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎩 Top Hat",
    "people-href": "https://emojipedia.org/top-hat/",
    emojiName: "🎩 Top Hat",
    description:
      "A top hat, worn in traditional British weddings and other formal occasions. This is also a popular playing piece in the game of Monopoly.",
    emoji: "🎩",
  },
  {
    "web-scraper-order": "1666027014-1570",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👒 Woman’s Hat",
    "people-href": "https://emojipedia.org/womans-hat/",
    emojiName: "👒 Woman’s Hat",
    description: "A hat worn by women for sun protection, or for fashion.",
    emoji: "👒",
  },
  {
    "web-scraper-order": "1666027017-1573",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👑 Crown",
    "people-href": "https://emojipedia.org/crown/",
    emojiName: "👑 Crown",
    description:
      "A gold crown with jewels on the sides. Representative of a King, Queen, or other form of Royalty.",
    emoji: "👑",
  },
  {
    "web-scraper-order": "1666027019-1576",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👢 Woman’s Boot",
    "people-href": "https://emojipedia.org/womans-boot/",
    emojiName: "👢 Woman’s Boot",
    description:
      "A tall boot generally featuring a slight heel, shown in brown or red on most platforms.",
    emoji: "👢",
  },
  {
    "web-scraper-order": "1666027021-1579",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩰 Ballet Shoes",
    "people-href": "https://emojipedia.org/ballet-shoes/",
    emojiName: "🩰 Ballet Shoes",
    description:
      "Shoes worn by ballet dancers for pointe work. Most platforms show a pair of pink shoes resting on their pointes. Sometimes used to represent dancing in general, rather than ballet specifically. Sometimes also used to represent the color pink.",
    emoji: "🩰",
  },
  {
    "web-scraper-order": "1666027024-1582",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👡 Woman’s Sandal",
    "people-href": "https://emojipedia.org/womans-sandal/",
    emojiName: "👡 Woman’s Sandal",
    description:
      "A sandal worn by a woman in summer, spring, or other weather that suits open-toed footwear. Has a heel at the back providing additional height to the wearer.",
    emoji: "👡",
  },
  {
    "web-scraper-order": "1666027027-1585",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👠 High-Heeled Shoe",
    "people-href": "https://emojipedia.org/high-heeled-shoe/",
    emojiName: "👠 High-Heeled Shoe",
    description:
      "A high-heeled shoe, primarily worn by women. Generally found in a context which requires formal dress, such as social occasions, or some work places.",
    emoji: "👠",
  },
  {
    "web-scraper-order": "1666027029-1588",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥿 Flat Shoe",
    "people-href": "https://emojipedia.org/flat-shoe/",
    emojiName: "🥿 Flat Shoe",
    description:
      "A flat shoe, in a style generally worn by women. More practical than a high-heeled shoe.",
    emoji: "🥿",
  },
  {
    "web-scraper-order": "1666027032-1591",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥾 Hiking Boot",
    "people-href": "https://emojipedia.org/hiking-boot/",
    emojiName: "🥾 Hiking Boot",
    description:
      "A style of boot commonly worn on long walks or for hiking. Generally distinct from other footwear-related emojis by the considerable grip on the sole of the shoe.",
    emoji: "🥾",
  },
  {
    "web-scraper-order": "1666027034-1594",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👟 Running Shoe",
    "people-href": "https://emojipedia.org/running-shoe/",
    emojiName: "👟 Running Shoe",
    description:
      "A sneaker – a comfortable shoe used in sports such as tennis or golf, or for fashion purposes.",
    emoji: "👟",
  },
  {
    "web-scraper-order": "1666027037-1597",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👞 Man’s Shoe",
    "people-href": "https://emojipedia.org/mans-shoe/",
    emojiName: "👞 Man’s Shoe",
    description:
      "A shoe worn by a man, to work, dinner, or another occasion that requires footwear. Unlike womens shoes, this shoe is likely to be comfortable.",
    emoji: "👞",
  },
  {
    "web-scraper-order": "1666027040-1600",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩴 Thong Sandal",
    "people-href": "https://emojipedia.org/thong-sandal/",
    emojiName: "🩴 Thong Sandal",
    description:
      "A single flip flop or thong sandal. Often worn to the beach and/or in warm weather. Can be used to talk about sandals, the beach, or warm weather in general.",
    emoji: "🩴",
  },
  {
    "web-scraper-order": "1666027042-1603",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎒 Backpack",
    "people-href": "https://emojipedia.org/backpack/",
    emojiName: "🎒 Backpack",
    description:
      "A school bag Emoji (also called a satchel) used by children attending school to carry books, lunch, and other personal belongings.",
    emoji: "🎒",
  },
  {
    "web-scraper-order": "1666027045-1606",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👝 Clutch Bag",
    "people-href": "https://emojipedia.org/clutch-bag/",
    emojiName: "👝 Clutch Bag",
    description:
      "A small pouch, somewhere between the size of a handbag, and a purse.",
    emoji: "👝",
  },
  {
    "web-scraper-order": "1666027047-1609",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👜 Handbag",
    "people-href": "https://emojipedia.org/handbag/",
    emojiName: "👜 Handbag",
    description:
      "A bag or purse, used to carry personal items, often doubling as a fashion accessory.",
    emoji: "👜",
  },
  {
    "web-scraper-order": "1666027050-1612",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👛 Purse",
    "people-href": "https://emojipedia.org/purse/",
    emojiName: "👛 Purse",
    description:
      "A small pouch with a clasp, generally used to hold coins. Sometimes called a “coin purse.”",
    emoji: "👛",
  },
  {
    "web-scraper-order": "1666027053-1615",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👚 Woman’s Clothes",
    "people-href": "https://emojipedia.org/womans-clothes/",
    emojiName: "👚 Woman’s Clothes",
    description: "A blouse worn by women in a neat-casual setting.",
    emoji: "👚",
  },
  {
    "web-scraper-order": "1666027055-1618",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👙 Bikini",
    "people-href": "https://emojipedia.org/bikini/",
    emojiName: "👙 Bikini",
    description:
      "A two-piece bikini, worn at the beach, pool, or on vacation at a tropical destination.",
    emoji: "👙",
  },
  {
    "web-scraper-order": "1666027059-1621",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩳 Shorts",
    "people-href": "https://emojipedia.org/shorts/",
    emojiName: "🩳 Shorts",
    description:
      "Shorts or swimming trunks. This emoji is shown in different colors and styles across platforms. Most platforms depict this emoji in a casual sporty style.",
    emoji: "🩳",
  },
  {
    "web-scraper-order": "1666027061-1624",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩲 Briefs",
    "people-href": "https://emojipedia.org/briefs/",
    emojiName: "🩲 Briefs",
    description:
      "Underwear or swim briefs. The swimming variety are often called 'Speedos' after the brand. This emoji is shown in different colors and styles across platforms. Some platforms depict this emoji as tighty whities with a visible fly, while others use a less specific design.",
    emoji: "🩲",
  },
  {
    "web-scraper-order": "1666027063-1627",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🩱 One-Piece Swimsuit",
    "people-href": "https://emojipedia.org/one-piece-swimsuit/",
    emojiName: "🩱 One-Piece Swimsuit",
    description:
      "A sporty one-piece swimsuit shown in a variety of colors and patterns across different platforms.",
    emoji: "🩱",
  },
  {
    "web-scraper-order": "1666027066-1630",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥻 Sari",
    "people-href": "https://emojipedia.org/sari/",
    emojiName: "🥻 Sari",
    description:
      "A brightly colored sari draped in different ways across platforms. Sometimes used to mean a dress in general.",
    emoji: "🥻",
  },
  {
    "web-scraper-order": "1666027068-1633",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👘 Kimono",
    "people-href": "https://emojipedia.org/kimono/",
    emojiName: "👘 Kimono",
    description:
      "A traditional Japanese robe that can be worn by women or men.",
    emoji: "👘",
  },
  {
    "web-scraper-order": "1666027070-1636",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👗 Dress",
    "people-href": "https://emojipedia.org/dress/",
    emojiName: "👗 Dress",
    description:
      "A pretty dress, suitable for a ball, party or other similar occasion.",
    emoji: "👗",
  },
  {
    "web-scraper-order": "1666027073-1639",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧦 Socks",
    "people-href": "https://emojipedia.org/socks/",
    emojiName: "🧦 Socks",
    description:
      "Socks was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧦",
  },
  {
    "web-scraper-order": "1666027075-1642",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧥 Coat",
    "people-href": "https://emojipedia.org/coat/",
    emojiName: "🧥 Coat",
    description: "A winter jacket, shown in a variety of colors and styles.",
    emoji: "🧥",
  },
  {
    "web-scraper-order": "1666027077-1644",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧤 Gloves",
    "people-href": "https://emojipedia.org/gloves/",
    emojiName: "🧤 Gloves",
    description:
      "Gloves was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧤",
  },
  {
    "web-scraper-order": "1666027080-1647",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧣 Scarf",
    "people-href": "https://emojipedia.org/scarf/",
    emojiName: "🧣 Scarf",
    description:
      "Scarf was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧣",
  },
  {
    "web-scraper-order": "1666027082-1650",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👖 Jeans",
    "people-href": "https://emojipedia.org/jeans/",
    emojiName: "👖 Jeans",
    description:
      "Denim jeans, worn by men or women. A popular form of casual trousers worn by the runner emoji in Apple's emoji artwork",
    emoji: "👖",
  },
  {
    "web-scraper-order": "1666027085-1654",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👕 T-Shirt",
    "people-href": "https://emojipedia.org/t-shirt/",
    emojiName: "👕 T-Shirt",
    description:
      "A plain t-shirt, that can be worn by men or women. Displayed as a blue polo shirt on iOS, a light blue ringer t-shirt on Android, Samsung and Windows, or a standard green tee on other platforms.",
    emoji: "👕",
  },
  {
    "web-scraper-order": "1666027089-1658",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👔 Necktie",
    "people-href": "https://emojipedia.org/necktie/",
    emojiName: "👔 Necktie",
    description:
      "A necktie commonly worn at work or formal occasions, usually shown being worn with a shirt.",
    emoji: "👔",
  },
  {
    "web-scraper-order": "1666027092-1661",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦺 Safety Vest",
    "people-href": "https://emojipedia.org/safety-vest/",
    emojiName: "🦺 Safety Vest",
    description:
      "An orange safety vest with reflective lines across the chest and over the shoulders.",
    emoji: "🦺",
  },
  {
    "web-scraper-order": "1666027095-1664",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥼 Lab Coat",
    "people-href": "https://emojipedia.org/lab-coat/",
    emojiName: "🥼 Lab Coat",
    description: "A white coat worn in a science laboratory.",
    emoji: "🥼",
  },
  {
    "web-scraper-order": "1666027099-1668",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥽 Goggles",
    "people-href": "https://emojipedia.org/goggles/",
    emojiName: "🥽 Goggles",
    description:
      "Clear safety goggles. When this emoji was approved in 2018 it was implied to be safety goggles rather than swimming goggles. A year later 🤿 Diving Mask, which is similar in design but used to represent swimming goggles rather than safety goggles, was approved.",
    emoji: "🥽",
  },
  {
    "web-scraper-order": "1666027102-1672",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕶️ Sunglasses",
    "people-href": "https://emojipedia.org/sunglasses/",
    emojiName: "🕶️ Sunglasses",
    description:
      'Sunglasses that can be worn outside for protection from the sun. Often association with connotations of being "cool", or leisurely in sunny places.',
    emoji: "🕶️",
  },
  {
    "web-scraper-order": "1666027104-1675",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👓 Glasses",
    "people-href": "https://emojipedia.org/glasses/",
    emojiName: "👓 Glasses",
    description:
      "Prescription glasses, shown with a variety of frames, depending on platform.",
    emoji: "👓",
  },
  {
    "web-scraper-order": "1666027106-1678",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧶 Yarn",
    "people-href": "https://emojipedia.org/yarn/",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
    emoji: "🧶",
  },
  {
    "web-scraper-order": "1666027109-1680",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧵 Thread",
    "people-href": "https://emojipedia.org/thread/",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
    emoji: "🧵",
  },
  {
    "web-scraper-order": "1666027113-1685",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎃 Jack-O-Lantern",
    "people-href": "https://emojipedia.org/jack-o-lantern/",
    emojiName: "🎃 Jack-O-Lantern",
    description:
      "An orange pumpkin carved into the shape of a face and commonly known as a Jack-o’-lantern. See also Halloween.",
    emoji: "🎃",
  },
  {
    "web-scraper-order": "1666027117-1688",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☂️ Umbrella",
    "people-href": "https://emojipedia.org/umbrella/",
    emojiName: "☂️ Umbrella",
    description:
      "An opened, dry umbrella. Generally depicted with purple fabric and a hooked handle.",
    emoji: "☂️",
  },
  {
    "web-scraper-order": "1666027120-1691",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🌂 Closed Umbrella",
    "people-href": "https://emojipedia.org/closed-umbrella/",
    emojiName: "🌂 Closed Umbrella",
    description:
      "An umbrella that is closed, likely as a result of collapsing it prior to going indoors.",
    emoji: "🌂",
  },
  {
    "web-scraper-order": "1666027122-1694",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧳 Luggage",
    "people-href": "https://emojipedia.org/luggage/",
    emojiName: "🧳 Luggage",
    description:
      "A suitcase or bag, as used for traveling. Most platforms depict gray or blue rolling luggage with an extended handle. Commonly used for various content concerning traveling or taking trips, whether for business or leisure.",
    emoji: "🧳",
  },
  {
    "web-scraper-order": "1666027126-1698",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👣 Footprints",
    "people-href": "https://emojipedia.org/footprints/",
    emojiName: "👣 Footprints",
    description:
      "Two human footsteps,  showing the outline of both feet, including all five toes.",
    emoji: "👣",
  },
  {
    "web-scraper-order": "1666027130-1703",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫂 People Hugging",
    "people-href": "https://emojipedia.org/people-hugging/",
    emojiName: "🫂 People Hugging",
    description:
      "Two people hugging, shown as faceless blue forms on most platforms. Details of each person are not distinct and thus no options are available to customize the gender or skin tone of either individual.",
    emoji: "🫂",
  },
  {
    "web-scraper-order": "1666027134-1707",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👥 Busts in Silhouette",
    "people-href": "https://emojipedia.org/busts-in-silhouette/",
    emojiName: "👥 Busts in Silhouette",
    description:
      "Generic profile of two people. Often used in interface design to represent users.",
    emoji: "👥",
  },
  {
    "web-scraper-order": "1666027137-1710",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👤 Bust in Silhouette",
    "people-href": "https://emojipedia.org/bust-in-silhouette/",
    emojiName: "👤 Bust in Silhouette",
    description:
      "Generic profile of one person. Often used in interface design to represent a user.",
    emoji: "👤",
  },
  {
    "web-scraper-order": "1666027141-1714",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🗣️ Speaking Head",
    "people-href": "https://emojipedia.org/speaking-head/",
    emojiName: "🗣️ Speaking Head",
    description:
      "The silhouette of a person speaking. Faces left-to-right, with lines demonstrating speech being expelled. Sometimes used in the context of shouting or mansplaining.",
    emoji: "🗣️",
  },
  {
    "web-scraper-order": "1666027146-1719",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧‍👧 Family: Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-woman-girl-girl/",
    emojiName: "👩‍👧‍👧 Family: Woman, Girl, Girl",
    description:
      "The Family: Woman, Girl, Girl emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027151-1724",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧‍👦 Family: Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-woman-girl-boy/",
    emojiName: "👩‍👧‍👦 Family: Woman, Girl, Boy",
    description:
      "The Family: Woman, Girl, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner, 👧 Girl and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027156-1728",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👧 Family: Woman, Girl",
    "people-href": "https://emojipedia.org/family-woman-girl/",
    emojiName: "👩‍👧 Family: Woman, Girl",
    description:
      "The Family: Woman, Girl emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👧",
  },
  {
    "web-scraper-order": "1666027161-1733",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👦‍👦 Family: Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-woman-boy-boy/",
    emojiName: "👩‍👦‍👦 Family: Woman, Boy, Boy",
    description:
      "The Family: Woman, Boy, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027166-1738",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👦 Family: Woman, Boy",
    "people-href": "https://emojipedia.org/family-woman-boy/",
    emojiName: "👩‍👦 Family: Woman, Boy",
    description:
      "The Family: Woman, Boy emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍👦",
  },
  {
    "web-scraper-order": "1666027171-1743",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧‍👧 Family: Man, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-girl-girl/",
    emojiName: "👨‍👧‍👧 Family: Man, Girl, Girl",
    description:
      "The Family: Man, Girl, Girl emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027176-1747",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧‍👦 Family: Man, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-girl-boy/",
    emojiName: "👨‍👧‍👦 Family: Man, Girl, Boy",
    description:
      "The Family: Man, Girl, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner, 👧 Girl and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027187-1754",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👧 Family: Man, Girl",
    "people-href": "https://emojipedia.org/family-man-girl/",
    emojiName: "👨‍👧 Family: Man, Girl",
    description:
      "The Family: Man, Girl emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👧 Girl.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👧",
  },
  {
    "web-scraper-order": "1666027192-1757",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👦‍👦 Family: Man, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-boy-boy/",
    emojiName: "👨‍👦‍👦 Family: Man, Boy, Boy",
    description:
      "The Family: Man, Boy, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027196-1762",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👦 Family: Man, Boy",
    "people-href": "https://emojipedia.org/family-man-boy/",
    emojiName: "👨‍👦 Family: Man, Boy",
    description:
      "The Family: Man, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👦",
  },
  {
    "web-scraper-order": "1666027206-1766",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧‍👧 Family: Woman, Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-woman-woman-girl-girl/",
    emojiName: "👩‍👩‍👧‍👧 Family: Woman, Woman, Girl, Girl",
    description: "A family with two mothers, and two daughters.",
    emoji: "👩‍👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027213-1773",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👦‍👦 Family: Woman, Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-boy-boy/",
    emojiName: "👩‍👩‍👦‍👦 Family: Woman, Woman, Boy, Boy",
    description: "A family with two mothers, and two sons.",
    emoji: "👩‍👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027218-1777",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧‍👦 Family: Woman, Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-girl-boy/",
    emojiName: "👩‍👩‍👧‍👦 Family: Woman, Woman, Girl, Boy",
    description: "A family with two mothers, one daughter, and one son.",
    emoji: "👩‍👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027224-1783",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👧 Family: Woman, Woman, Girl",
    "people-href": "https://emojipedia.org/family-woman-woman-girl/",
    emojiName: "👩‍👩‍👧 Family: Woman, Woman, Girl",
    description: "A family with two mothers, and one daughter.",
    emoji: "👩‍👩‍👧",
  },
  {
    "web-scraper-order": "1666027230-1788",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍👩‍👦 Family: Woman, Woman, Boy",
    "people-href": "https://emojipedia.org/family-woman-woman-boy/",
    emojiName: "👩‍👩‍👦 Family: Woman, Woman, Boy",
    description: "A family with two mothers, and one son.",
    emoji: "👩‍👩‍👦",
  },
  {
    "web-scraper-order": "1666027238-1795",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧‍👧 Family: Man, Man, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-man-girl-girl/",
    emojiName: "👨‍👨‍👧‍👧 Family: Man, Man, Girl, Girl",
    description: "A family with two fathers, and two daughters.",
    emoji: "👨‍👨‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027245-1801",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👦‍👦 Family: Man, Man, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-man-boy-boy/",
    emojiName: "👨‍👨‍👦‍👦 Family: Man, Man, Boy, Boy",
    description: "A family with two fathers, and two sons.",
    emoji: "👨‍👨‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027249-1805",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧‍👦 Family: Man, Man, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-man-girl-boy/",
    emojiName: "👨‍👨‍👧‍👦 Family: Man, Man, Girl, Boy",
    description: "A family with two fathers, one daughter, and one son.",
    emoji: "👨‍👨‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027255-1811",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👧 Family: Man, Man, Girl",
    "people-href": "https://emojipedia.org/family-man-man-girl/",
    emojiName: "👨‍👨‍👧 Family: Man, Man, Girl",
    description: "A family with two fathers, and one daughter.",
    emoji: "👨‍👨‍👧",
  },
  {
    "web-scraper-order": "1666027262-1819",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👨‍👦 Family: Man, Man, Boy",
    "people-href": "https://emojipedia.org/family-man-man-boy/",
    emojiName: "👨‍👨‍👦 Family: Man, Man, Boy",
    description: "A family with two fathers, and one son.",
    emoji: "👨‍👨‍👦",
  },
  {
    "web-scraper-order": "1666027270-1823",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧‍👧 Family: Man, Woman, Girl, Girl",
    "people-href": "https://emojipedia.org/family-man-woman-girl-girl/",
    emojiName: "👨‍👩‍👧‍👧 Family: Man, Woman, Girl, Girl",
    description: "A family with a father, mother, and two daughters.",
    emoji: "👨‍👩‍👧‍👧",
  },
  {
    "web-scraper-order": "1666027277-1829",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👦‍👦 Family: Man, Woman, Boy, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-boy-boy/",
    emojiName: "👨‍👩‍👦‍👦 Family: Man, Woman, Boy, Boy",
    description: "A family with a father, mother, and two sons.",
    emoji: "👨‍👩‍👦‍👦",
  },
  {
    "web-scraper-order": "1666027284-1834",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧‍👦 Family: Man, Woman, Girl, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-girl-boy/",
    emojiName: "👨‍👩‍👧‍👦 Family: Man, Woman, Girl, Boy",
    description: "A family with a father, mother, daughter, and son.",
    emoji: "👨‍👩‍👧‍👦",
  },
  {
    "web-scraper-order": "1666027291-1839",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👧 Family: Man, Woman, Girl",
    "people-href": "https://emojipedia.org/family-man-woman-girl/",
    emojiName: "👨‍👩‍👧 Family: Man, Woman, Girl",
    description: "A family with a father, mother, and one daughter.",
    emoji: "👨‍👩‍👧",
  },
  {
    "web-scraper-order": "1666027297-1843",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍👩‍👦 Family: Man, Woman, Boy",
    "people-href": "https://emojipedia.org/family-man-woman-boy/",
    emojiName: "👨‍👩‍👦 Family: Man, Woman, Boy",
    description:
      "The Family: Man, Woman, Boy emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner, 👩 Woman and 👦 Boy.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍👩‍👦",
  },
  {
    "web-scraper-order": "1666027303-1847",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👪 Family",
    "people-href": "https://emojipedia.org/family/",
    emojiName: "👪 Family",
    description:
      "A family unit shown with two adults and one child. Previously displayed with the same design as 👨‍👩‍👦 Family: Man, Woman, Boy on most platforms, but now has its own gender inclusive appearance.",
    emoji: "👪",
  },
  {
    "web-scraper-order": "1666027310-1853",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍👩 Couple with Heart: Woman, Woman",
    "people-href": "https://emojipedia.org/couple-with-heart-woman-woman/",
    emojiName: "👩‍❤️‍👩 Couple with Heart: Woman, Woman",
    description:
      "Two women standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👩‍❤️‍👩",
  },
  {
    "web-scraper-order": "1666027315-1857",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍❤️‍👨 Couple with Heart: Man, Man",
    "people-href": "https://emojipedia.org/couple-with-heart-man-man/",
    emojiName: "👨‍❤️‍👨 Couple with Heart: Man, Man",
    description:
      "Two men standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👨‍❤️‍👨",
  },
  {
    "web-scraper-order": "1666027320-1861",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍👨 Couple with Heart: Woman, Man",
    "people-href": "https://emojipedia.org/couple-with-heart-woman-man/",
    emojiName: "👩‍❤️‍👨 Couple with Heart: Woman, Man",
    description:
      "A woman and a man standing next to each other, smiling, with a love heart floating in the air between them.",
    emoji: "👩‍❤️‍👨",
  },
  {
    "web-scraper-order": "1666027325-1865",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💑 Couple with Heart",
    "people-href": "https://emojipedia.org/couple-with-heart/",
    emojiName: "💑 Couple with Heart",
    description:
      "A couple standing next to each other, smiling, with a love heart floating in the air between them. No gender is specified for the two people, and as such this may be used to represent the concept of a couple broadly, and/or as a means of showing two non-binary people.",
    emoji: "💑",
  },
  {
    "web-scraper-order": "1666027331-1870",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍💋‍👩 Kiss: Woman, Woman",
    "people-href": "https://emojipedia.org/kiss-woman-woman/",
    emojiName: "👩‍❤️‍💋‍👩 Kiss: Woman, Woman",
    description:
      "Two women displayed kissing, or gesturing a kiss toward each other. At small sizes this may be difficult to discern from two men kissing.",
    emoji: "👩‍❤️‍💋‍👩",
  },
  {
    "web-scraper-order": "1666027333-1872",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍❤️‍💋‍👨 Kiss: Man, Man",
    "people-href": "https://emojipedia.org/kiss-man-man/",
    emojiName: "👨‍❤️‍💋‍👨 Kiss: Man, Man",
    description:
      "Two men displayed kissing, or gesturing a kiss toward each other. At small sizes this may be difficult to discern from the two women kissing.",
    emoji: "👨‍❤️‍💋‍👨",
  },
  {
    "web-scraper-order": "1666027337-1875",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍❤️‍💋‍👨 Kiss: Woman, Man",
    "people-href": "https://emojipedia.org/kiss-woman-man/",
    emojiName: "👩‍❤️‍💋‍👨 Kiss: Woman, Man",
    description:
      "The Kiss: Woman, Man emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner, ❤️ Red Heart, 💋 Kiss Mark and 👨 Man.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍❤️‍💋‍👨",
  },
  {
    "web-scraper-order": "1666027342-1879",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💏 Kiss",
    "people-href": "https://emojipedia.org/kiss/",
    emojiName: "💏 Kiss",
    description:
      "A kissing gesture, shown with a pink love heart floating in the air between two people. No gender is specified for the two people, and as such this may be used to represent the concept of a couple broadly, and/or as a means of showing two non-binary people.",
    emoji: "💏",
  },
  {
    "web-scraper-order": "1666027346-1882",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👬 Men Holding Hands",
    "people-href": "https://emojipedia.org/men-holding-hands/",
    emojiName: "👬 Men Holding Hands",
    description:
      "Two men holding hands, most likely due to being in a relationship.",
    emoji: "👬",
  },
  {
    "web-scraper-order": "1666027350-1885",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👫 Woman and Man Holding Hands",
    "people-href": "https://emojipedia.org/woman-and-man-holding-hands/",
    emojiName: "👫 Woman and Man Holding Hands",
    description:
      "A woman and man holding hands, most likely due to being in a relationship.",
    emoji: "👫",
  },
  {
    "web-scraper-order": "1666027354-1889",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👭 Women Holding Hands",
    "people-href": "https://emojipedia.org/women-holding-hands/",
    emojiName: "👭 Women Holding Hands",
    description:
      "Two women holding hands, most likely due to being in a relationship.",
    emoji: "👭",
  },
  {
    "web-scraper-order": "1666027357-1892",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🤝‍🧑 People Holding Hands",
    "people-href": "https://emojipedia.org/people-holding-hands/",
    emojiName: "🧑‍🤝‍🧑 People Holding Hands",
    description:
      "Two people holding hands, most likely due to being in a relationship.",
    emoji: "🧑‍🤝‍🧑",
  },
  {
    "web-scraper-order": "1666027361-1895",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧘 Person in Lotus Position",
    "people-href": "https://emojipedia.org/person-in-lotus-position/",
    emojiName: "🧘 Person in Lotus Position",
    description:
      "Person in Lotus Position was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧘",
  },
  {
    "web-scraper-order": "1666027365-1899",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖‍♀️ Woman in Steamy Room",
    "people-href": "https://emojipedia.org/woman-in-steamy-room/",
    emojiName: "🧖‍♀️ Woman in Steamy Room",
    description:
      "The Woman in Steamy Room emoji is a ZWJ sequence combining 🧖 Person in Steamy Room, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧖‍♀️",
  },
  {
    "web-scraper-order": "1666027371-1903",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖‍♂️ Man in Steamy Room",
    "people-href": "https://emojipedia.org/man-in-steamy-room/",
    emojiName: "🧖‍♂️ Man in Steamy Room",
    description:
      "The Man in Steamy Room emoji is a ZWJ sequence combining 🧖 Person in Steamy Room, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧖‍♂️",
  },
  {
    "web-scraper-order": "1666027374-1906",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧖 Person in Steamy Room",
    "people-href": "https://emojipedia.org/person-in-steamy-room/",
    emojiName: "🧖 Person in Steamy Room",
    description:
      "A person in a sauna, usually with a towel or robe and sometimes holding a ladle for pouring water on hot stones to create the steamy environment.",
    emoji: "🧖",
  },
  {
    "web-scraper-order": "1666027377-1909",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯‍♀️ Women with Bunny Ears",
    "people-href": "https://emojipedia.org/women-with-bunny-ears/",
    emojiName: "👯‍♀️ Women with Bunny Ears",
    description: "A female version of the 👯 People With Bunny Ears emoji.",
    emoji: "👯‍♀️",
  },
  {
    "web-scraper-order": "1666027380-1911",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯‍♂️ Men with Bunny Ears",
    "people-href": "https://emojipedia.org/men-with-bunny-ears/",
    emojiName: "👯‍♂️ Men with Bunny Ears",
    description: "The male version of the 👯 Woman With Bunny Ears emoji.",
    emoji: "👯‍♂️",
  },
  {
    "web-scraper-order": "1666027384-1915",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👯 People with Bunny Ears",
    "people-href": "https://emojipedia.org/people-with-bunny-ears/",
    emojiName: "👯 People with Bunny Ears",
    description:
      "An iteration of the Playboy Bunny known in Japan as a Bunny Girl. Usually depicted as an attractive woman  wearing bunny ears; a bunny girl can also be seen in anime as a hybrid human/animal known as Kemonomimi.",
    emoji: "👯",
  },
  {
    "web-scraper-order": "1666027386-1918",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕴️ Person in Suit Levitating",
    "people-href": "https://emojipedia.org/person-in-suit-levitating/",
    emojiName: "🕴️ Person in Suit Levitating",
    description:
      "A person wearing a suit, hovering above the ground with a shadow displayed beneath them. Generally shown wearing a fedora or similar style of hat.",
    emoji: "🕴️",
  },
  {
    "web-scraper-order": "1666027389-1921",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕺 Man Dancing",
    "people-href": "https://emojipedia.org/man-dancing/",
    emojiName: "🕺 Man Dancing",
    description:
      "A man dancing, added as a gender pair for the 💃 Woman Dancing. Shown on most platforms in a 70s-era suit, and one hand in the air in a disco-dancing style.",
    emoji: "🕺",
  },
  {
    "web-scraper-order": "1666027393-1926",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💃 Woman Dancing",
    "people-href": "https://emojipedia.org/woman-dancing/",
    emojiName: "💃 Woman Dancing",
    description:
      'A person dancing, most commonly displayed as woman with one arm raised wearing a red dress, while dancing the salsa or flamenco. Often used to represent a sense of fun or as a positive affirmation, e.g. "great! 💃"',
    emoji: "💃",
  },
  {
    "web-scraper-order": "1666027396-1929",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃‍♀️ Woman Running",
    "people-href": "https://emojipedia.org/woman-running/",
    emojiName: "🏃‍♀️ Woman Running",
    description: "The female version of the 🏃 Runner emoji.",
    emoji: "🏃‍♀️",
  },
  {
    "web-scraper-order": "1666027399-1932",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃‍♂️ Man Running",
    "people-href": "https://emojipedia.org/man-running/",
    emojiName: "🏃‍♂️ Man Running",
    description:
      "The male version of the 🏃 Runner emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🏃‍♂️",
  },
  {
    "web-scraper-order": "1666027402-1935",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🏃 Person Running",
    "people-href": "https://emojipedia.org/person-running/",
    emojiName: "🏃 Person Running",
    description:
      "A person running, with a large stride and arms outstretched. May be wearing a running shirt.",
    emoji: "🏃",
  },
  {
    "web-scraper-order": "1666027405-1938",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦽 Woman in Manual Wheelchair",
    "people-href": "https://emojipedia.org/woman-in-manual-wheelchair/",
    emojiName: "👩‍🦽 Woman in Manual Wheelchair",
    description:
      "The Woman in Manual Wheelchair emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦽",
  },
  {
    "web-scraper-order": "1666027409-1943",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦽 Man in Manual Wheelchair",
    "people-href": "https://emojipedia.org/man-in-manual-wheelchair/",
    emojiName: "👨‍🦽 Man in Manual Wheelchair",
    description:
      "The Man in Manual Wheelchair emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦽",
  },
  {
    "web-scraper-order": "1666027413-1946",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦽 Person in Manual Wheelchair",
    "people-href": "https://emojipedia.org/person-in-manual-wheelchair/",
    emojiName: "🧑‍🦽 Person in Manual Wheelchair",
    description:
      "The Person in Manual Wheelchair emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦽 Manual Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦽",
  },
  {
    "web-scraper-order": "1666027417-1950",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦼 Woman in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/woman-in-motorized-wheelchair/",
    emojiName: "👩‍🦼 Woman in Motorized Wheelchair",
    description:
      "The Woman in Motorized Wheelchair emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦼",
  },
  {
    "web-scraper-order": "1666027421-1953",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦼 Man in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/man-in-motorized-wheelchair/",
    emojiName: "👨‍🦼 Man in Motorized Wheelchair",
    description:
      "The Man in Motorized Wheelchair emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦼",
  },
  {
    "web-scraper-order": "1666027426-1957",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦼 Person in Motorized Wheelchair",
    "people-href": "https://emojipedia.org/person-in-motorized-wheelchair/",
    emojiName: "🧑‍🦼 Person in Motorized Wheelchair",
    description:
      "The Person in Motorized Wheelchair emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦼 Motorized Wheelchair.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦼",
  },
  {
    "web-scraper-order": "1666027428-1960",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦯 Woman with White Cane",
    "people-href": "https://emojipedia.org/woman-with-white-cane/",
    emojiName: "👩‍🦯 Woman with White Cane",
    description:
      "The Woman with White Cane emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🦯",
  },
  {
    "web-scraper-order": "1666027431-1962",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦯 Man with White Cane",
    "people-href": "https://emojipedia.org/man-with-white-cane/",
    emojiName: "👨‍🦯 Man with White Cane",
    description:
      "The Man with White Cane emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🦯",
  },
  {
    "web-scraper-order": "1666027433-1964",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦯 Person with White Cane",
    "people-href": "https://emojipedia.org/person-with-white-cane/",
    emojiName: "🧑‍🦯 Person with White Cane",
    description:
      "The Person with White Cane emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🦯 White Cane.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🦯",
  },
  {
    "web-scraper-order": "1666027436-1967",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎‍♀️ Woman Kneeling",
    "people-href": "https://emojipedia.org/woman-kneeling/",
    emojiName: "🧎‍♀️ Woman Kneeling",
    description:
      "The Woman Kneeling emoji is a ZWJ sequence combining 🧎 Person Kneeling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧎‍♀️",
  },
  {
    "web-scraper-order": "1666027438-1969",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎‍♂️ Man Kneeling",
    "people-href": "https://emojipedia.org/man-kneeling/",
    emojiName: "🧎‍♂️ Man Kneeling",
    description:
      "The Man Kneeling emoji is a ZWJ sequence combining 🧎 Person Kneeling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧎‍♂️",
  },
  {
    "web-scraper-order": "1666027441-1971",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧎 Person Kneeling",
    "people-href": "https://emojipedia.org/person-kneeling/",
    emojiName: "🧎 Person Kneeling",
    description:
      "A person kneeling on both knees. May be used to represent someone in prayer, or a person resting on the floor.",
    emoji: "🧎",
  },
  {
    "web-scraper-order": "1666027444-1973",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍‍♀️ Woman Standing",
    "people-href": "https://emojipedia.org/woman-standing/",
    emojiName: "🧍‍♀️ Woman Standing",
    description:
      "A person standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍‍♀️",
  },
  {
    "web-scraper-order": "1666027446-1975",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍‍♂️ Man Standing",
    "people-href": "https://emojipedia.org/man-standing/",
    emojiName: "🧍‍♂️ Man Standing",
    description:
      "A man standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍‍♂️",
  },
  {
    "web-scraper-order": "1666027448-1977",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧍 Person Standing",
    "people-href": "https://emojipedia.org/person-standing/",
    emojiName: "🧍 Person Standing",
    description:
      "A person standing upright. Commonly used to convey awkwardness, particularly on TikTok.",
    emoji: "🧍",
  },
  {
    "web-scraper-order": "1666027451-1978",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶‍♀️ Woman Walking",
    "people-href": "https://emojipedia.org/woman-walking/",
    emojiName: "🚶‍♀️ Woman Walking",
    description: "The female version of the 🚶 Pedestrian emoji.",
    emoji: "🚶‍♀️",
  },
  {
    "web-scraper-order": "1666027453-1980",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶‍♂️ Man Walking",
    "people-href": "https://emojipedia.org/man-walking/",
    emojiName: "🚶‍♂️ Man Walking",
    description:
      "The male version of the 🚶 Pedestrian emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🚶‍♂️",
  },
  {
    "web-scraper-order": "1666027455-1981",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🚶 Person Walking",
    "people-href": "https://emojipedia.org/person-walking/",
    emojiName: "🚶 Person Walking",
    description:
      "A person going for a walk. Taking a slow-medium pace, this person would be a runner if they picked up their speed.",
    emoji: "🚶",
  },
  {
    "web-scraper-order": "1666027460-1983",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇‍♀️ Woman Getting Haircut",
    "people-href": "https://emojipedia.org/woman-getting-haircut/",
    emojiName: "💇‍♀️ Woman Getting Haircut",
    description:
      "The female version of the 💇 Haircut emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "💇‍♀️",
  },
  {
    "web-scraper-order": "1666027464-1985",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇‍♂️ Man Getting Haircut",
    "people-href": "https://emojipedia.org/man-getting-haircut/",
    emojiName: "💇‍♂️ Man Getting Haircut",
    description:
      "The Man Getting Haircut emoji is a ZWJ sequence combining 💇 Person Getting Haircut, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "💇‍♂️",
  },
  {
    "web-scraper-order": "1666027468-1987",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💇 Person Getting Haircut",
    "people-href": "https://emojipedia.org/person-getting-haircut/",
    emojiName: "💇 Person Getting Haircut",
    description:
      "A person in the process of getting their hair cut. This emoji is intended to be gender-neutral, but is commonly shown as a girl or woman smiling, with scissors shown open next to the hair on her head.",
    emoji: "💇",
  },
  {
    "web-scraper-order": "1666027472-1989",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆‍♀️ Woman Getting Massage",
    "people-href": "https://emojipedia.org/woman-getting-massage/",
    emojiName: "💆‍♀️ Woman Getting Massage",
    description:
      "The Woman Getting Massage emoji is a ZWJ sequence combining 💆 Person Getting Massage, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "💆‍♀️",
  },
  {
    "web-scraper-order": "1666027477-1991",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆‍♂️ Man Getting Massage",
    "people-href": "https://emojipedia.org/man-getting-massage/",
    emojiName: "💆‍♂️ Man Getting Massage",
    description: "The male version of the 💆 Face Massage emoji.",
    emoji: "💆‍♂️",
  },
  {
    "web-scraper-order": "1666027480-1994",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💆 Person Getting Massage",
    "people-href": "https://emojipedia.org/person-getting-massage/",
    emojiName: "💆 Person Getting Massage",
    description: "A person getting his or her face massaged.",
    emoji: "💆",
  },
  {
    "web-scraper-order": "1666027482-1995",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧌 Troll",
    "people-href": "https://emojipedia.org/troll/",
    emojiName: "🧌 Troll",
    description: "A green troll holding a club.",
    emoji: "🧌",
  },
  {
    "web-scraper-order": "1666027487-1998",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟‍♀️ Woman Zombie",
    "people-href": "https://emojipedia.org/woman-zombie/",
    emojiName: "🧟‍♀️ Woman Zombie",
    description:
      "The Woman Zombie emoji is a ZWJ sequence combining 🧟 Zombie, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧟‍♀️",
  },
  {
    "web-scraper-order": "1666027492-2000",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟‍♂️ Man Zombie",
    "people-href": "https://emojipedia.org/man-zombie/",
    emojiName: "🧟‍♂️ Man Zombie",
    description:
      "The Man Zombie emoji is a ZWJ sequence combining 🧟 Zombie, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧟‍♂️",
  },
  {
    "web-scraper-order": "1666027497-2002",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧟 Zombie",
    "people-href": "https://emojipedia.org/zombie/",
    emojiName: "🧟 Zombie",
    description:
      "A reanimated human, often found in works of horror fiction. May have a female or male appearance.",
    emoji: "🧟",
  },
  {
    "web-scraper-order": "1666027501-2003",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞‍♀️ Woman Genie",
    "people-href": "https://emojipedia.org/woman-genie/",
    emojiName: "🧞‍♀️ Woman Genie",
    description:
      "The Woman Genie emoji is a ZWJ sequence combining 🧞 Genie, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧞‍♀️",
  },
  {
    "web-scraper-order": "1666027506-2004",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞‍♂️ Man Genie",
    "people-href": "https://emojipedia.org/man-genie/",
    emojiName: "🧞‍♂️ Man Genie",
    description:
      "The Man Genie emoji is a ZWJ sequence combining 🧞 Genie, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧞‍♂️",
  },
  {
    "web-scraper-order": "1666027510-2005",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧞 Genie",
    "people-href": "https://emojipedia.org/genie/",
    emojiName: "🧞 Genie",
    description:
      "A supernatural being, which is generally shown to be imprisoned within a bottle or lamp. May be capable of granting wishes when summoned. Variations exist for a female genie or male genie.",
    emoji: "🧞",
  },
  {
    "web-scraper-order": "1666027514-2006",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝‍♀️ Woman Elf",
    "people-href": "https://emojipedia.org/woman-elf/",
    emojiName: "🧝‍♀️ Woman Elf",
    description:
      "The Woman Elf emoji is a ZWJ sequence combining 🧝 Elf, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧝‍♀️",
  },
  {
    "web-scraper-order": "1666027518-2007",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝‍♂️ Man Elf",
    "people-href": "https://emojipedia.org/man-elf/",
    emojiName: "🧝‍♂️ Man Elf",
    description:
      "The Man Elf emoji is a ZWJ sequence combining 🧝 Elf, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧝‍♂️",
  },
  {
    "web-scraper-order": "1666027523-2008",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧝 Elf",
    "people-href": "https://emojipedia.org/elf/",
    emojiName: "🧝 Elf",
    description:
      "Creatures with pointed ears and human-like faces. Female and male elves are available.",
    emoji: "🧝",
  },
  {
    "web-scraper-order": "1666027526-2009",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜‍♀️ Mermaid",
    "people-href": "https://emojipedia.org/mermaid/",
    emojiName: "🧜‍♀️ Mermaid",
    description:
      "The Mermaid emoji is a ZWJ sequence combining 🧜 Merperson, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧜‍♀️",
  },
  {
    "web-scraper-order": "1666027531-2010",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜‍♂️ Merman",
    "people-href": "https://emojipedia.org/merman/",
    emojiName: "🧜‍♂️ Merman",
    description:
      "The Merman emoji is a ZWJ sequence combining 🧜 Merperson, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧜‍♂️",
  },
  {
    "web-scraper-order": "1666027535-2011",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧜 Merperson",
    "people-href": "https://emojipedia.org/merperson/",
    emojiName: "🧜 Merperson",
    description:
      "A merperson who may be referred to as merfolk or merpeople in plural. May be used for the display of a mermaid, mergirl, merwoman, or merman.",
    emoji: "🧜",
  },
  {
    "web-scraper-order": "1666027540-2012",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛‍♀️ Woman Vampire",
    "people-href": "https://emojipedia.org/woman-vampire/",
    emojiName: "🧛‍♀️ Woman Vampire",
    description:
      "The Woman Vampire emoji is a ZWJ sequence combining 🧛 Vampire, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧛‍♀️",
  },
  {
    "web-scraper-order": "1666027544-2013",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛‍♂️ Man Vampire",
    "people-href": "https://emojipedia.org/man-vampire/",
    emojiName: "🧛‍♂️ Man Vampire",
    description:
      "The Man Vampire emoji is a ZWJ sequence combining 🧛 Vampire, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧛‍♂️",
  },
  {
    "web-scraper-order": "1666027548-2014",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧛 Vampire",
    "people-href": "https://emojipedia.org/vampire/",
    emojiName: "🧛 Vampire",
    description:
      "A vampire shown wearing a dark cape, and with pointed fangs. This emoji supports skin tones, and variations that are female or male.",
    emoji: "🧛",
  },
  {
    "web-scraper-order": "1666027551-2015",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚‍♀️ Woman Fairy",
    "people-href": "https://emojipedia.org/woman-fairy/",
    emojiName: "🧚‍♀️ Woman Fairy",
    description:
      "The Woman Fairy emoji is a ZWJ sequence combining 🧚 Fairy, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧚‍♀️",
  },
  {
    "web-scraper-order": "1666027553-2016",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚‍♂️ Man Fairy",
    "people-href": "https://emojipedia.org/man-fairy/",
    emojiName: "🧚‍♂️ Man Fairy",
    description:
      "The Man Fairy emoji is a ZWJ sequence combining 🧚 Fairy, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧚‍♂️",
  },
  {
    "web-scraper-order": "1666027556-2017",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧚 Fairy",
    "people-href": "https://emojipedia.org/fairy/",
    emojiName: "🧚 Fairy",
    description:
      "A magical humanoid creature found in myths and fantasy stories. Generally depicted as being diminutive in size and having insect-inspired wings.",
    emoji: "🧚",
  },
  {
    "web-scraper-order": "1666027560-2018",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙‍♀️ Woman Mage",
    "people-href": "https://emojipedia.org/woman-mage/",
    emojiName: "🧙‍♀️ Woman Mage",
    description:
      "The Woman Mage emoji is a ZWJ sequence combining 🧙 Mage, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧙‍♀️",
  },
  {
    "web-scraper-order": "1666027565-2019",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙‍♂️ Man Mage",
    "people-href": "https://emojipedia.org/man-mage/",
    emojiName: "🧙‍♂️ Man Mage",
    description:
      "The Man Mage emoji is a ZWJ sequence combining 🧙 Mage, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧙‍♂️",
  },
  {
    "web-scraper-order": "1666027570-2020",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧙 Mage",
    "people-href": "https://emojipedia.org/mage/",
    emojiName: "🧙 Mage",
    description:
      "Mage was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
    emoji: "🧙",
  },
  {
    "web-scraper-order": "1666027574-2021",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹‍♀️ Woman Supervillain",
    "people-href": "https://emojipedia.org/woman-supervillain/",
    emojiName: "🦹‍♀️ Woman Supervillain",
    description:
      "The Woman Supervillain emoji is a ZWJ sequence combining 🦹 Supervillain, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦹‍♀️",
  },
  {
    "web-scraper-order": "1666027578-2022",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹‍♂️ Man Supervillain",
    "people-href": "https://emojipedia.org/man-supervillain/",
    emojiName: "🦹‍♂️ Man Supervillain",
    description:
      "The Man Supervillain emoji is a ZWJ sequence combining 🦹 Supervillain, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦹‍♂️",
  },
  {
    "web-scraper-order": "1666027584-2023",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦹 Supervillain",
    "people-href": "https://emojipedia.org/supervillain/",
    emojiName: "🦹 Supervillain",
    description:
      "A villain which may be displayed as a man,woman or gender-neutral / gender-inclusive depending on the platform. This base emoji does not specify a gender, but is used to create the emojis for Man Supervillain and Woman Supervillain.",
    emoji: "🦹",
  },
  {
    "web-scraper-order": "1666027589-2024",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸‍♀️ Woman Superhero",
    "people-href": "https://emojipedia.org/woman-superhero/",
    emojiName: "🦸‍♀️ Woman Superhero",
    description:
      "The Woman Superhero emoji is a ZWJ sequence combining 🦸 Superhero, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦸‍♀️",
  },
  {
    "web-scraper-order": "1666027593-2025",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸‍♂️ Man Superhero",
    "people-href": "https://emojipedia.org/man-superhero/",
    emojiName: "🦸‍♂️ Man Superhero",
    description:
      "The Man Superhero emoji is a ZWJ sequence combining 🦸 Superhero, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🦸‍♂️",
  },
  {
    "web-scraper-order": "1666027598-2026",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦸 Superhero",
    "people-href": "https://emojipedia.org/superhero/",
    emojiName: "🦸 Superhero",
    description:
      "A hero which may be displayed as a man,woman or gender-neutral / gender-inclusive depending on the platform. This base emoji does not specify a gender, but is used to create the emojis for Man Superhero and Woman Superhero.",
    emoji: "🦸",
  },
  {
    "web-scraper-order": "1666027604-2027",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎄 Mx Claus",
    "people-href": "https://emojipedia.org/mx-claus/",
    emojiName: "🧑‍🎄 Mx Claus",
    description:
      'A person, generally depicted as being older with gray hair, wearing a red Christmas (aka "Santa") hat. Does not represent any specific character in folklore. Mx Claus provides a gender inclusive alternative to 🎅 Santa Claus or 🤶 Mrs. Claus.',
    emoji: "🧑‍🎄",
  },
  {
    "web-scraper-order": "1666027608-2028",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤶 Mrs. Claus",
    "people-href": "https://emojipedia.org/mrs-claus/",
    emojiName: "🤶 Mrs. Claus",
    description:
      "Mother Christmas, more commonly known as Mrs. Claus, is the wife of Santa Claus. Displayed as an older woman with glasses and a festive red and white bonnet. See also: Christmas emoji list.",
    emoji: "🤶",
  },
  {
    "web-scraper-order": "1666027614-2029",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🎅 Santa Claus",
    "people-href": "https://emojipedia.org/santa-claus/",
    emojiName: "🎅 Santa Claus",
    description:
      "Santa Claus, sometimes referred to as Father Christmas, brings joy to children at Christmas time. Displayed with a beard and red festive hat.",
    emoji: "🎅",
  },
  {
    "web-scraper-order": "1666027619-2030",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👼 Baby Angel",
    "people-href": "https://emojipedia.org/baby-angel/",
    emojiName: "👼 Baby Angel",
    description:
      "A baby with a halo and wings. Can represent a sweet baby, a biblical cherub, a mythological cupid, a decorative putto, or an angel as a supernatural being in general. This emoji can be used earnestly or in a tongue-in-cheek way to talk about goodness or innocence.",
    emoji: "👼",
  },
  {
    "web-scraper-order": "1666027624-2031",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🍼 Person Feeding Baby",
    "people-href": "https://emojipedia.org/person-feeding-baby/",
    emojiName: "🧑‍🍼 Person Feeding Baby",
    description:
      "A person feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "🧑‍🍼",
  },
  {
    "web-scraper-order": "1666027628-2032",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🍼 Man Feeding Baby",
    "people-href": "https://emojipedia.org/man-feeding-baby/",
    emojiName: "👨‍🍼 Man Feeding Baby",
    description:
      "A man feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "👨‍🍼",
  },
  {
    "web-scraper-order": "1666027633-2033",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🍼 Woman Feeding Baby",
    "people-href": "https://emojipedia.org/woman-feeding-baby/",
    emojiName: "👩‍🍼 Woman Feeding Baby",
    description:
      "A woman feeding a baby with a bottle, sometimes looking down to the infant and smiling.",
    emoji: "👩‍🍼",
  },
  {
    "web-scraper-order": "1666027637-2034",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤱 Breast-Feeding",
    "people-href": "https://emojipedia.org/breast-feeding/",
    emojiName: "🤱 Breast-Feeding",
    description:
      "A woman shown breastfeeding a baby, sometimes looking down to the infant and smiling.",
    emoji: "🤱",
  },
  {
    "web-scraper-order": "1666027639-2035",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫄 Pregnant Person",
    "people-href": "https://emojipedia.org/pregnant-person/",
    emojiName: "🫄 Pregnant Person",
    description:
      'A pregnant person holding their round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🫄",
  },
  {
    "web-scraper-order": "1666027642-2036",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫃 Pregnant Man",
    "people-href": "https://emojipedia.org/pregnant-man/",
    emojiName: "🫃 Pregnant Man",
    description:
      'A pregnant man holding his round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🫃",
  },
  {
    "web-scraper-order": "1666027646-2037",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤰 Pregnant Woman",
    "people-href": "https://emojipedia.org/pregnant-woman/",
    emojiName: "🤰 Pregnant Woman",
    description:
      'A pregnant woman holding her round stomach. Sometimes used in jest to represent feeling too full after overeating, as in a "food baby."',
    emoji: "🤰",
  },
  {
    "web-scraper-order": "1666027651-2038",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰‍♀️ Woman with Veil",
    "people-href": "https://emojipedia.org/woman-with-veil/",
    emojiName: "👰‍♀️ Woman with Veil",
    description:
      "The Woman with Veil emoji is a ZWJ sequence combining 👰 Person with Veil, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "👰‍♀️",
  },
  {
    "web-scraper-order": "1666027656-2039",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰‍♂️ Man with Veil",
    "people-href": "https://emojipedia.org/man-with-veil/",
    emojiName: "👰‍♂️ Man with Veil",
    description:
      "The Man with Veil emoji is a ZWJ sequence combining 👰 Person with Veil, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "👰‍♂️",
  },
  {
    "web-scraper-order": "1666027660-2040",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👰 Person with Veil",
    "people-href": "https://emojipedia.org/person-with-veil/",
    emojiName: "👰 Person with Veil",
    description:
      "A person in traditional western wedding dress with a veil over their head.",
    emoji: "👰",
  },
  {
    "web-scraper-order": "1666027664-2041",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵‍♀️ Woman in Tuxedo",
    "people-href": "https://emojipedia.org/woman-in-tuxedo/",
    emojiName: "🤵‍♀️ Woman in Tuxedo",
    description:
      "The Woman in Tuxedo emoji is a ZWJ sequence combining 🤵 Person in Tuxedo, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤵‍♀️",
  },
  {
    "web-scraper-order": "1666027668-2042",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵‍♂️ Man in Tuxedo",
    "people-href": "https://emojipedia.org/man-in-tuxedo/",
    emojiName: "🤵‍♂️ Man in Tuxedo",
    description:
      "The Man in Tuxedo emoji is a ZWJ sequence combining 🤵 Person in Tuxedo, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤵‍♂️",
  },
  {
    "web-scraper-order": "1666027671-2043",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤵 Person in Tuxedo",
    "people-href": "https://emojipedia.org/person-in-tuxedo/",
    emojiName: "🤵 Person in Tuxedo",
    description:
      "A person dressed for a formal occassion, wearing a tuxedo. No gender is specified for this emoji. See also Woman in Tuxedo and Man in Tuxedo.",
    emoji: "🤵",
  },
  {
    "web-scraper-order": "1666027674-2044",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧕 Woman with Headscarf",
    "people-href": "https://emojipedia.org/person-with-headscarf/",
    emojiName: "🧕 Woman with Headscarf",
    description:
      "A person (generally depicted as a woman) wearing a headscarf. While the type of  headscarf is not specified, this is most commonly displayed as a woman wearing a hijab.",
    emoji: "🧕",
  },
  {
    "web-scraper-order": "1666027677-2045",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👲 Person with Skullcap",
    "people-href": "https://emojipedia.org/person-with-skullcap/",
    emojiName: "👲 Person with Skullcap",
    description:
      "A person wearing a gua pi mao; a type of Chinese hat. Sometimes referred to as a skullcap.",
    emoji: "👲",
  },
  {
    "web-scraper-order": "1666027682-2046",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳‍♀️ Woman Wearing Turban",
    "people-href": "https://emojipedia.org/woman-wearing-turban/",
    emojiName: "👳‍♀️ Woman Wearing Turban",
    description: "The female version of the 👳 Man Wearing Turban emoji.",
    emoji: "👳‍♀️",
  },
  {
    "web-scraper-order": "1666027687-2047",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳‍♂️ Man Wearing Turban",
    "people-href": "https://emojipedia.org/man-wearing-turban/",
    emojiName: "👳‍♂️ Man Wearing Turban",
    description: "The male version of the 👳‍♀️ Woman Wearing Turban emoji.",
    emoji: "👳‍♂️",
  },
  {
    "web-scraper-order": "1666027693-2048",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👳 Person Wearing Turban",
    "people-href": "https://emojipedia.org/person-wearing-turban/",
    emojiName: "👳 Person Wearing Turban",
    description:
      "A man wearing a turban; a form of customary headwear worn by Sikhs or Muslims.",
    emoji: "👳",
  },
  {
    "web-scraper-order": "1666027697-2049",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👸 Princess",
    "people-href": "https://emojipedia.org/princess/",
    emojiName: "👸 Princess",
    description:
      "The face of a princess; a girl or woman wearing a small crown or tiara. Could also be used to represent a Queen or other royalty.",
    emoji: "👸",
  },
  {
    "web-scraper-order": "1666027701-2050",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤴 Prince",
    "people-href": "https://emojipedia.org/prince/",
    emojiName: "🤴 Prince",
    description:
      "Male royalty, intended as a gender pair for the princess emoji. Shown as a man with a crown.",
    emoji: "🤴",
  },
  {
    "web-scraper-order": "1666027704-2051",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫅 Person with Crown",
    "people-href": "https://emojipedia.org/person-with-crown/",
    emojiName: "🫅 Person with Crown",
    description: "A person wearing a crown.",
    emoji: "🫅",
  },
  {
    "web-scraper-order": "1666027708-2052",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷‍♀️ Woman Construction Worker",
    "people-href": "https://emojipedia.org/woman-construction-worker/",
    emojiName: "👷‍♀️ Woman Construction Worker",
    description: "The female version of the 👷 Construction Worker emoji.",
    emoji: "👷‍♀️",
  },
  {
    "web-scraper-order": "1666027713-2053",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷‍♂️ Man Construction Worker",
    "people-href": "https://emojipedia.org/man-construction-worker/",
    emojiName: "👷‍♂️ Man Construction Worker",
    description:
      "The male version of the 👷 Construction Worker emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "👷‍♂️",
  },
  {
    "web-scraper-order": "1666027716-2054",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👷 Construction Worker",
    "people-href": "https://emojipedia.org/construction-worker/",
    emojiName: "👷 Construction Worker",
    description:
      "A construction worker wearing a hard-hat (safety helmet). Has a high visibility vest or hammer in some variations.",
    emoji: "👷",
  },
  {
    "web-scraper-order": "1666027721-2055",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥷 Ninja",
    "people-href": "https://emojipedia.org/ninja/",
    emojiName: "🥷 Ninja",
    description:
      "A person dressed as a ninja with a black hood, a mask covering the lower half of their face, and the hilt of a knife or sword emerging from behind their shoulder.",
    emoji: "🥷",
  },
  {
    "web-scraper-order": "1666027726-2056",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂‍♀️ Woman Guard",
    "people-href": "https://emojipedia.org/woman-guard/",
    emojiName: "💂‍♀️ Woman Guard",
    description: "The female version of the 💂 Guardsman emoji.",
    emoji: "💂‍♀️",
  },
  {
    "web-scraper-order": "1666027730-2057",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂‍♂️ Man Guard",
    "people-href": "https://emojipedia.org/man-guard/",
    emojiName: "💂‍♂️ Man Guard",
    description:
      "The male version of the 💂 Guardsman emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "💂‍♂️",
  },
  {
    "web-scraper-order": "1666027733-2058",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💂 Guard",
    "people-href": "https://emojipedia.org/guard/",
    emojiName: "💂 Guard",
    description:
      "A British guardsman, known as a foot guard. Wears a tall black hat with a yellow chin-strap. Must look straight ahead at all times, even when tourists attempt to distract them.",
    emoji: "💂",
  },
  {
    "web-scraper-order": "1666027738-2059",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️‍♀️ Woman Detective",
    "people-href": "https://emojipedia.org/woman-detective/",
    emojiName: "🕵️‍♀️ Woman Detective",
    description: "The female version of the 🕵 Sleuth or Spy emoji.",
    emoji: "🕵️‍♀️",
  },
  {
    "web-scraper-order": "1666027743-2060",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️‍♂️ Man Detective",
    "people-href": "https://emojipedia.org/man-detective/",
    emojiName: "🕵️‍♂️ Man Detective",
    description:
      "The male version of the 🕵 Sleuth or Spy emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🕵️‍♂️",
  },
  {
    "web-scraper-order": "1666027748-2061",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🕵️ Detective",
    "people-href": "https://emojipedia.org/detective/",
    emojiName: "🕵️ Detective",
    description:
      "An undercover investigator, wearing a hat, and sometimes using a magnifying glass to closely inspect evidence. This emoji did not originally recommend emoji modifiers, but a proposal was created to address this.",
    emoji: "🕵️",
  },
  {
    "web-scraper-order": "1666027753-2062",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮‍♀️ Woman Police Officer",
    "people-href": "https://emojipedia.org/woman-police-officer/",
    emojiName: "👮‍♀️ Woman Police Officer",
    description: "The female version of the 👮 Police Officer emoji.",
    emoji: "👮‍♀️",
  },
  {
    "web-scraper-order": "1666027758-2063",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮‍♂️ Man Police Officer",
    "people-href": "https://emojipedia.org/man-police-officer/",
    emojiName: "👮‍♂️ Man Police Officer",
    description:
      "The male version of the 👮 Police Officer emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "👮‍♂️",
  },
  {
    "web-scraper-order": "1666027762-2064",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👮 Police Officer",
    "people-href": "https://emojipedia.org/police-officer/",
    emojiName: "👮 Police Officer",
    description:
      "A police officer wearing a blue hat with a gold badge or shield in the middle.",
    emoji: "👮",
  },
  {
    "web-scraper-order": "1666027767-2065",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🚒 Woman Firefighter",
    "people-href": "https://emojipedia.org/woman-firefighter/",
    emojiName: "👩‍🚒 Woman Firefighter",
    description:
      "The Woman Firefighter emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🚒",
  },
  {
    "web-scraper-order": "1666027772-2066",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🚒 Man Firefighter",
    "people-href": "https://emojipedia.org/man-firefighter/",
    emojiName: "👨‍🚒 Man Firefighter",
    description:
      "The Man Firefighter emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🚒",
  },
  {
    "web-scraper-order": "1666027776-2067",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🚒 Firefighter",
    "people-href": "https://emojipedia.org/firefighter/",
    emojiName: "🧑‍🚒 Firefighter",
    description:
      "The Firefighter emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🚒 Fire Engine.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🚒",
  },
  {
    "web-scraper-order": "1666027781-2068",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🚀 Woman Astronaut",
    "people-href": "https://emojipedia.org/woman-astronaut/",
    emojiName: "👩‍🚀 Woman Astronaut",
    description:
      "A female astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "👩‍🚀",
  },
  {
    "web-scraper-order": "1666027785-2069",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🚀 Man Astronaut",
    "people-href": "https://emojipedia.org/man-astronaut/",
    emojiName: "👨‍🚀 Man Astronaut",
    description:
      "A male astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "👨‍🚀",
  },
  {
    "web-scraper-order": "1666027790-2070",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🚀 Astronaut",
    "people-href": "https://emojipedia.org/astronaut/",
    emojiName: "🧑‍🚀 Astronaut",
    description:
      "An astronaut or cosmonaut shown wearing a space suit and helmet.",
    emoji: "🧑‍🚀",
  },
  {
    "web-scraper-order": "1666027793-2071",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍✈️ Woman Pilot",
    "people-href": "https://emojipedia.org/woman-pilot/",
    emojiName: "👩‍✈️ Woman Pilot",
    description:
      "The Woman Pilot emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍✈️",
  },
  {
    "web-scraper-order": "1666027798-2072",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍✈️ Man Pilot",
    "people-href": "https://emojipedia.org/man-pilot/",
    emojiName: "👨‍✈️ Man Pilot",
    description:
      "The Man Pilot emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍✈️",
  },
  {
    "web-scraper-order": "1666027802-2073",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍✈️ Pilot",
    "people-href": "https://emojipedia.org/pilot/",
    emojiName: "🧑‍✈️ Pilot",
    description:
      "The Pilot emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ✈️ Airplane.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍✈️",
  },
  {
    "web-scraper-order": "1666027805-2074",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎨 Woman Artist",
    "people-href": "https://emojipedia.org/woman-artist/",
    emojiName: "👩‍🎨 Woman Artist",
    description:
      "The Woman Artist emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🎨",
  },
  {
    "web-scraper-order": "1666027809-2075",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎨 Man Artist",
    "people-href": "https://emojipedia.org/man-artist/",
    emojiName: "👨‍🎨 Man Artist",
    description:
      "The Man Artist emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🎨",
  },
  {
    "web-scraper-order": "1666027814-2076",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎨 Artist",
    "people-href": "https://emojipedia.org/artist/",
    emojiName: "🧑‍🎨 Artist",
    description:
      "The Artist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🎨 Artist Palette.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🎨",
  },
  {
    "web-scraper-order": "1666027817-2077",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎤 Woman Singer",
    "people-href": "https://emojipedia.org/woman-singer/",
    emojiName: "👩‍🎤 Woman Singer",
    description:
      "A woman singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "👩‍🎤",
  },
  {
    "web-scraper-order": "1666027821-2078",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎤 Man Singer",
    "people-href": "https://emojipedia.org/man-singer/",
    emojiName: "👨‍🎤 Man Singer",
    description:
      "A man singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "👨‍🎤",
  },
  {
    "web-scraper-order": "1666027825-2079",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎤 Singer",
    "people-href": "https://emojipedia.org/singer/",
    emojiName: "🧑‍🎤 Singer",
    description:
      "A singer or rock star generally displayed with a microphone, and sometimes musical notes.",
    emoji: "🧑‍🎤",
  },
  {
    "web-scraper-order": "1666027827-2080",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍💻 Woman Technologist",
    "people-href": "https://emojipedia.org/woman-technologist/",
    emojiName: "👩‍💻 Woman Technologist",
    description:
      "A woman behind a computer screen, working in the field of technology.",
    emoji: "👩‍💻",
  },
  {
    "web-scraper-order": "1666027830-2081",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍💻 Man Technologist",
    "people-href": "https://emojipedia.org/man-technologist/",
    emojiName: "👨‍💻 Man Technologist",
    description:
      "A man behind a computer screen, working in the field of technology.",
    emoji: "👨‍💻",
  },
  {
    "web-scraper-order": "1666027834-2082",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍💻 Technologist",
    "people-href": "https://emojipedia.org/technologist/",
    emojiName: "🧑‍💻 Technologist",
    description:
      "The Technologist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 💻 Laptop.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍💻",
  },
  {
    "web-scraper-order": "1666027838-2083",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🔬 Woman Scientist",
    "people-href": "https://emojipedia.org/woman-scientist/",
    emojiName: "👩‍🔬 Woman Scientist",
    description:
      "The Woman Scientist emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🔬",
  },
  {
    "web-scraper-order": "1666027843-2084",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🔬 Man Scientist",
    "people-href": "https://emojipedia.org/man-scientist/",
    emojiName: "👨‍🔬 Man Scientist",
    description:
      "The Man Scientist emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🔬",
  },
  {
    "web-scraper-order": "1666027847-2085",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🔬 Scientist",
    "people-href": "https://emojipedia.org/scientist/",
    emojiName: "🧑‍🔬 Scientist",
    description:
      "The Scientist emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🔬 Microscope.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🔬",
  },
  {
    "web-scraper-order": "1666027850-2086",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍💼 Woman Office Worker",
    "people-href": "https://emojipedia.org/woman-office-worker/",
    emojiName: "👩‍💼 Woman Office Worker",
    description:
      "A woman wearing business attire. This may include items such as a shirt, blouse, tie, jacket, or headset.",
    emoji: "👩‍💼",
  },
  {
    "web-scraper-order": "1666027853-2087",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍💼 Man Office Worker",
    "people-href": "https://emojipedia.org/man-office-worker/",
    emojiName: "👨‍💼 Man Office Worker",
    description:
      "A man wearing business attire. This may include items such as a shirt, tie, jacket, or headset.",
    emoji: "👨‍💼",
  },
  {
    "web-scraper-order": "1666027857-2088",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍💼 Office Worker",
    "people-href": "https://emojipedia.org/office-worker/",
    emojiName: "🧑‍💼 Office Worker",
    description:
      "The Office Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 💼 Briefcase.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍💼",
  },
  {
    "web-scraper-order": "1666027860-2089",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🏭 Woman Factory Worker",
    "people-href": "https://emojipedia.org/woman-factory-worker/",
    emojiName: "👩‍🏭 Woman Factory Worker",
    description:
      "The Woman Factory Worker emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🏭",
  },
  {
    "web-scraper-order": "1666027865-2090",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🏭 Man Factory Worker",
    "people-href": "https://emojipedia.org/man-factory-worker/",
    emojiName: "👨‍🏭 Man Factory Worker",
    description:
      "The Man Factory Worker emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🏭",
  },
  {
    "web-scraper-order": "1666027870-2091",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🏭 Factory Worker",
    "people-href": "https://emojipedia.org/factory-worker/",
    emojiName: "🧑‍🏭 Factory Worker",
    description:
      "The Factory Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🏭 Factory.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🏭",
  },
  {
    "web-scraper-order": "1666027874-2092",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🔧 Woman Mechanic",
    "people-href": "https://emojipedia.org/woman-mechanic/",
    emojiName: "👩‍🔧 Woman Mechanic",
    description:
      "The Woman Mechanic emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🔧",
  },
  {
    "web-scraper-order": "1666027878-2093",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🔧 Man Mechanic",
    "people-href": "https://emojipedia.org/man-mechanic/",
    emojiName: "👨‍🔧 Man Mechanic",
    description:
      "The Man Mechanic emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🔧",
  },
  {
    "web-scraper-order": "1666027883-2094",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🔧 Mechanic",
    "people-href": "https://emojipedia.org/mechanic/",
    emojiName: "🧑‍🔧 Mechanic",
    description:
      "The Mechanic emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🔧 Wrench.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🔧",
  },
  {
    "web-scraper-order": "1666027887-2095",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🍳 Woman Cook",
    "people-href": "https://emojipedia.org/woman-cook/",
    emojiName: "👩‍🍳 Woman Cook",
    description:
      "The Woman Cook emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🍳",
  },
  {
    "web-scraper-order": "1666027892-2096",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🍳 Man Cook",
    "people-href": "https://emojipedia.org/man-cook/",
    emojiName: "👨‍🍳 Man Cook",
    description:
      "The Man Cook emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🍳",
  },
  {
    "web-scraper-order": "1666027897-2097",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🍳 Cook",
    "people-href": "https://emojipedia.org/cook/",
    emojiName: "🧑‍🍳 Cook",
    description:
      "The Cook emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🍳 Cooking.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🍳",
  },
  {
    "web-scraper-order": "1666027902-2098",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🌾 Woman Farmer",
    "people-href": "https://emojipedia.org/woman-farmer/",
    emojiName: "👩‍🌾 Woman Farmer",
    description:
      "The Woman Farmer emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🌾",
  },
  {
    "web-scraper-order": "1666027906-2099",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🌾 Man Farmer",
    "people-href": "https://emojipedia.org/man-farmer/",
    emojiName: "👨‍🌾 Man Farmer",
    description:
      "The Man Farmer emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🌾",
  },
  {
    "web-scraper-order": "1666027911-2100",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🌾 Farmer",
    "people-href": "https://emojipedia.org/farmer/",
    emojiName: "🧑‍🌾 Farmer",
    description:
      "The Farmer emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🌾 Sheaf of Rice.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🌾",
  },
  {
    "web-scraper-order": "1666027916-2101",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍⚖️ Woman Judge",
    "people-href": "https://emojipedia.org/woman-judge/",
    emojiName: "👩‍⚖️ Woman Judge",
    description:
      "The Woman Judge emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍⚖️",
  },
  {
    "web-scraper-order": "1666027921-2102",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍⚖️ Man Judge",
    "people-href": "https://emojipedia.org/man-judge/",
    emojiName: "👨‍⚖️ Man Judge",
    description:
      "The Man Judge emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍⚖️",
  },
  {
    "web-scraper-order": "1666027925-2103",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍⚖️ Judge",
    "people-href": "https://emojipedia.org/judge/",
    emojiName: "🧑‍⚖️ Judge",
    description:
      "The Judge emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ⚖️ Balance Scale.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍⚖️",
  },
  {
    "web-scraper-order": "1666027930-2104",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🏫 Woman Teacher",
    "people-href": "https://emojipedia.org/woman-teacher/",
    emojiName: "👩‍🏫 Woman Teacher",
    description:
      "A woman standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "👩‍🏫",
  },
  {
    "web-scraper-order": "1666027935-2105",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🏫 Man Teacher",
    "people-href": "https://emojipedia.org/man-teacher/",
    emojiName: "👨‍🏫 Man Teacher",
    description:
      "A man standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "👨‍🏫",
  },
  {
    "web-scraper-order": "1666027939-2106",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🏫 Teacher",
    "people-href": "https://emojipedia.org/teacher/",
    emojiName: "🧑‍🏫 Teacher",
    description:
      "A person standing in front of a chalkboard (aka blackboard) with the intention of teaching a class. Often shown holding a 📕 Closed Book or a pointer.",
    emoji: "🧑‍🏫",
  },
  {
    "web-scraper-order": "1666027943-2107",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🎓 Woman Student",
    "people-href": "https://emojipedia.org/woman-student/",
    emojiName: "👩‍🎓 Woman Student",
    description:
      "The Woman Student emoji is a ZWJ sequence combining 👩 Woman, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "👩‍🎓",
  },
  {
    "web-scraper-order": "1666027948-2108",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🎓 Man Student",
    "people-href": "https://emojipedia.org/man-student/",
    emojiName: "👨‍🎓 Man Student",
    description:
      "The Man Student emoji is a ZWJ sequence combining 👨 Man, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "👨‍🎓",
  },
  {
    "web-scraper-order": "1666027952-2109",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🎓 Student",
    "people-href": "https://emojipedia.org/student/",
    emojiName: "🧑‍🎓 Student",
    description:
      "The Student emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and 🎓 Graduation Cap.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍🎓",
  },
  {
    "web-scraper-order": "1666027957-2110",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍⚕️ Woman Health Worker",
    "people-href": "https://emojipedia.org/woman-health-worker/",
    emojiName: "👩‍⚕️ Woman Health Worker",
    description:
      "A woman working in the field of health care. This may be used to represent a doctor, nurse, or pharmacist.",
    emoji: "👩‍⚕️",
  },
  {
    "web-scraper-order": "1666027961-2111",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍⚕️ Man Health Worker",
    "people-href": "https://emojipedia.org/man-health-worker/",
    emojiName: "👨‍⚕️ Man Health Worker",
    description:
      "A man working in the field of health care. This may be used to represent a doctor, nurse, or pharmacist.",
    emoji: "👨‍⚕️",
  },
  {
    "web-scraper-order": "1666027966-2112",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍⚕️ Health Worker",
    "people-href": "https://emojipedia.org/health-worker/",
    emojiName: "🧑‍⚕️ Health Worker",
    description:
      "The Health Worker emoji is a ZWJ sequence combining 🧑 Person, ‍ Zero Width Joiner and ⚕️ Medical Symbol.\nThese display as a single emoji on supported platforms.",
    emoji: "🧑‍⚕️",
  },
  {
    "web-scraper-order": "1666027992-2113",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷‍♀️ Woman Shrugging",
    "people-href": "https://emojipedia.org/woman-shrugging/",
    emojiName: "🤷‍♀️ Woman Shrugging",
    description:
      "The Woman Shrugging emoji is a ZWJ sequence combining 🤷 Person Shrugging, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤷‍♀️",
  },
  {
    "web-scraper-order": "1666027997-2114",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷‍♂️ Man Shrugging",
    "people-href": "https://emojipedia.org/man-shrugging/",
    emojiName: "🤷‍♂️ Man Shrugging",
    description:
      "The Man Shrugging emoji is a ZWJ sequence combining 🤷 Person Shrugging, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤷‍♂️",
  },
  {
    "web-scraper-order": "1666028001-2115",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤷 Person Shrugging",
    "people-href": "https://emojipedia.org/person-shrugging/",
    emojiName: "🤷 Person Shrugging",
    description:
      "A person shrugging their shoulders to indicate a lack of knowledge about a particular topic, or a lack of care about the result of a situation.",
    emoji: "🤷",
  },
  {
    "web-scraper-order": "1666028005-2116",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦‍♀️ Woman Facepalming",
    "people-href": "https://emojipedia.org/woman-facepalming/",
    emojiName: "🤦‍♀️ Woman Facepalming",
    description:
      "The Woman Facepalming emoji is a ZWJ sequence combining 🤦 Person Facepalming, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤦‍♀️",
  },
  {
    "web-scraper-order": "1666028009-2117",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦‍♂️ Man Facepalming",
    "people-href": "https://emojipedia.org/man-facepalming/",
    emojiName: "🤦‍♂️ Man Facepalming",
    description:
      "The Man Facepalming emoji is a ZWJ sequence combining 🤦 Person Facepalming, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🤦‍♂️",
  },
  {
    "web-scraper-order": "1666028013-2118",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤦 Person Facepalming",
    "people-href": "https://emojipedia.org/person-facepalming/",
    emojiName: "🤦 Person Facepalming",
    description:
      "A hand shown pressing against the head of a person, commonly written as facepalm. Used to display frustration or embarrassment at the ineptitude of a person or situation.",
    emoji: "🤦",
  },
  {
    "web-scraper-order": "1666028018-2119",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇‍♀️ Woman Bowing",
    "people-href": "https://emojipedia.org/woman-bowing/",
    emojiName: "🙇‍♀️ Woman Bowing",
    description: "The female version of the 🙇 Person Bowing Deeply emoji.",
    emoji: "🙇‍♀️",
  },
  {
    "web-scraper-order": "1666028022-2120",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇‍♂️ Man Bowing",
    "people-href": "https://emojipedia.org/man-bowing/",
    emojiName: "🙇‍♂️ Man Bowing",
    description:
      "The male version of the 🙇 Person Bowing Deeply emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙇‍♂️",
  },
  {
    "web-scraper-order": "1666028027-2121",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙇 Person Bowing",
    "people-href": "https://emojipedia.org/person-bowing/",
    emojiName: "🙇 Person Bowing",
    description:
      "A person bowing deeply which is known as dogeza in Japan. Used to express a sincere apology, or to request a large favour.",
    emoji: "🙇",
  },
  {
    "web-scraper-order": "1666028029-2122",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏‍♀️ Deaf Woman",
    "people-href": "https://emojipedia.org/deaf-woman/",
    emojiName: "🧏‍♀️ Deaf Woman",
    description:
      "The Deaf Woman emoji is a ZWJ sequence combining 🧏 Deaf Person, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧏‍♀️",
  },
  {
    "web-scraper-order": "1666028032-2123",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏‍♂️ Deaf Man",
    "people-href": "https://emojipedia.org/deaf-man/",
    emojiName: "🧏‍♂️ Deaf Man",
    description:
      "The Deaf Man emoji is a ZWJ sequence combining 🧏 Deaf Person, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
    emoji: "🧏‍♂️",
  },
  {
    "web-scraper-order": "1666028034-2124",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧏 Deaf Person",
    "people-href": "https://emojipedia.org/deaf-person/",
    emojiName: "🧏 Deaf Person",
    description:
      "A person gesturing with their index finger between ear and mouth, used as a deaf sign in American Sign Language (ASL) and a number of other global sign languages. See also 🦻 Ear With Hearing Aid.",
    emoji: "🧏",
  },
  {
    "web-scraper-order": "1666028039-2125",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋‍♀️ Woman Raising Hand",
    "people-href": "https://emojipedia.org/woman-raising-hand/",
    emojiName: "🙋‍♀️ Woman Raising Hand",
    description:
      "The female version of the 🙋 Happy Person Raising One Hand emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙋‍♀️",
  },
  {
    "web-scraper-order": "1666028044-2126",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋‍♂️ Man Raising Hand",
    "people-href": "https://emojipedia.org/man-raising-hand/",
    emojiName: "🙋‍♂️ Man Raising Hand",
    description:
      "The man version of the 🙋 Happy Person Raising One Hand emoji.",
    emoji: "🙋‍♂️",
  },
  {
    "web-scraper-order": "1666028049-2127",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙋 Person Raising Hand",
    "people-href": "https://emojipedia.org/person-raising-hand/",
    emojiName: "🙋 Person Raising Hand",
    description:
      "A person with its hand in the air, as if it wants to ask or answer a question.",
    emoji: "🙋",
  },
  {
    "web-scraper-order": "1666028052-2128",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁‍♀️ Woman Tipping Hand",
    "people-href": "https://emojipedia.org/woman-tipping-hand/",
    emojiName: "💁‍♀️ Woman Tipping Hand",
    description:
      "A woman tipping her hand by her shoulder as if she’s carrying a tray of drinks or flipping her hair.",
    emoji: "💁‍♀️",
  },
  {
    "web-scraper-order": "1666028056-2129",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁‍♂️ Man Tipping Hand",
    "people-href": "https://emojipedia.org/man-tipping-hand/",
    emojiName: "💁‍♂️ Man Tipping Hand",
    description:
      "A man tipping his hand by his shoulder as if he’s carrying a tray of drinks or flipping his hair.",
    emoji: "💁‍♂️",
  },
  {
    "web-scraper-order": "1666028061-2130",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💁 Person Tipping Hand",
    "people-href": "https://emojipedia.org/person-tipping-hand/",
    emojiName: "💁 Person Tipping Hand",
    description:
      "A person tipping their hand by their shoulder as if they’re carrying a tray of drinks or flipping their hair. Originally called Information Desk Person.",
    emoji: "💁",
  },
  {
    "web-scraper-order": "1666028066-2131",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆‍♀️ Woman Gesturing OK",
    "people-href": "https://emojipedia.org/woman-gesturing-ok/",
    emojiName: "🙆‍♀️ Woman Gesturing OK",
    description:
      "The female version of the 🙆 Face With OK Gesture emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙆‍♀️",
  },
  {
    "web-scraper-order": "1666028072-2132",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆‍♂️ Man Gesturing OK",
    "people-href": "https://emojipedia.org/man-gesturing-ok/",
    emojiName: "🙆‍♂️ Man Gesturing OK",
    description: "The male version of the 🙆 Face With OK Gesture emoji.",
    emoji: "🙆‍♂️",
  },
  {
    "web-scraper-order": "1666028077-2133",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙆 Person Gesturing OK",
    "people-href": "https://emojipedia.org/person-gesturing-ok/",
    emojiName: "🙆 Person Gesturing OK",
    description:
      "A person with arms above their head, making an ‘OK’ sign (circle) with the whole body. No gender is specified.",
    emoji: "🙆",
  },
  {
    "web-scraper-order": "1666028082-2134",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅‍♀️ Woman Gesturing No",
    "people-href": "https://emojipedia.org/woman-gesturing-no/",
    emojiName: "🙅‍♀️ Woman Gesturing No",
    description:
      "A woman with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’. Intended to be gender-neutral but shown as a woman on most platforms.",
    emoji: "🙅‍♀️",
  },
  {
    "web-scraper-order": "1666028087-2135",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅‍♂️ Man Gesturing No",
    "people-href": "https://emojipedia.org/man-gesturing-no/",
    emojiName: "🙅‍♂️ Man Gesturing No",
    description:
      "A woman with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’. Intended to be gender-neutral but shown as a woman on most platforms.",
    emoji: "🙅‍♂️",
  },
  {
    "web-scraper-order": "1666028092-2136",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙅 Person Gesturing No",
    "people-href": "https://emojipedia.org/person-gesturing-no/",
    emojiName: "🙅 Person Gesturing No",
    description:
      "A person with arms crossed forming an ‘X’ to indicate ‘no’ or ‘no good’. This motion is used on the TV game show Deal or No Deal to indicate ‘No Deal’.",
    emoji: "🙅",
  },
  {
    "web-scraper-order": "1666028096-2137",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎‍♀️ Woman Pouting",
    "people-href": "https://emojipedia.org/woman-pouting/",
    emojiName: "🙎‍♀️ Woman Pouting",
    description:
      "The female version of the 🙎 Person With Pouting Face emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙎‍♀️",
  },
  {
    "web-scraper-order": "1666028101-2138",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎‍♂️ Man Pouting",
    "people-href": "https://emojipedia.org/man-pouting/",
    emojiName: "🙎‍♂️ Man Pouting",
    description: "The male version of the 🙎 Person With Pouting Face emoji.",
    emoji: "🙎‍♂️",
  },
  {
    "web-scraper-order": "1666028104-2139",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙎 Person Pouting",
    "people-href": "https://emojipedia.org/person-pouting/",
    emojiName: "🙎 Person Pouting",
    description:
      "A person with a serious expression, showing mild displeasure with the situation. Could be considered to be reserved or stoic in response, as this person is not visible angry.",
    emoji: "🙎",
  },
  {
    "web-scraper-order": "1666028109-2140",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍‍♀️ Woman Frowning",
    "people-href": "https://emojipedia.org/woman-frowning/",
    emojiName: "🙍‍♀️ Woman Frowning",
    description:
      "The female version of the 🙍 Person Frowning emoji. Currently identical in appearance to the non-gendered base emoji.",
    emoji: "🙍‍♀️",
  },
  {
    "web-scraper-order": "1666028113-2141",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍‍♂️ Man Frowning",
    "people-href": "https://emojipedia.org/man-frowning/",
    emojiName: "🙍‍♂️ Man Frowning",
    description: "The male version of the 🙍 Person Frowning emoji.",
    emoji: "🙍‍♂️",
  },
  {
    "web-scraper-order": "1666028118-2142",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙍 Person Frowning",
    "people-href": "https://emojipedia.org/person-frowning/",
    emojiName: "🙍 Person Frowning",
    description:
      "An upset person, frowning with dismay. Gender is not specified, but generally shown as a woman.",
    emoji: "🙍",
  },
  {
    "web-scraper-order": "1666028122-2143",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👵 Old Woman",
    "people-href": "https://emojipedia.org/old-woman/",
    emojiName: "👵 Old Woman",
    description:
      "An elderly woman with gray (grey) hair, and visible wrinkles. Wears glasses on some platforms.",
    emoji: "👵",
  },
  {
    "web-scraper-order": "1666028126-2144",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👴 Old Man",
    "people-href": "https://emojipedia.org/old-man/",
    emojiName: "👴 Old Man",
    description:
      "An elderly man gray (grey) hair, and visible wrinkles. Balding in many versions of this artwork, such as Apple and Microsoft designs.",
    emoji: "👴",
  },
  {
    "web-scraper-order": "1666028131-2145",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧓 Older Person",
    "people-href": "https://emojipedia.org/older-person/",
    emojiName: "🧓 Older Person",
    description:
      "An older adult with no gender specified. This emoji may be used to talk about older adults in a gender-inclusive way.",
    emoji: "🧓",
  },
  {
    "web-scraper-order": "1666028136-2146",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱‍♂️ Man: Blond Hair",
    "people-href": "https://emojipedia.org/man-blond-hair/",
    emojiName: "👱‍♂️ Man: Blond Hair",
    description: "The male version of 👱 Person with Blond Hair.",
    emoji: "👱‍♂️",
  },
  {
    "web-scraper-order": "1666028142-2147",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱‍♀️ Woman: Blond Hair",
    "people-href": "https://emojipedia.org/woman-blond-hair/",
    emojiName: "👱‍♀️ Woman: Blond Hair",
    description: "The female version of 👱 Person with Blond Hair.",
    emoji: "👱‍♀️",
  },
  {
    "web-scraper-order": "1666028147-2148",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦲 Person: Bald",
    "people-href": "https://emojipedia.org/person-bald/",
    emojiName: "🧑‍🦲 Person: Bald",
    description:
      "A person with a bald head. Can be used to represent a bald person or a person with a shaved head. May also be used to represent a person experiencing hair loss from chemotherapy, alopecia, or other medical treatments or conditions.",
    emoji: "🧑‍🦲",
  },
  {
    "web-scraper-order": "1666028151-2149",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦲 Woman: Bald",
    "people-href": "https://emojipedia.org/woman-bald/",
    emojiName: "👩‍🦲 Woman: Bald",
    description:
      "A woman with a bald head. Can be used to represent a bald woman or a woman with a shaved head. May also be used to represent a woman experiencing hair loss from chemotherapy, alopecia, or other medical treatments or conditions.",
    emoji: "👩‍🦲",
  },
  {
    "web-scraper-order": "1666028156-2150",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦳 Person: White Hair",
    "people-href": "https://emojipedia.org/person-white-hair/",
    emojiName: "🧑‍🦳 Person: White Hair",
    description:
      "A person with white hair. This emoji maintains white hair no matter which skin tone is chosen. This emoji may be used to talk about people with white hair in a gender-inclusive way.",
    emoji: "🧑‍🦳",
  },
  {
    "web-scraper-order": "1666028162-2151",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦳 Woman: White Hair",
    "people-href": "https://emojipedia.org/woman-white-hair/",
    emojiName: "👩‍🦳 Woman: White Hair",
    description: "The female version of 🧑‍🦳 Person with White Hair.",
    emoji: "👩‍🦳",
  },
  {
    "web-scraper-order": "1666028170-2152",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦱 Person: Curly Hair",
    "people-href": "https://emojipedia.org/person-curly-hair/",
    emojiName: "🧑‍🦱 Person: Curly Hair",
    description:
      "A person with curly hair. This emoji may be used to talk about people with curly hair in a gender-inclusive way.",
    emoji: "🧑‍🦱",
  },
  {
    "web-scraper-order": "1666028180-2153",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦱 Woman: Curly Hair",
    "people-href": "https://emojipedia.org/woman-curly-hair/",
    emojiName: "👩‍🦱 Woman: Curly Hair",
    description: "The female version of 🧑‍🦱 Person with Curly Hair.",
    emoji: "👩‍🦱",
  },
  {
    "web-scraper-order": "1666028184-2154",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑‍🦰 Person: Red Hair",
    "people-href": "https://emojipedia.org/person-red-hair/",
    emojiName: "🧑‍🦰 Person: Red Hair",
    description:
      "A person with red hair. This emoji maintains red hair no matter which skin tone is chosen. This emoji may be used to talk about redheads in a gender-inclusive way.",
    emoji: "🧑‍🦰",
  },
  {
    "web-scraper-order": "1666028190-2155",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩‍🦰 Woman: Red Hair",
    "people-href": "https://emojipedia.org/woman-red-hair/",
    emojiName: "👩‍🦰 Woman: Red Hair",
    description: "The female version of 🧑‍🦰 Person with Red Hair.",
    emoji: "👩‍🦰",
  },
  {
    "web-scraper-order": "1666028195-2156",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👩 Woman",
    "people-href": "https://emojipedia.org/woman/",
    emojiName: "👩 Woman",
    description: "The female version of 🧑 Person.",
    emoji: "👩",
  },
  {
    "web-scraper-order": "1666028199-2157",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦲 Man: Bald",
    "people-href": "https://emojipedia.org/man-bald/",
    emojiName: "👨‍🦲 Man: Bald",
    description: "The male version of 🧑‍🦲 Blad Person.",
    emoji: "👨‍🦲",
  },
  {
    "web-scraper-order": "1666028204-2158",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦳 Man: White Hair",
    "people-href": "https://emojipedia.org/man-white-hair/",
    emojiName: "👨‍🦳 Man: White Hair",
    description: "The male version of 🧑‍🦳 Person with White Hair.",
    emoji: "👨‍🦳",
  },
  {
    "web-scraper-order": "1666028210-2159",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦱 Man: Curly Hair",
    "people-href": "https://emojipedia.org/man-curly-hair/",
    emojiName: "👨‍🦱 Man: Curly Hair",
    description: "The male version of 🧑‍🦱 Person with Curly Hair.",
    emoji: "👨‍🦱",
  },
  {
    "web-scraper-order": "1666028214-2160",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨‍🦰 Man: Red Hair",
    "people-href": "https://emojipedia.org/man-red-hair/",
    emojiName: "👨‍🦰 Man: Red Hair",
    description: "The male version of 🧑‍🦰 Person with Red Hair.",
    emoji: "👨‍🦰",
  },
  {
    "web-scraper-order": "1666028219-2161",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧔 Person: Beard",
    "people-href": "https://emojipedia.org/person-beard/",
    emojiName: "🧔 Person: Beard",
    description: "A person with a beard.",
    emoji: "🧔",
  },
  {
    "web-scraper-order": "1666028222-2162",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👨 Man",
    "people-href": "https://emojipedia.org/man/",
    emojiName: "👨 Man",
    description: "The male version of 🧑 Person.",
    emoji: "👨",
  },
  {
    "web-scraper-order": "1666028227-2163",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👱 Person: Blond Hair",
    "people-href": "https://emojipedia.org/person-blond-hair/",
    emojiName: "👱 Person: Blond Hair",
    description:
      "A person with blond hair. This emoji maintains blond hair no matter which skin tone is chosen. This emoji may be used to talk about blonds in a gender-inclusive way.",
    emoji: "👱",
  },
  {
    "web-scraper-order": "1666028232-2164",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧑 Person",
    "people-href": "https://emojipedia.org/person/",
    emojiName: "🧑 Person",
    description:
      "An adult with no gender specified. This emoji may be used to talk about adults in a gender-inclusive way.",
    emoji: "🧑",
  },
  {
    "web-scraper-order": "1666028237-2165",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👧 Girl",
    "people-href": "https://emojipedia.org/girl/",
    emojiName: "👧 Girl",
    description:
      "The face of a girl, smiling. Most platforms feature the girl's hair in pigtails.",
    emoji: "👧",
  },
  {
    "web-scraper-order": "1666028242-2166",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👦 Boy",
    "people-href": "https://emojipedia.org/boy/",
    emojiName: "👦 Boy",
    description: "The face of a boy, smiling.",
    emoji: "👦",
  },
  {
    "web-scraper-order": "1666028247-2167",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧒 Child",
    "people-href": "https://emojipedia.org/child/",
    emojiName: "🧒 Child",
    description:
      "A child with no gender specified. This emoji may be used to talk about children in a gender-inclusive way.",
    emoji: "🧒",
  },
  {
    "web-scraper-order": "1666028251-2168",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👶 Baby",
    "people-href": "https://emojipedia.org/baby/",
    emojiName: "👶 Baby",
    description:
      "The face of a baby with a small tuft of hair on top of its head. Some platforms show the baby sucking on a pacifier, and some platforms show a single tooth in the baby’s open mouth. Android previously displayed this emoji as a swaddled baby.",
    emoji: "👶",
  },
  {
    "web-scraper-order": "1666028253-2169",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫦 Biting Lip",
    "people-href": "https://emojipedia.org/biting-lip/",
    emojiName: "🫦 Biting Lip",
    description:
      "A mouth with the top teeth biting down on one side of the lower lip.",
    emoji: "🫦",
  },
  {
    "web-scraper-order": "1666028257-2170",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👄 Mouth",
    "people-href": "https://emojipedia.org/mouth/",
    emojiName: "👄 Mouth",
    description:
      "A human mouth which is generally displayed as a pair of lips and a top row of teeth, instead of the inside of the mouth.",
    emoji: "👄",
  },
  {
    "web-scraper-order": "1666028260-2171",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👅 Tongue",
    "people-href": "https://emojipedia.org/tongue/",
    emojiName: "👅 Tongue",
    description:
      "A tongue, sticking out. May be used as a childish sign of defiance. Alternatively: licking, in various contexts.",
    emoji: "👅",
  },
  {
    "web-scraper-order": "1666028264-2172",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👁️ Eye",
    "people-href": "https://emojipedia.org/eye/",
    emojiName: "👁️ Eye",
    description:
      "A single human eye, looking forward. This eye is in a different shape and style to the pair of eyes, which are more rounded, and looking to one side.",
    emoji: "👁️",
  },
  {
    "web-scraper-order": "1666028267-2173",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👀 Eyes",
    "people-href": "https://emojipedia.org/eyes/",
    emojiName: "👀 Eyes",
    description:
      "A pair of eyes, glancing slightly to the left on most platforms. The Google version of this emoji previously showed only a single eye, despite the emojiName of this character being eyes (plural).",
    emoji: "👀",
  },
  {
    "web-scraper-order": "1666028270-2174",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦴 Bone",
    "people-href": "https://emojipedia.org/bone/",
    emojiName: "🦴 Bone",
    description:
      "A bone which may be used for a dog to chew on, or as a part of the human body. The type of bone is not specified.",
    emoji: "🦴",
  },
  {
    "web-scraper-order": "1666028274-2175",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦷 Tooth",
    "people-href": "https://emojipedia.org/tooth/",
    emojiName: "🦷 Tooth",
    description:
      "Tooth was approved as part of Unicode 11.0 in 2018 and added to Emoji 11.0 in 2018.",
    emoji: "🦷",
  },
  {
    "web-scraper-order": "1666028279-2176",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫁 Lungs",
    "people-href": "https://emojipedia.org/lungs/",
    emojiName: "🫁 Lungs",
    description:
      "Pink anatomical lungs and trachea, shown with bronchial tubes on some platforms. Used in medical contexts to talk about lung health. Sometimes used in reference to taking deep breaths, hyperventilating, or breathing in general. Also used in the context of smoking or vaping.",
    emoji: "🫁",
  },
  {
    "web-scraper-order": "1666028282-2177",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫀 Anatomical Heart",
    "people-href": "https://emojipedia.org/anatomical-heart/",
    emojiName: "🫀 Anatomical Heart",
    description:
      "A red anatomical heart, shown with blue or purple veins on some platforms.",
    emoji: "🫀",
  },
  {
    "web-scraper-order": "1666028284-2178",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧠 Brain",
    "people-href": "https://emojipedia.org/brain/",
    emojiName: "🧠 Brain",
    description:
      "A human brain, shown in pink on most platforms. Used to indicate thinking or the human mind.",
    emoji: "🧠",
  },
  {
    "web-scraper-order": "1666028286-2179",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👃 Nose",
    "people-href": "https://emojipedia.org/nose/",
    emojiName: "👃 Nose",
    description:
      "A human nose. May be used to indicate smelling, or something that smells.",
    emoji: "👃",
  },
  {
    "web-scraper-order": "1666028291-2180",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦻 Ear with Hearing Aid",
    "people-href": "https://emojipedia.org/ear-with-hearing-aid/",
    emojiName: "🦻 Ear with Hearing Aid",
    description:
      "An ear shown with a hearing aid, worn by a person with hearing loss. The style shown in Behind The Ear (BTE), but this can represent any form of hearing aid.",
    emoji: "🦻",
  },
  {
    "web-scraper-order": "1666028294-2181",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👂 Ear",
    "people-href": "https://emojipedia.org/ear/",
    emojiName: "👂 Ear",
    description:
      "A single human ear. May be used in the context of listening, or hearing something.",
    emoji: "👂",
  },
  {
    "web-scraper-order": "1666028298-2182",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦶 Foot",
    "people-href": "https://emojipedia.org/foot/",
    emojiName: "🦶 Foot",
    description:
      "A human foot shown with five toes and may include part or all of the ankle. Shown on Apple platforms as the sole of a foot.",
    emoji: "🦶",
  },
  {
    "web-scraper-order": "1666028300-2183",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦵 Leg",
    "people-href": "https://emojipedia.org/leg/",
    emojiName: "🦵 Leg",
    description:
      "A human leg, shown detached from a human body. Displayed from the thigh and may include the foot.",
    emoji: "🦵",
  },
  {
    "web-scraper-order": "1666028303-2184",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦿 Mechanical Leg",
    "people-href": "https://emojipedia.org/mechanical-leg/",
    emojiName: "🦿 Mechanical Leg",
    description: "A mechanical or prosthetic leg.",
    emoji: "🦿",
  },
  {
    "web-scraper-order": "1666028307-2185",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🦾 Mechanical Arm",
    "people-href": "https://emojipedia.org/mechanical-arm/",
    emojiName: "🦾 Mechanical Arm",
    description: "A mechanical or prosthetic arm.",
    emoji: "🦾",
  },
  {
    "web-scraper-order": "1666028311-2186",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💪 Flexed Biceps",
    "people-href": "https://emojipedia.org/flexed-biceps/",
    emojiName: "💪 Flexed Biceps",
    description:
      "An arm flexing to show its biceps muscle. Represents strength, or working out.",
    emoji: "💪",
  },
  {
    "web-scraper-order": "1666028315-2187",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤳 Selfie",
    "people-href": "https://emojipedia.org/selfie/",
    emojiName: "🤳 Selfie",
    description:
      "A mobile phone held up to take a selfie (photo of the person holding the phone or camera). Generally represented as a disembodied arm holding a mobile phone.",
    emoji: "🤳",
  },
  {
    "web-scraper-order": "1666028318-2188",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💅 Nail Polish",
    "people-href": "https://emojipedia.org/nail-polish/",
    emojiName: "💅 Nail Polish",
    description:
      "Colored nail polish being applied to finger nails, often used to display an air of nonchalance or indifference.",
    emoji: "💅",
  },
  {
    "web-scraper-order": "1666028322-2189",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✍️ Writing Hand",
    "people-href": "https://emojipedia.org/writing-hand/",
    emojiName: "✍️ Writing Hand",
    description:
      "A hand holding a pen or pencil and writing. Most often shown as holding either a blue or black pen, though Microsoft's design has a red pen. LG's design displays a left hand, while all other platforms show a right hand. Used broadly to represent writing.",
    emoji: "✍️",
  },
  {
    "web-scraper-order": "1666028327-2190",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙏 Folded Hands",
    "people-href": "https://emojipedia.org/folded-hands/",
    emojiName: "🙏 Folded Hands",
    description:
      "Two hands placed firmly together, meaning please or thank you in Japanese culture. A common alternative use for this emoji is for prayer, using the same gesture as praying hands. It can also represent a respectful greeting or show of adoration many in Southeast Asian religions and cultures, such as the Hindu namaste or Buddhist añjali mudra.",
    emoji: "🙏",
  },
  {
    "web-scraper-order": "1666028332-2191",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤝 Handshake",
    "people-href": "https://emojipedia.org/handshake/",
    emojiName: "🤝 Handshake",
    description:
      "Two hands performing a handshake gesture, indicating a cordial greeting between friends or associates.",
    emoji: "🤝",
  },
  {
    "web-scraper-order": "1666028337-2192",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤲 Palms Up Together",
    "people-href": "https://emojipedia.org/palms-up-together/",
    emojiName: "🤲 Palms Up Together",
    description:
      "Two hands held out together with open palms facing up, in a slightly cupped manner.",
    emoji: "🤲",
  },
  {
    "web-scraper-order": "1666028341-2193",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👐 Open Hands",
    "people-href": "https://emojipedia.org/open-hands/",
    emojiName: "👐 Open Hands",
    description:
      "Two open hands, representing openness. Sometimes used as a hug, or as a display of jazz hands.",
    emoji: "👐",
  },
  {
    "web-scraper-order": "1666028346-2194",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫶 Heart Hands",
    "people-href": "https://emojipedia.org/heart-hands/",
    emojiName: "🫶 Heart Hands",
    description:
      "Two hands forming a heart shape. Used to express love and support.",
    emoji: "🫶",
  },
  {
    "web-scraper-order": "1666028350-2195",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙌 Raising Hands",
    "people-href": "https://emojipedia.org/raising-hands/",
    emojiName: "🙌 Raising Hands",
    description:
      "Two hands raised in the air, celebrating success or another joyous event.",
    emoji: "🙌",
  },
  {
    "web-scraper-order": "1666028353-2196",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👏 Clapping Hands",
    "people-href": "https://emojipedia.org/clapping-hands/",
    emojiName: "👏 Clapping Hands",
    description:
      "Two hands clapping emoji, which when used multiple times can be used as a round of applause.",
    emoji: "👏",
  },
  {
    "web-scraper-order": "1666028356-2197",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤜 Right-Facing Fist",
    "people-href": "https://emojipedia.org/right-facing-fist/",
    emojiName: "🤜 Right-Facing Fist",
    description:
      "A fist pointing right, which may be used in conjunction with the left-facing fist to complete a fist-bump gesture.",
    emoji: "🤜",
  },
  {
    "web-scraper-order": "1666028359-2198",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤛 Left-Facing Fist",
    "people-href": "https://emojipedia.org/left-facing-fist/",
    emojiName: "🤛 Left-Facing Fist",
    description:
      "A fist pointing left, which may be used in conjunction with the right-facing fist to complete a fist-bump gesture.",
    emoji: "🤛",
  },
  {
    "web-scraper-order": "1666028363-2199",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👊 Oncoming Fist",
    "people-href": "https://emojipedia.org/oncoming-fist/",
    emojiName: "👊 Oncoming Fist",
    description:
      "A fist displayed in a position to punch someone, or to fist-bump another person.",
    emoji: "👊",
  },
  {
    "web-scraper-order": "1666028366-2200",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✊ Raised Fist",
    "people-href": "https://emojipedia.org/raised-fist/",
    emojiName: "✊ Raised Fist",
    description:
      "A fist raised in the air that may be used as a celebratory gesture: the fist pump. Can also be used to represent zero items, due to a lack of any fingers being held up.",
    emoji: "✊",
  },
  {
    "web-scraper-order": "1666028369-2201",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👎 Thumbs Down",
    "people-href": "https://emojipedia.org/thumbs-down/",
    emojiName: "👎 Thumbs Down",
    description: "A thumbs-down gesture indicating disapproval.",
    emoji: "👎",
  },
  {
    "web-scraper-order": "1666028374-2202",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👍 Thumbs Up",
    "people-href": "https://emojipedia.org/thumbs-up/",
    emojiName: "👍 Thumbs Up",
    description: "A thumbs-up gesture indicating approval.",
    emoji: "👍",
  },
  {
    "web-scraper-order": "1666028376-2203",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫵 Index Pointing at the Viewer",
    "people-href": "https://emojipedia.org/index-pointing-at-the-viewer/",
    emojiName: "🫵 Index Pointing at the Viewer",
    description:
      "A hand with the index finger pointing straight forward at the person viewing the emoji. Used to represent the word and concept of 'you,' the second-person singular and plural pronoun.",
    emoji: "🫵",
  },
  {
    "web-scraper-order": "1666028379-2204",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☝️ Index Pointing Up",
    "people-href": "https://emojipedia.org/index-pointing-up/",
    emojiName: "☝️ Index Pointing Up",
    description:
      "A single finger pointing upward, which could be used to represent the number one, or to ask a question.",
    emoji: "☝️",
  },
  {
    "web-scraper-order": "1666028381-2205",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👇 Backhand Index Pointing Down",
    "people-href": "https://emojipedia.org/backhand-index-pointing-down/",
    emojiName: "👇 Backhand Index Pointing Down",
    description: "Index finger pointing downward.",
    emoji: "👇",
  },
  {
    "web-scraper-order": "1666028384-2206",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖕 Middle Finger",
    "people-href": "https://emojipedia.org/middle-finger/",
    emojiName: "🖕 Middle Finger",
    description:
      "A middle finger emoji, used in some western cultures as a rude or insulting gesture. The back of the hand is shown with the middle finger raised.",
    emoji: "🖕",
  },
  {
    "web-scraper-order": "1666028387-2207",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👆 Backhand Index Pointing Up",
    "people-href": "https://emojipedia.org/backhand-index-pointing-up/",
    emojiName: "👆 Backhand Index Pointing Up",
    description:
      "Index finger pointing upward, showing the back of the hand while doing so.",
    emoji: "👆",
  },
  {
    "web-scraper-order": "1666028389-2208",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👉 Backhand Index Pointing Right",
    "people-href": "https://emojipedia.org/backhand-index-pointing-right/",
    emojiName: "👉 Backhand Index Pointing Right",
    description: "Index finger pointing to the right.",
    emoji: "👉",
  },
  {
    "web-scraper-order": "1666028392-2209",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👈 Backhand Index Pointing Left",
    "people-href": "https://emojipedia.org/backhand-index-pointing-left/",
    emojiName: "👈 Backhand Index Pointing Left",
    description: "Index finger pointing to the left.",
    emoji: "👈",
  },
  {
    "web-scraper-order": "1666028395-2210",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤙 Call Me Hand",
    "people-href": "https://emojipedia.org/call-me-hand/",
    emojiName: "🤙 Call Me Hand",
    description:
      "A hand with thumb and little (pinky) finger extended, making a traditional phone-like shape. May be used in conjunction with a face to suggest “call me” (please).",
    emoji: "🤙",
  },
  {
    "web-scraper-order": "1666028398-2211",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤘 Sign of the Horns",
    "people-href": "https://emojipedia.org/sign-of-the-horns/",
    emojiName: "🤘 Sign of the Horns",
    description:
      'A "rock on" hand gesture raising the pinky and index fingers on one hand, which a variety of other meanings.',
    emoji: "🤘",
  },
  {
    "web-scraper-order": "1666028401-2212",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤟 Love-You Gesture",
    "people-href": "https://emojipedia.org/love-you-gesture/",
    emojiName: "🤟 Love-You Gesture",
    description:
      "The gesture for “I love you” in American Sign Language, shown as a raised pinky (little) finger, index finger, and an extended thumb.",
    emoji: "🤟",
  },
  {
    "web-scraper-order": "1666028404-2213",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫰 Hand with Index Finger and Thumb Crossed",
    "people-href":
      "https://emojipedia.org/hand-with-index-finger-and-thumb-crossed/",
    emojiName: "🫰 Hand with Index Finger and Thumb Crossed",
    description:
      "A hand with the index finger and thumb crossed and the rest of the fingers making a fist. Can be used in various contexts to represent the fingers snapping, love, or money.",
    emoji: "🫰",
  },
  {
    "web-scraper-order": "1666028409-2214",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤞 Crossed Fingers",
    "people-href": "https://emojipedia.org/crossed-fingers/",
    emojiName: "🤞 Crossed Fingers",
    description:
      "A fingers crossed emoji which displays the index (first) finger crossed over the middle (second) finger. Commonly used as a gesture indicating luck, or to show desire of a favorable outcome.",
    emoji: "🤞",
  },
  {
    "web-scraper-order": "1666028411-2215",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✌️ Victory Hand",
    "people-href": "https://emojipedia.org/victory-hand/",
    emojiName: "✌️ Victory Hand",
    description:
      "Most commonly known as a ✌️ Peace Sign, but traditionally called as a Victory Hand. Two fingers held up on one hand making a V sign.",
    emoji: "✌️",
  },
  {
    "web-scraper-order": "1666028415-2216",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤏 Pinching Hand",
    "people-href": "https://emojipedia.org/pinching-hand/",
    emojiName: "🤏 Pinching Hand",
    description:
      "A hand with thumb and index finger in close proximity. Used to suggest that something is small, or to gesture a small amount. Has",
    emoji: "🤏",
  },
  {
    "web-scraper-order": "1666028419-2217",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤌 Pinched Fingers",
    "people-href": "https://emojipedia.org/pinched-fingers/",
    emojiName: "🤌 Pinched Fingers",
    description:
      'An emoji showing the fingers held together in a vertical orientation, often referred to as the Italian hand gesture ma che vuoi, sometimes called the "finger purse." In Italy this gesture tends to be used in disagreement, frustration, or disbelief and can mean “What do you want?” or “What are you saying?” Outside Italy anyone performing a caricature of an Italian person, regardless of context or tone, might use this gesture.',
    emoji: "🤌",
  },
  {
    "web-scraper-order": "1666028423-2218",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👌 OK Hand",
    "people-href": "https://emojipedia.org/ok-hand/",
    emojiName: "👌 OK Hand",
    description:
      "A gesture showing the index finger and thumb touching to make an open circle. Represents “I’m okay” or “yes, that’s correct / good”.",
    emoji: "👌",
  },
  {
    "web-scraper-order": "1666028425-2219",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫴 Palm Up Hand",
    "people-href": "https://emojipedia.org/palm-up-hand/",
    emojiName: "🫴 Palm Up Hand",
    description: "A hand in profile with the palm facing up.",
    emoji: "🫴",
  },
  {
    "web-scraper-order": "1666028428-2220",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫳 Palm Down Hand",
    "people-href": "https://emojipedia.org/palm-down-hand/",
    emojiName: "🫳 Palm Down Hand",
    description: "A hand in profile with the palm facing down.",
    emoji: "🫳",
  },
  {
    "web-scraper-order": "1666028430-2221",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫲 Leftwards Hand",
    "people-href": "https://emojipedia.org/leftwards-hand/",
    emojiName: "🫲 Leftwards Hand",
    description:
      "An open right hand facing left, so as to show the palm of the hand with the thumb on the top and the pinky on the bottom.",
    emoji: "🫲",
  },
  {
    "web-scraper-order": "1666028432-2222",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫱 Rightwards Hand",
    "people-href": "https://emojipedia.org/rightwards-hand/",
    emojiName: "🫱 Rightwards Hand",
    description:
      "An open right hand facing right, so as to show the back of the hand with the thumb on the top and the pinky on the bottom.",
    emoji: "🫱",
  },
  {
    "web-scraper-order": "1666028437-2223",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖖 Vulcan Salute",
    "people-href": "https://emojipedia.org/vulcan-salute/",
    emojiName: "🖖 Vulcan Salute",
    description:
      "A raised hand, with the fingers separated between the ring finger and the middle finger.",
    emoji: "🖖",
  },
  {
    "web-scraper-order": "1666028440-2224",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "✋ Raised Hand",
    "people-href": "https://emojipedia.org/raised-hand/",
    emojiName: "✋ Raised Hand",
    description:
      "A hand held up showing its palm. May be used to mean stop, or as a high-five.",
    emoji: "✋",
  },
  {
    "web-scraper-order": "1666028443-2225",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🖐️ Hand with Fingers Splayed",
    "people-href": "https://emojipedia.org/hand-with-fingers-splayed/",
    emojiName: "🖐️ Hand with Fingers Splayed",
    description:
      "The palm of a hand with the fingers spread apart. Held in a manner that may indicate the number five. Similar to 👋 Waving Hand, but without any motion.",
    emoji: "🖐️",
  },
  {
    "web-scraper-order": "1666028445-2226",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤚 Raised Back of Hand",
    "people-href": "https://emojipedia.org/raised-back-of-hand/",
    emojiName: "🤚 Raised Back of Hand",
    description:
      "A raised hand, showing the reverse side of the palm. May be paired with the forward-facing raised hand emoji.",
    emoji: "🤚",
  },
  {
    "web-scraper-order": "1666028448-2227",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👋 Waving Hand",
    "people-href": "https://emojipedia.org/waving-hand/",
    emojiName: "👋 Waving Hand",
    description:
      "A hand waving most commonly used to say “hello” or “goodbye”.",
    emoji: "👋",
  },
  {
    "web-scraper-order": "1666028451-2228",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💋 Kiss Mark",
    "people-href": "https://emojipedia.org/kiss-mark/",
    emojiName: "💋 Kiss Mark",
    description:
      "The mark left after a firm kiss is placed with bright lipstick. Used in place of ‘xxx’ (kisses), or to send a kiss to someone. More seductive than the kiss emoji.",
    emoji: "💋",
  },
  {
    "web-scraper-order": "1666028453-2229",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😾 Pouting Cat",
    "people-href": "https://emojipedia.org/pouting-cat/",
    emojiName: "😾 Pouting Cat",
    description:
      "A cartoon cat variant of 😡 Pouting Face. Also resembles 😠 Angry Face. Depicted as yellow on major platforms. Sometimes used to represent the internet meme and celebrity Grumpy Cat.",
    emoji: "😾",
  },
  {
    "web-scraper-order": "1666028459-2230",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😿 Crying Cat",
    "people-href": "https://emojipedia.org/crying-cat/",
    emojiName: "😿 Crying Cat",
    description:
      "A cartoon cat variant of 😢 Crying Face. Depicted as yellow on major platforms.",
    emoji: "😿",
  },
  {
    "web-scraper-order": "1666028463-2231",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙀 Weary Cat",
    "people-href": "https://emojipedia.org/weary-cat/",
    emojiName: "🙀 Weary Cat",
    description:
      "A cartoon cat variant of 😩 Weary Face. Its expression more closely resembles 😱 Face Screaming in Fear. Depicted as yellow on major platforms.",
    emoji: "🙀",
  },
  {
    "web-scraper-order": "1666028468-2232",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😽 Kissing Cat",
    "people-href": "https://emojipedia.org/kissing-cat/",
    emojiName: "😽 Kissing Cat",
    description:
      "A cartoon cat variant of 😚 Kissing Face With Closed Eyes. Depicted as yellow on major platforms.",
    emoji: "😽",
  },
  {
    "web-scraper-order": "1666028473-2233",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😼 Cat with Wry Smile",
    "people-href": "https://emojipedia.org/cat-with-wry-smile/",
    emojiName: "😼 Cat with Wry Smile",
    description:
      "A cartoon cat variant of 😏 Smirking Face. Depicted as yellow on major platforms.",
    emoji: "😼",
  },
  {
    "web-scraper-order": "1666028477-2234",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😻 Smiling Cat with Heart-Eyes",
    "people-href": "https://emojipedia.org/smiling-cat-with-heart-eyes/",
    emojiName: "😻 Smiling Cat with Heart-Eyes",
    description:
      "A cartoon cat variant of 😍 Smiling Face With Heart-Eyes. Depicted as yellow on major platforms.",
    emoji: "😻",
  },
  {
    "web-scraper-order": "1666028481-2235",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😹 Cat with Tears of Joy",
    "people-href": "https://emojipedia.org/cat-with-tears-of-joy/",
    emojiName: "😹 Cat with Tears of Joy",
    description:
      "A cartoon cat variant of 😂 Face With Tears of Joy. Depicted as yellow on major platforms.",
    emoji: "😹",
  },
  {
    "web-scraper-order": "1666028486-2236",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😸 Grinning Cat with Smiling Eyes",
    "people-href": "https://emojipedia.org/grinning-cat-with-smiling-eyes/",
    emojiName: "😸 Grinning Cat with Smiling Eyes",
    description:
      "A cartoon cat variant of 😄 Grinning Face With Smiling Eyes. Depicted as yellow on major platforms.",
    emoji: "😸",
  },
  {
    "web-scraper-order": "1666028491-2237",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😺 Grinning Cat",
    "people-href": "https://emojipedia.org/grinning-cat/",
    emojiName: "😺 Grinning Cat",
    description:
      "A cartoon cat variant of 😀 Grinning Face. Depicted as yellow on major platforms.",
    emoji: "😺",
  },
  {
    "web-scraper-order": "1666028494-2238",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤖 Robot",
    "people-href": "https://emojipedia.org/robot/",
    emojiName: "🤖 Robot",
    description:
      "The head of a classic robot. Commonly depicted as a vintage, tin toy robot with circular eyes, a triangular nose, knobs for ears, a light and/or antennae atop its head, and a grill-like mouth similar to a grimace. Colors vary across platform, but its head is metallic on most platforms.",
    emoji: "🤖",
  },
  {
    "web-scraper-order": "1666028498-2239",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👾 Alien Monster",
    "people-href": "https://emojipedia.org/alien-monster/",
    emojiName: "👾 Alien Monster",
    description:
      "A friendly-looking, tentacled space creature with two eyes. Most major platforms style their design after aliens in classic arcade games like Space Invaders, rendering it purple and pixellated, as if in 8-bit graphics.",
    emoji: "👾",
  },
  {
    "web-scraper-order": "1666028502-2240",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👽 Alien",
    "people-href": "https://emojipedia.org/alien/",
    emojiName: "👽 Alien",
    description:
      "A classic alien face. The oval, bare head of a gray or green alien with large black eyes and a slight, friendly smile. Samsung depicts nostrils, Facebook a nose.",
    emoji: "👽",
  },
  {
    "web-scraper-order": "1666028508-2241",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👻 Ghost",
    "people-href": "https://emojipedia.org/ghost/",
    emojiName: "👻 Ghost",
    description:
      "Boo! A white, cartoon ghost making a silly face. Its tongue is stuck out and arms are outstretched, as if trying to scare someone in a friendly way. Several platforms feature one larger, bulging eye.",
    emoji: "👻",
  },
  {
    "web-scraper-order": "1666028513-2242",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👺 Goblin",
    "people-href": "https://emojipedia.org/goblin/",
    emojiName: "👺 Goblin",
    description:
      "A menacing, red mask featuring a grotesquely long nose, angry eyes, and bushy eyebrows and mustache. Depicts a tengu, a proud trickster figure in Japanese folklore.",
    emoji: "👺",
  },
  {
    "web-scraper-order": "1666028516-2243",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👹 Ogre",
    "people-href": "https://emojipedia.org/ogre/",
    emojiName: "👹 Ogre",
    description:
      "A grotesque, red face with horns, wide eyes, a large nose, crooked fangs, and a fringe of shaggy hair. Depicts an oni, a kind of hideous ogre in Japanese folklore.",
    emoji: "👹",
  },
  {
    "web-scraper-order": "1666028521-2244",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤡 Clown Face",
    "people-href": "https://emojipedia.org/clown-face/",
    emojiName: "🤡 Clown Face",
    description:
      "A circus or birthday clown displayed with white face makeup, a red nose, exaggerated eyes and smile, and two tufts of hair (red or blue). Commonly used as comment on TikTok or other social media platforms to indicate that a person is foolish, idiotic and/or selfish.",
    emoji: "🤡",
  },
  {
    "web-scraper-order": "1666028526-2245",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💩 Pile of Poo",
    "people-href": "https://emojipedia.org/pile-of-poo/",
    emojiName: "💩 Pile of Poo",
    description:
      "A swirl of brown poop, shaped like soft-serve ice cream with large, excited eyes and a big, friendly smile.",
    emoji: "💩",
  },
  {
    "web-scraper-order": "1666028530-2246",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☠️ Skull and Crossbones",
    "people-href": "https://emojipedia.org/skull-and-crossbones/",
    emojiName: "☠️ Skull and Crossbones",
    description:
      "A cartoon human skull atop an X-shaped pair of bones, as on a pirate flag or poison symbol. Samsung’s design previously displayed a skull and crossbones on a yellow triangle, indicating a hazardous material.",
    emoji: "☠️",
  },
  {
    "web-scraper-order": "1666028535-2247",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "💀 Skull",
    "people-href": "https://emojipedia.org/skull/",
    emojiName: "💀 Skull",
    description:
      "A whitish-gray, cartoon-styled human skull with large, black eye sockets. Commonly expresses figurative death, e.g., dying from extreme laughter, frustration, or affection.",
    emoji: "💀",
  },
  {
    "web-scraper-order": "1666028541-2248",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "👿 Angry Face with Horns",
    "people-href": "https://emojipedia.org/angry-face-with-horns/",
    emojiName: "👿 Angry Face with Horns",
    description:
      "A face, usually purple, with two devil horns, frowning mouth and eyes, and eyebrows scrunched downwards in anger. Bears the same expression as 😠 Angry Face and 😡 Pouting Face on most platforms. Google’s design is red and Facebook’s has black horns, green eyes, and clenched teeth.",
    emoji: "👿",
  },
  {
    "web-scraper-order": "1666028558-2249",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😈 Smiling Face with Horns",
    "people-href": "https://emojipedia.org/smiling-face-with-horns/",
    emojiName: "😈 Smiling Face with Horns",
    description:
      "A face, usually purple, with devil horns, a wide grin, and eyes and eyebrows scrunched downward in the same manner as 😠 Angry Face on most platforms. Google’s design is red and Facebook’s has black horns and green eyes.",
    emoji: "😈",
  },
  {
    "web-scraper-order": "1666028562-2250",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤬 Face with Symbols on Mouth",
    "people-href": "https://emojipedia.org/face-with-symbols-on-mouth/",
    emojiName: "🤬 Face with Symbols on Mouth",
    description:
      "An angry-red face with a black bar and white grawlixes covering its mouth, indicating it's swearing or being vulgar. Grawlixes are typographical symbols (e.g., @#$%&!) representing swear words or obscenities. Often used to convey an outburst of anger, frustration, or rage.",
    emoji: "🤬",
  },
  {
    "web-scraper-order": "1666028572-2251",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😠 Angry Face",
    "people-href": "https://emojipedia.org/angry-face/",
    emojiName: "😠 Angry Face",
    description:
      "A yellow face with a frowning mouth and eyes and eyebrows scrunched downward in anger.",
    emoji: "😠",
  },
  {
    "web-scraper-order": "1666028588-2252",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😡 Enraged Face",
    "people-href": "https://emojipedia.org/pouting-face/",
    emojiName: "😡 Enraged Face",
    description:
      "A red face with an angry expression: frowning mouth with eyes and eyebrows scrunched downward. Bears the same expression as 😠 Angry Face on most platforms and may convey more intense degrees of anger, e.g., hate or rage.",
    emoji: "😡",
  },
  {
    "web-scraper-order": "1666028596-2253",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😤 Face with Steam From Nose",
    "people-href": "https://emojipedia.org/face-with-steam-from-nose/",
    emojiName: "😤 Face with Steam From Nose",
    description:
      "A yellow face with closed eyes, furrowed eyebrows, broad frown, and two puffs of steam blowing out of its nose, as if in a huff or fuming.",
    emoji: "😤",
  },
  {
    "web-scraper-order": "1666028601-2254",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥱 Yawning Face",
    "people-href": "https://emojipedia.org/yawning-face/",
    emojiName: "🥱 Yawning Face",
    description:
      "A yellow face with eyes closed and mouth wide open covered by a hand. Captured mid-yawn, this may represent having insufficient sleep, or to imply boredom with a person or topic.",
    emoji: "🥱",
  },
  {
    "web-scraper-order": "1666028609-2255",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😫 Tired Face",
    "people-href": "https://emojipedia.org/tired-face/",
    emojiName: "😫 Tired Face",
    description:
      "A yellow face with scrunched, X-shaped eyes, furrowed eyebrows, and a broad, open frown, as if yawning in exhaustion or groaning in exasperation. Usually shown with upper teeth and sometimes tongue.",
    emoji: "😫",
  },
  {
    "web-scraper-order": "1666028618-2256",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😩 Weary Face",
    "people-href": "https://emojipedia.org/weary-face/",
    emojiName: "😩 Weary Face",
    description:
      "A yellow face with closed eyes, furrowed brows, and a broad, open frown, as if distraught to the point of giving up. Usually shown with upper teeth and sometimes tongue.",
    emoji: "😩",
  },
  {
    "web-scraper-order": "1666028628-2257",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😓 Downcast Face with Sweat",
    "people-href": "https://emojipedia.org/downcast-face-with-sweat/",
    emojiName: "😓 Downcast Face with Sweat",
    description:
      "A yellow face with closed eyes, frown, and a bead of sweat dripping from its forehead. Usually depicted with a single sweat bead on its right side, though Facebook and WhatsApp include the sweat bead on its left side.",
    emoji: "😓",
  },
  {
    "web-scraper-order": "1666028641-2258",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😞 Disappointed Face",
    "people-href": "https://emojipedia.org/disappointed-face/",
    emojiName: "😞 Disappointed Face",
    description:
      "A yellow face with a frown and closed, downcast eyes, as if aching with sorrow or pain. May convey a variety of unhappy emotions, including disappointment, grief, stress, regret, and remorse.",
    emoji: "😞",
  },
  {
    "web-scraper-order": "1666028658-2259",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😣 Persevering Face",
    "people-href": "https://emojipedia.org/persevering-face/",
    emojiName: "😣 Persevering Face",
    description:
      "A yellow face with a slight frown, furrowed eyebrows, and scrunched eyes, as if holding back tears or exerting great effort. May convey various degrees and tones of frustration, sadness, helplessness, and struggle. Facebook’s design features a light-purple forehead.",
    emoji: "😣",
  },
  {
    "web-scraper-order": "1666028667-2260",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😖 Confounded Face",
    "people-href": "https://emojipedia.org/confounded-face/",
    emojiName: "😖 Confounded Face",
    description:
      "A yellow face with scrunched, X-shaped eyes and a crumpled mouth, as if quivering in frustration or holding back tears. May be used to represent being overcome with various emotions, including irritation, frustration, disgust, and sadness, as if to the point of defeat.",
    emoji: "😖",
  },
  {
    "web-scraper-order": "1666028679-2261",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😱 Face Screaming in Fear",
    "people-href": "https://emojipedia.org/face-screaming-in-fear/",
    emojiName: "😱 Face Screaming in Fear",
    description:
      "A yellow face screaming in fear, depicted by wide, white eyes, a long, open mouth, hands pressed on cheeks, and a pale blue forehead, as if it has lost its color. Its expression evokes Edvard Munch’s iconic painting The Scream.",
    emoji: "😱",
  },
  {
    "web-scraper-order": "1666028688-2262",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😭 Loudly Crying Face",
    "people-href": "https://emojipedia.org/loudly-crying-face/",
    emojiName: "😭 Loudly Crying Face",
    description:
      "A yellow face with an open mouth wailing and streams of heavy tears flowing from closed eyes. May convey inconsolable grief but also other intense feelings, such as uncontrollable laughter, pride or overwhelming joy.",
    emoji: "😭",
  },
  {
    "web-scraper-order": "1666028697-2263",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😢 Crying Face",
    "people-href": "https://emojipedia.org/crying-face/",
    emojiName: "😢 Crying Face",
    description:
      "A yellow face with raised eyebrows and a slight frown, shedding a single, blue tear from one eye down its cheek. May convey a moderate degree of sadness or pain, usually less intensely than 😭 Loudly Crying Face.",
    emoji: "😢",
  },
  {
    "web-scraper-order": "1666028716-2264",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😥 Sad but Relieved Face",
    "people-href": "https://emojipedia.org/sad-but-relieved-face/",
    emojiName: "😥 Sad but Relieved Face",
    description:
      "A yellow face with small, open eyes, a slight frown, and furrowed eyebrows, from which a single bead of sweat drips, as if from concern or anxiety. Also known as Disappointed but Relieved Face, suggesting the smiley is upset but is grateful things didn’t turn out worse.",
    emoji: "😥",
  },
  {
    "web-scraper-order": "1666028729-2265",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😰 Anxious Face with Sweat",
    "people-href": "https://emojipedia.org/anxious-face-with-sweat/",
    emojiName: "😰 Anxious Face with Sweat",
    description:
      "A face with open eyes and a small, open frown. Its eyebrows are furrowed, with a single bead of cold sweat dripping down, and its forehead is pale blue, as if experiencing a cold flash. Samsung's design shows upper teeth and tongue.",
    emoji: "😰",
  },
  {
    "web-scraper-order": "1666028736-2266",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😨 Fearful Face",
    "people-href": "https://emojipedia.org/fearful-face/",
    emojiName: "😨 Fearful Face",
    description:
      "A face with small, open eyes, open frown, raised eyebrows, and a pale blue forehead, as if experiencing a cold flash. Samsung’s design shows upper teeth and tongue.",
    emoji: "😨",
  },
  {
    "web-scraper-order": "1666028744-2267",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😧 Anguished Face",
    "people-href": "https://emojipedia.org/anguished-face/",
    emojiName: "😧 Anguished Face",
    description:
      "A yellow face with small, open eyes, open frown, and raised eyebrows. Samsung’s design shows upper teeth and tongue. Meaning widely varies, but may convey alarm, confusion, or sadness, as if gasping in shock or concern.",
    emoji: "😧",
  },
  {
    "web-scraper-order": "1666028761-2268",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😦 Frowning Face with Open Mouth",
    "people-href": "https://emojipedia.org/frowning-face-with-open-mouth/",
    emojiName: "😦 Frowning Face with Open Mouth",
    description:
      "A yellow face with small, open eyes and an open frown. Samsung’s design shows upper teeth and tongue. Meaning widely varies, but may convey mild sadness, disappointment, concern, and amazement.",
    emoji: "😦",
  },
  {
    "web-scraper-order": "1666028765-2269",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥹 Face Holding Back Tears",
    "people-href": "https://emojipedia.org/face-holding-back-tears/",
    emojiName: "🥹 Face Holding Back Tears",
    description:
      "A yellow face with tears welling up at the bottom of its two large eyes.",
    emoji: "🥹",
  },
  {
    "web-scraper-order": "1666028782-2270",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥺 Pleading Face",
    "people-href": "https://emojipedia.org/pleading-face/",
    emojiName: "🥺 Pleading Face",
    description:
      "A yellow face with furrowed eyebrows, a small frown, and large, “puppy dog” eyes, as if begging or pleading. May also represent adoration or feeling touched by a loving gesture.",
    emoji: "🥺",
  },
  {
    "web-scraper-order": "1666028794-2271",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😳 Flushed Face",
    "people-href": "https://emojipedia.org/flushed-face/",
    emojiName: "😳 Flushed Face",
    description:
      "A yellow face with raised eyebrows, a small, closed mouth, wide, white eyes staring straight ahead, and blushing cheeks. Intended to depict such feelings as embarrassment, but meaning very widely varies. Other senses include flattery, surprise, disbelief, admiration, affection, and excitement.",
    emoji: "😳",
  },
  {
    "web-scraper-order": "1666028799-2272",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😲 Astonished Face",
    "people-href": "https://emojipedia.org/astonished-face/",
    emojiName: "😲 Astonished Face",
    description:
      "A yellow face with open eyes, raised eyebrows, and an open mouth, as if gasping in shock or surprise. Often depicted showing its upper teeth. May convey a wide range of emotions, including awe, amazement, admiration, disbelief, excitement, or concern.",
    emoji: "😲",
  },
  {
    "web-scraper-order": "1666028802-2273",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😯 Hushed Face",
    "people-href": "https://emojipedia.org/hushed-face/",
    emojiName: "😯 Hushed Face",
    description:
      "A yellow face with small, open eyes, raised eyebrows, and a small, open mouth, as if it has been hushed by concern or correction. Meaning widely varies, but its expression is commonly taken as surprise, embarrassment, or mild excitement.",
    emoji: "😯",
  },
  {
    "web-scraper-order": "1666028807-2274",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😮 Face with Open Mouth",
    "people-href": "https://emojipedia.org/face-with-open-mouth/",
    emojiName: "😮 Face with Open Mouth",
    description:
      "A yellow face with small, open eyes and a large, round mouth, slack with surprise or shock, as if saying Wow! or Oh my! May convey such feelings as awe or disbelief, often milder or more ironic in tone than 😱 Face Screaming in Fear.",
    emoji: "😮",
  },
  {
    "web-scraper-order": "1666028812-2275",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☹️ Frowning Face",
    "people-href": "https://emojipedia.org/frowning-face/",
    emojiName: "☹️ Frowning Face",
    description:
      "A classic sad face. A yellow face with simple, open eyes and wide, steep frown. May convey such feelings as moderate concern or disappointment and affectionate sadness, as when missing a loved one. Its sentiment is usually more intense than 🙁 Slightly Frowning Face, which has a smaller frown.",
    emoji: "☹️",
  },
  {
    "web-scraper-order": "1666028816-2276",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙁 Slightly Frowning Face",
    "people-href": "https://emojipedia.org/slightly-frowning-face/",
    emojiName: "🙁 Slightly Frowning Face",
    description:
      "A yellow face with simple, open eyes and a slight frown. Often conveys a mild degree of concern, disappointment, or sadness, but usually less intensely than ☹️ Frowning Face.",
    emoji: "🙁",
  },
  {
    "web-scraper-order": "1666028821-2277",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😟 Worried Face",
    "people-href": "https://emojipedia.org/worried-face/",
    emojiName: "😟 Worried Face",
    description:
      "A yellow face with open eyes, raised or furrowed eyebrows, and a broad frown. May convey a variety of moderately sad or tense emotions, including concern, anxiety, alarm, disappointment, and unhappiness.",
    emoji: "😟",
  },
  {
    "web-scraper-order": "1666028824-2278",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫤 Face with Diagonal Mouth",
    "people-href": "https://emojipedia.org/face-with-diagonal-mouth/",
    emojiName: "🫤 Face with Diagonal Mouth",
    description:
      "A yellow face with a closed slanted mouth. Can be used to express skepticism, confusion, or frustration.",
    emoji: "🫤",
  },
  {
    "web-scraper-order": "1666028839-2279",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😕 Confused Face",
    "people-href": "https://emojipedia.org/confused-face/",
    emojiName: "😕 Confused Face",
    description:
      "A yellow face with open eyes and a skewed frown, as if scrunching its cheeks or chewing its lips. A look of feeling unsure.",
    emoji: "😕",
  },
  {
    "web-scraper-order": "1666028844-2280",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🧐 Face with Monocle",
    "people-href": "https://emojipedia.org/face-with-monocle/",
    emojiName: "🧐 Face with Monocle",
    description:
      "A yellow face with furrowed eyebrows wearing a monocle. Usually depicted with a small, intent frown and head slightly upturned, as if in careful inspection.",
    emoji: "🧐",
  },
  {
    "web-scraper-order": "1666028848-2281",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤓 Nerd Face",
    "people-href": "https://emojipedia.org/nerd-face/",
    emojiName: "🤓 Nerd Face",
    description:
      "A smiling yellow face with glasses, often with teeth showing, originally buck teeth on most platforms.",
    emoji: "🤓",
  },
  {
    "web-scraper-order": "1666028858-2282",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😎 Smiling Face with Sunglasses",
    "people-href": "https://emojipedia.org/smiling-face-with-sunglasses/",
    emojiName: "😎 Smiling Face with Sunglasses",
    description:
      "A yellow face with a broad, closed smile wearing black sunglasses, as if a pair of classic Wayfarers. Often used to convey the slang sense of cool. May also express a confident, carefree attitude or that something is excellent.",
    emoji: "😎",
  },
  {
    "web-scraper-order": "1666028863-2283",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥸 Disguised Face",
    "people-href": "https://emojipedia.org/disguised-face/",
    emojiName: "🥸 Disguised Face",
    description:
      "A yellow face with big glasses, a large nose, thick eyebrows, and a mustache. Used to represent someone in disguise.",
    emoji: "🥸",
  },
  {
    "web-scraper-order": "1666028868-2284",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥳 Partying Face",
    "people-href": "https://emojipedia.org/partying-face/",
    emojiName: "🥳 Partying Face",
    description:
      "A yellow face with a party hat blowing a party horn as confetti floats around its head. Used for celebrating joyous occasions (such as New Year's Eve or World Emoji Day) and enjoying good times more generally.",
    emoji: "🥳",
  },
  {
    "web-scraper-order": "1666028874-2285",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤠 Cowboy Hat Face",
    "people-href": "https://emojipedia.org/cowboy-hat-face/",
    emojiName: "🤠 Cowboy Hat Face",
    description:
      "Yee-haw! A yellow smiley wearing a wide-brimmed, brown-leather cowboy hat. Its smile varies across platforms. May convey a sense of exuberance, whimsy, confidence, adventure, or other sentiments.",
    emoji: "🤠",
  },
  {
    "web-scraper-order": "1666028883-2286",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤯 Exploding Head",
    "people-href": "https://emojipedia.org/exploding-head/",
    emojiName: "🤯 Exploding Head",
    description:
      "A yellow face with an open mouth, the top of its head exploding in the shape of a brain-like mushroom cloud. A visual form of the expression mind blown, it may represent such emotions as shock, awe, amazement, and disbelief.",
    emoji: "🤯",
  },
  {
    "web-scraper-order": "1666028893-2287",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😵‍💫 Face with Spiral Eyes",
    "people-href": "https://emojipedia.org/face-with-spiral-eyes/",
    emojiName: "😵‍💫 Face with Spiral Eyes",
    description:
      "A face showing a spiral eyes, commonly used to indicate dizziness, but may also represent hypnosis or other forms of disorientation.",
    emoji: "😵‍💫",
  },
  {
    "web-scraper-order": "1666028898-2288",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😵 Face with Crossed-Out Eyes",
    "people-href": "https://emojipedia.org/dizzy-face/",
    emojiName: "😵 Face with Crossed-Out Eyes",
    description:
      "A yellow face with X’s for eyes and a round, open mouth. Often depicted with raised or furrowed eyebrows. Facebook’s design features a purple forehead. Previously displayed with spiral eyes on some platforms.",
    emoji: "😵",
  },
  {
    "web-scraper-order": "1666028904-2289",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥴 Woozy Face",
    "people-href": "https://emojipedia.org/woozy-face/",
    emojiName: "🥴 Woozy Face",
    description:
      "A yellow face with a crumpled mouth and a cockeyed expression, as if tired and emotional from inebriation or smitten with love. Depicted with raised or furrowed eyebrows and at least one eye half-open. WhatsApp's design features a tongue hanging out.",
    emoji: "🥴",
  },
  {
    "web-scraper-order": "1666028908-2290",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥶 Cold Face",
    "people-href": "https://emojipedia.org/cold-face/",
    emojiName: "🥶 Cold Face",
    description:
      "An icy-blue face with gritted teeth usually depicted with icicles clinging to its cheeks or jaw, as if frozen from extreme cold. May also represent unfriendliness (slang, cold) or excellence (slang, cool or chill).",
    emoji: "🥶",
  },
  {
    "web-scraper-order": "1666028914-2291",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥵 Hot Face",
    "people-href": "https://emojipedia.org/hot-face/",
    emojiName: "🥵 Hot Face",
    description:
      "A reddish-orange face with furrowed eyebrows, tongue stuck out, and beads of sweat, as if overheated from high temperatures. Number and position of sweat droplets vary by platforms. May also represent physical attractiveness (slang, hot).",
    emoji: "🥵",
  },
  {
    "web-scraper-order": "1666028919-2292",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤧 Sneezing Face",
    "people-href": "https://emojipedia.org/sneezing-face/",
    emojiName: "🤧 Sneezing Face",
    description:
      "A yellow face with scrunched, X-shaped eyes sneezing or blowing its nose into a white tissue, as if from a cold or allergies. Often depicted with a crumpled-looking mouth.",
    emoji: "🤧",
  },
  {
    "web-scraper-order": "1666028922-2293",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤮 Face Vomiting",
    "people-href": "https://emojipedia.org/face-vomiting/",
    emojiName: "🤮 Face Vomiting",
    description:
      "A yellow face with scrunched, X-shaped eyes spewing bright-green vomit. May represent physical illness or disgust, more intensely so than 🤢 Nauseated Face.",
    emoji: "🤮",
  },
  {
    "web-scraper-order": "1666028927-2294",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤢 Nauseated Face",
    "people-href": "https://emojipedia.org/nauseated-face/",
    emojiName: "🤢 Nauseated Face",
    description:
      "A sickly-green face with concerned eyes and puffed, often red cheeks, as if holding back vomit. May represent physical illness or general disgust. Not to be confused with 🤮 Face Vomiting.",
    emoji: "🤢",
  },
  {
    "web-scraper-order": "1666028932-2295",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤕 Face with Head-Bandage",
    "people-href": "https://emojipedia.org/face-with-head-bandage/",
    emojiName: "🤕 Face with Head-Bandage",
    description:
      "A yellow face with a half-frown and white bandage wrapped around its head, often depicted partially over one eye. May represent physical injury or pain but also emotional hurting, sometimes for ironic effect.",
    emoji: "🤕",
  },
  {
    "web-scraper-order": "1666028937-2296",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤒 Face with Thermometer",
    "people-href": "https://emojipedia.org/face-with-thermometer/",
    emojiName: "🤒 Face with Thermometer",
    description:
      "A yellow face with raised or furrowed eyebrows and a thermometer in its mouth. Often depicted with red cheeks, as if feverish. May be used to represent a hospital patient or person with a cold or flu.",
    emoji: "🤒",
  },
  {
    "web-scraper-order": "1666028942-2297",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😷 Face with Medical Mask",
    "people-href": "https://emojipedia.org/face-with-medical-mask/",
    emojiName: "😷 Face with Medical Mask",
    description:
      "A yellow face wearing a white surgical mask, as used by health workers in hospitals as well as the general public during a pandemic. May be worn to avoid sickness or spreading airborne diseases.",
    emoji: "😷",
  },
  {
    "web-scraper-order": "1666028951-2298",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😴 Sleeping Face",
    "people-href": "https://emojipedia.org/sleeping-face/",
    emojiName: "😴 Sleeping Face",
    description:
      "A yellow face with eyes closed and mouth letting out three, cartoon-styled Zzz’s overhead to indicate it's sound asleep. The Zzz’s appear blue or purple across most platforms. May also represent boredom (slang, snooze).",
    emoji: "😴",
  },
  {
    "web-scraper-order": "1666028961-2299",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤤 Drooling Face",
    "people-href": "https://emojipedia.org/drooling-face/",
    emojiName: "🤤 Drooling Face",
    description:
      "A yellow face, usually shown with closed eyes and raised eyebrows, with saliva drooling from one corner of its mouth. Often used to show desire for a person (sexy, attractive) or object (e.g., delicious food). May also represent someone is tired or sleeping.",
    emoji: "🤤",
  },
  {
    "web-scraper-order": "1666028970-2300",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😪 Sleepy Face",
    "people-href": "https://emojipedia.org/sleepy-face/",
    emojiName: "😪 Sleepy Face",
    description:
      "A yellow face with closed eyes, mouth slightly open, and a blue snot bubble coming from its nose. Snot bubbles indicate a character is tired or sleeping in anime or manga. Not to be confused with 😴 Sleeping Face",
    emoji: "😪",
  },
  {
    "web-scraper-order": "1666028982-2301",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😔 Pensive Face",
    "people-href": "https://emojipedia.org/pensive-face/",
    emojiName: "😔 Pensive Face",
    description:
      "A pensive, remorseful face. Saddened by life. Quietly considering where things all went wrong. Depicted as a yellow face with sad, closed eyes, furrowed eyebrows, and a slight, flat mouth.",
    emoji: "😔",
  },
  {
    "web-scraper-order": "1666028995-2302",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😌 Relieved Face",
    "people-href": "https://emojipedia.org/relieved-face/",
    emojiName: "😌 Relieved Face",
    description:
      "A yellow face with soft, closed eyes, raised eyebrows, and a slight smile. Facebook’s design features a slightly open mouth, as if sighing.",
    emoji: "😌",
  },
  {
    "web-scraper-order": "1666029000-2303",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤥 Lying Face",
    "people-href": "https://emojipedia.org/lying-face/",
    emojiName: "🤥 Lying Face",
    description:
      "A yellow face with raised eyebrows, enlarged eyes, slight frown, and long nose, indicating it’s telling a lie in the manner of Pinocchio. Like that character, Facebook's design features a wooden nose.",
    emoji: "🤥",
  },
  {
    "web-scraper-order": "1666029007-2304",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😮‍💨 Face Exhaling",
    "people-href": "https://emojipedia.org/face-exhaling/",
    emojiName: "😮‍💨 Face Exhaling",
    description:
      "A face showing a visible breath of air being dispelled. Used to represent relief, exhaustion, or as a sigh of disappointment or displeasure.",
    emoji: "😮‍💨",
  },
  {
    "web-scraper-order": "1666029021-2305",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😬 Grimacing Face",
    "people-href": "https://emojipedia.org/grimacing-face/",
    emojiName: "😬 Grimacing Face",
    description:
      "A yellow face with simple open eyes showing clenched teeth. May represent a range of negative or tense emotions, especially nervousness, embarrassment, or awkwardness (e.g., Eek!).",
    emoji: "😬",
  },
  {
    "web-scraper-order": "1666029036-2306",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙄 Face with Rolling Eyes",
    "people-href": "https://emojipedia.org/face-with-rolling-eyes/",
    emojiName: "🙄 Face with Rolling Eyes",
    description:
      "A yellow face with a small, closed mouth, flat or frowning, rolling its large, white eyes upwards. As with the gesture of an eye-roll, commonly conveys moderate disdain, disapproval, frustration, or boredom. Tone varies, including playful, sassy, resentful, and sarcastic, as if saying Yeah, whatever.",
    emoji: "🙄",
  },
  {
    "web-scraper-order": "1666029050-2307",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😒 Unamused Face",
    "people-href": "https://emojipedia.org/unamused-face/",
    emojiName: "😒 Unamused Face",
    description:
      "A yellow face with slightly raised eyebrows, a frown, and eyes looking to the side. May convey a variety of negative emotions, including irritation, displeasure, grumpiness, and skepticism, as if giving the side-eye.",
    emoji: "😒",
  },
  {
    "web-scraper-order": "1666029060-2308",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😏 Smirking Face",
    "people-href": "https://emojipedia.org/smirking-face/",
    emojiName: "😏 Smirking Face",
    description:
      "A yellow face with a sly, smug, mischievous, or suggestive facial expression. It features a half-smile, raised eyebrows, and eyes looking to the side. Often used to convey flirtation or sexual innuendo.",
    emoji: "😏",
  },
  {
    "web-scraper-order": "1666029067-2309",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😶‍🌫️ Face in Clouds",
    "people-href": "https://emojipedia.org/face-in-clouds/",
    emojiName: "😶‍🌫️ Face in Clouds",
    description:
      "A face that appears surrounded by clouds or a haze of smoke. Ambiguous in appearance, this may represent a foggy state of mind, confusion, or even a sense of calm bliss.",
    emoji: "😶‍🌫️",
  },
  {
    "web-scraper-order": "1666029069-2310",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫥 Dotted Line Face",
    "people-href": "https://emojipedia.org/dotted-line-face/",
    emojiName: "🫥 Dotted Line Face",
    description: "A muted yellow neutral face with a dotted or dashed outline.",
    emoji: "🫥",
  },
  {
    "web-scraper-order": "1666029084-2311",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😶 Face Without Mouth",
    "people-href": "https://emojipedia.org/face-without-mouth/",
    emojiName: "😶 Face Without Mouth",
    description:
      "A yellow face with simple, open eyes and no mouth, as if at a loss for words. Meaning widely varies, but commonly conveys speechlessness, humility, and silence. May also convey moderately negative emotions, such as disappointment, frustration, or sadness.",
    emoji: "😶",
  },
  {
    "web-scraper-order": "1666029095-2312",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😑 Expressionless Face",
    "people-href": "https://emojipedia.org/expressionless-face/",
    emojiName: "😑 Expressionless Face",
    description:
      "A yellow face with flat, closed eyes and mouth. May convey a sense of frustration or annoyance more intense than suggested by 😐 Neutral Face, as if taking a moment to collect itself.",
    emoji: "😑",
  },
  {
    "web-scraper-order": "1666029109-2313",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😐 Neutral Face",
    "people-href": "https://emojipedia.org/neutral-face/",
    emojiName: "😐 Neutral Face",
    description:
      "A yellow face with simple, open eyes and a flat, closed mouth. Intended to depict a neutral sentiment but often used to convey mild irritation and concern or a deadpan sense of humor.",
    emoji: "😐",
  },
  {
    "web-scraper-order": "1666029113-2314",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤨 Face with Raised Eyebrow",
    "people-href": "https://emojipedia.org/face-with-raised-eyebrow/",
    emojiName: "🤨 Face with Raised Eyebrow",
    description:
      "A yellow face with a flat, neutral mouth and furrowed eyebrows, its left raised higher than its right. Conveys a wide variety of sentiments, including suspicion, skepticism, concern, consideration, disbelief, and disapproval.",
    emoji: "🤨",
  },
  {
    "web-scraper-order": "1666029120-2315",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤐 Zipper-Mouth Face",
    "people-href": "https://emojipedia.org/zipper-mouth-face/",
    emojiName: "🤐 Zipper-Mouth Face",
    description:
      "A yellow face with simple, open eyes and a closed zipper for a mouth. Meaning widely varies, but commonly conveys a secret or that someone will keep one (e.g., My lips are sealed). May also be used to tell someone to stop talking (e.g., Zip it! or I’ll shut up now).",
    emoji: "🤐",
  },
  {
    "web-scraper-order": "1666029122-2316",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫡 Saluting Face",
    "people-href": "https://emojipedia.org/saluting-face/",
    emojiName: "🫡 Saluting Face",
    description:
      "A yellow face with its right hand saluting. Used as a sign of respect.",
    emoji: "🫡",
  },
  {
    "web-scraper-order": "1666029132-2317",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤔 Thinking Face",
    "people-href": "https://emojipedia.org/thinking-face/",
    emojiName: "🤔 Thinking Face",
    description:
      "A yellow face with furrowed eyebrows looking upwards with thumb and index finger resting on its chin. Intended to show a person pondering or deep in thought. Often used to question or scorn something or someone, as if saying Hmm, I don't know about that. Tone varies, including earnest, playful, puzzled, skeptical, and mocking.",
    emoji: "🤔",
  },
  {
    "web-scraper-order": "1666029146-2318",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤫 Shushing Face",
    "people-href": "https://emojipedia.org/shushing-face/",
    emojiName: "🤫 Shushing Face",
    description:
      "A yellow face placing an index finger over pursed lips, as if issuing Shh! or Shush! for silence. Some platforms feature raised eyebrows. Apple’s design suggests the face is tilting back slightly.",
    emoji: "🤫",
  },
  {
    "web-scraper-order": "1666029148-2319",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫣 Face with Peeking Eye",
    "people-href": "https://emojipedia.org/face-with-peeking-eye/",
    emojiName: "🫣 Face with Peeking Eye",
    description:
      "A yellow face with its hands over its eyes and raised eyebrows. One wide eye is peeking through the fingers.",
    emoji: "🫣",
  },
  {
    "web-scraper-order": "1666029150-2320",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫢 Face with Open Eyes and Hand Over Mouth",
    "people-href":
      "https://emojipedia.org/face-with-open-eyes-and-hand-over-mouth/",
    emojiName: "🫢 Face with Open Eyes and Hand Over Mouth",
    description:
      "A yellow face with open (non-smiling) eyes and a hand over the mouth, used to convey shock or surprise.",
    emoji: "🫢",
  },
  {
    "web-scraper-order": "1666029163-2321",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤭 Face with Hand Over Mouth",
    "people-href": "https://emojipedia.org/face-with-hand-over-mouth/",
    emojiName: "🤭 Face with Hand Over Mouth",
    description:
      "A yellow face with a hand covering its mouth. Displays most often with smiling eyes and/or blushing cheeks, suggesting coy laughter or embarrassment, as if cheekily saying Oops!",
    emoji: "🤭",
  },
  {
    "web-scraper-order": "1666029178-2322",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤗 Smiling Face with Open Hands",
    "people-href": "https://emojipedia.org/hugging-face/",
    emojiName: "🤗 Smiling Face with Open Hands",
    description:
      "A yellow face smiling with open hands, as if giving a hug. May be used to offer thanks and support, show love and care, or express warm, positive feelings more generally.",
    emoji: "🤗",
  },
  {
    "web-scraper-order": "1666029192-2323",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤑 Money-Mouth Face",
    "people-href": "https://emojipedia.org/money-mouth-face/",
    emojiName: "🤑 Money-Mouth Face",
    description:
      "A yellow face with raised eyebrows, dollar signs for eyes, and an open smile sticking out a tongue styled after a green, dollar banknote. Some platforms depict the dollar-sign eyes in green circles.",
    emoji: "🤑",
  },
  {
    "web-scraper-order": "1666029202-2324",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😝 Squinting Face with Tongue",
    "people-href": "https://emojipedia.org/squinting-face-with-tongue/",
    emojiName: "😝 Squinting Face with Tongue",
    description:
      "A yellow face with scrunched, X-shaped eyes and a big grin, sticking out its tongue. Often conveys a sense of fun, excitement, playfulness, hilarity, and happiness, as if saying Squee! or Awesome!",
    emoji: "😝",
  },
  {
    "web-scraper-order": "1666029210-2325",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤪 Zany Face",
    "people-href": "https://emojipedia.org/zany-face/",
    emojiName: "🤪 Zany Face",
    description:
      "A yellow face with its head tilted, its tongue hanging out of a big grin, and wide eyes in a wild, cockeyed expression. Generally used to express silliness.",
    emoji: "🤪",
  },
  {
    "web-scraper-order": "1666029217-2326",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😜 Winking Face with Tongue",
    "people-href": "https://emojipedia.org/winking-face-with-tongue/",
    emojiName: "😜 Winking Face with Tongue",
    description:
      "A yellow face sticking out its tongue and making a zany wink, usually shown with its right eye closed and left wide open. Often conveys a sense of fun, excitement, wackiness, buffoonery, or joking.",
    emoji: "😜",
  },
  {
    "web-scraper-order": "1666029226-2327",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😛 Face with Tongue",
    "people-href": "https://emojipedia.org/face-with-tongue/",
    emojiName: "😛 Face with Tongue",
    description:
      "A yellow face with small, open eyes and a big grin, playfully sticking out its tongue. Can variously convey a sense of fun, excitement, silliness, cuteness, happiness, or jesting, as if saying Just kidding!",
    emoji: "😛",
  },
  {
    "web-scraper-order": "1666029233-2328",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😋 Face Savoring Food",
    "people-href": "https://emojipedia.org/face-savoring-food/",
    emojiName: "😋 Face Savoring Food",
    description:
      "A yellow face with smiling eyes and a broad, closed smile with its tongue sticking out of one corner, as if licking its lips in appetite or contentment. Widely used to convey that a food item is delicious. May also express that a person is attractive.",
    emoji: "😋",
  },
  {
    "web-scraper-order": "1666029237-2329",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥲 Smiling Face with Tear",
    "people-href": "https://emojipedia.org/smiling-face-with-tear/",
    emojiName: "🥲 Smiling Face with Tear",
    description:
      "A yellow face with open eyes, a thin closed-mouth smile, and a single tear falling from one of its eyes. Can be used to express a wide range of emotions and expressions including gratitude, tender happiness, an attempt to look happy when actually sad, or smiling through pain. Can also be a response to something that is bittersweet.",
    emoji: "🥲",
  },
  {
    "web-scraper-order": "1666029242-2330",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😙 Kissing Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/kissing-face-with-smiling-eyes/",
    emojiName: "😙 Kissing Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and puckered lips giving a kiss. Commonly conveys sentiments of love and affection.",
    emoji: "😙",
  },
  {
    "web-scraper-order": "1666029250-2331",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😚 Kissing Face with Closed Eyes",
    "people-href": "https://emojipedia.org/kissing-face-with-closed-eyes/",
    emojiName: "😚 Kissing Face with Closed Eyes",
    description:
      "A yellow face with smiling eyes, rosy cheeks, and puckered lips giving a kiss. Commonly conveys sentiments of romantic love and affection. Several platforms, including Apple, feature the same eyes and cheeks as their ☺️ Smiling Face.",
    emoji: "😚",
  },
  {
    "web-scraper-order": "1666029255-2332",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "☺️ Smiling Face",
    "people-href": "https://emojipedia.org/smiling-face/",
    emojiName: "☺️ Smiling Face",
    description:
      "A classic smiley. A yellow face with a modest smile, rosy cheeks, and soft, closed eyes. Many platforms, including Apple, feature relaxed eyebrows. Conveys a wide range of warm, positive feelings, including love, happiness, and gratitude.",
    emoji: "☺️",
  },
  {
    "web-scraper-order": "1666029260-2333",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😗 Kissing Face",
    "people-href": "https://emojipedia.org/kissing-face/",
    emojiName: "😗 Kissing Face",
    description:
      "A yellow face with simple, open eyes and puckered lips giving a kiss. Commonly conveys sentiments of love and affection.",
    emoji: "😗",
  },
  {
    "web-scraper-order": "1666029268-2334",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😘 Face Blowing a Kiss",
    "people-href": "https://emojipedia.org/face-blowing-a-kiss/",
    emojiName: "😘 Face Blowing a Kiss",
    description:
      "A yellow face winking with puckered lips blowing a kiss, depicted as a small, red heart. May represent a kiss goodbye or good night and convey feelings of love and affection more generally.",
    emoji: "😘",
  },
  {
    "web-scraper-order": "1666029273-2335",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤩 Star-Struck",
    "people-href": "https://emojipedia.org/star-struck/",
    emojiName: "🤩 Star-Struck",
    description:
      "A yellow face with a broad, open smile, showing upper teeth on most platforms, with stars for eyes, as if seeing a beloved celebrity. Color of stars widely varies by platform, though commonly gold or red. May express that someone or something is amazing, fascinating, impressive, or exciting.",
    emoji: "🤩",
  },
  {
    "web-scraper-order": "1666029281-2336",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😍 Smiling Face with Heart-Eyes",
    "people-href": "https://emojipedia.org/smiling-face-with-heart-eyes/",
    emojiName: "😍 Smiling Face with Heart-Eyes",
    description:
      "A yellow face with an open smile, sometimes showing teeth, and red, cartoon-styled hearts for eyes. Often conveys enthusiastic feelings of love, infatuation, and adoration, e.g., I love/am in love with this person or thing.",
    emoji: "😍",
  },
  {
    "web-scraper-order": "1666029290-2337",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🥰 Smiling Face with Hearts",
    "people-href": "https://emojipedia.org/smiling-face-with-hearts/",
    emojiName: "🥰 Smiling Face with Hearts",
    description:
      "A yellow face with smiling eyes, a closed smile, rosy cheeks, and several hearts floating around its head. Expresses a range of happy, affectionate feelings, especially being in love. The placement of the hearts varies slightly by platform.",
    emoji: "🥰",
  },
  {
    "web-scraper-order": "1666029305-2338",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😇 Smiling Face with Halo",
    "people-href": "https://emojipedia.org/smiling-face-with-halo/",
    emojiName: "😇 Smiling Face with Halo",
    description:
      "A yellow face with smiling eyes, closed smile, and halo, usually blue, overhead. Often represents angels, prayers, and blessings. May also convey angelic behavior, e.g., doing good deeds. See also 👼 Baby Angel.",
    emoji: "😇",
  },
  {
    "web-scraper-order": "1666029319-2339",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😊 Smiling Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/smiling-face-with-smiling-eyes/",
    emojiName: "😊 Smiling Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and a broad, closed smile turning up to rosy cheeks. Often expresses genuine happiness and warm, positive feelings.",
    emoji: "😊",
  },
  {
    "web-scraper-order": "1666029330-2340",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😉 Winking Face",
    "people-href": "https://emojipedia.org/winking-face/",
    emojiName: "😉 Winking Face",
    description:
      "A yellow face with a slight smile or open mouth shown winking, usually its left eye. May signal a joke, flirtation, hidden meaning, or general positivity. Tone varies, including playful, affectionate, suggestive, or ironic.",
    emoji: "😉",
  },
  {
    "web-scraper-order": "1666029333-2341",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🫠 Melting Face",
    "people-href": "https://emojipedia.org/melting-face/",
    emojiName: "🫠 Melting Face",
    description: "A yellow smiley face melting into a puddle.",
    emoji: "🫠",
  },
  {
    "web-scraper-order": "1666029341-2342",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙃 Upside-Down Face",
    "people-href": "https://emojipedia.org/upside-down-face/",
    emojiName: "🙃 Upside-Down Face",
    description:
      "A classic smiley, turned upside down. Implemented as a flipped version of 🙂 Slightly Smiling Face on most platforms.",
    emoji: "🙃",
  },
  {
    "web-scraper-order": "1666029356-2343",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🙂 Slightly Smiling Face",
    "people-href": "https://emojipedia.org/slightly-smiling-face/",
    emojiName: "🙂 Slightly Smiling Face",
    description:
      "A yellow face with simple, open eyes and a thin, closed smile. Conveys a wide range of positive, happy, and friendly sentiments. Its tone can also be patronizing, passive-aggressive, or ironic, as if saying This is fine when it’s really not.",
    emoji: "🙂",
  },
  {
    "web-scraper-order": "1666029366-2344",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😂 Face with Tears of Joy",
    "people-href": "https://emojipedia.org/face-with-tears-of-joy/",
    emojiName: "😂 Face with Tears of Joy",
    description:
      "A yellow face with a big grin, uplifted eyebrows, and smiling eyes, each shedding a tear from laughing so hard. Widely used to show something is funny or pleasing.",
    emoji: "😂",
  },
  {
    "web-scraper-order": "1666029372-2345",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "🤣 Rolling on the Floor Laughing",
    "people-href": "https://emojipedia.org/rolling-on-the-floor-laughing/",
    emojiName: "🤣 Rolling on the Floor Laughing",
    description:
      "A yellow face with a big grin and scrunched, X-shaped eyes, tilted on its side as if rolling on the floor laughing (the internet acronym ROFL). Sheds two tears and tilts right on most platforms. Often conveys hysterical laughter more intense than 😂 Face With Tears of Joy.",
    emoji: "🤣",
  },
  {
    "web-scraper-order": "1666029381-2346",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😅 Grinning Face with Sweat",
    "people-href": "https://emojipedia.org/grinning-face-with-sweat/",
    emojiName: "😅 Grinning Face with Sweat",
    description:
      "Has the same grin and eyes as 😄 Grinning Face With Smiling Eyes but with a single, blue bead of sweat, usually over its left eye. Intended to depict nerves or discomfort but commonly used to express a close call, as if saying Whew! and wiping sweat from the forehead.",
    emoji: "😅",
  },
  {
    "web-scraper-order": "1666029395-2347",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😆 Grinning Squinting Face",
    "people-href": "https://emojipedia.org/grinning-squinting-face/",
    emojiName: "😆 Grinning Squinting Face",
    description:
      "A yellow face with a broad, open smile and scrunched, X-shaped eyes. Often conveys excitement or hearty laughter.",
    emoji: "😆",
  },
  {
    "web-scraper-order": "1666029411-2348",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😁 Beaming Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/beaming-face-with-smiling-eyes/",
    emojiName: "😁 Beaming Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and full-toothed grin, as if saying Cheese! for the camera. Teeth may be smoothed-over or crosshatched. Often expresses a radiant, gratified happiness. Tone varies, including warm, silly, amused, or proud.",
    emoji: "😁",
  },
  {
    "web-scraper-order": "1666029422-2349",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😄 Grinning Face with Smiling Eyes",
    "people-href": "https://emojipedia.org/grinning-face-with-smiling-eyes/",
    emojiName: "😄 Grinning Face with Smiling Eyes",
    description:
      "A yellow face with smiling eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general happiness and good-natured amusement.",
    emoji: "😄",
  },
  {
    "web-scraper-order": "1666029434-2350",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😃 Grinning Face with Big Eyes",
    "people-href": "https://emojipedia.org/grinning-face-with-big-eyes/",
    emojiName: "😃 Grinning Face with Big Eyes",
    description:
      "A yellow face with smiling eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general happiness and good-natured amusement.",
    emoji: "😃",
  },
  {
    "web-scraper-order": "1666029444-2351",
    "web-scraper-start-url": "https://emojipedia.org/people/",
    people: "😀 Grinning Face",
    "people-href": "https://emojipedia.org/grinning-face/",
    emojiName: "😀 Grinning Face",
    description:
      "A yellow face with simple, open eyes and a broad, open smile, showing upper teeth and tongue on some platforms. Often conveys general pleasure and good cheer or humor.",
    emoji: "😀",
  },
  {
    "web-scraper-order": "1666025637-818",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏹 Bow and Arrow",
    "activity-href": "https://emojipedia.org/bow-and-arrow/",
    emoji: "🏹",
    emojiName: "🏹 Bow and Arrow",
    description:
      "A bow and arrow used in the sport of archery. May also be used by cupid.",
  },
  {
    "web-scraper-order": "1666025640-819",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎬 Clapper Board",
    "activity-href": "https://emojipedia.org/clapper-board/",
    emoji: "🎬",
    emojiName: "🎬 Clapper Board",
    description:
      "A board which contains the scene name, number, and film. A person ‘claps’ the board shut at the top while saying “Action” or “Cut” to indicate the start and stop of a scene that is being filmed.",
  },
  {
    "web-scraper-order": "1666025645-820",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪘 Long Drum",
    "activity-href": "https://emojipedia.org/long-drum/",
    emoji: "🪘",
    emojiName: "🪘 Long Drum",
    description:
      "A long drum with a tall body and a cylindrical or hourglass shell. Can be used to represent various drums found around the world from Africa to the Caribbean to Latin America to Asia. Types of long drum include (but are not limited to) djembe, talking drum, conga, bongo, tumbadora, atabaque, and dhol.",
  },
  {
    "web-scraper-order": "1666025650-821",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥁 Drum",
    "activity-href": "https://emojipedia.org/drum/",
    emoji: "🥁",
    emojiName: "🥁 Drum",
    description:
      "A drum shown with drumsticks. A percussion instrument which is likely to be displayed as a snare drum.music, instrument,",
  },
  {
    "web-scraper-order": "1666025653-822",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎻 Violin",
    "activity-href": "https://emojipedia.org/violin/",
    emoji: "🎻",
    emojiName: "🎻 Violin",
    description:
      "A violin emoji. Sometimes used in the context of the world’s smallest violin.",
  },
  {
    "web-scraper-order": "1666025657-823",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎺 Trumpet",
    "activity-href": "https://emojipedia.org/trumpet/",
    emoji: "🎺",
    emojiName: "🎺 Trumpet",
    description: "A trumpet, a brass instrument played in jazz bands.",
  },
  {
    "web-scraper-order": "1666025660-824",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎹 Musical Keyboard",
    "activity-href": "https://emojipedia.org/musical-keyboard/",
    emoji: "🎹",
    emojiName: "🎹 Musical Keyboard",
    description:
      "A small section of a music keyboard, which differs from a computer keyboard.",
  },
  {
    "web-scraper-order": "1666025662-825",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎸 Guitar",
    "activity-href": "https://emojipedia.org/guitar/",
    emoji: "🎸",
    emojiName: "🎸 Guitar",
    description:
      "A guitar, which most platforms display as a red electric guitar.",
  },
  {
    "web-scraper-order": "1666025665-826",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪗 Accordion",
    "activity-href": "https://emojipedia.org/accordion/",
    emoji: "🪗",
    emojiName: "🪗 Accordion",
    description:
      "A red accordion with a keyboard on one side, buttons on the other side, and bellows in the middle. Used to talk about accordion music or music in general. Also may be used in reference to things that expand and contract, or are folded like the bellows of an accordion.",
  },
  {
    "web-scraper-order": "1666025667-827",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎷 Saxophone",
    "activity-href": "https://emojipedia.org/saxophone/",
    emoji: "🎷",
    emojiName: "🎷 Saxophone",
    description:
      "Saxophone was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025670-828",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎧 Headphone",
    "activity-href": "https://emojipedia.org/headphone/",
    emoji: "🎧",
    emojiName: "🎧 Headphone",
    description:
      "Headphones, used to listen to music or other forms audio, such as podcasts. Most platforms display this emoji with large over-ear headphones in shades of black, blue, and gray.",
  },
  {
    "web-scraper-order": "1666025673-829",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎤 Microphone",
    "activity-href": "https://emojipedia.org/microphone/",
    emoji: "🎤",
    emojiName: "🎤 Microphone",
    description:
      "A microphone, used to amplify a person’s voice when speaking or singing.",
  },
  {
    "web-scraper-order": "1666025675-830",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎼 Musical Score",
    "activity-href": "https://emojipedia.org/musical-score/",
    emoji: "🎼",
    emojiName: "🎼 Musical Score",
    description:
      "A staff (or stave) showing a treble clef and five horizontal lines.",
  },
  {
    "web-scraper-order": "1666025678-831",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧶 Yarn",
    "activity-href": "https://emojipedia.org/yarn/",
    emoji: "🧶",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
  },
  {
    "web-scraper-order": "1666025680-832",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧵 Thread",
    "activity-href": "https://emojipedia.org/thread/",
    emoji: "🧵",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
  },
  {
    "web-scraper-order": "1666025683-833",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎨 Artist Palette",
    "activity-href": "https://emojipedia.org/artist-palette/",
    emoji: "🎨",
    emojiName: "🎨 Artist Palette",
    description:
      "A palette used by an artist when painting, to store and mix paint colors.",
  },
  {
    "web-scraper-order": "1666025686-834",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎭 Performing Arts",
    "activity-href": "https://emojipedia.org/performing-arts/",
    emoji: "🎭",
    emojiName: "🎭 Performing Arts",
    description:
      "Two masks often used on maps to indicate a theatre, these originate in Greek Theatre as masks of tragedy and comedy.",
  },
  {
    "web-scraper-order": "1666025688-835",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "♟️ Chess Pawn",
    "activity-href": "https://emojipedia.org/chess-pawn/",
    emoji: "♟️",
    emojiName: "♟️ Chess Pawn",
    description:
      "Chess Pawn was approved as part of Unicode 1.1 in 1993 under the name “Black Chess Pawn” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025690-836",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🪩 Mirror Ball",
    "activity-href": "https://emojipedia.org/mirror-ball/",
    emoji: "🪩",
    emojiName: "🪩 Mirror Ball",
    description:
      "A mirror ball, also called a disco ball. A hanging sphere made up of a bunch of tiny mirrors, which reflect spots of light around a room, creating a party atmosphere.",
  },
  {
    "web-scraper-order": "1666025693-837",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧩 Puzzle Piece",
    "activity-href": "https://emojipedia.org/puzzle-piece/",
    emoji: "🧩",
    emojiName: "🧩 Puzzle Piece",
    description:
      "Puzzle Piece was approved as part of Unicode 11.0 in 2018 under the name “Jigsaw Puzzle Piece” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025696-838",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎲 Game Die",
    "activity-href": "https://emojipedia.org/game-die/",
    emoji: "🎲",
    emojiName: "🎲 Game Die",
    description:
      "A six-sided die, used in a range of board and turn-based games. Commonly called dice which refers to the plural of die.",
  },
  {
    "web-scraper-order": "1666025698-839",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎰 Slot Machine",
    "activity-href": "https://emojipedia.org/slot-machine/",
    emoji: "🎰",
    emojiName: "🎰 Slot Machine",
    description:
      "A gambling machine generally found in casinos. Shows three wheels with a lever to the side. Most platforms display three 7 digits on this emoji.",
  },
  {
    "web-scraper-order": "1666025701-840",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎮 Video Game",
    "activity-href": "https://emojipedia.org/video-game/",
    emoji: "🎮",
    emojiName: "🎮 Video Game",
    description:
      "A video game emoji, shown on major platforms as a console gamepad with D-pad, joysticks, and buttons.",
  },
  {
    "web-scraper-order": "1666025704-841",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎱 Pool 8 Ball",
    "activity-href": "https://emojipedia.org/pool-8-ball/",
    emoji: "🎱",
    emojiName: "🎱 Pool 8 Ball",
    description:
      "This emoji displays the black 8 ball on most platforms, which looks similar to the Magic 8-Ball toy. This is despite the fact that emoji was originally created intending to represent game of billiards, of which pool is a common version.",
  },
  {
    "web-scraper-order": "1666025707-842",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎯 Bullseye",
    "activity-href": "https://emojipedia.org/direct-hit/",
    emoji: "🎯",
    emojiName: "🎯 Bullseye",
    description: "A dart board with dart hitting the center / bullseye region.",
  },
  {
    "web-scraper-order": "1666025710-843",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥌 Curling Stone",
    "activity-href": "https://emojipedia.org/curling-stone/",
    emoji: "🥌",
    emojiName: "🥌 Curling Stone",
    description:
      "Curling Stone was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666025713-844",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛷 Sled",
    "activity-href": "https://emojipedia.org/sled/",
    emoji: "🛷",
    emojiName: "🛷 Sled",
    description: "A sled, otherwise known as a toboggan or sledge.",
  },
  {
    "web-scraper-order": "1666025716-845",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎿 Skis",
    "activity-href": "https://emojipedia.org/skis/",
    emoji: "🎿",
    emojiName: "🎿 Skis",
    description:
      "A pair of skis which are shown on some platforms alongside ski poles and/or ski boots. The color and design of the skis varies by platform, with some versions also showing the skis moving at speed.",
  },
  {
    "web-scraper-order": "1666025719-846",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎽 Running Shirt",
    "activity-href": "https://emojipedia.org/running-shirt/",
    emoji: "🎽",
    emojiName: "🎽 Running Shirt",
    description: "A singlet or running shirt. Shown with a sash.",
  },
  {
    "web-scraper-order": "1666025722-847",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎣 Fishing Pole",
    "activity-href": "https://emojipedia.org/fishing-pole/",
    emoji: "🎣",
    emojiName: "🎣 Fishing Pole",
    description: "A fishing rod (pole) with a fish caught on the end.",
  },
  {
    "web-scraper-order": "1666025725-848",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛸️ Ice Skate",
    "activity-href": "https://emojipedia.org/ice-skate/",
    emoji: "⛸️",
    emojiName: "⛸️ Ice Skate",
    description:
      "A single ice skate used for ice skating. Shown in white and facing right on most platforms.",
  },
  {
    "web-scraper-order": "1666025728-849",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛳ Flag in Hole",
    "activity-href": "https://emojipedia.org/flag-in-hole/",
    emoji: "⛳",
    emojiName: "⛳ Flag in Hole",
    description:
      "A red, triangular flag shown sitting in the hole of a golf course green. Some versions of this emoji also include golf balls, with an early iOS design simply depicting a single golf ball.",
  },
  {
    "web-scraper-order": "1666025730-850",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥅 Goal Net",
    "activity-href": "https://emojipedia.org/goal-net/",
    emoji: "🥅",
    emojiName: "🥅 Goal Net",
    description:
      "Goal Net was approved as part of Unicode 9.0 in 2016 and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025732-851",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥋 Martial Arts Uniform",
    "activity-href": "https://emojipedia.org/martial-arts-uniform/",
    emoji: "🥋",
    emojiName: "🥋 Martial Arts Uniform",
    description:
      "A white uniform used in marital arts such as judo or karate. Held together using a material belt. Known as keikogi in Japanese.",
  },
  {
    "web-scraper-order": "1666025735-852",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥊 Boxing Glove",
    "activity-href": "https://emojipedia.org/boxing-glove/",
    emoji: "🥊",
    emojiName: "🥊 Boxing Glove",
    description:
      "A padded boxing glove, used in the sport of boxing. Usually red.",
  },
  {
    "web-scraper-order": "1666025738-853",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏸 Badminton",
    "activity-href": "https://emojipedia.org/badminton/",
    emoji: "🏸",
    emojiName: "🏸 Badminton",
    description:
      "Badminton was approved as part of Unicode 8.0 in 2015 under the name “Badminton Racquet and Shuttlecock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025741-854",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏓 Ping Pong",
    "activity-href": "https://emojipedia.org/ping-pong/",
    emoji: "🏓",
    emojiName: "🏓 Ping Pong",
    description:
      "A paddle and ping pong ball used in the sport of table tennis.",
  },
  {
    "web-scraper-order": "1666025743-855",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥍 Lacrosse",
    "activity-href": "https://emojipedia.org/lacrosse/",
    emoji: "🥍",
    emojiName: "🥍 Lacrosse",
    description:
      "Lacrosse was approved as part of Unicode 11.0 in 2018 under the name “Lacrosse Stick and Ball” and added to Emoji 11.0 in 2018.",
  },
  {
    "web-scraper-order": "1666025746-856",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏒 Ice Hockey",
    "activity-href": "https://emojipedia.org/ice-hockey/",
    emoji: "🏒",
    emojiName: "🏒 Ice Hockey",
    description:
      "A hockey stick and puck, used in the sport of ice hockey. Not to be confused with the field hockey stick and ball.",
  },
  {
    "web-scraper-order": "1666025748-857",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏑 Field Hockey",
    "activity-href": "https://emojipedia.org/field-hockey/",
    emoji: "🏑",
    emojiName: "🏑 Field Hockey",
    description:
      "A hockey stick and ball, used in the sport of field hockey. Not to be confused with the ice hockey stick and puck.",
  },
  {
    "web-scraper-order": "1666025751-858",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏏 Cricket Game",
    "activity-href": "https://emojipedia.org/cricket-game/",
    emoji: "🏏",
    emojiName: "🏏 Cricket Game",
    description:
      "A cricket bat, with a cricket ball also shown. May be displayed with a wicket present.",
  },
  {
    "web-scraper-order": "1666025754-859",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎳 Bowling",
    "activity-href": "https://emojipedia.org/bowling/",
    emoji: "🎳",
    emojiName: "🎳 Bowling",
    description: "Ten-pin bowling emoji, showing a bowling ball and pins.",
  },
  {
    "web-scraper-order": "1666025757-860",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥏 Flying Disc",
    "activity-href": "https://emojipedia.org/flying-disc/",
    emoji: "🥏",
    emojiName: "🥏 Flying Disc",
    description:
      "A flying disc, more commonly known as a frisbee. Used in the sport of Ultimate or disc golf.",
  },
  {
    "web-scraper-order": "1666025760-861",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎾 Tennis",
    "activity-href": "https://emojipedia.org/tennis/",
    emoji: "🎾",
    emojiName: "🎾 Tennis",
    description:
      "A tennis racket (racquet) with a tennis ball. Only a ball is shown on certain platforms, including Apple, Twitter, and WhatsApp.",
  },
  {
    "web-scraper-order": "1666025763-862",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏉 Rugby Football",
    "activity-href": "https://emojipedia.org/rugby-football/",
    emoji: "🏉",
    emojiName: "🏉 Rugby Football",
    description:
      "The oval-shaped ball used in the game of rugby. Varies slightly in shape in the two main versions of the game: rugby union and rugby league.",
  },
  {
    "web-scraper-order": "1666025765-863",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏈 American Football",
    "activity-href": "https://emojipedia.org/american-football/",
    emoji: "🏈",
    emojiName: "🏈 American Football",
    description:
      "The oval ball used in the game of American football, known as gridiron in some countries.",
  },
  {
    "web-scraper-order": "1666025768-864",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏐 Volleyball",
    "activity-href": "https://emojipedia.org/volleyball/",
    emoji: "🏐",
    emojiName: "🏐 Volleyball",
    description:
      "A volleyball emoji, showing the round ball used in the sport. Played as part of the Summer Olympic Games.",
  },
  {
    "web-scraper-order": "1666025770-865",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏀 Basketball",
    "activity-href": "https://emojipedia.org/basketball/",
    emoji: "🏀",
    emojiName: "🏀 Basketball",
    description:
      "An orange-colored basketball. Originally intended to display as a basketball and a hoop, as per previous designs by Google, Samsung, and Microsoft.",
  },
  {
    "web-scraper-order": "1666025773-866",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥎 Softball",
    "activity-href": "https://emojipedia.org/softball/",
    emoji: "🥎",
    emojiName: "🥎 Softball",
    description:
      "A softball, which is differentiated from a baseball by size (it is larger, though hard to tell in emoji form) and color (yellow, not white).",
  },
  {
    "web-scraper-order": "1666025776-867",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⚾ Baseball",
    "activity-href": "https://emojipedia.org/baseball/",
    emoji: "⚾",
    emojiName: "⚾ Baseball",
    description:
      "A white baseball, with regulation red stitching. Used in the game of the same name, baseball.",
  },
  {
    "web-scraper-order": "1666025779-868",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⚽ Soccer Ball",
    "activity-href": "https://emojipedia.org/soccer-ball/",
    emoji: "⚽",
    emojiName: "⚽ Soccer Ball",
    description:
      "A round, black and white ball used in the game of soccer, which is known as football in much of the world. See also: emojis for the World Cup.",
  },
  {
    "web-scraper-order": "1666025781-869",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥉 3rd Place Medal",
    "activity-href": "https://emojipedia.org/3rd-place-medal/",
    emoji: "🥉",
    emojiName: "🥉 3rd Place Medal",
    description:
      "3rd Place Medal was approved as part of Unicode 9.0 in 2016 under the name “Third Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025784-870",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥈 2nd Place Medal",
    "activity-href": "https://emojipedia.org/2nd-place-medal/",
    emoji: "🥈",
    emojiName: "🥈 2nd Place Medal",
    description:
      "2nd Place Medal was approved as part of Unicode 9.0 in 2016 under the name “Second Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025786-871",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🥇 1st Place Medal",
    "activity-href": "https://emojipedia.org/1st-place-medal/",
    emoji: "🥇",
    emojiName: "🥇 1st Place Medal",
    description:
      "1st Place Medal was approved as part of Unicode 9.0 in 2016 under the name “First Place Medal” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025789-872",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏅 Sports Medal",
    "activity-href": "https://emojipedia.org/sports-medal/",
    emoji: "🏅",
    emojiName: "🏅 Sports Medal",
    description:
      "A gold medal, given to a person who has won a sporting event, such as a race. Not to be confused with the military medal emoji.",
  },
  {
    "web-scraper-order": "1666025792-873",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏆 Trophy",
    "activity-href": "https://emojipedia.org/trophy/",
    emoji: "🏆",
    emojiName: "🏆 Trophy",
    description:
      "A trophy given as an recognition of achievement, usually in sports. The trophy emoji is a gold cup, with a engraving on the bottom detailing the award.",
  },
  {
    "web-scraper-order": "1666025794-874",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎖️ Military Medal",
    "activity-href": "https://emojipedia.org/military-medal/",
    emoji: "🎖️",
    emojiName: "🎖️ Military Medal",
    description:
      "A ribbon and medallion generally awarded to a person in the military for heroic acts.",
  },
  {
    "web-scraper-order": "1666025797-875",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎫 Ticket",
    "activity-href": "https://emojipedia.org/ticket/",
    emoji: "🎫",
    emojiName: "🎫 Ticket",
    description:
      "A paper ticket, which may be for a theatre show, sporting event, or other ticketed performance. Shown in blue, yellow or grey on most platforms.",
  },
  {
    "web-scraper-order": "1666025800-876",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎟️ Admission Tickets",
    "activity-href": "https://emojipedia.org/admission-tickets/",
    emoji: "🎟️",
    emojiName: "🎟️ Admission Tickets",
    description:
      'A ticket or tickets to an event that may say "Admit One" on the front. Shown in pink or yellow on most platforms.',
  },
  {
    "web-scraper-order": "1666025802-877",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎗️ Reminder Ribbon",
    "activity-href": "https://emojipedia.org/reminder-ribbon/",
    emoji: "🎗️",
    emojiName: "🎗️ Reminder Ribbon",
    description:
      "An awareness ribbon, worn to show support of a cause or group.",
  },
  {
    "web-scraper-order": "1666025805-878",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛶 Canoe",
    "activity-href": "https://emojipedia.org/canoe/",
    emoji: "🛶",
    emojiName: "🛶 Canoe",
    description:
      "Canoe was approved as part of Unicode 9.0 in 2016 and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025810-879",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛼 Roller Skate",
    "activity-href": "https://emojipedia.org/roller-skate/",
    emoji: "🛼",
    emojiName: "🛼 Roller Skate",
    description:
      "A single vibrantly colored roller skate. Colors and styles vary across platform.",
  },
  {
    "web-scraper-order": "1666025815-881",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🛹 Skateboard",
    "activity-href": "https://emojipedia.org/skateboard/",
    emoji: "🛹",
    emojiName: "🛹 Skateboard",
    description: "A skateboard emoji, usually showing the board from the top.",
  },
  {
    "web-scraper-order": "1666025818-883",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🎪 Circus Tent",
    "activity-href": "https://emojipedia.org/circus-tent/",
    emoji: "🎪",
    emojiName: "🎪 Circus Tent",
    description:
      "A circular ‘big top’ circus tent, with a triangle flag on top.",
  },
  {
    "web-scraper-order": "1666025823-885",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘‍♀️ Woman in Lotus Position",
    "activity-href": "https://emojipedia.org/woman-in-lotus-position/",
    emoji: "🧘‍♀️",
    emojiName: "🧘‍♀️ Woman in Lotus Position",
    description:
      "The Woman in Lotus Position emoji is a ZWJ sequence combining 🧘 Person in Lotus Position, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025828-888",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘‍♂️ Man in Lotus Position",
    "activity-href": "https://emojipedia.org/man-in-lotus-position/",
    emoji: "🧘‍♂️",
    emojiName: "🧘‍♂️ Man in Lotus Position",
    description:
      "The Man in Lotus Position emoji is a ZWJ sequence combining 🧘 Person in Lotus Position, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025833-890",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧘 Person in Lotus Position",
    "activity-href": "https://emojipedia.org/person-in-lotus-position/",
    emoji: "🧘",
    emojiName: "🧘 Person in Lotus Position",
    description:
      "Person in Lotus Position was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666025840-894",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹‍♀️ Woman Juggling",
    "activity-href": "https://emojipedia.org/woman-juggling/",
    emoji: "🤹‍♀️",
    emojiName: "🤹‍♀️ Woman Juggling",
    description:
      "The Woman Juggling emoji is a ZWJ sequence combining 🤹 Person Juggling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025845-897",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹‍♂️ Man Juggling",
    "activity-href": "https://emojipedia.org/man-juggling/",
    emoji: "🤹‍♂️",
    emojiName: "🤹‍♂️ Man Juggling",
    description:
      "The Man Juggling emoji is a ZWJ sequence combining 🤹 Person Juggling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025851-898",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤹 Person Juggling",
    "activity-href": "https://emojipedia.org/person-juggling/",
    emoji: "🤹",
    emojiName: "🤹 Person Juggling",
    description:
      "A person juggling between three and five colored balls. The person shown in this emoji wears a hat on most major platforms.",
  },
  {
    "web-scraper-order": "1666025855-899",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾‍♀️ Woman Playing Handball",
    "activity-href": "https://emojipedia.org/woman-playing-handball/",
    emoji: "🤾‍♀️",
    emojiName: "🤾‍♀️ Woman Playing Handball",
    description:
      "The Woman Playing Handball emoji is a ZWJ sequence combining 🤾 Person Playing Handball, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025859-900",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾‍♂️ Man Playing Handball",
    "activity-href": "https://emojipedia.org/man-playing-handball/",
    emoji: "🤾‍♂️",
    emojiName: "🤾‍♂️ Man Playing Handball",
    description:
      "The Man Playing Handball emoji is a ZWJ sequence combining 🤾 Person Playing Handball, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025862-902",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤾 Person Playing Handball",
    "activity-href": "https://emojipedia.org/person-playing-handball/",
    emoji: "🤾",
    emojiName: "🤾 Person Playing Handball",
    description:
      "Person Playing Handball was approved as part of Unicode 9.0 in 2016 under the name “Handball” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025868-905",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽‍♀️ Woman Playing Water Polo",
    "activity-href": "https://emojipedia.org/woman-playing-water-polo/",
    emoji: "🤽‍♀️",
    emojiName: "🤽‍♀️ Woman Playing Water Polo",
    description:
      "The Woman Playing Water Polo emoji is a ZWJ sequence combining 🤽 Person Playing Water Polo, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025874-907",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽‍♂️ Man Playing Water Polo",
    "activity-href": "https://emojipedia.org/man-playing-water-polo/",
    emoji: "🤽‍♂️",
    emojiName: "🤽‍♂️ Man Playing Water Polo",
    description:
      "The Man Playing Water Polo emoji is a ZWJ sequence combining 🤽 Person Playing Water Polo, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025877-909",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤽 Person Playing Water Polo",
    "activity-href": "https://emojipedia.org/person-playing-water-polo/",
    emoji: "🤽",
    emojiName: "🤽 Person Playing Water Polo",
    description:
      "A person shown in water with a ball, playing the sport of water polo.",
  },
  {
    "web-scraper-order": "1666025883-911",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼‍♀️ Women Wrestling",
    "activity-href": "https://emojipedia.org/women-wrestling/",
    emoji: "🤼‍♀️",
    emojiName: "🤼‍♀️ Women Wrestling",
    description:
      "The Women Wrestling emoji is a ZWJ sequence combining 🤼 People Wrestling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025888-913",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼‍♂️ Men Wrestling",
    "activity-href": "https://emojipedia.org/men-wrestling/",
    emoji: "🤼‍♂️",
    emojiName: "🤼‍♂️ Men Wrestling",
    description:
      "The Men Wrestling emoji is a ZWJ sequence combining 🤼 People Wrestling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025894-916",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤼 People Wrestling",
    "activity-href": "https://emojipedia.org/people-wrestling/",
    emoji: "🤼",
    emojiName: "🤼 People Wrestling",
    description: "Two people in the sport of wrestling.",
  },
  {
    "web-scraper-order": "1666025898-917",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸‍♀️ Woman Cartwheeling",
    "activity-href": "https://emojipedia.org/woman-cartwheeling/",
    emoji: "🤸‍♀️",
    emojiName: "🤸‍♀️ Woman Cartwheeling",
    description:
      "The Woman Cartwheeling emoji is a ZWJ sequence combining 🤸 Person Cartwheeling, ‍ Zero Width Joiner and ♀️ Female Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025902-919",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸‍♂️ Man Cartwheeling",
    "activity-href": "https://emojipedia.org/man-cartwheeling/",
    emoji: "🤸‍♂️",
    emojiName: "🤸‍♂️ Man Cartwheeling",
    description:
      "The Man Cartwheeling emoji is a ZWJ sequence combining 🤸 Person Cartwheeling, ‍ Zero Width Joiner and ♂️ Male Sign.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666025906-921",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤸 Person Cartwheeling",
    "activity-href": "https://emojipedia.org/person-cartwheeling/",
    emoji: "🤸",
    emojiName: "🤸 Person Cartwheeling",
    description:
      "A person doing a cartwheel, representing the sport of gymnastics.",
  },
  {
    "web-scraper-order": "1666025912-923",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵‍♀️ Woman Mountain Biking",
    "activity-href": "https://emojipedia.org/woman-mountain-biking/",
    emoji: "🚵‍♀️",
    emojiName: "🚵‍♀️ Woman Mountain Biking",
    description: "The female version of the 🚵 Mountain Bicyclist emoji.",
  },
  {
    "web-scraper-order": "1666025918-926",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵‍♂️ Man Mountain Biking",
    "activity-href": "https://emojipedia.org/man-mountain-biking/",
    emoji: "🚵‍♂️",
    emojiName: "🚵‍♂️ Man Mountain Biking",
    description:
      "The male version of the 🚵 Mountain Bicyclist emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025923-928",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚵 Person Mountain Biking",
    "activity-href": "https://emojipedia.org/person-mountain-biking/",
    emoji: "🚵",
    emojiName: "🚵 Person Mountain Biking",
    description:
      "A person (cyclist) who rides a mountain bike: a type of off-road bicycle. Intended to be gender-neutral.",
  },
  {
    "web-scraper-order": "1666025928-930",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴‍♀️ Woman Biking",
    "activity-href": "https://emojipedia.org/woman-biking/",
    emoji: "🚴‍♀️",
    emojiName: "🚴‍♀️ Woman Biking",
    description: "The female version of the 🚴 Bicyclist emoji.",
  },
  {
    "web-scraper-order": "1666025933-932",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴‍♂️ Man Biking",
    "activity-href": "https://emojipedia.org/man-biking/",
    emoji: "🚴‍♂️",
    emojiName: "🚴‍♂️ Man Biking",
    description:
      "The male version of the 🚴 Bicyclist emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025937-934",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚴 Person Biking",
    "activity-href": "https://emojipedia.org/person-biking/",
    emoji: "🚴",
    emojiName: "🚴 Person Biking",
    description:
      "A person riding a bicycle for leisure, sport or transport. Intended to be gender-neutral.",
  },
  {
    "web-scraper-order": "1666025943-937",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️‍♀️ Woman Lifting Weights",
    "activity-href": "https://emojipedia.org/woman-lifting-weights/",
    emoji: "🏋️‍♀️",
    emojiName: "🏋️‍♀️ Woman Lifting Weights",
    description: "The female version of the 🏋 Weight Lifter emoji.",
  },
  {
    "web-scraper-order": "1666025946-940",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️‍♂️ Man Lifting Weights",
    "activity-href": "https://emojipedia.org/man-lifting-weights/",
    emoji: "🏋️‍♂️",
    emojiName: "🏋️‍♂️ Man Lifting Weights",
    description:
      "The male version of the 🏋 Weight Lifter emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025950-944",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏋️ Person Lifting Weights",
    "activity-href": "https://emojipedia.org/person-lifting-weights/",
    emoji: "🏋️",
    emojiName: "🏋️ Person Lifting Weights",
    description:
      "A person lifting a barbell loaded with weights above their head.",
  },
  {
    "web-scraper-order": "1666025959-947",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️‍♀️ Woman Bouncing Ball",
    "activity-href": "https://emojipedia.org/woman-bouncing-ball/",
    emoji: "⛹️‍♀️",
    emojiName: "⛹️‍♀️ Woman Bouncing Ball",
    description: "The female version of the ⛹ Person With Ball emoji.",
  },
  {
    "web-scraper-order": "1666025963-952",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️‍♂️ Man Bouncing Ball",
    "activity-href": "https://emojipedia.org/man-bouncing-ball/",
    emoji: "⛹️‍♂️",
    emojiName: "⛹️‍♂️ Man Bouncing Ball",
    description:
      "The male version of the ⛹ Person With Ball emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025967-956",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛹️ Person Bouncing Ball",
    "activity-href": "https://emojipedia.org/person-bouncing-ball/",
    emoji: "⛹️",
    emojiName: "⛹️ Person Bouncing Ball",
    description:
      "A person with a ball, which is generally displayed as a basketballer running and dribbling (bouncing) the basketball.",
  },
  {
    "web-scraper-order": "1666025970-960",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊‍♀️ Woman Swimming",
    "activity-href": "https://emojipedia.org/woman-swimming/",
    emoji: "🏊‍♀️",
    emojiName: "🏊‍♀️ Woman Swimming",
    description: "The female version of the 🏊 Swimmer emoji.",
  },
  {
    "web-scraper-order": "1666025974-965",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊‍♂️ Man Swimming",
    "activity-href": "https://emojipedia.org/man-swimming/",
    emoji: "🏊‍♂️",
    emojiName: "🏊‍♂️ Man Swimming",
    description:
      "The male version of the 🏊 Swimmer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025978-967",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏊 Person Swimming",
    "activity-href": "https://emojipedia.org/person-swimming/",
    emoji: "🏊",
    emojiName: "🏊 Person Swimming",
    description:
      "A person swimming in a pool, the ocean, or another body of water. Lacked goggles on prior versions of iOS.",
  },
  {
    "web-scraper-order": "1666025981-971",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣‍♀️ Woman Rowing Boat",
    "activity-href": "https://emojipedia.org/woman-rowing-boat/",
    emoji: "🚣‍♀️",
    emojiName: "🚣‍♀️ Woman Rowing Boat",
    description: "The female version of the 🚣 Rowboat emoji.",
  },
  {
    "web-scraper-order": "1666025984-974",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣‍♂️ Man Rowing Boat",
    "activity-href": "https://emojipedia.org/man-rowing-boat/",
    emoji: "🚣‍♂️",
    emojiName: "🚣‍♂️ Man Rowing Boat",
    description:
      "The male version of the 🚣 Rowboat emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025986-977",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🚣 Person Rowing Boat",
    "activity-href": "https://emojipedia.org/person-rowing-boat/",
    emoji: "🚣",
    emojiName: "🚣 Person Rowing Boat",
    description:
      "A small rowboat suitable for a small number of people. Couples or families sometimes hire these as an activity on calm waters.",
  },
  {
    "web-scraper-order": "1666025991-982",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄‍♀️ Woman Surfing",
    "activity-href": "https://emojipedia.org/woman-surfing/",
    emoji: "🏄‍♀️",
    emojiName: "🏄‍♀️ Woman Surfing",
    description: "The female version of the 🏄 Surfer emoji.",
  },
  {
    "web-scraper-order": "1666025995-985",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄‍♂️ Man Surfing",
    "activity-href": "https://emojipedia.org/man-surfing/",
    emoji: "🏄‍♂️",
    emojiName: "🏄‍♂️ Man Surfing",
    description:
      "The male version of the 🏄 Surfer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666025998-988",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏄 Person Surfing",
    "activity-href": "https://emojipedia.org/person-surfing/",
    emoji: "🏄",
    emojiName: "🏄 Person Surfing",
    description:
      "A person on a surfboard, riding on a wave in the ocean. Wears a wetsuit or board shorts in most versions.",
  },
  {
    "web-scraper-order": "1666026002-992",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️‍♀️ Woman Golfing",
    "activity-href": "https://emojipedia.org/woman-golfing/",
    emoji: "🏌️‍♀️",
    emojiName: "🏌️‍♀️ Woman Golfing",
    description: "The female version of the 🏌 Golfer emoji.",
  },
  {
    "web-scraper-order": "1666026006-995",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️‍♂️ Man Golfing",
    "activity-href": "https://emojipedia.org/man-golfing/",
    emoji: "🏌️‍♂️",
    emojiName: "🏌️‍♂️ Man Golfing",
    description:
      "The male version of the 🏌 Golfer emoji. Currently identical in appearance to the non-gendered base emoji.",
  },
  {
    "web-scraper-order": "1666026010-1000",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏌️ Person Golfing",
    "activity-href": "https://emojipedia.org/person-golfing/",
    emoji: "🏌️",
    emojiName: "🏌️ Person Golfing",
    description:
      "A person swinging a golf club, attempting to hit a golf ball toward the flag on the green.",
  },
  {
    "web-scraper-order": "1666026014-1004",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏂 Snowboarder",
    "activity-href": "https://emojipedia.org/snowboarder/",
    emoji: "🏂",
    emojiName: "🏂 Snowboarder",
    description:
      "A person snowboarding downhill at a ski resort. Wearing clothing designed for cold climates.",
  },
  {
    "web-scraper-order": "1666026017-1007",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "⛷️ Skier",
    "activity-href": "https://emojipedia.org/skier/",
    emoji: "⛷️",
    emojiName: "⛷️ Skier",
    description:
      "A person downhill-skiiing. Displayed with poles and skis, generally wearing a mask.",
  },
  {
    "web-scraper-order": "1666026021-1011",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🏇 Horse Racing",
    "activity-href": "https://emojipedia.org/horse-racing/",
    emoji: "🏇",
    emojiName: "🏇 Horse Racing",
    description:
      "A jockey riding a horse in a horse race. Shown riding to the left of screen on all major platforms. Emoji modifiers change the skin tone of the jockey on some platforms, which can be difficult to discern at small sizes.",
  },
  {
    "web-scraper-order": "1666026025-1014",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🤺 Person Fencing",
    "activity-href": "https://emojipedia.org/person-fencing/",
    emoji: "🤺",
    emojiName: "🤺 Person Fencing",
    description:
      "A person shown in the sport of fencing, with a Rapier-style sword, mask, and protective clothing.",
  },
  {
    "web-scraper-order": "1666026030-1018",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗‍♀️ Woman Climbing",
    "activity-href": "https://emojipedia.org/woman-climbing/",
    emoji: "🧗‍♀️",
    emojiName: "🧗‍♀️ Woman Climbing",
    description:
      "A female rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet, and/or rope.",
  },
  {
    "web-scraper-order": "1666026034-1023",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗‍♂️ Man Climbing",
    "activity-href": "https://emojipedia.org/man-climbing/",
    emoji: "🧗‍♂️",
    emojiName: "🧗‍♂️ Man Climbing",
    description:
      "A male rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet, and/or rope.",
  },
  {
    "web-scraper-order": "1666026038-1027",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🧗 Person Climbing",
    "activity-href": "https://emojipedia.org/person-climbing/",
    emoji: "🧗",
    emojiName: "🧗 Person Climbing",
    description:
      "A rock climber, shown climbing up a rock formation. Some platforms show the climber with a helmet and/or rope. The Emojipedia Sample image was created with assistance from World Champion Rock Climber Sasha DiGiulian.",
  },
  {
    "web-scraper-order": "1666026040-1030",
    "web-scraper-start-url": "https://emojipedia.org/activity/",
    activity: "🕴️ Person in Suit Levitating",
    "activity-href": "https://emojipedia.org/person-in-suit-levitating/",
    emoji: "🕴️",
    emojiName: "🕴️ Person in Suit Levitating",
    description:
      "A person wearing a suit, hovering above the ground with a shadow displayed beneath them. Generally shown wearing a fedora or similar style of hat.",
  },
  {
    "web-scraper-order": "1666017682-484",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🫧 Bubbles",
    "name-href": "https://emojipedia.org/bubbles/",
    emoji: "🫧",
    emojiName: "🫧 Bubbles",
    description:
      "A few floating bubbles. May be used to represent soap suds, carbonation, or an effervescent personality.",
  },
  {
    "web-scraper-order": "1666017685-485",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎍 Pine Decoration",
    "name-href": "https://emojipedia.org/pine-decoration/",
    emoji: "🎍",
    emojiName: "🎍 Pine Decoration",
    description:
      "A Japanese kadomatsu, composed of pine leaves and bamboo shoots. Traditionally placed outside homes in Japan around the New Year to welcome spirits for a plentiful, happy year ahead.",
  },
  {
    "web-scraper-order": "1666017687-486",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎋 Tanabata Tree",
    "name-href": "https://emojipedia.org/tanabata-tree/",
    emoji: "🎋",
    emojiName: "🎋 Tanabata Tree",
    description:
      "A Tanabata tree, a type of wish tree on which people hang wishes written on paper and other decorations during Tanabata, a Japanese festival celebrating two heavenly lovers. Depicted as one or two stalks of green bamboo, on which hangs one or more slips of paper, generally red.",
  },
  {
    "web-scraper-order": "1666017690-487",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "✨ Sparkles",
    "name-href": "https://emojipedia.org/sparkles/",
    emoji: "✨",
    emojiName: "✨ Sparkles",
    description:
      "The glittering flashes of sparkles. Generally depicted as a cluster of three, yellow four-point stars, with one large sparkle and two small ones to its left or right.",
  },
  {
    "web-scraper-order": "1666017693-488",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🎄 Christmas Tree",
    "name-href": "https://emojipedia.org/christmas-tree/",
    emoji: "🎄",
    emojiName: "🎄 Christmas Tree",
    description:
      "A classic Christmas tree, an evergreen tree decorated with lights and ornaments to celebrate Christmas.  Depicted with round, variously colored ornaments and topped with a yellow star.",
  },
  {
    "web-scraper-order": "1666017697-489",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌊 Water Wave",
    "name-href": "https://emojipedia.org/water-wave/",
    emoji: "🌊",
    emojiName: "🌊 Water Wave",
    description:
      "A wave of water, as breaks at the beach. Depicted as a blue wave with a foamy, white crest, curling to the right.",
  },
  {
    "web-scraper-order": "1666017699-490",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💧 Droplet",
    "name-href": "https://emojipedia.org/droplet/",
    emoji: "💧",
    emojiName: "💧 Droplet",
    description: "A single, light blue droplet, as of water, sweat, or tears.",
  },
  {
    "web-scraper-order": "1666017703-491",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🔥 Fire",
    "name-href": "https://emojipedia.org/fire/",
    emoji: "🔥",
    emojiName: "🔥 Fire",
    description:
      "A flame, as produced when something is on fire. Depicted as a red, orange, and yellow flickering flame.",
  },
  {
    "web-scraper-order": "1666017706-492",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☄️ Comet",
    "name-href": "https://emojipedia.org/comet/",
    emoji: "☄️",
    emojiName: "☄️ Comet",
    description:
      "A comet, an icy, rocky space object that can form a tail of gas and dust when near the sun. Generally depicted as an icy-blue comet, as if streaking downwards in a night sky.",
  },
  {
    "web-scraper-order": "1666017710-493",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛄ Snowman Without Snow",
    "name-href": "https://emojipedia.org/snowman-without-snow/",
    emoji: "⛄",
    emojiName: "⛄ Snowman Without Snow",
    description:
      "A classic snowman, as Frosty the Snowman. Depicted as a snowman, facing forward, made from two or three large snowballs and stick arms, dressed with a top hat, a carrot nose, coal eyes, and two or three buttons on its torso. Sometimes shown with a smile and a red scarf.",
  },
  {
    "web-scraper-order": "1666017715-494",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☃️ Snowman",
    "name-href": "https://emojipedia.org/snowman/",
    emoji: "☃️",
    emojiName: "☃️ Snowman",
    description:
      "A classic snowman, as Frosty the Snowman, with snowflakes falling on it. Depicted as a snowman, facing forward, made from two or three large snowballs and stick arms, dressed with a top hat, a carrot nose, coal eyes, and two or three buttons on its torso. Sometimes shown with a smile and a red scarf.",
  },
  {
    "web-scraper-order": "1666017719-495",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "❄️ Snowflake",
    "name-href": "https://emojipedia.org/snowflake/",
    emoji: "❄️",
    emojiName: "❄️ Snowflake",
    description:
      "The unique, feathery ice crystal of a snowflake. Depicted as a bluish-white snowflake with six intricate symmetrical branches.",
  },
  {
    "web-scraper-order": "1666017721-496",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⚡ High Voltage",
    "name-href": "https://emojipedia.org/high-voltage/",
    emoji: "⚡",
    emojiName: "⚡ High Voltage",
    description:
      "A symbol for high voltage, as warns against injury from electricity. Depicted as a jagged yellow bolt.",
  },
  {
    "web-scraper-order": "1666017725-497",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☔ Umbrella with Rain Drops",
    "name-href": "https://emojipedia.org/umbrella-with-rain-drops/",
    emoji: "☔",
    emojiName: "☔ Umbrella with Rain Drops",
    description:
      "An umbrella, opened to provide cover from rain. Generally depicted with purple fabric and a hooked handle with several rain droplets falling on its top.",
  },
  {
    "web-scraper-order": "1666017729-498",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☂️ Umbrella",
    "name-href": "https://emojipedia.org/umbrella/",
    emoji: "☂️",
    emojiName: "☂️ Umbrella",
    description:
      "An opened, dry umbrella. Generally depicted with purple fabric and a hooked handle.",
  },
  {
    "web-scraper-order": "1666017732-499",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌈 Rainbow",
    "name-href": "https://emojipedia.org/rainbow/",
    emoji: "🌈",
    emojiName: "🌈 Rainbow",
    description:
      "The colorful arc of a rainbow, as may appear after rain. Generally depicted as the left half of a full rainbow, showing six bands of color: red, orange, yellow, green, blue, and violet.",
  },
  {
    "web-scraper-order": "1666017738-500",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌬️ Wind Face",
    "name-href": "https://emojipedia.org/wind-face/",
    emoji: "🌬️",
    emojiName: "🌬️ Wind Face",
    description:
      "A face blowing the wind, as a personification of nature (e.g., Mother Nature, the North Wind) who creates the wind by blowing air from its mouth. Depicted as a gray, profile of a human face, generally with a feminine appearance, blowing swirls from her mouth to the right.",
  },
  {
    "web-scraper-order": "1666017741-501",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌫️ Fog",
    "name-href": "https://emojipedia.org/fog/",
    emoji: "🌫️",
    emojiName: "🌫️ Fog",
    description:
      "Fog, as obscures visibility. Generally depicted as a square of a gray, hazy, cloud-like mass.",
  },
  {
    "web-scraper-order": "1666017746-502",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌪️ Tornado",
    "name-href": "https://emojipedia.org/tornado/",
    emoji: "🌪️",
    emojiName: "🌪️ Tornado",
    description:
      "A tornado, a destructive column of air. Depicted as a gray, funnel-shaped cloud, rotating in contact with the ground.",
  },
  {
    "web-scraper-order": "1666017751-503",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌩️ Cloud with Lightning",
    "name-href": "https://emojipedia.org/cloud-with-lightning/",
    emoji: "🌩️",
    emojiName: "🌩️ Cloud with Lightning",
    description:
      "A thundercloud. Depicted as a yellow lightning bolt flashing from a white cloud.",
  },
  {
    "web-scraper-order": "1666017755-504",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌨️ Cloud with Snow",
    "name-href": "https://emojipedia.org/cloud-with-snow/",
    emoji: "🌨️",
    emojiName: "🌨️ Cloud with Snow",
    description:
      "A snow cloud. Depicted as blue snowflakes falling from a white cloud.",
  },
  {
    "web-scraper-order": "1666017759-505",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌧️ Cloud with Rain",
    "name-href": "https://emojipedia.org/cloud-with-rain/",
    emoji: "🌧️",
    emojiName: "🌧️ Cloud with Rain",
    description:
      "A rain cloud. (Keep dry with ☔ Umbrella With Rain Drops.) Depicted as blue raindrops falling from a white cloud. Most platforms depict the raindrops falling to the left.",
  },
  {
    "web-scraper-order": "1666017762-506",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌦️ Sun Behind Rain Cloud",
    "name-href": "https://emojipedia.org/sun-behind-rain-cloud/",
    emoji: "🌦️",
    emojiName: "🌦️ Sun Behind Rain Cloud",
    description:
      "A yellow sun half covered by a white rain cloud with blue raindrops. Most platforms depict the raindrops falling to the left. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017767-507",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌥️ Sun Behind Large Cloud",
    "name-href": "https://emojipedia.org/sun-behind-large-cloud/",
    emoji: "🌥️",
    emojiName: "🌥️ Sun Behind Large Cloud",
    description:
      "A yellow sun mostly covered by a large, white cloud. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017771-508",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌤️ Sun Behind Small Cloud",
    "name-href": "https://emojipedia.org/sun-behind-small-cloud/",
    emoji: "🌤️",
    emojiName: "🌤️ Sun Behind Small Cloud",
    description:
      "A yellow sun partially covered by a small, white cloud. Position of the cloud varies across platforms.",
  },
  {
    "web-scraper-order": "1666017776-509",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛈️ Cloud with Lightning and Rain",
    "name-href": "https://emojipedia.org/cloud-with-lightning-and-rain/",
    emoji: "⛈️",
    emojiName: "⛈️ Cloud with Lightning and Rain",
    description:
      "Blue raindrops falling from a white cloud with a lightning bolt flashing.",
  },
  {
    "web-scraper-order": "1666017781-510",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⛅ Sun Behind Cloud",
    "name-href": "https://emojipedia.org/sun-behind-cloud/",
    emoji: "⛅",
    emojiName: "⛅ Sun Behind Cloud",
    description:
      "A yellow sun half covered by a white cloud. Position of the sun varies across platforms.",
  },
  {
    "web-scraper-order": "1666017785-511",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☁️ Cloud",
    "name-href": "https://emojipedia.org/cloud/",
    emoji: "☁️",
    emojiName: "☁️ Cloud",
    description:
      "A fluffy, white cloud, as a cumulus. May be used as a weather icon to represent a cloudy or overcast day.",
  },
  {
    "web-scraper-order": "1666017789-512",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌠 Shooting Star",
    "name-href": "https://emojipedia.org/shooting-star/",
    emoji: "🌠",
    emojiName: "🌠 Shooting Star",
    description:
      "A stylized representation of a shooting star, a small, fast meteor that burns up in the atmosphere. Generally depicted as a gold, five-point star trailing yellow motion lines against a night sky, as if moving down to the left.",
  },
  {
    "web-scraper-order": "1666017792-513",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌟 Glowing Star",
    "name-href": "https://emojipedia.org/glowing-star/",
    emoji: "🌟",
    emojiName: "🌟 Glowing Star",
    description:
      "A glowing, five-point gold star. Depicted as ⭐ Star with stylized bursts in between its points, representing glowing or twinkling.",
  },
  {
    "web-scraper-order": "1666017795-514",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "⭐ Star",
    "name-href": "https://emojipedia.org/star/",
    emoji: "⭐",
    emojiName: "⭐ Star",
    description: "A classic, five-point gold star.",
  },
  {
    "web-scraper-order": "1666017801-515",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌞 Sun with Face",
    "name-href": "https://emojipedia.org/sun-with-face/",
    emoji: "🌞",
    emojiName: "🌞 Sun with Face",
    description:
      "A sun with a smiling face, as a Sun of May. Generally depicted as a golden-yellow disc with a smiling, often human face with a nose, radiating triangular rays, representing the sun's heat and light.",
  },
  {
    "web-scraper-order": "1666017806-516",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌝 Full Moon Face",
    "name-href": "https://emojipedia.org/full-moon-face/",
    emoji: "🌝",
    emojiName: "🌝 Full Moon Face",
    description:
      "A full moon with a smiling face, as the Man in the Moon. Generally depicts the moon as a dark disc with a slightly smiling human face and nose.",
  },
  {
    "web-scraper-order": "1666017810-517",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☀️ Sun",
    "name-href": "https://emojipedia.org/sun/",
    emoji: "☀️",
    emojiName: "☀️ Sun",
    description:
      "The sun, the star at the center of our solar system. Generally depicted as a golden-yellow disc radiating eight triangular rays, representing the sun’s heat and light.",
  },
  {
    "web-scraper-order": "1666017814-518",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌜 Last Quarter Moon Face",
    "name-href": "https://emojipedia.org/last-quarter-moon-face/",
    emoji: "🌜",
    emojiName: "🌜 Last Quarter Moon Face",
    description:
      "A last quarter moon with a human face, as the Man in the Moon. Generally depicts a wide, golden crescent moon with the profile of slightly smiling human face with a nose, facing right.",
  },
  {
    "web-scraper-order": "1666017818-519",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌛 First Quarter Moon Face",
    "name-href": "https://emojipedia.org/first-quarter-moon-face/",
    emoji: "🌛",
    emojiName: "🌛 First Quarter Moon Face",
    description:
      "A first quarter moon with a human face, as the Man in the Moon. Generally depicts a wide, golden crescent moon with the profile of a slightly smiling human face with a nose, facing left.",
  },
  {
    "web-scraper-order": "1666017823-520",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌚 New Moon Face",
    "name-href": "https://emojipedia.org/new-moon-face/",
    emoji: "🌚",
    emojiName: "🌚 New Moon Face",
    description:
      "A new moon with a smiling face, as the Man in the Moon. Generally depicts the moon as a dark disc with a slightly smiling human face and nose.",
  },
  {
    "web-scraper-order": "1666017825-521",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌙 Crescent Moon",
    "name-href": "https://emojipedia.org/crescent-moon/",
    emoji: "🌙",
    emojiName: "🌙 Crescent Moon",
    description:
      "A crescent moon, as in its waxing crescent phase. Depicts the moon as a thin, golden crescent, curving to the right and not displaying the remaining outline of the moon.",
  },
  {
    "web-scraper-order": "1666017828-522",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌘 Waning Crescent Moon",
    "name-href": "https://emojipedia.org/waning-crescent-moon/",
    emoji: "🌘",
    emojiName: "🌘 Waning Crescent Moon",
    description:
      "A waning crescent moon (appearing to become smaller), the last of the phases of the moon. Depicts the moon as a cratered disc, its left side illuminated in a thin, golden or silver crescent, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017831-523",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌗 Last Quarter Moon",
    "name-href": "https://emojipedia.org/last-quarter-moon/",
    emoji: "🌗",
    emojiName: "🌗 Last Quarter Moon",
    description:
      "A last quarter moon, the seventh of the eight phases of the moon. Depicts the moon as a cratered disc, its left side half illuminated in gold or silver, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017833-524",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌖 Waning Gibbous Moon",
    "name-href": "https://emojipedia.org/waning-gibbous-moon/",
    emoji: "🌖",
    emojiName: "🌖 Waning Gibbous Moon",
    description:
      "A waning gibbous moon (appearing more than half full but getting smaller), the sixth of the eight phases of the moon. Depicts the moon as a cratered disc, mostly illuminated in gold or silver, but with its right side a dark crescent.",
  },
  {
    "web-scraper-order": "1666017836-525",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌕 Full Moon",
    "name-href": "https://emojipedia.org/full-moon/",
    emoji: "🌕",
    emojiName: "🌕 Full Moon",
    description:
      "A full moon, the fifth phase of the eight phases of the moon, when it is completely lit. Depicts the moon as a full, gold or silver, cratered disc, completely illuminated by the sun.",
  },
  {
    "web-scraper-order": "1666017838-526",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌔 Waxing Gibbous Moon",
    "name-href": "https://emojipedia.org/waxing-gibbous-moon/",
    emoji: "🌔",
    emojiName: "🌔 Waxing Gibbous Moon",
    description:
      "A waxing gibbous moon (appearing more than half full and getting larger), the fourth of the eight phases of the moon. Depicts the moon as a cratered disc, mostly illuminated in gold or silver, but with its left side a dark crescent.",
  },
  {
    "web-scraper-order": "1666017841-527",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌓 First Quarter Moon",
    "name-href": "https://emojipedia.org/first-quarter-moon/",
    emoji: "🌓",
    emojiName: "🌓 First Quarter Moon",
    description:
      "A first quarter moon, the third of the eight phases of the moon. Depicts the moon as a cratered disc, its right half illuminated in gold or silver, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017844-528",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌒 Waxing Crescent Moon",
    "name-href": "https://emojipedia.org/waxing-crescent-moon/",
    emoji: "🌒",
    emojiName: "🌒 Waxing Crescent Moon",
    description:
      "A waxing crescent moon (appearing to become larger), the second of the eight phases of the moon. Depicts the moon as a cratered disc, its right side illuminated in a thin, golden or silver crescent, its remainder dark.",
  },
  {
    "web-scraper-order": "1666017847-529",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌑 New Moon",
    "name-href": "https://emojipedia.org/new-moon/",
    emoji: "🌑",
    emojiName: "🌑 New Moon",
    description:
      "A new moon, the first of the eight phases of the moon. Depicts the moon as a full, bluish- or grayish-black, cratered disc, not illuminated by the sun.",
  },
  {
    "web-scraper-order": "1666017849-530",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪨 Rock",
    "name-href": "https://emojipedia.org/rock/",
    emoji: "🪨",
    emojiName: "🪨 Rock",
    description:
      "A large rock the size of a small rock. May be considered a boulder, a rock, a stone, a pebble, or a piece of dirt. The scale and meaning are context dependent.",
  },
  {
    "web-scraper-order": "1666017851-531",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌐 Globe with Meridians",
    "name-href": "https://emojipedia.org/globe-with-meridians/",
    emoji: "🌐",
    emojiName: "🌐 Globe with Meridians",
    description:
      "A stylized globe, with blue meridians (longitudes) and latitude. Depicted with light-blue grid of lines on a white, blue, or empty circle.",
  },
  {
    "web-scraper-order": "1666017854-532",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌏 Globe Showing Asia-Australia",
    "name-href": "https://emojipedia.org/globe-showing-asia-australia/",
    emoji: "🌏",
    emojiName: "🌏 Globe Showing Asia-Australia",
    description:
      "A globe, showing the continents of Asia and Australia in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017856-533",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌎 Globe Showing Americas",
    "name-href": "https://emojipedia.org/globe-showing-americas/",
    emoji: "🌎",
    emojiName: "🌎 Globe Showing Americas",
    description:
      "A globe, showing the continents of North and South America in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017858-534",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌍 Globe Showing Europe-Africa",
    "name-href": "https://emojipedia.org/globe-showing-europe-africa/",
    emoji: "🌍",
    emojiName: "🌍 Globe Showing Europe-Africa",
    description:
      "A globe, showing the continents of Europe and Africa in green against blue ocean.",
  },
  {
    "web-scraper-order": "1666017863-535",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦑 Squid",
    "name-href": "https://emojipedia.org/squid/",
    emoji: "🦑",
    emojiName: "🦑 Squid",
    description:
      "A squid, an octopus-like sea animal with ten arms. Generally depicted as a pinkish-orange giant squid, facing forward or angled to the left, with a slender, arrow-like body, small eyes, and two, long arms raised up at its sides. Platforms generally depict six arms.",
  },
  {
    "web-scraper-order": "1666017866-536",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦐 Shrimp",
    "name-href": "https://emojipedia.org/shrimp/",
    emoji: "🦐",
    emojiName: "🦐 Shrimp",
    description:
      "A shrimp (prawn), a small crustacean with a long tail. Generally depicted as a reddish-orange shrimp (as cooked) in full profile facing left, with tiny eyes, many limbs, and its long antennae curling back as its long tail curls in.",
  },
  {
    "web-scraper-order": "1666017871-537",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦞 Lobster",
    "name-href": "https://emojipedia.org/lobster/",
    emoji: "🦞",
    emojiName: "🦞 Lobster",
    description:
      "A lobster, a large crustacean with a prominent tail and pincers. Depicted as a reddish-orange lobster (as cooked) from above, with a long body and tail, short, tentacle-like eyes, and ten legs, the top of which are very large pincers.",
  },
  {
    "web-scraper-order": "1666017875-538",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦀 Crab",
    "name-href": "https://emojipedia.org/crab/",
    emoji: "🦀",
    emojiName: "🦀 Crab",
    description:
      "A crab, a squat crustacean with pincers. Depicted as a reddish-orange crab (as cooked) shown from above, with a round, shelled body, shorted, tentacle-like eyes, and ten legs, the top two of which are large pincers.",
  },
  {
    "web-scraper-order": "1666017878-539",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌰 Chestnut",
    "name-href": "https://emojipedia.org/chestnut/",
    emoji: "🌰",
    emojiName: "🌰 Chestnut",
    description:
      "The reddish-brown, acorn-shaped chestnut, tapering to a sharp tip from its light brown base on most platforms. A popular roasted snack associated with autumn and Christmas.",
  },
  {
    "web-scraper-order": "1666017880-540",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍄 Mushroom",
    "name-href": "https://emojipedia.org/mushroom/",
    emoji: "🍄",
    emojiName: "🍄 Mushroom",
    description:
      "The edible fungus of the mushroom, depicted as a toadstool with a white-spotted red cap and stem.",
  },
  {
    "web-scraper-order": "1666017882-541",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪺 Nest with Eggs",
    "name-href": "https://emojipedia.org/nest-with-eggs/",
    emoji: "🪺",
    emojiName: "🪺 Nest with Eggs",
    description: "A bird's nest with eggs inside.",
  },
  {
    "web-scraper-order": "1666017885-542",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪹 Empty Nest",
    "name-href": "https://emojipedia.org/empty-nest/",
    emoji: "🪹",
    emojiName: "🪹 Empty Nest",
    description: "An empty bird's nest.",
  },
  {
    "web-scraper-order": "1666017887-543",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍃 Leaf Fluttering in Wind",
    "name-href": "https://emojipedia.org/leaf-fluttering-in-wind/",
    emoji: "🍃",
    emojiName: "🍃 Leaf Fluttering in Wind",
    description:
      "Leaves, as fluttering in a spring or summer breeze. Depicted as one or two green, almond-shaped leaves, with gray or blue motion lines, as if swirling in the air or as the wind blowing through the trees.",
  },
  {
    "web-scraper-order": "1666017890-544",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍂 Fallen Leaf",
    "name-href": "https://emojipedia.org/fallen-leaf/",
    emoji: "🍂",
    emojiName: "🍂 Fallen Leaf",
    description:
      "Leaves, as a have changed color and fallen from a tree in fall/autumn. Depicted as two or three golden-brown, almond-shaped leaves of various sizes, with stems up, as if falling down.",
  },
  {
    "web-scraper-order": "1666017892-545",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍁 Maple Leaf",
    "name-href": "https://emojipedia.org/maple-leaf/",
    emoji: "🍁",
    emojiName: "🍁 Maple Leaf",
    description:
      "The distinctive, star-shaped leaf of the maple tree. Depicted as a reddish-orange maple leaf, as has changed color in the fall/autumn, with five pointed segments.",
  },
  {
    "web-scraper-order": "1666017896-546",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🍀 Four Leaf Clover",
    "name-href": "https://emojipedia.org/four-leaf-clover/",
    emoji: "🍀",
    emojiName: "🍀 Four Leaf Clover",
    description:
      "A four-leaf clover, a symbol of good luck. Depicted as a bright green sprig of clover, with four, heart-shaped leaves.",
  },
  {
    "web-scraper-order": "1666017899-547",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "☘️ Shamrock",
    "name-href": "https://emojipedia.org/shamrock/",
    emoji: "☘️",
    emojiName: "☘️ Shamrock",
    description:
      "A shamrock, a clover-like plant. Depicted as a bright green sprig with three, heart-shaped leaves.",
  },
  {
    "web-scraper-order": "1666017901-548",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌿 Herb",
    "name-href": "https://emojipedia.org/herb/",
    emoji: "🌿",
    emojiName: "🌿 Herb",
    description:
      "An herb, a plant used in cooking or medicine. Depicted as a green sprig, as of basil, sage, or oregano, generally with five or seven leaves.",
  },
  {
    "web-scraper-order": "1666017903-549",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌾 Sheaf of Rice",
    "name-href": "https://emojipedia.org/sheaf-of-rice/",
    emoji: "🌾",
    emojiName: "🌾 Sheaf of Rice",
    description:
      "A rice plant, as grown before harvesting and processing. Depicted as a sheaf of Asian rice with green leaves and yellow seed heads drooping over to the right or left. Sometimes assumed to be wheat.",
  },
  {
    "web-scraper-order": "1666017906-550",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌵 Cactus",
    "name-href": "https://emojipedia.org/cactus/",
    emoji: "🌵",
    emojiName: "🌵 Cactus",
    description:
      "A cactus, a spiky plant that grows in very dry regions. Depicted as a light-green saguaro cactus with two side arms covered in spines.",
  },
  {
    "web-scraper-order": "1666017909-551",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌴 Palm Tree",
    "name-href": "https://emojipedia.org/palm-tree/",
    emoji: "🌴",
    emojiName: "🌴 Palm Tree",
    description:
      "A palm tree, a tree-like plant, as grows by the sea. Depicted as a palm tree with long, green, feather-like leaves and a tall, brown, segmented trunk.",
  },
  {
    "web-scraper-order": "1666017911-552",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌳 Deciduous Tree",
    "name-href": "https://emojipedia.org/deciduous-tree/",
    emoji: "🌳",
    emojiName: "🌳 Deciduous Tree",
    description:
      "A deciduous tree, whose leaves change color before shedding, as 🍂 Fallen Leave, in the fall/autumn. Depicted as a generic tree with a round, lush, leafy top and brown trunk.",
  },
  {
    "web-scraper-order": "1666017913-553",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌲 Evergreen Tree",
    "name-href": "https://emojipedia.org/evergreen-tree/",
    emoji: "🌲",
    emojiName: "🌲 Evergreen Tree",
    description:
      "An evergreen tree, which keeps green leaves all year round. Depicted as a tall, dark green, cone-shaped tree with shaggy, layered leaves, as a pine or fir, showing a brown trunk.",
  },
  {
    "web-scraper-order": "1666017916-554",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪴 Potted Plant",
    "name-href": "https://emojipedia.org/potted-plant/",
    emoji: "🪴",
    emojiName: "🪴 Potted Plant",
    description: "A leafy green plant in pot. Plant type varies by platform.",
  },
  {
    "web-scraper-order": "1666017919-555",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌱 Seedling",
    "name-href": "https://emojipedia.org/seedling/",
    emoji: "🌱",
    emojiName: "🌱 Seedling",
    description:
      "A seedling, or a young plant, as a newly sprouted tree. Depicted as a tiny, light-green plant with a short stem and two leaves. Often shown freshly sprung from a small mound of brown earth.",
  },
  {
    "web-scraper-order": "1666017922-556",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌷 Tulip",
    "name-href": "https://emojipedia.org/tulip/",
    emoji: "🌷",
    emojiName: "🌷 Tulip",
    description:
      "A pink tulip flower. Depicted as a single, vertical pink tulip on a green stem.",
  },
  {
    "web-scraper-order": "1666017924-557",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌼 Blossom",
    "name-href": "https://emojipedia.org/blossom/",
    emoji: "🌼",
    emojiName: "🌼 Blossom",
    description:
      "A flower that has blossomed. Depicted as a flower with white or yellow petals, as a daisy, with a golden center.",
  },
  {
    "web-scraper-order": "1666017926-558",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌻 Sunflower",
    "name-href": "https://emojipedia.org/sunflower/",
    emoji: "🌻",
    emojiName: "🌻 Sunflower",
    description:
      "A sunflower, a tall, round flower with large yellow petals. Depicted as a single, vertical sunflower with a large, dark-brown center on a green stem.",
  },
  {
    "web-scraper-order": "1666017929-559",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌺 Hibiscus",
    "name-href": "https://emojipedia.org/hibiscus/",
    emoji: "🌺",
    emojiName: "🌺 Hibiscus",
    description:
      "A pink hibiscus, a flower that grows in warm climates. Depicted as a single, deep-pink hibiscus flower with green leaves and prominent, yellow stamen.",
  },
  {
    "web-scraper-order": "1666017932-560",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🥀 Wilted Flower",
    "name-href": "https://emojipedia.org/wilted-flower/",
    emoji: "🥀",
    emojiName: "🥀 Wilted Flower",
    description:
      "A flower that has wilted, or is dying. Generally depicted as a limp, faded red rose drooping over the to the right on a dried-out, green stem, shedding a petal.",
  },
  {
    "web-scraper-order": "1666017935-561",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌹 Rose",
    "name-href": "https://emojipedia.org/rose/",
    emoji: "🌹",
    emojiName: "🌹 Rose",
    description:
      "A red rose. Depicted as a single, vertical red rose on a green stem.",
  },
  {
    "web-scraper-order": "1666017938-562",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🏵️ Rosette",
    "name-href": "https://emojipedia.org/rosette/",
    emoji: "🏵️",
    emojiName: "🏵️ Rosette",
    description:
      "A rosette, a stylized, flower-shaped decoration often presented as an award with a ribbon or (military) medal. Appears as a motif in ancient cultures. Generally depicted as a circular, yellow-and-orange flower.",
  },
  {
    "web-scraper-order": "1666017940-563",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪷 Lotus",
    "name-href": "https://emojipedia.org/lotus/",
    emoji: "🪷",
    emojiName: "🪷 Lotus",
    description: "A pink lotus flower in full bloom.",
  },
  {
    "web-scraper-order": "1666017942-564",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💮 White Flower",
    "name-href": "https://emojipedia.org/white-flower/",
    emoji: "💮",
    emojiName: "💮 White Flower",
    description:
      "A stylized white flower. Generally depicted as a rosette-shaped cherry blossom in pink or red outline, often with a white fill.",
  },
  {
    "web-scraper-order": "1666017945-565",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🌸 Cherry Blossom",
    "name-href": "https://emojipedia.org/cherry-blossom/",
    emoji: "🌸",
    emojiName: "🌸 Cherry Blossom",
    description:
      "The pink flower of a cherry blossom tree. Depicted as a single, light-pink cherry blossom with five, notched petals and red-tipped stamens in a yellow or white center.",
  },
  {
    "web-scraper-order": "1666017948-566",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💐 Bouquet",
    "name-href": "https://emojipedia.org/bouquet/",
    emoji: "💐",
    emojiName: "💐 Bouquet",
    description:
      "A bouquet of brightly colored flowers. Generally depicted as a collection of pink and yellow flowers with green stems tied together. Positioned at various angles across platforms.",
  },
  {
    "web-scraper-order": "1666017952-567",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦠 Microbe",
    "name-href": "https://emojipedia.org/microbe/",
    emoji: "🦠",
    emojiName: "🦠 Microbe",
    description:
      "A microbe, as a bacterium grown in a 🧫 Petri Dish or observed under a 🔬 Microscope. Generally depicted as a squiggly, single-celled microorganism with prominent cilia. Color, shape, and position vary across platforms. Commonly used to represent bacteria, viruses, and germs and disease more generally.",
  },
  {
    "web-scraper-order": "1666017956-568",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪱 Worm",
    "name-href": "https://emojipedia.org/worm/",
    emoji: "🪱",
    emojiName: "🪱 Worm",
    description:
      "A pink or brown worm. Most platforms have more realistic designs, though Google and Samsung feature cartoony worms who are smiling sweetly.",
  },
  {
    "web-scraper-order": "1666017960-569",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪰 Fly",
    "name-href": "https://emojipedia.org/fly/",
    emoji: "🪰",
    emojiName: "🪰 Fly",
    description:
      "A fly with a dark or iridescent green body, six legs, and two translucent wings. On most platforms, its eyes are red.",
  },
  {
    "web-scraper-order": "1666017963-570",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦟 Mosquito",
    "name-href": "https://emojipedia.org/mosquito/",
    emoji: "🦟",
    emojiName: "🦟 Mosquito",
    description:
      "A mosquito, a type of bloodsucking fly. Depicted as a brown or black mosquito on its six, long legs, with wings, long abdomen, and needle-like mouth. Variously shown from above or facing left.",
  },
  {
    "web-scraper-order": "1666017967-571",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦂 Scorpion",
    "name-href": "https://emojipedia.org/scorpion/",
    emoji: "🦂",
    emojiName: "🦂 Scorpion",
    description:
      "A scorpion, an arachnid with lobster-like pincers and a stinging tail. Depicted as a light-brown scorpion from above, often facing left, with its pincers and curving stinger raised. Shown with six or, accurately, eight legs in addition to its pincers.",
  },
  {
    "web-scraper-order": "1666017972-572",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕸️ Spider Web",
    "name-href": "https://emojipedia.org/spider-web/",
    emoji: "🕸️",
    emojiName: "🕸️ Spider Web",
    description:
      "A classic spider web (cobweb), as spun by a 🕷️ Spider to catch prey. Depicted as a white, symmetrical, wheel-shaped web, as an orb web, with six or eight equal sectors.",
  },
  {
    "web-scraper-order": "1666017977-573",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕷️ Spider",
    "name-href": "https://emojipedia.org/spider/",
    emoji: "🕷️",
    emojiName: "🕷️ Spider",
    description:
      "A spider, an eight-legged arachnid that spins a web. Depicted as a common black spider, as a house spider or funnel-web spider, often shown from above with its large abdomen oriented at the bottom.",
  },
  {
    "web-scraper-order": "1666017982-574",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪳 Cockroach",
    "name-href": "https://emojipedia.org/cockroach/",
    emoji: "🪳",
    emojiName: "🪳 Cockroach",
    description:
      "A brown cockroach shown with antennae, six legs, and two sensory pads at its rear called cerci.",
  },
  {
    "web-scraper-order": "1666017987-575",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦗 Cricket",
    "name-href": "https://emojipedia.org/cricket/",
    emoji: "🦗",
    emojiName: "🦗 Cricket",
    description:
      "A cricket, a hopping insect that makes a chirping sound. Depicted as a brown or green cricket in full profile on its six legs facing left, with long antennae and large, bent back legs.",
  },
  {
    "web-scraper-order": "1666017992-576",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐞 Lady Beetle",
    "name-href": "https://emojipedia.org/lady-beetle/",
    emoji: "🐞",
    emojiName: "🐞 Lady Beetle",
    description:
      "A ladybug (ladybird, lady beetle), a beetle with a round, red shell with black spots. Generally depicted as a seven- or nine-spotted ladybug shown from above on its six legs, with antennae and its distinctively red-and-black, halved shell.",
  },
  {
    "web-scraper-order": "1666017996-577",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪲 Beetle",
    "name-href": "https://emojipedia.org/beetle/",
    emoji: "🪲",
    emojiName: "🪲 Beetle",
    description:
      "A green or brown beetle shown with antennae and six legs. Can be used to talk about beetles, bugs, or insects in general.",
  },
  {
    "web-scraper-order": "1666018000-578",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐝 Honeybee",
    "name-href": "https://emojipedia.org/honeybee/",
    emoji: "🐝",
    emojiName: "🐝 Honeybee",
    description:
      "A honey bee, a busy, flying insect that lives in a hive and makes honey. Depicted as a black-and-yellow bee with clear or white wings and a stinger. Variously facing left in full profile or shown from above.",
  },
  {
    "web-scraper-order": "1666018004-579",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐜 Ant",
    "name-href": "https://emojipedia.org/ant/",
    emoji: "🐜",
    emojiName: "🐜 Ant",
    description:
      "An ant, a small, industrious insect that lives in a colony. Depicted as a black or red ant in full profile on its six legs facing left, with a prominent abdomen and antennae.",
  },
  {
    "web-scraper-order": "1666018007-580",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐛 Bug",
    "name-href": "https://emojipedia.org/bug/",
    emoji: "🐛",
    emojiName: "🐛 Bug",
    description:
      "A bug, or insect, generally depicted as a caterpillar, which becomes a 🦋 Butterfly. Shown in full profile facing left, inching up on the back of its green, segmented, and textured body. Often featuring black stripes or yellow dots and tentacles on its head.",
  },
  {
    "web-scraper-order": "1666018017-581",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦋 Butterfly",
    "name-href": "https://emojipedia.org/butterfly/",
    emoji: "🦋",
    emojiName: "🦋 Butterfly",
    description:
      "A butterfly, a beautiful winged insect whose larva is a caterpillar. Depicted with its wings outspread, as a blue-and-black morpho butterfly or orange-and-black monarch butterfly.",
  },
  {
    "web-scraper-order": "1666018023-582",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐌 Snail",
    "name-href": "https://emojipedia.org/snail/",
    emoji: "🐌",
    emojiName: "🐌 Snail",
    description:
      "A snail, a slow-moving, snail-like mollusk in a spiraling shell. Generally depicted as a brown snail in full profile facing left or right, with a brown, textured shell and tentacle-like eyes.",
  },
  {
    "web-scraper-order": "1666018026-583",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪸 Coral",
    "name-href": "https://emojipedia.org/coral/",
    emoji: "🪸",
    emojiName: "🪸 Coral",
    description:
      "Coral as found in a reef, of varying shapes and colors. Sometimes used as a symbol of climate change due to coral bleaching.",
  },
  {
    "web-scraper-order": "1666018030-584",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐚 Spiral Shell",
    "name-href": "https://emojipedia.org/spiral-shell/",
    emoji: "🐚",
    emojiName: "🐚 Spiral Shell",
    description:
      "A seashell, as found at the beach. Generally depicted as an empty, spiraling, white seashell, as grown by a sea snail or home to a hermit crab. Positioned at various angles across platforms.",
  },
  {
    "web-scraper-order": "1666018034-585",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐙 Octopus",
    "name-href": "https://emojipedia.org/octopus/",
    emoji: "🐙",
    emojiName: "🐙 Octopus",
    description:
      "An octopus, a sea animal with eight legs, known to change color and release ink. Generally depicted as a pink or orange octopus facing forward, with a large, round head, prominent eyes, and its tentacle-like arms raised at its sides. Platforms vary in the number of arms shown, ranging from four to the full eight, with several designs featuring suckers on them.",
  },
  {
    "web-scraper-order": "1666018037-586",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦈 Shark",
    "name-href": "https://emojipedia.org/shark/",
    emoji: "🦈",
    emojiName: "🦈 Shark",
    description:
      "A shark, a large, stealthy fish with many teeth. Generally depicted as a gray shark in full profile facing left, as a tiger, bull, or great white shark hunting in the water. Shown with a white underside and three gills, its pointed nose and teeth-lined mouth curving down to a sharp dorsal fin and long, pointed tail.",
  },
  {
    "web-scraper-order": "1666018046-587",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐡 Blowfish",
    "name-href": "https://emojipedia.org/blowfish/",
    emoji: "🐡",
    emojiName: "🐡 Blowfish",
    description:
      "A blowfish (puffer), which puffs up and becomes spiky when alarmed. Depicted as an orange or brown blowfish in full profile facing left, with small fins, a white underside, and a round, spiky body, as if inflated.",
  },
  {
    "web-scraper-order": "1666018049-588",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐠 Tropical Fish",
    "name-href": "https://emojipedia.org/tropical-fish/",
    emoji: "🐠",
    emojiName: "🐠 Tropical Fish",
    description:
      "A tropical fish, as swims in the warm waters of a coral reef or is kept as a pet in an aquarium. Depicted as a brightly colored fish in full profile facing left, with slender fins. Often shown as a blue-and-yellow fish with stripes, as an angelfish.",
  },
  {
    "web-scraper-order": "1666018053-589",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐟 Fish",
    "name-href": "https://emojipedia.org/fish/",
    emoji: "🐟",
    emojiName: "🐟 Fish",
    description:
      "A common fish, as swims in the water. Depicted as a generic, light-blue fish, often with a white underside, in full profile facing left, with fins and prominent gill cover.",
  },
  {
    "web-scraper-order": "1666018057-590",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦭 Seal",
    "name-href": "https://emojipedia.org/seal/",
    emoji: "🦭",
    emojiName: "🦭 Seal",
    description:
      "A gray seal with dark eyes and a dark nose. Most platforms feature a design with whiskers.",
  },
  {
    "web-scraper-order": "1666018060-591",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐬 Dolphin",
    "name-href": "https://emojipedia.org/dolphin/",
    emoji: "🐬",
    emojiName: "🐬 Dolphin",
    description:
      "A dolphin, a sleek marine mammal known to be social and intelligent. Generally depicted as a light-blue dolphin with a white belly in full profile facing left, its short snout curving down to a prominent dorsal fin and tail, as a bottlenose dolphin leaping in the air.",
  },
  {
    "web-scraper-order": "1666018064-592",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐋 Whale",
    "name-href": "https://emojipedia.org/whale/",
    emoji: "🐋",
    emojiName: "🐋 Whale",
    description:
      "A whale, the massive marine mammal. Generally depicted as a light-blue whale in full profile facing left, with its tail curving down towards is huge mouth. Shown with a white, textured underside, as a humpback or blue whale.",
  },
  {
    "web-scraper-order": "1666018069-593",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐳 Spouting Whale",
    "name-href": "https://emojipedia.org/spouting-whale/",
    emoji: "🐳",
    emojiName: "🐳 Spouting Whale",
    description:
      "A friendly, cartoon-styled whale, shown spouting water from its blowhole. Generally depicted as a light-blue whale in full profile facing left, with a round body and white underside, its tail held upright.",
  },
  {
    "web-scraper-order": "1666018073-594",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦖 T-Rex",
    "name-href": "https://emojipedia.org/t-rex/",
    emoji: "🦖",
    emojiName: "🦖 T-Rex",
    description:
      "A Tyrannosaurus rex, a massive, meat-eating dinosaur with huge jaws, tiny arms, and a long tail. Depicted as a green tyrannosaur standing on its hind lefts facing left, often with a textured back, sharp teeth, and clawed toes.",
  },
  {
    "web-scraper-order": "1666018075-595",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦕 Sauropod",
    "name-href": "https://emojipedia.org/sauropod/",
    emoji: "🦕",
    emojiName: "🦕 Sauropod",
    description:
      "A sauropod, a massive, plant-eating dinosaur with a long neck and tail. Depicted as a blue, gray, or green sauropod, as a brachiosaurus, apatosaurus/brontosaurus, or diplodocus. Shown in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018080-596",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐉 Dragon",
    "name-href": "https://emojipedia.org/dragon/",
    emoji: "🐉",
    emojiName: "🐉 Dragon",
    description:
      "A dragon, a mythical creature resembling a giant reptile found in the folklore of many cultures. Depicted as a green, Chinese-styled dragon in full profile facing left. Generally shown with a curling, snake-like body, clawed feet, yellowish scales on its back, horn-like structures on its head, and whisker-like tendrils by its nostrils.",
  },
  {
    "web-scraper-order": "1666018084-597",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐲 Dragon Face",
    "name-href": "https://emojipedia.org/dragon-face/",
    emoji: "🐲",
    emojiName: "🐲 Dragon Face",
    description:
      "The face of a dragon, a mythical creature resembling a giant reptile found in the folklore of many cultures. Depicted as a green, Chinese-styled dragon looking straight ahead or facing left. Often shown with huge nostrils, baring large teeth and a red tongue, with antler-like structures on its head, whisker-like tendrils by its nostrils, and a green or yellow mane.",
  },
  {
    "web-scraper-order": "1666018089-598",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐍 Snake",
    "name-href": "https://emojipedia.org/snake/",
    emoji: "🐍",
    emojiName: "🐍 Snake",
    description:
      "A snake, a slithering reptile without limbs. Generally depicted as a yellowish-green snake facing left, with a long, coiled body and flicking a red, forked tongue.",
  },
  {
    "web-scraper-order": "1666018092-599",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦎 Lizard",
    "name-href": "https://emojipedia.org/lizard/",
    emoji: "🦎",
    emojiName: "🦎 Lizard",
    description:
      "A lizard, a scaly reptile with a long tail. Depicted as a light-green lizard on all fours from above, generally looking left with large eyes, a lightly textured or colored back, and toes outspread, as a gecko.",
  },
  {
    "web-scraper-order": "1666018099-600",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐢 Turtle",
    "name-href": "https://emojipedia.org/turtle/",
    emoji: "🐢",
    emojiName: "🐢 Turtle",
    description:
      "A turtle, a slow-moving reptile with a shell. Depicted as a light-green turtle in full profile on all fours facing left, with a long neck and green, textured shell.",
  },
  {
    "web-scraper-order": "1666018103-601",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐊 Crocodile",
    "name-href": "https://emojipedia.org/crocodile/",
    emoji: "🐊",
    emojiName: "🐊 Crocodile",
    description:
      "A crocodile, a stealthy reptile with massive jaws. Generally depicted as a light-green crocodile on all fours, with its long tail curving down to its toothed jaws, facing left.",
  },
  {
    "web-scraper-order": "1666018108-602",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐸 Frog",
    "name-href": "https://emojipedia.org/frog/",
    emoji: "🐸",
    emojiName: "🐸 Frog",
    description:
      "The face of a frog, the hopping amphibian. Generally depicted as a friendly, cartoon-styled, light-green frog looking straight ahead, with large eyes, slightly open mouth, and nostrils.",
  },
  {
    "web-scraper-order": "1666018112-603",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦜 Parrot",
    "name-href": "https://emojipedia.org/parrot/",
    emoji: "🦜",
    emojiName: "🦜 Parrot",
    description:
      "A parrot, a brightly colored bird known for its ability to mimic speech. Depicted in full profile facing left. Resembles a green lovebird with red and yellow wings on some platforms and a scarlet macaw with blue and yellow wings on others.",
  },
  {
    "web-scraper-order": "1666018116-604",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦚 Peacock",
    "name-href": "https://emojipedia.org/peacock/",
    emoji: "🦚",
    emojiName: "🦚 Peacock",
    description:
      "A peacock, the male bird that displays a large, fan-like, iridescent tale. Depicted facing forward standing on its legs, with a blue body and green tail feathers outspread.",
  },
  {
    "web-scraper-order": "1666018119-605",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦩 Flamingo",
    "name-href": "https://emojipedia.org/flamingo/",
    emoji: "🦩",
    emojiName: "🦩 Flamingo",
    description:
      "A flamingo, a waterbird with pink feathers and long neck and legs. Depicted as a flamingo in full profile facing left, standing on one leg, usually with a long, black beak.",
  },
  {
    "web-scraper-order": "1666018122-606",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🪶 Feather",
    "name-href": "https://emojipedia.org/feather/",
    emoji: "🪶",
    emojiName: "🪶 Feather",
    description:
      "A single feather slanted to one side. On most platforms it's light brown with a dark brown barred or striped pattern. Can be used to talk about feathers or birds, or to represent something that is lightweight, fluffy, or soft.",
  },
  {
    "web-scraper-order": "1666018127-607",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦤 Dodo",
    "name-href": "https://emojipedia.org/dodo/",
    emoji: "🦤",
    emojiName: "🦤 Dodo",
    description:
      "A brown or gray dodo shown in full profile. Generally depicted with a curved yellow beak, small wings, a fluffy white tail, yellow or orange feet, and black talons.",
  },
  {
    "web-scraper-order": "1666018131-608",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦉 Owl",
    "name-href": "https://emojipedia.org/owl/",
    emoji: "🦉",
    emojiName: "🦉 Owl",
    description:
      "An owl, the hooting, large-eyed bird. Depicted as a brown owl with its head facing forward. Shown with large, round, gold-rimmed eyes, talons, tucked wings, and horn-like tufts of feathers.",
  },
  {
    "web-scraper-order": "1666018135-609",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦢 Swan",
    "name-href": "https://emojipedia.org/swan/",
    emoji: "🦢",
    emojiName: "🦢 Swan",
    description:
      "A swan, a waterbird with white feathers and a long neck. Depicted in full profile facing left, with a curving neck, orange bill, black eye marking, and wings and legs tucked in, as if gliding in water.",
  },
  {
    "web-scraper-order": "1666018139-610",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦆 Duck",
    "name-href": "https://emojipedia.org/duck/",
    emoji: "🦆",
    emojiName: "🦆 Duck",
    description:
      "Quack! A duck, a waterbird with webbed feet. Depicted as a male (drake) mallard in full profile facing left, standing on its legs with gray and brown feathers, a yellow bill, and its distinctive green head.",
  },
  {
    "web-scraper-order": "1666018142-611",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦅 Eagle",
    "name-href": "https://emojipedia.org/eagle/",
    emoji: "🦅",
    emojiName: "🦅 Eagle",
    description:
      "A bald eagle, the majestic bird of prey with brown feathers and distinctive white head. Generally depicted facing left, with its wings outspread and talons out, as if swooping down to seize prey.",
  },
  {
    "web-scraper-order": "1666018146-612",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🕊️ Dove",
    "name-href": "https://emojipedia.org/dove/",
    emoji: "🕊️",
    emojiName: "🕊️ Dove",
    description:
      "A dove carrying an olive branch, a symbol of peace in Western and Judeo-Christian culture. Depicted as a white bird in full profile facing left, flying as it holds a green sprig in its beak.",
  },
  {
    "web-scraper-order": "1666018149-613",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐧 Penguin",
    "name-href": "https://emojipedia.org/penguin/",
    emoji: "🐧",
    emojiName: "🐧 Penguin",
    description:
      "A penguin, a flightless bird adapted to water and ice. Variously depicted as a full, black-bodied penguin with a white belly and orange bill or as a penguin head.",
  },
  {
    "web-scraper-order": "1666018153-614",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐦 Bird",
    "name-href": "https://emojipedia.org/bird/",
    emoji: "🐦",
    emojiName: "🐦 Bird",
    description:
      "A generic bird. Variously depicted as a blue or red bird, as a bluebird or cardinal, shown standing in full profile, or as a bird head. Both designs show the bird facing left.",
  },
  {
    "web-scraper-order": "1666018157-615",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐥 Front-Facing Baby Chick",
    "name-href": "https://emojipedia.org/front-facing-baby-chick/",
    emoji: "🐥",
    emojiName: "🐥 Front-Facing Baby Chick",
    description:
      "A baby chicken (chick), shown as if flapping its wings. Depicted as a yellow chick with an orange beak in full profile standing on its legs, generally with its wings raised.",
  },
  {
    "web-scraper-order": "1666018162-616",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐤 Baby Chick",
    "name-href": "https://emojipedia.org/baby-chick/",
    emoji: "🐤",
    emojiName: "🐤 Baby Chick",
    description:
      "A yellow baby chicken (chick). Variously depicted as a chick in full profile, standing on its legs, or as a chick head. Both designs show the bird facing left, with an orange beak and feet.",
  },
  {
    "web-scraper-order": "1666018174-617",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐣 Hatching Chick",
    "name-href": "https://emojipedia.org/hatching-chick/",
    emoji: "🐣",
    emojiName: "🐣 Hatching Chick",
    description:
      "A baby chicken (chick), hatching from an egg and seeing the world for the first time. Depicted as a yellow chick with an orange beak facing forward in the cracked, bottom half of a white egg, generally shown flapping its wings with a cute facial expression.",
  },
  {
    "web-scraper-order": "1666018178-618",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐓 Rooster",
    "name-href": "https://emojipedia.org/rooster/",
    emoji: "🐓",
    emojiName: "🐓 Rooster",
    description:
      "A rooster (cock), a male chicken known for its cock-a-doodle-do. Depicted as a white or multicolored rooster standing on its legs in full profile facing left, with a red comb on its head and red wattle on its neck.",
  },
  {
    "web-scraper-order": "1666018181-619",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐔 Chicken",
    "name-href": "https://emojipedia.org/chicken/",
    emoji: "🐔",
    emojiName: "🐔 Chicken",
    description:
      "A chicken, a bird used for its meat and eggs. Generally depicted as the white head of a chicken (hen or rooster) looking left, with a yellow beak, red comb on its head, and red wattle on its neck.",
  },
  {
    "web-scraper-order": "1666018186-620",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦃 Turkey",
    "name-href": "https://emojipedia.org/turkey/",
    emoji: "🦃",
    emojiName: "🦃 Turkey",
    description:
      "A turkey, a gobbling bird traditionally eaten at Thanksgiving or Christmas. Depicted in full profile facing left, standing on its legs with a dark-brown body, a white-fringed plume, pink or blue head, and its distinctive red snood and wattle.",
  },
  {
    "web-scraper-order": "1666018189-621",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐾 Paw Prints",
    "name-href": "https://emojipedia.org/paw-prints/",
    emoji: "🐾",
    emojiName: "🐾 Paw Prints",
    description:
      "A pair of paw prints, as left by a pet 🐈 cat or 🐕 dog. Generally depicted as two, staggered, dark-colored paw prints, each showing four toes and a pad.",
  },
  {
    "web-scraper-order": "1666018192-622",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦡 Badger",
    "name-href": "https://emojipedia.org/badger/",
    emoji: "🦡",
    emojiName: "🦡 Badger",
    description:
      "A badger, a stocky mammal in the weasel family with a long, pointed head. Generally depicted in full profile on all fours facing left, with a gray coat, black-and-white-striped face, and short tail.",
  },
  {
    "web-scraper-order": "1666018195-623",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦘 Kangaroo",
    "name-href": "https://emojipedia.org/kangaroo/",
    emoji: "🦘",
    emojiName: "🦘 Kangaroo",
    description:
      "A kangaroo, a marsupial with a large tail and legs. Depicted in yellowish-brown in full profile facing left with large, pointed ears, shown either resting on its hind legs and tail or jumping.",
  },
  {
    "web-scraper-order": "1666018199-624",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦨 Skunk",
    "name-href": "https://emojipedia.org/skunk/",
    emoji: "🦨",
    emojiName: "🦨 Skunk",
    description:
      "A skunk, a bushy-tailed mammal that sprays a foul odor when threatened. Depicted in full profile on all fours facing left, with black hair and its distinctive white stripe running from its head down to a curled-up tail.",
  },
  {
    "web-scraper-order": "1666018203-625",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦦 Otter",
    "name-href": "https://emojipedia.org/otter/",
    emoji: "🦦",
    emojiName: "🦦 Otter",
    description:
      "An otter, the playful water mammal in the weasel family. Depicted as a light-brown otter on its back, with its forepaws held together and whiskered face to the left, generally with its long tail curled up.",
  },
  {
    "web-scraper-order": "1666018210-626",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦥 Sloth",
    "name-href": "https://emojipedia.org/sloth/",
    emoji: "🦥",
    emojiName: "🦥 Sloth",
    description:
      "A sloth, the slow-moving, tree-dwelling mammal. Depicted as a light-brown sloth with a wide, whitish, masked face hanging from a tree branch, facing left or right. Generally shown as a three-toed sloth.",
  },
  {
    "web-scraper-order": "1666018216-627",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐼 Panda",
    "name-href": "https://emojipedia.org/panda/",
    emoji: "🐼",
    emojiName: "🐼 Panda",
    description:
      "A friendly, cartoon-styled face of a panda—a bear-like mammal known for eating bamboo—looking straight ahead. Depicted as a white panda face with black ears and black circles around its eyes.",
  },
  {
    "web-scraper-order": "1666018220-628",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐨 Koala",
    "name-href": "https://emojipedia.org/koala/",
    emoji: "🐨",
    emojiName: "🐨 Koala",
    description:
      "A friendly, cartoon-styled face of a koala—a bear-like marsupial known for eating eucalyptus and sleeping—looking straight ahead. Depicted as a gray face with round, fluffy ears and a large, black nose.",
  },
  {
    "web-scraper-order": "1666018225-629",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐻‍❄️ Polar Bear",
    "name-href": "https://emojipedia.org/polar-bear/",
    emoji: "🐻‍❄️",
    emojiName: "🐻‍❄️ Polar Bear",
    description:
      "A friendly, cartoon-styled face of polar bear, looking straight ahead. Depicted as the face of a white bear with round ears.",
  },
  {
    "web-scraper-order": "1666018230-630",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐻 Bear",
    "name-href": "https://emojipedia.org/bear/",
    emoji: "🐻",
    emojiName: "🐻 Bear",
    description:
      "A friendly, cartoon-styled face of bear, looking straight ahead. Depicted as a brown bear with round ears and a tan muzzle. Resembles a teddy bear.",
  },
  {
    "web-scraper-order": "1666018234-631",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦇 Bat",
    "name-href": "https://emojipedia.org/bat/",
    emoji: "🦇",
    emojiName: "🦇 Bat",
    description:
      "A bat, the flying mammal of the night. Variously depicted as a brown, black, or gray bat, with wings outspread and pointy ears, facing forward or left.",
  },
  {
    "web-scraper-order": "1666018238-632",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦔 Hedgehog",
    "name-href": "https://emojipedia.org/hedgehog/",
    emoji: "🦔",
    emojiName: "🦔 Hedgehog",
    description:
      "A hedgehog. A small, spiny mammal sometimes kept as a pet. Generally depicted in full profile on all fours facing left, with a round, brown body covered with spines and a light-brown face and underside.",
  },
  {
    "web-scraper-order": "1666018243-633",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦫 Beaver",
    "name-href": "https://emojipedia.org/beaver/",
    emoji: "🦫",
    emojiName: "🦫 Beaver",
    description:
      "A brown beaver with buckteeth and a wide paddle-like tail. Can be used in the context of actual beavers, or metaphorically to evoke qualities of beavers like working hard, as in the expression beavering away.",
  },
  {
    "web-scraper-order": "1666018247-634",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐿️ Chipmunk",
    "name-href": "https://emojipedia.org/chipmunk/",
    emoji: "🐿️",
    emojiName: "🐿️ Chipmunk",
    description:
      "A chipmunk, a small rodent with puffy cheeks. Depicted as a brown chipmunk in full profile facing left, sitting on its hind legs with a bushy tail and striped body. Generally holding an acorn or other nut in its hands.",
  },
  {
    "web-scraper-order": "1666018252-635",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐇 Rabbit",
    "name-href": "https://emojipedia.org/rabbit/",
    emoji: "🐇",
    emojiName: "🐇 Rabbit",
    description:
      "A rabbit, a hoppy mammal with long ears. Depicted as a white, gray, or brown rabbit in full profile facing left with pink ears and a short tail, sitting on its long, hind legs or on all fours.",
  },
  {
    "web-scraper-order": "1666018257-636",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐰 Rabbit Face",
    "name-href": "https://emojipedia.org/rabbit-face/",
    emoji: "🐰",
    emojiName: "🐰 Rabbit Face",
    description:
      "A friendly, cartoon-styled face of a rabbit, looking straight ahead. Generally depicted as a gray and/or white rabbit face with upright ears and pink ears and nose, often with whiskers and a buck tooth.",
  },
  {
    "web-scraper-order": "1666018262-637",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐹 Hamster",
    "name-href": "https://emojipedia.org/hamster/",
    emoji: "🐹",
    emojiName: "🐹 Hamster",
    description:
      "A friendly, cartoon-styled face of a hamster—a small rodent often kept as a pet—looking straight ahead. Generally depicted as a brown-and-white faced hamster with whiskers, a pink nose, puffy cheeks, and large, round, pink ears, sometimes with a buck tooth.",
  },
  {
    "web-scraper-order": "1666018266-638",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐀 Rat",
    "name-href": "https://emojipedia.org/rat/",
    emoji: "🐀",
    emojiName: "🐀 Rat",
    description:
      "A rat, a large rodent with a long tail, known to frequent big cities. Depicted in gray in full profile on all fours facing left, with pink ears, feet, and tail.",
  },
  {
    "web-scraper-order": "1666018270-639",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐁 Mouse",
    "name-href": "https://emojipedia.org/mouse/",
    emoji: "🐁",
    emojiName: "🐁 Mouse",
    description:
      "Eek! A mouse, a small rodent with large ears and a long tail. Generally depicted in white in full profile on all fours facing left, with pink ears, feet, and tail, often with reddish eyes.",
  },
  {
    "web-scraper-order": "1666018274-640",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐭 Mouse Face",
    "name-href": "https://emojipedia.org/mouse-face/",
    emoji: "🐭",
    emojiName: "🐭 Mouse Face",
    description:
      "A friendly, cartoon-styled face of a mouse, looking straight ahead. Generally depicted as a gray or white mouse face with large, round ears, a pink, pointed nose, and whiskers.",
  },
  {
    "web-scraper-order": "1666018278-641",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦛 Hippopotamus",
    "name-href": "https://emojipedia.org/hippopotamus/",
    emoji: "🦛",
    emojiName: "🦛 Hippopotamus",
    description:
      "A hippopotamus, a squat water mammal with huge jaws. Generally depicted in gray or tan in full profile facing left.",
  },
  {
    "web-scraper-order": "1666018283-642",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦏 Rhinoceros",
    "name-href": "https://emojipedia.org/rhinoceros/",
    emoji: "🦏",
    emojiName: "🦏 Rhinoceros",
    description:
      "A rhinoceros, a large mammal with one or two massive horns on its nose. Generally shown in light gray with two horns, depicted in full profile on all fours or as a rhinoceros head looking left.",
  },
  {
    "web-scraper-order": "1666018287-643",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦣 Mammoth",
    "name-href": "https://emojipedia.org/mammoth/",
    emoji: "🦣",
    emojiName: "🦣 Mammoth",
    description:
      "A brown wooly mammoth with large curved tusks. Can also be used to represent a mastodon.",
  },
  {
    "web-scraper-order": "1666018292-644",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐘 Elephant",
    "name-href": "https://emojipedia.org/elephant/",
    emoji: "🐘",
    emojiName: "🐘 Elephant",
    description:
      "An elephant, the largest land animal on Earth, with a long trunk and, often, tusks. Generally depicted in gray in full profile on all fours facing left, with tusks and prominent ears, as an African (vs. Asian) elephant.",
  },
  {
    "web-scraper-order": "1666018295-645",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦒 Giraffe",
    "name-href": "https://emojipedia.org/giraffe/",
    emoji: "🦒",
    emojiName: "🦒 Giraffe",
    description:
      "A giraffe, the tallest animal on Earth, with spots and a long neck. Generally depicted in yellow or tan in full profile on all fours facing left, with distinctive brown spots and small, horn-like structures.",
  },
  {
    "web-scraper-order": "1666018299-646",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦙 Llama",
    "name-href": "https://emojipedia.org/llama/",
    emoji: "🦙",
    emojiName: "🦙 Llama",
    description:
      "A llama, a long-necked, camel-like animal, native to South America and used for transport and wool. Depicted as a shaggy white, light-brown, or multicolored llama in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018303-647",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐫 Two-Hump Camel",
    "name-href": "https://emojipedia.org/two-hump-camel/",
    emoji: "🐫",
    emojiName: "🐫 Two-Hump Camel",
    description:
      "A Bactrian camel, a long-necked mammal with two large humps on its back. Depicted in light or yellowish brown, sometimes with a shaggy mane and humps, in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018306-648",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐪 Camel",
    "name-href": "https://emojipedia.org/camel/",
    emoji: "🐪",
    emojiName: "🐪 Camel",
    description:
      "A dromedary camel, a long-necked mammal with one large hump on its back. Depicted in light or yellowish brown in full profile on all fours facing left.",
  },
  {
    "web-scraper-order": "1666018310-649",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐐 Goat",
    "name-href": "https://emojipedia.org/goat/",
    emoji: "🐐",
    emojiName: "🐐 Goat",
    description:
      "A goat, a sturdy, hoofed animal raised for its meat and milk. Depicted as a light brown, white, or multicored goat in full profile on all fours facing left, a scraggly beard, upright tail, and brown or yellow horns curving back.",
  },
  {
    "web-scraper-order": "1666018314-650",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐑 Ewe",
    "name-href": "https://emojipedia.org/ewe/",
    emoji: "🐑",
    emojiName: "🐑 Ewe",
    description:
      "A ewe, or female sheep raised for its wool, meat, and milk and without the spiraling horns of a ram. Depicted in full profile on all fours facing left with a thick, white fleece and black, gray, or white skin.",
  },
  {
    "web-scraper-order": "1666018319-651",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐏 Ram",
    "name-href": "https://emojipedia.org/ram/",
    emoji: "🐏",
    emojiName: "🐏 Ram",
    description:
      "A ram, a male sheep with large, spiraling horns. Generally depicted in full profile on all fours facing left with a thick, white fleece and light-brown horns.",
  },
  {
    "web-scraper-order": "1666018323-652",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐽 Pig Nose",
    "name-href": "https://emojipedia.org/pig-nose/",
    emoji: "🐽",
    emojiName: "🐽 Pig Nose",
    description:
      "The snout of a pig. Depicted as a pink oval or slightly pear-shaped nose with two black nostrils.",
  },
  {
    "web-scraper-order": "1666018327-653",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐗 Boar",
    "name-href": "https://emojipedia.org/boar/",
    emoji: "🐗",
    emojiName: "🐗 Boar",
    description:
      "A boar, a hairy, wild pig with tusks. Generally depicted as the face of a brown boar, either facing left or looking straight ahead, with prominent tusks projecting from its lower jaw.",
  },
  {
    "web-scraper-order": "1666018330-654",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐖 Pig",
    "name-href": "https://emojipedia.org/pig/",
    emoji: "🐖",
    emojiName: "🐖 Pig",
    description:
      "A pig, a plump animal farmed for its meat, such as bacon. Depicted in light pink in full profile on all fours facing left, with a long snout and short, curly tail.",
  },
  {
    "web-scraper-order": "1666018335-655",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐷 Pig Face",
    "name-href": "https://emojipedia.org/pig-face/",
    emoji: "🐷",
    emojiName: "🐷 Pig Face",
    description:
      "A friendly, cartoon-styled face of a pig looking straight ahead. Depicted as a pink face with a neutral expression, pointed or floppy ears, and distinctive pig nose.",
  },
  {
    "web-scraper-order": "1666018339-656",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐄 Cow",
    "name-href": "https://emojipedia.org/cow/",
    emoji: "🐄",
    emojiName: "🐄 Cow",
    description:
      "A cow, a bovine farmed for its meat or milk. Depicted in full profile on all fours facing left with a black-and-white patched coat (as a Holstein Friesian) and, on many platforms, a pink udder and horns.",
  },
  {
    "web-scraper-order": "1666018343-657",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐃 Water Buffalo",
    "name-href": "https://emojipedia.org/water-buffalo/",
    emoji: "🐃",
    emojiName: "🐃 Water Buffalo",
    description:
      "A water buffalo, a bovine used to plough rice fields in parts of Asia. Depicted in gray or black in full profile on all fours facing left, with a tail and broad horns curled up at the tips.",
  },
  {
    "web-scraper-order": "1666018347-658",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐂 Ox",
    "name-href": "https://emojipedia.org/ox/",
    emoji: "🐂",
    emojiName: "🐂 Ox",
    description:
      "An ox, a bovine used as a draft animal. Depicted in brown in full profile on all fours facing left, with a tail and short horns.",
  },
  {
    "web-scraper-order": "1666018352-659",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐮 Cow Face",
    "name-href": "https://emojipedia.org/cow-face/",
    emoji: "🐮",
    emojiName: "🐮 Cow Face",
    description:
      "A friendly, cartoon-styled face of a cow looking straight ahead. Variously depicted as a white, brown, or multicolored cow face with a neutral expression, short horns, and a pink or brown muzzle.",
  },
  {
    "web-scraper-order": "1666018356-660",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦬 Bison",
    "name-href": "https://emojipedia.org/bison/",
    emoji: "🦬",
    emojiName: "🦬 Bison",
    description:
      "A brown bison shown in full profile with horns, a beard, and woolly mane. Also called a buffalo in North America.",
  },
  {
    "web-scraper-order": "1666018360-661",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦌 Deer",
    "name-href": "https://emojipedia.org/deer/",
    emoji: "🦌",
    emojiName: "🦌 Deer",
    description:
      "A deer, a fleet-footed, hoofed mammal whose males (bucks, stags) generally have antlers. Variously depicted as a light-brown deer in full profile on all fours facing left or as a deer face looking straight head; both depictions feature large, branched antlers.",
  },
  {
    "web-scraper-order": "1666018365-662",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦓 Zebra",
    "name-href": "https://emojipedia.org/zebra/",
    emoji: "🦓",
    emojiName: "🦓 Zebra",
    description:
      "A zebra, a horse-like mammal with black-and-white stripes. Variously depicted in full profile on all fours facing left or as a zebra head facing left with a short mane.",
  },
  {
    "web-scraper-order": "1666018369-663",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦄 Unicorn",
    "name-href": "https://emojipedia.org/unicorn/",
    emoji: "🦄",
    emojiName: "🦄 Unicorn",
    description:
      "The face of a unicorn, a mythical creature in the form of a white horse with a single, long horn on its forehead. Generally depicted as a white horse head facing left with a pink or purple mane and a yellow or rainbow-colored horn.",
  },
  {
    "web-scraper-order": "1666018373-664",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐎 Horse",
    "name-href": "https://emojipedia.org/horse/",
    emoji: "🐎",
    emojiName: "🐎 Horse",
    description:
      "A horse, a hoofed mammal used for riding and racing. Depicted as a brown horse in full profile galloping to the left, with a dark, flowing mane and tail.",
  },
  {
    "web-scraper-order": "1666018378-665",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐴 Horse Face",
    "name-href": "https://emojipedia.org/horse-face/",
    emoji: "🐴",
    emojiName: "🐴 Horse Face",
    description:
      "The face of a horse, generally facing left. Depicted as a light or reddish-brown horse with a dark brown or black mane, and, on many platforms, a light-colored muzzle.",
  },
  {
    "web-scraper-order": "1666018382-666",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐆 Leopard",
    "name-href": "https://emojipedia.org/leopard/",
    emoji: "🐆",
    emojiName: "🐆 Leopard",
    description:
      "A leopard, a large cat with a yellowish-brown coat and black-and-gold spots. Depicted in full profile on all fours facing left, with a long tail and its distinctive pattern.",
  },
  {
    "web-scraper-order": "1666018386-667",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐅 Tiger",
    "name-href": "https://emojipedia.org/tiger/",
    emoji: "🐅",
    emojiName: "🐅 Tiger",
    description:
      "A tiger, a large cat with an orange coat and black stripes. Depicted in full profile on all fours facing left, with a long tail, its distinctive stripes, and, on some platforms, white patches.",
  },
  {
    "web-scraper-order": "1666018391-668",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐯 Tiger Face",
    "name-href": "https://emojipedia.org/tiger-face/",
    emoji: "🐯",
    emojiName: "🐯 Tiger Face",
    description:
      "A friendly, cartoon-styled face of a tiger looking straight ahead. Generally depicted in yellowish-orange with black stripes on its forehead and cheeks, a white muzzle, and neutral expression.",
  },
  {
    "web-scraper-order": "1666018396-669",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦁 Lion",
    "name-href": "https://emojipedia.org/lion/",
    emoji: "🦁",
    emojiName: "🦁 Lion",
    description:
      "A friendly, cartoon-styled face of a lion—the large cat and king of the jungle—looking straight ahead. Depicted as a golden-yellow lion face with a light- or dark-brown mane, white muzzle, and neutral expression.",
  },
  {
    "web-scraper-order": "1666018400-670",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐈‍⬛ Black Cat",
    "name-href": "https://emojipedia.org/black-cat/",
    emoji: "🐈‍⬛",
    emojiName: "🐈‍⬛ Black Cat",
    description:
      "A black cat shown in full profile, often with its tail curling upward.",
  },
  {
    "web-scraper-order": "1666018405-671",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐈 Cat",
    "name-href": "https://emojipedia.org/cat/",
    emoji: "🐈",
    emojiName: "🐈 Cat",
    description:
      "A domestic cat, beloved as a pet. Generally depicted as a light-orange cat with stripes, as a tabby, in full profile on all fours facing left, with its long tell held upright.",
  },
  {
    "web-scraper-order": "1666018409-672",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐱 Cat Face",
    "name-href": "https://emojipedia.org/cat-face/",
    emoji: "🐱",
    emojiName: "🐱 Cat Face",
    description:
      "Meow! A friendly, cartoon-styled face of a cat, looking straight ahead. Generally depicted as a yellowish-orange cat face with pointed ears and whiskers.",
  },
  {
    "web-scraper-order": "1666018414-673",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦝 Raccoon",
    "name-href": "https://emojipedia.org/raccoon/",
    emoji: "🦝",
    emojiName: "🦝 Raccoon",
    description:
      "A raccoon, a nocturnal mammal with a mask around its eyes. Generally depicted as a friendly, cartoon-styled, gray raccoon face looking straight ahead, with black-and-white markings around its eyes and pointed ears and cheeks.",
  },
  {
    "web-scraper-order": "1666018419-674",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦊 Fox",
    "name-href": "https://emojipedia.org/fox/",
    emoji: "🦊",
    emojiName: "🦊 Fox",
    description:
      "A friendly, cartoon-styled faced of a fox, the cunning canine, looking straight ahead. Depicted as an orange fox  face with a black nose, pointed ears, and shaggy, white cheeks.",
  },
  {
    "web-scraper-order": "1666018423-675",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐺 Wolf",
    "name-href": "https://emojipedia.org/wolf/",
    emoji: "🐺",
    emojiName: "🐺 Wolf",
    description:
      "The face of a wolf, a howling canine that hunts in packs. Generally depicted as a cartoon-styled face of a gray wolf with pointed ears, white cheeks and muzzle, and black nose.",
  },
  {
    "web-scraper-order": "1666018427-676",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐩 Poodle",
    "name-href": "https://emojipedia.org/poodle/",
    emoji: "🐩",
    emojiName: "🐩 Poodle",
    description:
      "A poodle, a popular dog breed with curly hair, often groomed in an ornamental pattern.",
  },
  {
    "web-scraper-order": "1666018431-677",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐕‍🦺 Service Dog",
    "name-href": "https://emojipedia.org/service-dog/",
    emoji: "🐕‍🦺",
    emojiName: "🐕‍🦺 Service Dog",
    description:
      "A service animal displayed with a safety vest and lead. Differs from the guide dog as this animal is intended for detection of seizures or other “hidden disabilities”, according to the proposal from Apple.",
  },
  {
    "web-scraper-order": "1666018435-678",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦮 Guide Dog",
    "name-href": "https://emojipedia.org/guide-dog/",
    emoji: "🦮",
    emojiName: "🦮 Guide Dog",
    description:
      "A guide (or Seeing Eye) dog, trained to help lead a person who is blind or visually impaired. Generally depicted as a yellowish-brown Labrador Retriever on all fours facing left, equipped with a harness and handle. Many platforms additionally include a collar.",
  },
  {
    "web-scraper-order": "1666018439-679",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐕 Dog",
    "name-href": "https://emojipedia.org/dog/",
    emoji: "🐕",
    emojiName: "🐕 Dog",
    description:
      "A dog, a faithful, beloved pet canine. Depicted as a light-brown dog, of various breeds, in full profile on all fours facing left, with a long, curled tail held upright and pointed or floppy ears.",
  },
  {
    "web-scraper-order": "1666018447-680",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐶 Dog Face",
    "name-href": "https://emojipedia.org/dog-face/",
    emoji: "🐶",
    emojiName: "🐶 Dog Face",
    description:
      "A friendly, cartoon-styled face of a dog, looking straight ahead. Depicted as the face of a dog of various breeds, generally light-brown and white, with pointed or floppy ears and its tongue hanging out.",
  },
  {
    "web-scraper-order": "1666018452-681",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦧 Orangutan",
    "name-href": "https://emojipedia.org/orangutan/",
    emoji: "🦧",
    emojiName: "🦧 Orangutan",
    description:
      "An orangutan, the orange-haired ape with long arms. Depicted facing forward, with a long broad face and sitting with its legs bent. Occasionally shown scratching its head. Color varies across platforms, ranging from orange to light brown.",
  },
  {
    "web-scraper-order": "1666018457-682",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🦍 Gorilla",
    "name-href": "https://emojipedia.org/gorilla/",
    emoji: "🦍",
    emojiName: "🦍 Gorilla",
    description:
      "A gorilla, the powerful, black-haired great ape. Variously depicted in full profile on all fours facing left or as a friendly, cartoon-styled gorilla face looking straight ahead.",
  },
  {
    "web-scraper-order": "1666018462-683",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐒 Monkey",
    "name-href": "https://emojipedia.org/monkey/",
    emoji: "🐒",
    emojiName: "🐒 Monkey",
    description:
      "A monkey, a small primate with long limbs and tail for climbing trees. Generally depicted as a cartoon-styled, brown monkey with a cheeky facial expression, shown in full profile facing left, sitting on its hind legs with a long, curled tail and round ears.",
  },
  {
    "web-scraper-order": "1666018465-684",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🐵 Monkey Face",
    "name-href": "https://emojipedia.org/monkey-face/",
    emoji: "🐵",
    emojiName: "🐵 Monkey Face",
    description:
      "A friendly, cartoon-styled face of a monkey, looking straight ahead. Depicted as a brown-haired monkey with a tan or pinkish face, round ears, nostrils, and open-mouthed grin.",
  },
  {
    "web-scraper-order": "1666018468-685",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💨 Dashing Away",
    "name-href": "https://emojipedia.org/dashing-away/",
    emoji: "💨",
    emojiName: "💨 Dashing Away",
    description:
      "A cartoon-styled gust of air. Depicted as a small, gray cloud with motion lines, rushing to the left.",
  },
  {
    "web-scraper-order": "1666018473-686",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💦 Sweat Droplets",
    "name-href": "https://emojipedia.org/sweat-droplets/",
    emoji: "💦",
    emojiName: "💦 Sweat Droplets",
    description:
      "Three, light blue droplets, as sweat beads, splashing down to the right. Resembles plewds, stylized sweat droplets used in comics and animation to show characters working hard or feeling stressed.",
  },
  {
    "web-scraper-order": "1666018477-687",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💫 Dizzy",
    "name-href": "https://emojipedia.org/dizzy/",
    emoji: "💫",
    emojiName: "💫 Dizzy",
    description:
      "A cartoon-styled representation of dizziness. Generally depicted as one or more yellow stars swirling in a yellow or blue circle.",
  },
  {
    "web-scraper-order": "1666018480-688",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "💥 Collision",
    "name-href": "https://emojipedia.org/collision/",
    emoji: "💥",
    emojiName: "💥 Collision",
    description:
      "A cartoon-styled representation of a collision. Depicted as a star-like, orange-and-yellow fiery burst, generally with one point extending to the bottom right, as if from the source of the collision.",
  },
  {
    "web-scraper-order": "1666018485-689",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙊 Speak-No-Evil Monkey",
    "name-href": "https://emojipedia.org/speak-no-evil-monkey/",
    emoji: "🙊",
    emojiName: "🙊 Speak-No-Evil Monkey",
    description:
      "The speak no evil monkey, called Iwazaru (Japanese for “say not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its mouth.",
  },
  {
    "web-scraper-order": "1666018490-690",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙉 Hear-No-Evil Monkey",
    "name-href": "https://emojipedia.org/hear-no-evil-monkey/",
    emoji: "🙉",
    emojiName: "🙉 Hear-No-Evil Monkey",
    description:
      "The hear no evil monkey, called Kikazaru (Japanese for “hear not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its ears.",
  },
  {
    "web-scraper-order": "1666018495-691",
    "web-scraper-start-url": "https://emojipedia.org/nature/",
    name: "🙈 See-No-Evil Monkey",
    "name-href": "https://emojipedia.org/see-no-evil-monkey/",
    emoji: "🙈",
    emojiName: "🙈 See-No-Evil Monkey",
    description:
      "The see no evil monkey, called Mizaru (Japanese for “see not”), one of the Three Wise Monkeys. Depicted as the brown 🐵 Monkey Face with hands covering its eyes.",
  },
  {
    "web-scraper-order": "1666026666-1339",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳‍🟧‍⬛‍🟧 Refugee Nation Flag",
    "flags-href": "https://emojipedia.org/refugee-nation-flag/",
    emoji: "🏳‍🟧‍⬛‍🟧",
    emojiName: "🏳‍🟧‍⬛‍🟧 Refugee Nation Flag",
    description:
      "The flag for Refugee Nation; a proposal to create a new nation to resettle refugees. This flag uses a shade of orange commonly used for life vests and life buoys at sea. A thin, horizontal black stripe is shown in the lower-third.",
  },
  {
    "web-scraper-order": "1666026669-1341",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁵󠁳󠁴󠁸󠁿 Flag for Texas (US-TX)",
    "flags-href": "https://emojipedia.org/flag-for-texas-ustx/",
    emoji: "🏴󠁵󠁳󠁴󠁸󠁿",
    emojiName: "🏴󠁵󠁳󠁴󠁸󠁿 Flag for Texas (US-TX)",
    description:
      "The Flag for Texas (US-TX) emoji is a tag sequence combining 🏴 Black Flag, 󠁵 Tag Latin Small Letter U, 󠁳 Tag Latin Small Letter S, 󠁴 Tag Latin Small Letter T, 󠁸 Tag Latin Small Letter X and 󠁿 Cancel Tag.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026672-1343",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Flag: Wales",
    "flags-href": "https://emojipedia.org/flag-wales/",
    emoji: "🏴󠁧󠁢󠁷󠁬󠁳󠁿",
    emojiName: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Flag: Wales",
    description:
      "The flag for Wales, a country in the United Kingdom. May show as the letters gbwls.",
  },
  {
    "web-scraper-order": "1666026674-1344",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁳󠁣󠁴󠁿 Flag: Scotland",
    "flags-href": "https://emojipedia.org/flag-scotland/",
    emoji: "🏴󠁧󠁢󠁳󠁣󠁴󠁿",
    emojiName: "🏴󠁧󠁢󠁳󠁣󠁴󠁿 Flag: Scotland",
    description:
      "The flag for Scotland, a country in the United Kingdom. May show as the letters gbsct.",
  },
  {
    "web-scraper-order": "1666026676-1346",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴󠁧󠁢󠁥󠁮󠁧󠁿 Flag: England",
    "flags-href": "https://emojipedia.org/flag-england/",
    emoji: "🏴󠁧󠁢󠁥󠁮󠁧󠁿",
    emojiName: "🏴󠁧󠁢󠁥󠁮󠁧󠁿 Flag: England",
    description:
      "The flag for England, a country in the United Kingdom. May show as the letters gbeng.",
  },
  {
    "web-scraper-order": "1666026679-1348",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇼 Flag: Zimbabwe",
    "flags-href": "https://emojipedia.org/flag-zimbabwe/",
    emoji: "🇿🇼",
    emojiName: "🇿🇼 Flag: Zimbabwe",
    description:
      "The flag for Zimbabwe, which may show as the letters ZW on some platforms.",
  },
  {
    "web-scraper-order": "1666026682-1350",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇲 Flag: Zambia",
    "flags-href": "https://emojipedia.org/flag-zambia/",
    emoji: "🇿🇲",
    emojiName: "🇿🇲 Flag: Zambia",
    description:
      "The flag for Zambia, which may show as the letters ZM on some platforms.",
  },
  {
    "web-scraper-order": "1666026684-1352",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇿🇦 Flag: South Africa",
    "flags-href": "https://emojipedia.org/flag-south-africa/",
    emoji: "🇿🇦",
    emojiName: "🇿🇦 Flag: South Africa",
    description:
      "The flag for South Africa, which may show as the letters ZA on some platforms.",
  },
  {
    "web-scraper-order": "1666026687-1353",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇾🇹 Flag: Mayotte",
    "flags-href": "https://emojipedia.org/flag-mayotte/",
    emoji: "🇾🇹",
    emojiName: "🇾🇹 Flag: Mayotte",
    description:
      "The flag for Mayotte, which may show as the letters YT on some platforms.",
  },
  {
    "web-scraper-order": "1666026690-1355",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇾🇪 Flag: Yemen",
    "flags-href": "https://emojipedia.org/flag-yemen/",
    emoji: "🇾🇪",
    emojiName: "🇾🇪 Flag: Yemen",
    description:
      "The flag for Yemen, which may show as the letters YE on some platforms.",
  },
  {
    "web-scraper-order": "1666026693-1357",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇽🇰 Flag: Kosovo",
    "flags-href": "https://emojipedia.org/flag-kosovo/",
    emoji: "🇽🇰",
    emojiName: "🇽🇰 Flag: Kosovo",
    description:
      "The flag for Kosovo, which may show as the letters XK on some platforms.",
  },
  {
    "web-scraper-order": "1666026695-1358",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇼🇸 Flag: Samoa",
    "flags-href": "https://emojipedia.org/flag-samoa/",
    emoji: "🇼🇸",
    emojiName: "🇼🇸 Flag: Samoa",
    description:
      "The flag for Samoa, which may show as the letters WS on some platforms.",
  },
  {
    "web-scraper-order": "1666026698-1360",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇼🇫 Flag: Wallis & Futuna",
    "flags-href": "https://emojipedia.org/flag-wallis-futuna/",
    emoji: "🇼🇫",
    emojiName: "🇼🇫 Flag: Wallis & Futuna",
    description:
      "The Flag: Wallis & Futuna emoji is a flag sequence combining 🇼 Regional Indicator Symbol Letter W and 🇫 Regional Indicator Symbol Letter F.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026701-1362",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇺 Flag: Vanuatu",
    "flags-href": "https://emojipedia.org/flag-vanuatu/",
    emoji: "🇻🇺",
    emojiName: "🇻🇺 Flag: Vanuatu",
    description:
      "The flag for Vanuatu, which may show as the letters VU on some platforms.",
  },
  {
    "web-scraper-order": "1666026705-1364",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇳 Flag: Vietnam",
    "flags-href": "https://emojipedia.org/flag-vietnam/",
    emoji: "🇻🇳",
    emojiName: "🇻🇳 Flag: Vietnam",
    description:
      "The flag for Vietnam, which may show as the letters VN on some platforms.",
  },
  {
    "web-scraper-order": "1666026709-1366",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇮 Flag: U.S. Virgin Islands",
    "flags-href": "https://emojipedia.org/flag-us-virgin-islands/",
    emoji: "🇻🇮",
    emojiName: "🇻🇮 Flag: U.S. Virgin Islands",
    description:
      "The flag for US Virgin Islands, which may show as the letters VI on some platforms.",
  },
  {
    "web-scraper-order": "1666026712-1368",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇬 Flag: British Virgin Islands",
    "flags-href": "https://emojipedia.org/flag-british-virgin-islands/",
    emoji: "🇻🇬",
    emojiName: "🇻🇬 Flag: British Virgin Islands",
    description:
      "The flag for British Virgin Islands, which may show as the letters VG on some platforms.",
  },
  {
    "web-scraper-order": "1666026715-1369",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇪 Flag: Venezuela",
    "flags-href": "https://emojipedia.org/flag-venezuela/",
    emoji: "🇻🇪",
    emojiName: "🇻🇪 Flag: Venezuela",
    description:
      "The flag for Venezuela, which may show as the letters VE on some platforms.",
  },
  {
    "web-scraper-order": "1666026717-1371",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇨 Flag: St. Vincent & Grenadines",
    "flags-href": "https://emojipedia.org/flag-st-vincent-grenadines/",
    emoji: "🇻🇨",
    emojiName: "🇻🇨 Flag: St. Vincent & Grenadines",
    description:
      "The Flag: St. Vincent & Grenadines emoji is a flag sequence combining 🇻 Regional Indicator Symbol Letter V and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026720-1373",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇻🇦 Flag: Vatican City",
    "flags-href": "https://emojipedia.org/flag-vatican-city/",
    emoji: "🇻🇦",
    emojiName: "🇻🇦 Flag: Vatican City",
    description:
      "The flag for Vatican City, which may show as the letters VA on some platforms.",
  },
  {
    "web-scraper-order": "1666026722-1374",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇿 Flag: Uzbekistan",
    "flags-href": "https://emojipedia.org/flag-uzbekistan/",
    emoji: "🇺🇿",
    emojiName: "🇺🇿 Flag: Uzbekistan",
    description:
      "The flag for Uzbekistan, which may show as the letters UZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026741-1378",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇾 Flag: Uruguay",
    "flags-href": "https://emojipedia.org/flag-uruguay/",
    emoji: "🇺🇾",
    emojiName: "🇺🇾 Flag: Uruguay",
    description:
      "The flag for Uruguay, which may show as the letters UY on some platforms.",
  },
  {
    "web-scraper-order": "1666026744-1380",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇸 Flag: United States",
    "flags-href": "https://emojipedia.org/flag-united-states/",
    emoji: "🇺🇸",
    emojiName: "🇺🇸 Flag: United States",
    description:
      "The flag for the United States of America (USA), which may show as the letters US on some platforms.",
  },
  {
    "web-scraper-order": "1666026746-1382",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇳 Flag: United Nations",
    "flags-href": "https://emojipedia.org/flag-united-nations/",
    emoji: "🇺🇳",
    emojiName: "🇺🇳 Flag: United Nations",
    description:
      "The flag for United Nations. May show as the letters UN. This two letter regional indicator pair is an exceptional reservation as part of ISO 3166.",
  },
  {
    "web-scraper-order": "1666026749-1384",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇲 Flag: U.S. Outlying Islands",
    "flags-href": "https://emojipedia.org/flag-us-outlying-islands/",
    emoji: "🇺🇲",
    emojiName: "🇺🇲 Flag: U.S. Outlying Islands",
    description:
      "The flag for U.S. Outlying Islands, which may show as the letters UM on some platforms. This is the same flag as the United States.",
  },
  {
    "web-scraper-order": "1666026752-1386",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇬 Flag: Uganda",
    "flags-href": "https://emojipedia.org/flag-uganda/",
    emoji: "🇺🇬",
    emojiName: "🇺🇬 Flag: Uganda",
    description:
      "The flag for Uganda, which may show as the letters UG on some platforms.",
  },
  {
    "web-scraper-order": "1666026754-1388",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇺🇦 Flag: Ukraine",
    "flags-href": "https://emojipedia.org/flag-ukraine/",
    emoji: "🇺🇦",
    emojiName: "🇺🇦 Flag: Ukraine",
    description:
      "The flag for Ukraine, which may show as the letters UA on some platforms.",
  },
  {
    "web-scraper-order": "1666026757-1390",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇿 Flag: Tanzania",
    "flags-href": "https://emojipedia.org/flag-tanzania/",
    emoji: "🇹🇿",
    emojiName: "🇹🇿 Flag: Tanzania",
    description:
      "The flag for Tanzania, which may show as the letters TZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026759-1392",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇼 Flag: Taiwan",
    "flags-href": "https://emojipedia.org/flag-taiwan/",
    emoji: "🇹🇼",
    emojiName: "🇹🇼 Flag: Taiwan",
    description:
      "The flag for Taiwan (officially Republic of China), which may show as the letters TW on some platforms.",
  },
  {
    "web-scraper-order": "1666026762-1394",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇻 Flag: Tuvalu",
    "flags-href": "https://emojipedia.org/flag-tuvalu/",
    emoji: "🇹🇻",
    emojiName: "🇹🇻 Flag: Tuvalu",
    description:
      "The flag for Tuvalu, which may show as the letters TV on some platforms.",
  },
  {
    "web-scraper-order": "1666026764-1396",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇹 Flag: Trinidad & Tobago",
    "flags-href": "https://emojipedia.org/flag-trinidad-tobago/",
    emoji: "🇹🇹",
    emojiName: "🇹🇹 Flag: Trinidad & Tobago",
    description:
      "The Flag: Trinidad & Tobago emoji is a flag sequence combining 🇹 Regional Indicator Symbol Letter T.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026767-1398",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇷 Flag: Turkey",
    "flags-href": "https://emojipedia.org/flag-turkey/",
    emoji: "🇹🇷",
    emojiName: "🇹🇷 Flag: Turkey",
    description:
      "The flag for Turkey, which may show as the letters TR on some platforms.",
  },
  {
    "web-scraper-order": "1666026769-1399",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇴 Flag: Tonga",
    "flags-href": "https://emojipedia.org/flag-tonga/",
    emoji: "🇹🇴",
    emojiName: "🇹🇴 Flag: Tonga",
    description:
      "The flag for Tonga, which may show as the letters TO on some platforms.",
  },
  {
    "web-scraper-order": "1666026771-1401",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇳 Flag: Tunisia",
    "flags-href": "https://emojipedia.org/flag-tunisia/",
    emoji: "🇹🇳",
    emojiName: "🇹🇳 Flag: Tunisia",
    description:
      "The flag for Tunisia, which may show as the letters TN on some platforms.",
  },
  {
    "web-scraper-order": "1666026774-1403",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇲 Flag: Turkmenistan",
    "flags-href": "https://emojipedia.org/flag-turkmenistan/",
    emoji: "🇹🇲",
    emojiName: "🇹🇲 Flag: Turkmenistan",
    description:
      "The flag for Turkmenistan, which may show as the letters TM on some platforms.",
  },
  {
    "web-scraper-order": "1666026777-1405",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇱 Flag: Timor-Leste",
    "flags-href": "https://emojipedia.org/flag-timor-leste/",
    emoji: "🇹🇱",
    emojiName: "🇹🇱 Flag: Timor-Leste",
    description:
      "The flag for East Timor, which may show as the letters TL on some platforms.",
  },
  {
    "web-scraper-order": "1666026780-1407",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇰 Flag: Tokelau",
    "flags-href": "https://emojipedia.org/flag-tokelau/",
    emoji: "🇹🇰",
    emojiName: "🇹🇰 Flag: Tokelau",
    description:
      "The flag for Tokelau, which may show as the letters TK on some platforms.",
  },
  {
    "web-scraper-order": "1666026783-1409",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇯 Flag: Tajikistan",
    "flags-href": "https://emojipedia.org/flag-tajikistan/",
    emoji: "🇹🇯",
    emojiName: "🇹🇯 Flag: Tajikistan",
    description:
      "The flag for Tajikistan, which may show as the letters TJ on some platforms.",
  },
  {
    "web-scraper-order": "1666026786-1411",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇭 Flag: Thailand",
    "flags-href": "https://emojipedia.org/flag-thailand/",
    emoji: "🇹🇭",
    emojiName: "🇹🇭 Flag: Thailand",
    description:
      "The flag for Thailand, which may show as the letters TH on some platforms.",
  },
  {
    "web-scraper-order": "1666026788-1413",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇬 Flag: Togo",
    "flags-href": "https://emojipedia.org/flag-togo/",
    emoji: "🇹🇬",
    emojiName: "🇹🇬 Flag: Togo",
    description:
      "The flag for Togo, which may show as the letters TG on some platforms.",
  },
  {
    "web-scraper-order": "1666026791-1415",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇫 Flag: French Southern Territories",
    "flags-href": "https://emojipedia.org/flag-french-southern-territories/",
    emoji: "🇹🇫",
    emojiName: "🇹🇫 Flag: French Southern Territories",
    description:
      "The flag for French Southern Territories, which may show as the letters TF on some platforms.",
  },
  {
    "web-scraper-order": "1666026793-1417",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇩 Flag: Chad",
    "flags-href": "https://emojipedia.org/flag-chad/",
    emoji: "🇹🇩",
    emojiName: "🇹🇩 Flag: Chad",
    description:
      "The flag for Chad, which may show as the letters TD on some platforms.",
  },
  {
    "web-scraper-order": "1666026796-1419",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇨 Flag: Turks & Caicos Islands",
    "flags-href": "https://emojipedia.org/flag-turks-caicos-islands/",
    emoji: "🇹🇨",
    emojiName: "🇹🇨 Flag: Turks & Caicos Islands",
    description:
      "The Flag: Turks & Caicos Islands emoji is a flag sequence combining 🇹 Regional Indicator Symbol Letter T and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026799-1421",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇹🇦 Flag: Tristan Da Cunha",
    "flags-href": "https://emojipedia.org/flag-tristan-da-cunha/",
    emoji: "🇹🇦",
    emojiName: "🇹🇦 Flag: Tristan Da Cunha",
    description:
      "The flag for Tristan da Cunha, which may show as the letters TA on some platforms. Apple devices show the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666026802-1423",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇿 Flag: Eswatini",
    "flags-href": "https://emojipedia.org/flag-eswatini/",
    emoji: "🇸🇿",
    emojiName: "🇸🇿 Flag: Eswatini",
    description:
      "The flag for Swaziland, which may show as the letters SZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026804-1425",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇾 Flag: Syria",
    "flags-href": "https://emojipedia.org/flag-syria/",
    emoji: "🇸🇾",
    emojiName: "🇸🇾 Flag: Syria",
    description:
      "The flag for Syria, which may show as the letters SY on some platforms.",
  },
  {
    "web-scraper-order": "1666026806-1427",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇽 Flag: Sint Maarten",
    "flags-href": "https://emojipedia.org/flag-sint-maarten/",
    emoji: "🇸🇽",
    emojiName: "🇸🇽 Flag: Sint Maarten",
    description:
      "The flag for Sint Maarten, which may show as the letters SX on some platforms. This is the Dutch half of the of the Caribbean island of Saint Martin. Not to be confused with St. Martin, the French half of the same island.",
  },
  {
    "web-scraper-order": "1666026809-1429",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇻 Flag: El Salvador",
    "flags-href": "https://emojipedia.org/flag-el-salvador/",
    emoji: "🇸🇻",
    emojiName: "🇸🇻 Flag: El Salvador",
    description:
      "The flag for El Salvador, which may show as the letters SV on some platforms.",
  },
  {
    "web-scraper-order": "1666026812-1431",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇹 Flag: São Tomé & Príncipe",
    "flags-href": "https://emojipedia.org/flag-sao-tome-principe/",
    emoji: "🇸🇹",
    emojiName: "🇸🇹 Flag: São Tomé & Príncipe",
    description:
      "The Flag: São Tomé & Príncipe emoji is a flag sequence combining 🇸 Regional Indicator Symbol Letter S and 🇹 Regional Indicator Symbol Letter T.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026815-1434",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇸 Flag: South Sudan",
    "flags-href": "https://emojipedia.org/flag-south-sudan/",
    emoji: "🇸🇸",
    emojiName: "🇸🇸 Flag: South Sudan",
    description:
      "The flag for South Sudan, which may show as the letters SS on some platforms.",
  },
  {
    "web-scraper-order": "1666026818-1436",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇷 Flag: Suriname",
    "flags-href": "https://emojipedia.org/flag-suriname/",
    emoji: "🇸🇷",
    emojiName: "🇸🇷 Flag: Suriname",
    description:
      "The flag for Suriname, which may show as the letters SR on some platforms.",
  },
  {
    "web-scraper-order": "1666026821-1438",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇴 Flag: Somalia",
    "flags-href": "https://emojipedia.org/flag-somalia/",
    emoji: "🇸🇴",
    emojiName: "🇸🇴 Flag: Somalia",
    description:
      "The flag for Somalia, which may show as the letters SO on some platforms.",
  },
  {
    "web-scraper-order": "1666026823-1440",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇳 Flag: Senegal",
    "flags-href": "https://emojipedia.org/flag-senegal/",
    emoji: "🇸🇳",
    emojiName: "🇸🇳 Flag: Senegal",
    description:
      "The flag for Senegal, which may show as the letters SN on some platforms.",
  },
  {
    "web-scraper-order": "1666026826-1442",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇲 Flag: San Marino",
    "flags-href": "https://emojipedia.org/flag-san-marino/",
    emoji: "🇸🇲",
    emojiName: "🇸🇲 Flag: San Marino",
    description:
      "The flag for San Marino, which may show as the letters SM on some platforms.",
  },
  {
    "web-scraper-order": "1666026829-1444",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇱 Flag: Sierra Leone",
    "flags-href": "https://emojipedia.org/flag-sierra-leone/",
    emoji: "🇸🇱",
    emojiName: "🇸🇱 Flag: Sierra Leone",
    description:
      "The flag for Sierra Leone, which may show as the letters SL on some platforms.",
  },
  {
    "web-scraper-order": "1666026831-1446",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇰 Flag: Slovakia",
    "flags-href": "https://emojipedia.org/flag-slovakia/",
    emoji: "🇸🇰",
    emojiName: "🇸🇰 Flag: Slovakia",
    description:
      "The flag for Slovakia, which may show as the letters SK on some platforms.",
  },
  {
    "web-scraper-order": "1666026833-1448",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇯 Flag: Svalbard & Jan Mayen",
    "flags-href": "https://emojipedia.org/flag-svalbard-jan-mayen/",
    emoji: "🇸🇯",
    emojiName: "🇸🇯 Flag: Svalbard & Jan Mayen",
    description:
      "The flag for Svalbard & Jan Mayen, which may show as the letters SJ on some platforms. This is the same flag as Norway.",
  },
  {
    "web-scraper-order": "1666026836-1450",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇮 Flag: Slovenia",
    "flags-href": "https://emojipedia.org/flag-slovenia/",
    emoji: "🇸🇮",
    emojiName: "🇸🇮 Flag: Slovenia",
    description:
      "The flag for Slovenia, which may show as the letters SI on some platforms.",
  },
  {
    "web-scraper-order": "1666026839-1452",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇭 Flag: St. Helena",
    "flags-href": "https://emojipedia.org/flag-st-helena/",
    emoji: "🇸🇭",
    emojiName: "🇸🇭 Flag: St. Helena",
    description:
      "The flag for St. Helena, which may show as the letters SH on some platforms. Apple devices display the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666026841-1454",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇬 Flag: Singapore",
    "flags-href": "https://emojipedia.org/flag-singapore/",
    emoji: "🇸🇬",
    emojiName: "🇸🇬 Flag: Singapore",
    description:
      "The flag for Singapore, which may show as the letters SG on some platforms.",
  },
  {
    "web-scraper-order": "1666026843-1456",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇪 Flag: Sweden",
    "flags-href": "https://emojipedia.org/flag-sweden/",
    emoji: "🇸🇪",
    emojiName: "🇸🇪 Flag: Sweden",
    description:
      "The flag for Sweden, which may show as the letters SE on some platforms.",
  },
  {
    "web-scraper-order": "1666026846-1458",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇩 Flag: Sudan",
    "flags-href": "https://emojipedia.org/flag-sudan/",
    emoji: "🇸🇩",
    emojiName: "🇸🇩 Flag: Sudan",
    description:
      "The flag for Sudan, which may show as the letters SD on some platforms.",
  },
  {
    "web-scraper-order": "1666026849-1460",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇨 Flag: Seychelles",
    "flags-href": "https://emojipedia.org/flag-seychelles/",
    emoji: "🇸🇨",
    emojiName: "🇸🇨 Flag: Seychelles",
    description:
      "The flag for Seychelles, which may show as the letters SC on some platforms.",
  },
  {
    "web-scraper-order": "1666026852-1462",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇧 Flag: Solomon Islands",
    "flags-href": "https://emojipedia.org/flag-solomon-islands/",
    emoji: "🇸🇧",
    emojiName: "🇸🇧 Flag: Solomon Islands",
    description:
      "The flag for Solomon Islands, which may show as the letters SB on some platforms.",
  },
  {
    "web-scraper-order": "1666026854-1464",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇸🇦 Flag: Saudi Arabia",
    "flags-href": "https://emojipedia.org/flag-saudi-arabia/",
    emoji: "🇸🇦",
    emojiName: "🇸🇦 Flag: Saudi Arabia",
    description:
      "The flag for Saudi Arabia, which may show as the letters SA on some platforms.",
  },
  {
    "web-scraper-order": "1666026856-1466",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇼 Flag: Rwanda",
    "flags-href": "https://emojipedia.org/flag-rwanda/",
    emoji: "🇷🇼",
    emojiName: "🇷🇼 Flag: Rwanda",
    description:
      "The flag for Rwanda, which may show as the letters RW on some platforms.",
  },
  {
    "web-scraper-order": "1666026859-1468",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇺 Flag: Russia",
    "flags-href": "https://emojipedia.org/flag-russia/",
    emoji: "🇷🇺",
    emojiName: "🇷🇺 Flag: Russia",
    description:
      "The flag for Russia, which may show as the letters RU on some platforms.",
  },
  {
    "web-scraper-order": "1666026861-1470",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇸 Flag: Serbia",
    "flags-href": "https://emojipedia.org/flag-serbia/",
    emoji: "🇷🇸",
    emojiName: "🇷🇸 Flag: Serbia",
    description:
      "The flag for Serbia, which may show as the letters RS on some platforms.",
  },
  {
    "web-scraper-order": "1666026864-1472",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇴 Flag: Romania",
    "flags-href": "https://emojipedia.org/flag-romania/",
    emoji: "🇷🇴",
    emojiName: "🇷🇴 Flag: Romania",
    description:
      "The flag for Romania, which may show as the letters RO on some platforms.",
  },
  {
    "web-scraper-order": "1666026867-1474",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇷🇪 Flag: Réunion",
    "flags-href": "https://emojipedia.org/flag-reunion/",
    emoji: "🇷🇪",
    emojiName: "🇷🇪 Flag: Réunion",
    description:
      "The flag for Réunion, which may show as the letters RE on some platforms.",
  },
  {
    "web-scraper-order": "1666026869-1476",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇶🇦 Flag: Qatar",
    "flags-href": "https://emojipedia.org/flag-qatar/",
    emoji: "🇶🇦",
    emojiName: "🇶🇦 Flag: Qatar",
    description:
      "The flag for Qatar, which may show as the letters QA on some platforms.",
  },
  {
    "web-scraper-order": "1666026872-1478",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇾 Flag: Paraguay",
    "flags-href": "https://emojipedia.org/flag-paraguay/",
    emoji: "🇵🇾",
    emojiName: "🇵🇾 Flag: Paraguay",
    description:
      "The flag for Paraguay, which may show as the letters PY on some platforms.",
  },
  {
    "web-scraper-order": "1666026874-1480",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇼 Flag: Palau",
    "flags-href": "https://emojipedia.org/flag-palau/",
    emoji: "🇵🇼",
    emojiName: "🇵🇼 Flag: Palau",
    description:
      "The flag for Palau, which may show as the letters PW on some platforms.",
  },
  {
    "web-scraper-order": "1666026877-1482",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇹 Flag: Portugal",
    "flags-href": "https://emojipedia.org/flag-portugal/",
    emoji: "🇵🇹",
    emojiName: "🇵🇹 Flag: Portugal",
    description:
      "The flag for Portugal, which may show as the letters PT on some platforms.",
  },
  {
    "web-scraper-order": "1666026879-1484",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇸 Flag: Palestinian Territories",
    "flags-href": "https://emojipedia.org/flag-palestinian-territories/",
    emoji: "🇵🇸",
    emojiName: "🇵🇸 Flag: Palestinian Territories",
    description:
      "The Flag: Palestinian Territories emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇸 Regional Indicator Symbol Letter S.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026882-1486",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇷 Flag: Puerto Rico",
    "flags-href": "https://emojipedia.org/flag-puerto-rico/",
    emoji: "🇵🇷",
    emojiName: "🇵🇷 Flag: Puerto Rico",
    description:
      "The flag for Puerto Rico, which may show as the letters PR on some platforms.",
  },
  {
    "web-scraper-order": "1666026886-1488",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇳 Flag: Pitcairn Islands",
    "flags-href": "https://emojipedia.org/flag-pitcairn-islands/",
    emoji: "🇵🇳",
    emojiName: "🇵🇳 Flag: Pitcairn Islands",
    description:
      "The Flag: Pitcairn Islands emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇳 Regional Indicator Symbol Letter N.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026889-1490",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇲 Flag: St. Pierre & Miquelon",
    "flags-href": "https://emojipedia.org/flag-st-pierre-miquelon/",
    emoji: "🇵🇲",
    emojiName: "🇵🇲 Flag: St. Pierre & Miquelon",
    description:
      "The Flag: St. Pierre & Miquelon emoji is a flag sequence combining 🇵 Regional Indicator Symbol Letter P and 🇲 Regional Indicator Symbol Letter M.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026892-1492",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇱 Flag: Poland",
    "flags-href": "https://emojipedia.org/flag-poland/",
    emoji: "🇵🇱",
    emojiName: "🇵🇱 Flag: Poland",
    description:
      "The flag for Poland, which may show as the letters PL on some platforms.",
  },
  {
    "web-scraper-order": "1666026895-1494",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇰 Flag: Pakistan",
    "flags-href": "https://emojipedia.org/flag-pakistan/",
    emoji: "🇵🇰",
    emojiName: "🇵🇰 Flag: Pakistan",
    description:
      "The flag for Pakistan, which may show as the letters PK on some platforms.",
  },
  {
    "web-scraper-order": "1666026898-1495",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇭 Flag: Philippines",
    "flags-href": "https://emojipedia.org/flag-philippines/",
    emoji: "🇵🇭",
    emojiName: "🇵🇭 Flag: Philippines",
    description:
      "The flag for Philippines, which may show as the letters PH on some platforms.",
  },
  {
    "web-scraper-order": "1666026900-1497",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇬 Flag: Papua New Guinea",
    "flags-href": "https://emojipedia.org/flag-papua-new-guinea/",
    emoji: "🇵🇬",
    emojiName: "🇵🇬 Flag: Papua New Guinea",
    description:
      "The flag for Papua New Guinea, which may show as the letters PG on some platforms.",
  },
  {
    "web-scraper-order": "1666026904-1499",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇫 Flag: French Polynesia",
    "flags-href": "https://emojipedia.org/flag-french-polynesia/",
    emoji: "🇵🇫",
    emojiName: "🇵🇫 Flag: French Polynesia",
    description:
      "The flag for French Polynesia, which may show as the letters PF on some platforms.",
  },
  {
    "web-scraper-order": "1666026907-1501",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇪 Flag: Peru",
    "flags-href": "https://emojipedia.org/flag-peru/",
    emoji: "🇵🇪",
    emojiName: "🇵🇪 Flag: Peru",
    description:
      "The flag for Peru, which may show as the letters PE on some platforms.",
  },
  {
    "web-scraper-order": "1666026910-1503",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇵🇦 Flag: Panama",
    "flags-href": "https://emojipedia.org/flag-panama/",
    emoji: "🇵🇦",
    emojiName: "🇵🇦 Flag: Panama",
    description:
      "The flag for Panama, which may show as the letters PA on some platforms.",
  },
  {
    "web-scraper-order": "1666026913-1505",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇴🇲 Flag: Oman",
    "flags-href": "https://emojipedia.org/flag-oman/",
    emoji: "🇴🇲",
    emojiName: "🇴🇲 Flag: Oman",
    description:
      "The flag for Oman, which may show as the letters OM on some platforms.",
  },
  {
    "web-scraper-order": "1666026916-1507",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇿 Flag: New Zealand",
    "flags-href": "https://emojipedia.org/flag-new-zealand/",
    emoji: "🇳🇿",
    emojiName: "🇳🇿 Flag: New Zealand",
    description:
      "The flag for New Zealand, which may show as the letters NZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026919-1509",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇺 Flag: Niue",
    "flags-href": "https://emojipedia.org/flag-niue/",
    emoji: "🇳🇺",
    emojiName: "🇳🇺 Flag: Niue",
    description:
      "The flag for Niue, which may show as the letters NU on some platforms.",
  },
  {
    "web-scraper-order": "1666026922-1511",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇷 Flag: Nauru",
    "flags-href": "https://emojipedia.org/flag-nauru/",
    emoji: "🇳🇷",
    emojiName: "🇳🇷 Flag: Nauru",
    description:
      "The flag for Nauru, which may show as the letters NR on some platforms.",
  },
  {
    "web-scraper-order": "1666026924-1512",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇵 Flag: Nepal",
    "flags-href": "https://emojipedia.org/flag-nepal/",
    emoji: "🇳🇵",
    emojiName: "🇳🇵 Flag: Nepal",
    description:
      "The flag for Nepal, which may show as the letters NP on some platforms.",
  },
  {
    "web-scraper-order": "1666026928-1514",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇴 Flag: Norway",
    "flags-href": "https://emojipedia.org/flag-norway/",
    emoji: "🇳🇴",
    emojiName: "🇳🇴 Flag: Norway",
    description:
      "The flag for Norway, which may show as the letters NO on some platforms.",
  },
  {
    "web-scraper-order": "1666026930-1516",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇱 Flag: Netherlands",
    "flags-href": "https://emojipedia.org/flag-netherlands/",
    emoji: "🇳🇱",
    emojiName: "🇳🇱 Flag: Netherlands",
    description:
      "The flag for Netherlands, which may show as the letters NL on some platforms.",
  },
  {
    "web-scraper-order": "1666026933-1517",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇮 Flag: Nicaragua",
    "flags-href": "https://emojipedia.org/flag-nicaragua/",
    emoji: "🇳🇮",
    emojiName: "🇳🇮 Flag: Nicaragua",
    description:
      "The flag for Nicaragua, which may show as the letters NI on some platforms.",
  },
  {
    "web-scraper-order": "1666026936-1519",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇬 Flag: Nigeria",
    "flags-href": "https://emojipedia.org/flag-nigeria/",
    emoji: "🇳🇬",
    emojiName: "🇳🇬 Flag: Nigeria",
    description:
      "The flag for Nigeria, which may show as the letters NG on some platforms.",
  },
  {
    "web-scraper-order": "1666026938-1522",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇫 Flag: Norfolk Island",
    "flags-href": "https://emojipedia.org/flag-norfolk-island/",
    emoji: "🇳🇫",
    emojiName: "🇳🇫 Flag: Norfolk Island",
    description:
      "The flag for Norfolk Island, which may show as the letters NF on some platforms.",
  },
  {
    "web-scraper-order": "1666026941-1523",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇪 Flag: Niger",
    "flags-href": "https://emojipedia.org/flag-niger/",
    emoji: "🇳🇪",
    emojiName: "🇳🇪 Flag: Niger",
    description:
      "The flag for Niger, which may show as the letters NE on some platforms.",
  },
  {
    "web-scraper-order": "1666026943-1525",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇨 Flag: New Caledonia",
    "flags-href": "https://emojipedia.org/flag-new-caledonia/",
    emoji: "🇳🇨",
    emojiName: "🇳🇨 Flag: New Caledonia",
    description:
      "The flag for New Caledonia, which may show as the letters NC on some platforms.",
  },
  {
    "web-scraper-order": "1666026946-1526",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇳🇦 Flag: Namibia",
    "flags-href": "https://emojipedia.org/flag-namibia/",
    emoji: "🇳🇦",
    emojiName: "🇳🇦 Flag: Namibia",
    description:
      "The flag for Namibia, which may show as the letters NA on some platforms.",
  },
  {
    "web-scraper-order": "1666026949-1528",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇿 Flag: Mozambique",
    "flags-href": "https://emojipedia.org/flag-mozambique/",
    emoji: "🇲🇿",
    emojiName: "🇲🇿 Flag: Mozambique",
    description:
      "The flag for Mozambique, which may show as the letters MZ on some platforms.",
  },
  {
    "web-scraper-order": "1666026952-1530",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇾 Flag: Malaysia",
    "flags-href": "https://emojipedia.org/flag-malaysia/",
    emoji: "🇲🇾",
    emojiName: "🇲🇾 Flag: Malaysia",
    description:
      "The flag for Malaysia, which may show as the letters MY on some platforms.",
  },
  {
    "web-scraper-order": "1666026954-1532",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇽 Flag: Mexico",
    "flags-href": "https://emojipedia.org/flag-mexico/",
    emoji: "🇲🇽",
    emojiName: "🇲🇽 Flag: Mexico",
    description:
      "The flag for Mexico, which may show as the letters MX on some platforms.",
  },
  {
    "web-scraper-order": "1666026957-1534",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇼 Flag: Malawi",
    "flags-href": "https://emojipedia.org/flag-malawi/",
    emoji: "🇲🇼",
    emojiName: "🇲🇼 Flag: Malawi",
    description:
      "The flag for Malawi, which may show as the letters MW on some platforms.",
  },
  {
    "web-scraper-order": "1666026960-1536",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇻 Flag: Maldives",
    "flags-href": "https://emojipedia.org/flag-maldives/",
    emoji: "🇲🇻",
    emojiName: "🇲🇻 Flag: Maldives",
    description:
      "The flag for Maldives, which may show as the letters MV on some platforms.",
  },
  {
    "web-scraper-order": "1666026963-1537",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇺 Flag: Mauritius",
    "flags-href": "https://emojipedia.org/flag-mauritius/",
    emoji: "🇲🇺",
    emojiName: "🇲🇺 Flag: Mauritius",
    description:
      "The flag for Mauritius, which may show as the letters MU on some platforms.",
  },
  {
    "web-scraper-order": "1666026965-1539",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇹 Flag: Malta",
    "flags-href": "https://emojipedia.org/flag-malta/",
    emoji: "🇲🇹",
    emojiName: "🇲🇹 Flag: Malta",
    description:
      "The flag for Malta, which may show as the letters MT on some platforms.",
  },
  {
    "web-scraper-order": "1666026969-1541",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇸 Flag: Montserrat",
    "flags-href": "https://emojipedia.org/flag-montserrat/",
    emoji: "🇲🇸",
    emojiName: "🇲🇸 Flag: Montserrat",
    description:
      "The flag for Montserrat, which may show as the letters MS on some platforms.",
  },
  {
    "web-scraper-order": "1666026971-1543",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇷 Flag: Mauritania",
    "flags-href": "https://emojipedia.org/flag-mauritania/",
    emoji: "🇲🇷",
    emojiName: "🇲🇷 Flag: Mauritania",
    description:
      "The flag for Mauritania, which may show as the letters MR on some platforms. This design changed in August 2017, adding a red band at the top and bottom.",
  },
  {
    "web-scraper-order": "1666026990-1545",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇶 Flag: Martinique",
    "flags-href": "https://emojipedia.org/flag-martinique/",
    emoji: "🇲🇶",
    emojiName: "🇲🇶 Flag: Martinique",
    description:
      "The flag for Martinique, which may show as the letters MQ on some platforms.",
  },
  {
    "web-scraper-order": "1666026993-1548",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇵 Flag: Northern Mariana Islands",
    "flags-href": "https://emojipedia.org/flag-northern-mariana-islands/",
    emoji: "🇲🇵",
    emojiName: "🇲🇵 Flag: Northern Mariana Islands",
    description:
      "The flag for Northern Mariana Islands, which may show as the letters MP on some platforms.",
  },
  {
    "web-scraper-order": "1666026996-1551",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇴 Flag: Macao Sar China",
    "flags-href": "https://emojipedia.org/flag-macao-sar-china/",
    emoji: "🇲🇴",
    emojiName: "🇲🇴 Flag: Macao Sar China",
    description:
      "The flag for Macau, which may show as the letters MO on some platforms.",
  },
  {
    "web-scraper-order": "1666026999-1555",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇳 Flag: Mongolia",
    "flags-href": "https://emojipedia.org/flag-mongolia/",
    emoji: "🇲🇳",
    emojiName: "🇲🇳 Flag: Mongolia",
    description:
      "The flag for Mongolia, which may show as the letters MN on some platforms.",
  },
  {
    "web-scraper-order": "1666027002-1557",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇲 Flag: Myanmar (Burma)",
    "flags-href": "https://emojipedia.org/flag-myanmar-burma/",
    emoji: "🇲🇲",
    emojiName: "🇲🇲 Flag: Myanmar (Burma)",
    description:
      "The flag for Myanmar, which may show as the letters MM on some platforms.",
  },
  {
    "web-scraper-order": "1666027005-1560",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇱 Flag: Mali",
    "flags-href": "https://emojipedia.org/flag-mali/",
    emoji: "🇲🇱",
    emojiName: "🇲🇱 Flag: Mali",
    description:
      "The flag for Mali, which may show as the letters ML on some platforms.",
  },
  {
    "web-scraper-order": "1666027008-1564",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇰 Flag: North Macedonia",
    "flags-href": "https://emojipedia.org/flag-north-macedonia/",
    emoji: "🇲🇰",
    emojiName: "🇲🇰 Flag: North Macedonia",
    description:
      "The flag for North Macedonia (until 2019: Macedonia), which may show as the letters MK on some platforms.",
  },
  {
    "web-scraper-order": "1666027012-1567",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇭 Flag: Marshall Islands",
    "flags-href": "https://emojipedia.org/flag-marshall-islands/",
    emoji: "🇲🇭",
    emojiName: "🇲🇭 Flag: Marshall Islands",
    description:
      "The flag for Marshall Islands, which may show as the letters MH on some platforms.",
  },
  {
    "web-scraper-order": "1666027015-1571",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇬 Flag: Madagascar",
    "flags-href": "https://emojipedia.org/flag-madagascar/",
    emoji: "🇲🇬",
    emojiName: "🇲🇬 Flag: Madagascar",
    description:
      "The flag for Madagascar, which may show as the letters MG on some platforms",
  },
  {
    "web-scraper-order": "1666027018-1574",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇫 Flag: St. Martin",
    "flags-href": "https://emojipedia.org/flag-st-martin/",
    emoji: "🇲🇫",
    emojiName: "🇲🇫 Flag: St. Martin",
    description:
      "The flag for St. Martin, which may show as the letters MF on some platforms. This is the French half of the of the Caribbean island of Saint Martin. Not to be confused with Sint Maarten, the Dutch half of the same island.",
  },
  {
    "web-scraper-order": "1666027020-1577",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇪 Flag: Montenegro",
    "flags-href": "https://emojipedia.org/flag-montenegro/",
    emoji: "🇲🇪",
    emojiName: "🇲🇪 Flag: Montenegro",
    description:
      "The flag for Montenegro, which may show as the letters ME on some platforms",
  },
  {
    "web-scraper-order": "1666027023-1580",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇩 Flag: Moldova",
    "flags-href": "https://emojipedia.org/flag-moldova/",
    emoji: "🇲🇩",
    emojiName: "🇲🇩 Flag: Moldova",
    description:
      "The flag for Moldova, which may show as the letters MD on some platforms.",
  },
  {
    "web-scraper-order": "1666027025-1583",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇨 Flag: Monaco",
    "flags-href": "https://emojipedia.org/flag-monaco/",
    emoji: "🇲🇨",
    emojiName: "🇲🇨 Flag: Monaco",
    description:
      "The flag for Monaco, which may show as the letters MC on some platforms.",
  },
  {
    "web-scraper-order": "1666027027-1586",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇲🇦 Flag: Morocco",
    "flags-href": "https://emojipedia.org/flag-morocco/",
    emoji: "🇲🇦",
    emojiName: "🇲🇦 Flag: Morocco",
    description:
      "The flag for Morocco, which may show as the letters MA on some platforms.",
  },
  {
    "web-scraper-order": "1666027030-1589",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇾 Flag: Libya",
    "flags-href": "https://emojipedia.org/flag-libya/",
    emoji: "🇱🇾",
    emojiName: "🇱🇾 Flag: Libya",
    description:
      "The flag for Libya, which may show as the letters LY on some platforms.",
  },
  {
    "web-scraper-order": "1666027032-1592",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇻 Flag: Latvia",
    "flags-href": "https://emojipedia.org/flag-latvia/",
    emoji: "🇱🇻",
    emojiName: "🇱🇻 Flag: Latvia",
    description:
      "The flag for Latvia, which may show as the letters LV on some platforms.",
  },
  {
    "web-scraper-order": "1666027035-1595",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇺 Flag: Luxembourg",
    "flags-href": "https://emojipedia.org/flag-luxembourg/",
    emoji: "🇱🇺",
    emojiName: "🇱🇺 Flag: Luxembourg",
    description:
      "The flag for Luxembourg, which may show as the letters LU on some platforms",
  },
  {
    "web-scraper-order": "1666027038-1598",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇹 Flag: Lithuania",
    "flags-href": "https://emojipedia.org/flag-lithuania/",
    emoji: "🇱🇹",
    emojiName: "🇱🇹 Flag: Lithuania",
    description:
      "The flag for Lithuania, which may show as the letters LT on some platforms.",
  },
  {
    "web-scraper-order": "1666027041-1601",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇸 Flag: Lesotho",
    "flags-href": "https://emojipedia.org/flag-lesotho/",
    emoji: "🇱🇸",
    emojiName: "🇱🇸 Flag: Lesotho",
    description:
      "The flag for Lesotho, which may show as the letters LS on some platforms.",
  },
  {
    "web-scraper-order": "1666027043-1604",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇷 Flag: Liberia",
    "flags-href": "https://emojipedia.org/flag-liberia/",
    emoji: "🇱🇷",
    emojiName: "🇱🇷 Flag: Liberia",
    description:
      "The flag for Liberia, which may show as the letters LR on some platforms.",
  },
  {
    "web-scraper-order": "1666027046-1607",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇰 Flag: Sri Lanka",
    "flags-href": "https://emojipedia.org/flag-sri-lanka/",
    emoji: "🇱🇰",
    emojiName: "🇱🇰 Flag: Sri Lanka",
    description:
      "The flag for Sri Lanka, which may show as the letters LK on some platforms.",
  },
  {
    "web-scraper-order": "1666027049-1611",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇮 Flag: Liechtenstein",
    "flags-href": "https://emojipedia.org/flag-liechtenstein/",
    emoji: "🇱🇮",
    emojiName: "🇱🇮 Flag: Liechtenstein",
    description:
      "The flag for Liechtenstein, which may show as the letters LI on some platforms.",
  },
  {
    "web-scraper-order": "1666027052-1614",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇨 Flag: St. Lucia",
    "flags-href": "https://emojipedia.org/flag-st-lucia/",
    emoji: "🇱🇨",
    emojiName: "🇱🇨 Flag: St. Lucia",
    description:
      "The Flag: St. Lucia emoji is a flag sequence combining 🇱 Regional Indicator Symbol Letter L and 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027055-1617",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇧 Flag: Lebanon",
    "flags-href": "https://emojipedia.org/flag-lebanon/",
    emoji: "🇱🇧",
    emojiName: "🇱🇧 Flag: Lebanon",
    description:
      "The flag for Lebanon, which may show as the letters LB on some platforms.",
  },
  {
    "web-scraper-order": "1666027057-1620",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇱🇦 Flag: Laos",
    "flags-href": "https://emojipedia.org/flag-laos/",
    emoji: "🇱🇦",
    emojiName: "🇱🇦 Flag: Laos",
    description:
      "The flag for Laos, which may show as the letters LA on some platforms.",
  },
  {
    "web-scraper-order": "1666027060-1623",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇿 Flag: Kazakhstan",
    "flags-href": "https://emojipedia.org/flag-kazakhstan/",
    emoji: "🇰🇿",
    emojiName: "🇰🇿 Flag: Kazakhstan",
    description:
      "The flag for Kazakhstan, which may show as the letters KZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027063-1626",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇾 Flag: Cayman Islands",
    "flags-href": "https://emojipedia.org/flag-cayman-islands/",
    emoji: "🇰🇾",
    emojiName: "🇰🇾 Flag: Cayman Islands",
    description:
      "The flag for Cayman Islands, which may show as the letters KY on some platforms.",
  },
  {
    "web-scraper-order": "1666027065-1629",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇼 Flag: Kuwait",
    "flags-href": "https://emojipedia.org/flag-kuwait/",
    emoji: "🇰🇼",
    emojiName: "🇰🇼 Flag: Kuwait",
    description:
      "The flag for Kuwait, which may show as the letters KW on some platforms.",
  },
  {
    "web-scraper-order": "1666027067-1632",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇷 Flag: South Korea",
    "flags-href": "https://emojipedia.org/flag-south-korea/",
    emoji: "🇰🇷",
    emojiName: "🇰🇷 Flag: South Korea",
    description:
      "The flag for South Korea, which may show as the letters KR on some platforms.",
  },
  {
    "web-scraper-order": "1666027070-1635",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇵 Flag: North Korea",
    "flags-href": "https://emojipedia.org/flag-north-korea/",
    emoji: "🇰🇵",
    emojiName: "🇰🇵 Flag: North Korea",
    description:
      "The flag for North Korea, which may show as the letters KP on some platforms.",
  },
  {
    "web-scraper-order": "1666027072-1638",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇳 Flag: St. Kitts & Nevis",
    "flags-href": "https://emojipedia.org/flag-st-kitts-nevis/",
    emoji: "🇰🇳",
    emojiName: "🇰🇳 Flag: St. Kitts & Nevis",
    description:
      "The Flag: St. Kitts & Nevis emoji is a flag sequence combining 🇰 Regional Indicator Symbol Letter K and 🇳 Regional Indicator Symbol Letter N.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027075-1641",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇲 Flag: Comoros",
    "flags-href": "https://emojipedia.org/flag-comoros/",
    emoji: "🇰🇲",
    emojiName: "🇰🇲 Flag: Comoros",
    description:
      "The flag for Comoros, which may show as the letters KM on some platforms.",
  },
  {
    "web-scraper-order": "1666027078-1645",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇮 Flag: Kiribati",
    "flags-href": "https://emojipedia.org/flag-kiribati/",
    emoji: "🇰🇮",
    emojiName: "🇰🇮 Flag: Kiribati",
    description:
      "The flag for Kiribati, which may show as the letters KI on some platforms.",
  },
  {
    "web-scraper-order": "1666027080-1648",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇭 Flag: Cambodia",
    "flags-href": "https://emojipedia.org/flag-cambodia/",
    emoji: "🇰🇭",
    emojiName: "🇰🇭 Flag: Cambodia",
    description:
      "The flag for Cambodia, which may show as the letters KH on some platforms.",
  },
  {
    "web-scraper-order": "1666027083-1651",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇬 Flag: Kyrgyzstan",
    "flags-href": "https://emojipedia.org/flag-kyrgyzstan/",
    emoji: "🇰🇬",
    emojiName: "🇰🇬 Flag: Kyrgyzstan",
    description:
      "The flag for Kyrgyzstan, which may show as the letters KG on some platforms.",
  },
  {
    "web-scraper-order": "1666027085-1653",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇰🇪 Flag: Kenya",
    "flags-href": "https://emojipedia.org/flag-kenya/",
    emoji: "🇰🇪",
    emojiName: "🇰🇪 Flag: Kenya",
    description:
      "The flag for Kenya, which may show as the letters KE on some platforms.",
  },
  {
    "web-scraper-order": "1666027087-1656",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇵 Flag: Japan",
    "flags-href": "https://emojipedia.org/flag-japan/",
    emoji: "🇯🇵",
    emojiName: "🇯🇵 Flag: Japan",
    description:
      "The flag for Japan, which may show as the letters JP on some platforms.",
  },
  {
    "web-scraper-order": "1666027090-1659",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇴 Flag: Jordan",
    "flags-href": "https://emojipedia.org/flag-jordan/",
    emoji: "🇯🇴",
    emojiName: "🇯🇴 Flag: Jordan",
    description:
      "The flag for Jordan, which may show as the letters JO on some platforms.",
  },
  {
    "web-scraper-order": "1666027094-1663",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇲 Flag: Jamaica",
    "flags-href": "https://emojipedia.org/flag-jamaica/",
    emoji: "🇯🇲",
    emojiName: "🇯🇲 Flag: Jamaica",
    description:
      "The flag for Jamaica, which may show as the letters JM on some platforms.",
  },
  {
    "web-scraper-order": "1666027096-1666",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇯🇪 Flag: Jersey",
    "flags-href": "https://emojipedia.org/flag-jersey/",
    emoji: "🇯🇪",
    emojiName: "🇯🇪 Flag: Jersey",
    description:
      "The flag for Jersey, which may show as the letters JE on some platforms.",
  },
  {
    "web-scraper-order": "1666027098-1667",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇹 Flag: Italy",
    "flags-href": "https://emojipedia.org/flag-italy/",
    emoji: "🇮🇹",
    emojiName: "🇮🇹 Flag: Italy",
    description:
      "The flag for Italy, which may show as the letters IT on some platforms.",
  },
  {
    "web-scraper-order": "1666027101-1670",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇸 Flag: Iceland",
    "flags-href": "https://emojipedia.org/flag-iceland/",
    emoji: "🇮🇸",
    emojiName: "🇮🇸 Flag: Iceland",
    description:
      "The flag for Iceland, which may show as the letters IS on some platforms.",
  },
  {
    "web-scraper-order": "1666027103-1673",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇷 Flag: Iran",
    "flags-href": "https://emojipedia.org/flag-iran/",
    emoji: "🇮🇷",
    emojiName: "🇮🇷 Flag: Iran",
    description:
      "The flag for Iran, which may show as the letters IR on some platforms.",
  },
  {
    "web-scraper-order": "1666027105-1676",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇶 Flag: Iraq",
    "flags-href": "https://emojipedia.org/flag-iraq/",
    emoji: "🇮🇶",
    emojiName: "🇮🇶 Flag: Iraq",
    description:
      "The flag for Iraq, which may show as the letters IQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027108-1679",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇴 Flag: British Indian Ocean Territory",
    "flags-href": "https://emojipedia.org/flag-british-indian-ocean-territory/",
    emoji: "🇮🇴",
    emojiName: "🇮🇴 Flag: British Indian Ocean Territory",
    description:
      "The flag for British Indian Ocean Territory, which may show as the letters IO on some platforms. The same flag is used for Diego Garcia.",
  },
  {
    "web-scraper-order": "1666027110-1682",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇳 Flag: India",
    "flags-href": "https://emojipedia.org/flag-india/",
    emoji: "🇮🇳",
    emojiName: "🇮🇳 Flag: India",
    description:
      "The flag for India, which may show as the letters IN on some platforms.",
  },
  {
    "web-scraper-order": "1666027113-1684",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇲 Flag: Isle of Man",
    "flags-href": "https://emojipedia.org/flag-isle-of-man/",
    emoji: "🇮🇲",
    emojiName: "🇮🇲 Flag: Isle of Man",
    description:
      "The flag for Isle of Man, which may show as the letters IM on some platforms.",
  },
  {
    "web-scraper-order": "1666027115-1687",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇱 Flag: Israel",
    "flags-href": "https://emojipedia.org/flag-israel/",
    emoji: "🇮🇱",
    emojiName: "🇮🇱 Flag: Israel",
    description:
      "The flag for Israel, which may show as the letters IL on some platforms.",
  },
  {
    "web-scraper-order": "1666027118-1689",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇪 Flag: Ireland",
    "flags-href": "https://emojipedia.org/flag-ireland/",
    emoji: "🇮🇪",
    emojiName: "🇮🇪 Flag: Ireland",
    description:
      "The flag for Ireland, which may show as the letters IE on some platforms.",
  },
  {
    "web-scraper-order": "1666027120-1692",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇩 Flag: Indonesia",
    "flags-href": "https://emojipedia.org/flag-indonesia/",
    emoji: "🇮🇩",
    emojiName: "🇮🇩 Flag: Indonesia",
    description:
      "The flag for Indonesia, which may show as the letters ID on some platforms.",
  },
  {
    "web-scraper-order": "1666027123-1695",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇮🇨 Flag: Canary Islands",
    "flags-href": "https://emojipedia.org/flag-canary-islands/",
    emoji: "🇮🇨",
    emojiName: "🇮🇨 Flag: Canary Islands",
    description:
      "The flag for Canary Islands, which may show as the letters IC on some platforms.",
  },
  {
    "web-scraper-order": "1666027125-1697",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇺 Flag: Hungary",
    "flags-href": "https://emojipedia.org/flag-hungary/",
    emoji: "🇭🇺",
    emojiName: "🇭🇺 Flag: Hungary",
    description:
      "The flag for Hungary, which may show as the letters HU on some platforms.",
  },
  {
    "web-scraper-order": "1666027128-1700",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇹 Flag: Haiti",
    "flags-href": "https://emojipedia.org/flag-haiti/",
    emoji: "🇭🇹",
    emojiName: "🇭🇹 Flag: Haiti",
    description:
      "The flag for Haiti, which may show as the letters HT on some platforms.",
  },
  {
    "web-scraper-order": "1666027130-1702",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇷 Flag: Croatia",
    "flags-href": "https://emojipedia.org/flag-croatia/",
    emoji: "🇭🇷",
    emojiName: "🇭🇷 Flag: Croatia",
    description:
      "The flag for Croatia, which may show as the letters HR on some platforms.",
  },
  {
    "web-scraper-order": "1666027133-1705",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇳 Flag: Honduras",
    "flags-href": "https://emojipedia.org/flag-honduras/",
    emoji: "🇭🇳",
    emojiName: "🇭🇳 Flag: Honduras",
    description:
      "The flag for Honduras, which may show as the letters HN on some platforms.",
  },
  {
    "web-scraper-order": "1666027136-1708",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇲 Flag: Heard & McDonald Islands",
    "flags-href": "https://emojipedia.org/flag-heard-mcdonald-islands/",
    emoji: "🇭🇲",
    emojiName: "🇭🇲 Flag: Heard & McDonald Islands",
    description:
      "The flag for  Heard & McDonald Islands, which may show as the letters HM on some platforms. This is the same flag as Australia.",
  },
  {
    "web-scraper-order": "1666027138-1711",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇭🇰 Flag: Hong Kong SAR China",
    "flags-href": "https://emojipedia.org/flag-hong-kong-sar-china/",
    emoji: "🇭🇰",
    emojiName: "🇭🇰 Flag: Hong Kong SAR China",
    description:
      "The flag for Hong Kong, which may show as the letters HK on some platforms.",
  },
  {
    "web-scraper-order": "1666027140-1713",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇾 Flag: Guyana",
    "flags-href": "https://emojipedia.org/flag-guyana/",
    emoji: "🇬🇾",
    emojiName: "🇬🇾 Flag: Guyana",
    description:
      "The flag for Guyana, which may show as the letters GY on some platforms.",
  },
  {
    "web-scraper-order": "1666027143-1716",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇼 Flag: Guinea-Bissau",
    "flags-href": "https://emojipedia.org/flag-guinea-bissau/",
    emoji: "🇬🇼",
    emojiName: "🇬🇼 Flag: Guinea-Bissau",
    description:
      "The flag for Guinea-Bissau, which may show as the letters GW on some platforms.",
  },
  {
    "web-scraper-order": "1666027146-1718",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇺 Flag: Guam",
    "flags-href": "https://emojipedia.org/flag-guam/",
    emoji: "🇬🇺",
    emojiName: "🇬🇺 Flag: Guam",
    description:
      "The flag for Guam, which may show as the letters GU on some platforms.",
  },
  {
    "web-scraper-order": "1666027148-1721",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇹 Flag: Guatemala",
    "flags-href": "https://emojipedia.org/flag-guatemala/",
    emoji: "🇬🇹",
    emojiName: "🇬🇹 Flag: Guatemala",
    description:
      "The flag for Guatemala, which may show as the letters GT on some platforms.",
  },
  {
    "web-scraper-order": "1666027151-1723",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇸 Flag: South Georgia & South Sandwich Islands",
    "flags-href":
      "https://emojipedia.org/flag-south-georgia-south-sandwich-islands/",
    emoji: "🇬🇸",
    emojiName: "🇬🇸 Flag: South Georgia & South Sandwich Islands",
    description:
      "The Flag: South Georgia & South Sandwich Islands emoji is a flag sequence combining 🇬 Regional Indicator Symbol Letter G and 🇸 Regional Indicator Symbol Letter S.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027154-1726",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇷 Flag: Greece",
    "flags-href": "https://emojipedia.org/flag-greece/",
    emoji: "🇬🇷",
    emojiName: "🇬🇷 Flag: Greece",
    description:
      "The flag for Greece, which may show as the letters GR on some platforms.",
  },
  {
    "web-scraper-order": "1666027156-1729",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇶 Flag: Equatorial Guinea",
    "flags-href": "https://emojipedia.org/flag-equatorial-guinea/",
    emoji: "🇬🇶",
    emojiName: "🇬🇶 Flag: Equatorial Guinea",
    description:
      "The flag for Equatorial Guinea, which may show as the letters GQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027159-1732",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇵 Flag: Guadeloupe",
    "flags-href": "https://emojipedia.org/flag-guadeloupe/",
    emoji: "🇬🇵",
    emojiName: "🇬🇵 Flag: Guadeloupe",
    description:
      "The flag for Guadeloupe, which may show as the letters GP on some platforms.",
  },
  {
    "web-scraper-order": "1666027162-1734",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇳 Flag: Guinea",
    "flags-href": "https://emojipedia.org/flag-guinea/",
    emoji: "🇬🇳",
    emojiName: "🇬🇳 Flag: Guinea",
    description:
      "The flag for Guinea, which may show as the letters GN on some platforms.",
  },
  {
    "web-scraper-order": "1666027165-1736",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇲 Flag: Gambia",
    "flags-href": "https://emojipedia.org/flag-gambia/",
    emoji: "🇬🇲",
    emojiName: "🇬🇲 Flag: Gambia",
    description:
      "The flag for Gambia, which may show as the letters GM on some platforms.",
  },
  {
    "web-scraper-order": "1666027167-1739",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇱 Flag: Greenland",
    "flags-href": "https://emojipedia.org/flag-greenland/",
    emoji: "🇬🇱",
    emojiName: "🇬🇱 Flag: Greenland",
    description:
      "The flag for Greenland, which may show as the letters GL on some platforms.",
  },
  {
    "web-scraper-order": "1666027170-1741",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇮 Flag: Gibraltar",
    "flags-href": "https://emojipedia.org/flag-gibraltar/",
    emoji: "🇬🇮",
    emojiName: "🇬🇮 Flag: Gibraltar",
    description:
      "The flag for Gibraltar, which may show as the letters GI on some platforms.",
  },
  {
    "web-scraper-order": "1666027173-1745",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇭 Flag: Ghana",
    "flags-href": "https://emojipedia.org/flag-ghana/",
    emoji: "🇬🇭",
    emojiName: "🇬🇭 Flag: Ghana",
    description:
      "The flag for Ghana, which may show as the letters GH on some platforms.",
  },
  {
    "web-scraper-order": "1666027177-1748",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇬 Flag: Guernsey",
    "flags-href": "https://emojipedia.org/flag-guernsey/",
    emoji: "🇬🇬",
    emojiName: "🇬🇬 Flag: Guernsey",
    description:
      "The flag for Guernsey, which may show as the letters GG on some platforms.",
  },
  {
    "web-scraper-order": "1666027183-1751",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇫 Flag: French Guiana",
    "flags-href": "https://emojipedia.org/flag-french-guiana/",
    emoji: "🇬🇫",
    emojiName: "🇬🇫 Flag: French Guiana",
    description:
      "The flag for French Guiana, which may show as the letters GF on some platforms.",
  },
  {
    "web-scraper-order": "1666027186-1752",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇪 Flag: Georgia",
    "flags-href": "https://emojipedia.org/flag-georgia/",
    emoji: "🇬🇪",
    emojiName: "🇬🇪 Flag: Georgia",
    description:
      "The flag for Georgia, which may show as the letters GE on some platforms.",
  },
  {
    "web-scraper-order": "1666027190-1756",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇩 Flag: Grenada",
    "flags-href": "https://emojipedia.org/flag-grenada/",
    emoji: "🇬🇩",
    emojiName: "🇬🇩 Flag: Grenada",
    description:
      "The flag for Grenada, which may show as the letters GD on some platforms.",
  },
  {
    "web-scraper-order": "1666027192-1758",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇧 Flag: United Kingdom",
    "flags-href": "https://emojipedia.org/flag-united-kingdom/",
    emoji: "🇬🇧",
    emojiName: "🇬🇧 Flag: United Kingdom",
    description:
      "The flag for the United Kingdom, which may show as the letters GB on some platforms. England, Scotland and Wales also have individual emoji flags.",
  },
  {
    "web-scraper-order": "1666027194-1760",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇬🇦 Flag: Gabon",
    "flags-href": "https://emojipedia.org/flag-gabon/",
    emoji: "🇬🇦",
    emojiName: "🇬🇦 Flag: Gabon",
    description:
      "The flag for Gabon, which may show as the letters GA on some platforms.",
  },
  {
    "web-scraper-order": "1666027203-1765",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇷 Flag: France",
    "flags-href": "https://emojipedia.org/flag-france/",
    emoji: "🇫🇷",
    emojiName: "🇫🇷 Flag: France",
    description:
      "The flag for France, which may show as the letters FR on some platforms.",
  },
  {
    "web-scraper-order": "1666027208-1768",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇴 Flag: Faroe Islands",
    "flags-href": "https://emojipedia.org/flag-faroe-islands/",
    emoji: "🇫🇴",
    emojiName: "🇫🇴 Flag: Faroe Islands",
    description:
      "The flag for Faroe Islands, which may show as the letters FO on some platforms.",
  },
  {
    "web-scraper-order": "1666027210-1770",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇲 Flag: Micronesia",
    "flags-href": "https://emojipedia.org/flag-micronesia/",
    emoji: "🇫🇲",
    emojiName: "🇫🇲 Flag: Micronesia",
    description:
      "The flag for Micronesia, which may show as the letters FM on some platforms.",
  },
  {
    "web-scraper-order": "1666027213-1772",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇰 Flag: Falkland Islands",
    "flags-href": "https://emojipedia.org/flag-falkland-islands/",
    emoji: "🇫🇰",
    emojiName: "🇫🇰 Flag: Falkland Islands",
    description:
      "The flag for Falkland Islands (Malvinas), which may show as the letters FK on some platforms.",
  },
  {
    "web-scraper-order": "1666027216-1775",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇯 Flag: Fiji",
    "flags-href": "https://emojipedia.org/flag-fiji/",
    emoji: "🇫🇯",
    emojiName: "🇫🇯 Flag: Fiji",
    description:
      "The flag for Fiji, which may show as the letters FJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027218-1778",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇫🇮 Flag: Finland",
    "flags-href": "https://emojipedia.org/flag-finland/",
    emoji: "🇫🇮",
    emojiName: "🇫🇮 Flag: Finland",
    description:
      "The flag for Finland, which may show as the letters FI on some platforms.",
  },
  {
    "web-scraper-order": "1666027221-1779",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇺 Flag: European Union",
    "flags-href": "https://emojipedia.org/flag-european-union/",
    emoji: "🇪🇺",
    emojiName: "🇪🇺 Flag: European Union",
    description:
      "The flag for European Union, which may show as the letters EU on some platforms.",
  },
  {
    "web-scraper-order": "1666027223-1782",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇹 Flag: Ethiopia",
    "flags-href": "https://emojipedia.org/flag-ethiopia/",
    emoji: "🇪🇹",
    emojiName: "🇪🇹 Flag: Ethiopia",
    description:
      "The flag for Ethiopia, which may show as the letters ET on some platforms.",
  },
  {
    "web-scraper-order": "1666027226-1784",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇸 Flag: Spain",
    "flags-href": "https://emojipedia.org/flag-spain/",
    emoji: "🇪🇸",
    emojiName: "🇪🇸 Flag: Spain",
    description:
      "The flag for Spain, which may show as the letters ES on some platforms.",
  },
  {
    "web-scraper-order": "1666027228-1786",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇷 Flag: Eritrea",
    "flags-href": "https://emojipedia.org/flag-eritrea/",
    emoji: "🇪🇷",
    emojiName: "🇪🇷 Flag: Eritrea",
    description:
      "The flag for Eritrea, which may show as the letters ER on some platforms.",
  },
  {
    "web-scraper-order": "1666027231-1790",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇭 Flag: Western Sahara",
    "flags-href": "https://emojipedia.org/flag-western-sahara/",
    emoji: "🇪🇭",
    emojiName: "🇪🇭 Flag: Western Sahara",
    description:
      "The flag for Western Sahara, which may show as the letters EH on some platforms.",
  },
  {
    "web-scraper-order": "1666027234-1792",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇬 Flag: Egypt",
    "flags-href": "https://emojipedia.org/flag-egypt/",
    emoji: "🇪🇬",
    emojiName: "🇪🇬 Flag: Egypt",
    description:
      "The flag for Egypt, which may show as the letters EG on some platforms.",
  },
  {
    "web-scraper-order": "1666027237-1794",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇪 Flag: Estonia",
    "flags-href": "https://emojipedia.org/flag-estonia/",
    emoji: "🇪🇪",
    emojiName: "🇪🇪 Flag: Estonia",
    description:
      "The flag for Estonia, which may show as the letters EE on some platforms.",
  },
  {
    "web-scraper-order": "1666027240-1797",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇨 Flag: Ecuador",
    "flags-href": "https://emojipedia.org/flag-ecuador/",
    emoji: "🇪🇨",
    emojiName: "🇪🇨 Flag: Ecuador",
    description:
      "The flag for Ecuador, which may show as the letters EC on some platforms.",
  },
  {
    "web-scraper-order": "1666027242-1799",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇪🇦 Flag: Ceuta & Melilla",
    "flags-href": "https://emojipedia.org/flag-ceuta-melilla/",
    emoji: "🇪🇦",
    emojiName: "🇪🇦 Flag: Ceuta & Melilla",
    description:
      "The flag for Ceuta, Melilla, which may show as the letters EA on some platforms. Uses the same flag as Spain.",
  },
  {
    "web-scraper-order": "1666027245-1802",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇿 Flag: Algeria",
    "flags-href": "https://emojipedia.org/flag-algeria/",
    emoji: "🇩🇿",
    emojiName: "🇩🇿 Flag: Algeria",
    description:
      "The flag for Algeria, which may show as the letters DZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027247-1804",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇴 Flag: Dominican Republic",
    "flags-href": "https://emojipedia.org/flag-dominican-republic/",
    emoji: "🇩🇴",
    emojiName: "🇩🇴 Flag: Dominican Republic",
    description:
      "The flag for Dominican Republic, which may show as the letters DO on some platforms.",
  },
  {
    "web-scraper-order": "1666027250-1807",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇲 Flag: Dominica",
    "flags-href": "https://emojipedia.org/flag-dominica/",
    emoji: "🇩🇲",
    emojiName: "🇩🇲 Flag: Dominica",
    description:
      "The flag for Dominica, which may show as the letters DM on some platforms.",
  },
  {
    "web-scraper-order": "1666027252-1808",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇰 Flag: Denmark",
    "flags-href": "https://emojipedia.org/flag-denmark/",
    emoji: "🇩🇰",
    emojiName: "🇩🇰 Flag: Denmark",
    description:
      "The flag for Denmark, which may show as the letters DK on some platforms.",
  },
  {
    "web-scraper-order": "1666027255-1812",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇯 Flag: Djibouti",
    "flags-href": "https://emojipedia.org/flag-djibouti/",
    emoji: "🇩🇯",
    emojiName: "🇩🇯 Flag: Djibouti",
    description:
      "The flag for Djibouti, which may show as the letters DJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027257-1814",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇬 Flag: Diego Garcia",
    "flags-href": "https://emojipedia.org/flag-diego-garcia/",
    emoji: "🇩🇬",
    emojiName: "🇩🇬 Flag: Diego Garcia",
    description:
      "The flag for Diego Garcia, which may show as the letters DG on some platforms. The same flag is used for British Indian Ocean Territory.",
  },
  {
    "web-scraper-order": "1666027260-1815",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇩🇪 Flag: Germany",
    "flags-href": "https://emojipedia.org/flag-germany/",
    emoji: "🇩🇪",
    emojiName: "🇩🇪 Flag: Germany",
    description:
      "The flag for Germany, which may show as the letters DE on some platforms",
  },
  {
    "web-scraper-order": "1666027262-1817",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇿 Flag: Czechia",
    "flags-href": "https://emojipedia.org/flag-czechia/",
    emoji: "🇨🇿",
    emojiName: "🇨🇿 Flag: Czechia",
    description:
      "The flag for Czechia, which may show as the letters CZ on some platforms. Also known as Czech Republic.",
  },
  {
    "web-scraper-order": "1666027265-1820",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇾 Flag: Cyprus",
    "flags-href": "https://emojipedia.org/flag-cyprus/",
    emoji: "🇨🇾",
    emojiName: "🇨🇾 Flag: Cyprus",
    description:
      "The flag for Cyprus, which may show as the letters CY on some platforms.",
  },
  {
    "web-scraper-order": "1666027268-1822",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇽 Flag: Christmas Island",
    "flags-href": "https://emojipedia.org/flag-christmas-island/",
    emoji: "🇨🇽",
    emojiName: "🇨🇽 Flag: Christmas Island",
    description:
      "The flag for Christmas Island, which may show as the letters CX on some platforms.",
  },
  {
    "web-scraper-order": "1666027271-1825",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇼 Flag: Curaçao",
    "flags-href": "https://emojipedia.org/flag-curacao/",
    emoji: "🇨🇼",
    emojiName: "🇨🇼 Flag: Curaçao",
    description:
      "The flag for Curaçao, which may show as the letters CW on some platforms.",
  },
  {
    "web-scraper-order": "1666027274-1826",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇻 Flag: Cape Verde",
    "flags-href": "https://emojipedia.org/flag-cape-verde/",
    emoji: "🇨🇻",
    emojiName: "🇨🇻 Flag: Cape Verde",
    description:
      "The flag for Cape Verde, which may show as the letters CV on some platforms.",
  },
  {
    "web-scraper-order": "1666027276-1828",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇺 Flag: Cuba",
    "flags-href": "https://emojipedia.org/flag-cuba/",
    emoji: "🇨🇺",
    emojiName: "🇨🇺 Flag: Cuba",
    description:
      "The flag for Cuba, which may show as the letters CU on some platforms.",
  },
  {
    "web-scraper-order": "1666027279-1830",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇷 Flag: Costa Rica",
    "flags-href": "https://emojipedia.org/flag-costa-rica/",
    emoji: "🇨🇷",
    emojiName: "🇨🇷 Flag: Costa Rica",
    description:
      "The flag for Costa Rica, which may show as the letters CR on some platforms.",
  },
  {
    "web-scraper-order": "1666027282-1832",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇵 Flag: Clipperton Island",
    "flags-href": "https://emojipedia.org/flag-clipperton-island/",
    emoji: "🇨🇵",
    emojiName: "🇨🇵 Flag: Clipperton Island",
    description:
      "The flag for Clipperton Island, which may show as the letters CP on some platforms. Uses the same flag as France.",
  },
  {
    "web-scraper-order": "1666027284-1835",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇴 Flag: Colombia",
    "flags-href": "https://emojipedia.org/flag-colombia/",
    emoji: "🇨🇴",
    emojiName: "🇨🇴 Flag: Colombia",
    description:
      "The flag for Colombia, which may show as the letters CO on some platforms.",
  },
  {
    "web-scraper-order": "1666027287-1836",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇳 Flag: China",
    "flags-href": "https://emojipedia.org/flag-china/",
    emoji: "🇨🇳",
    emojiName: "🇨🇳 Flag: China",
    description:
      "The flag for China, which may show as the letters CN on some platforms.",
  },
  {
    "web-scraper-order": "1666027289-1838",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇲 Flag: Cameroon",
    "flags-href": "https://emojipedia.org/flag-cameroon/",
    emoji: "🇨🇲",
    emojiName: "🇨🇲 Flag: Cameroon",
    description:
      "The flag for Cameroon, which may show as the letters CM on some platforms.",
  },
  {
    "web-scraper-order": "1666027291-1840",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇱 Flag: Chile",
    "flags-href": "https://emojipedia.org/flag-chile/",
    emoji: "🇨🇱",
    emojiName: "🇨🇱 Flag: Chile",
    description:
      "The flag for Chile, which may show as the letters CL on some platforms.",
  },
  {
    "web-scraper-order": "1666027294-1842",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇰 Flag: Cook Islands",
    "flags-href": "https://emojipedia.org/flag-cook-islands/",
    emoji: "🇨🇰",
    emojiName: "🇨🇰 Flag: Cook Islands",
    description:
      "The flag for Cook Islands, which may show as the letters CK on some platforms.",
  },
  {
    "web-scraper-order": "1666027297-1844",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇮 Flag: Côte d’Ivoire",
    "flags-href": "https://emojipedia.org/flag-cote-divoire/",
    emoji: "🇨🇮",
    emojiName: "🇨🇮 Flag: Côte d’Ivoire",
    description:
      "The Flag: Côte d’Ivoire emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇮 Regional Indicator Symbol Letter I.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027299-1846",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇭 Flag: Switzerland",
    "flags-href": "https://emojipedia.org/flag-switzerland/",
    emoji: "🇨🇭",
    emojiName: "🇨🇭 Flag: Switzerland",
    description:
      "The flag for Switzerland, which may show as the letters CH on some platforms.",
  },
  {
    "web-scraper-order": "1666027303-1848",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇬 Flag: Congo - Brazzaville",
    "flags-href": "https://emojipedia.org/flag-congo-brazzaville/",
    emoji: "🇨🇬",
    emojiName: "🇨🇬 Flag: Congo - Brazzaville",
    description:
      "The Flag: Congo - Brazzaville emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇬 Regional Indicator Symbol Letter G.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027305-1850",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇫 Flag: Central African Republic",
    "flags-href": "https://emojipedia.org/flag-central-african-republic/",
    emoji: "🇨🇫",
    emojiName: "🇨🇫 Flag: Central African Republic",
    description:
      "The flag for Central African Republic, which may show as the letters CF on some platforms.",
  },
  {
    "web-scraper-order": "1666027308-1851",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇩 Flag: Congo - Kinshasa",
    "flags-href": "https://emojipedia.org/flag-congo-kinshasa/",
    emoji: "🇨🇩",
    emojiName: "🇨🇩 Flag: Congo - Kinshasa",
    description:
      "The Flag: Congo - Kinshasa emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C and 🇩 Regional Indicator Symbol Letter D.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027311-1854",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇨 Flag: Cocos (Keeling) Islands",
    "flags-href": "https://emojipedia.org/flag-cocos-keeling-islands/",
    emoji: "🇨🇨",
    emojiName: "🇨🇨 Flag: Cocos (Keeling) Islands",
    description:
      "The Flag: Cocos (Keeling) Islands emoji is a flag sequence combining 🇨 Regional Indicator Symbol Letter C.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027313-1855",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇨🇦 Flag: Canada",
    "flags-href": "https://emojipedia.org/flag-canada/",
    emoji: "🇨🇦",
    emojiName: "🇨🇦 Flag: Canada",
    description:
      "The flag for Canada, which may show as the letters CA on some platforms.",
  },
  {
    "web-scraper-order": "1666027316-1858",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇿 Flag: Belize",
    "flags-href": "https://emojipedia.org/flag-belize/",
    emoji: "🇧🇿",
    emojiName: "🇧🇿 Flag: Belize",
    description:
      "The flag for Belize, which may show as the letters BZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027318-1859",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇾 Flag: Belarus",
    "flags-href": "https://emojipedia.org/flag-belarus/",
    emoji: "🇧🇾",
    emojiName: "🇧🇾 Flag: Belarus",
    description:
      "The flag for Belarus, which may show as the letters BY on some platforms.",
  },
  {
    "web-scraper-order": "1666027321-1862",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇼 Flag: Botswana",
    "flags-href": "https://emojipedia.org/flag-botswana/",
    emoji: "🇧🇼",
    emojiName: "🇧🇼 Flag: Botswana",
    description:
      "The flag for Botswana, which may show as the letters BW on some platforms.",
  },
  {
    "web-scraper-order": "1666027323-1863",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇻 Flag: Bouvet Island",
    "flags-href": "https://emojipedia.org/flag-bouvet-island/",
    emoji: "🇧🇻",
    emojiName: "🇧🇻 Flag: Bouvet Island",
    description:
      "The flag for Bouvet Island, which may show as the letters BV on some platforms. This is the same flag as Norway.",
  },
  {
    "web-scraper-order": "1666027326-1866",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇹 Flag: Bhutan",
    "flags-href": "https://emojipedia.org/flag-bhutan/",
    emoji: "🇧🇹",
    emojiName: "🇧🇹 Flag: Bhutan",
    description:
      "The flag for Bhutan, which may show as the letters BT on some platforms.",
  },
  {
    "web-scraper-order": "1666027328-1868",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇸 Flag: Bahamas",
    "flags-href": "https://emojipedia.org/flag-bahamas/",
    emoji: "🇧🇸",
    emojiName: "🇧🇸 Flag: Bahamas",
    description:
      "The flag for Bahamas, which may show as the letters BS on some platforms.",
  },
  {
    "web-scraper-order": "1666027331-1869",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇷 Flag: Brazil",
    "flags-href": "https://emojipedia.org/flag-brazil/",
    emoji: "🇧🇷",
    emojiName: "🇧🇷 Flag: Brazil",
    description:
      "The flag for Brazil, which may show as the letters BR on some platforms.",
  },
  {
    "web-scraper-order": "1666027334-1873",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇶 Flag: Caribbean Netherlands",
    "flags-href": "https://emojipedia.org/flag-caribbean-netherlands/",
    emoji: "🇧🇶",
    emojiName: "🇧🇶 Flag: Caribbean Netherlands",
    description:
      "The Caribbean Netherlands, a group of islands in the Caribbean Sea. The design for this emoji is shown as the flag for Bonaire on most platforms.",
  },
  {
    "web-scraper-order": "1666027336-1874",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇴 Flag: Bolivia",
    "flags-href": "https://emojipedia.org/flag-bolivia/",
    emoji: "🇧🇴",
    emojiName: "🇧🇴 Flag: Bolivia",
    description:
      "The flag for Bolivia, which may show as the letters BO on some platforms.",
  },
  {
    "web-scraper-order": "1666027339-1877",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇳 Flag: Brunei",
    "flags-href": "https://emojipedia.org/flag-brunei/",
    emoji: "🇧🇳",
    emojiName: "🇧🇳 Flag: Brunei",
    description:
      "The flag for Brunei Darussalam, which may show as the letters BN on some platforms.",
  },
  {
    "web-scraper-order": "1666027342-1880",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇲 Flag: Bermuda",
    "flags-href": "https://emojipedia.org/flag-bermuda/",
    emoji: "🇧🇲",
    emojiName: "🇧🇲 Flag: Bermuda",
    description:
      "The flag for Bermuda, which may show as the letters BM on some platforms.",
  },
  {
    "web-scraper-order": "1666027346-1881",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇱 Flag: St. Barthélemy",
    "flags-href": "https://emojipedia.org/flag-st-barthelemy/",
    emoji: "🇧🇱",
    emojiName: "🇧🇱 Flag: St. Barthélemy",
    description:
      "The Flag: St. Barthélemy emoji is a flag sequence combining 🇧 Regional Indicator Symbol Letter B and 🇱 Regional Indicator Symbol Letter L.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027349-1884",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇯 Flag: Benin",
    "flags-href": "https://emojipedia.org/flag-benin/",
    emoji: "🇧🇯",
    emojiName: "🇧🇯 Flag: Benin",
    description:
      "The flag for Benin, which may show as the letters BJ on some platforms.",
  },
  {
    "web-scraper-order": "1666027351-1886",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇮 Flag: Burundi",
    "flags-href": "https://emojipedia.org/flag-burundi/",
    emoji: "🇧🇮",
    emojiName: "🇧🇮 Flag: Burundi",
    description:
      "The flag for Burundi, which may show as the letters BI on some platforms.",
  },
  {
    "web-scraper-order": "1666027353-1888",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇭 Flag: Bahrain",
    "flags-href": "https://emojipedia.org/flag-bahrain/",
    emoji: "🇧🇭",
    emojiName: "🇧🇭 Flag: Bahrain",
    description:
      "The flag for Bahrain, which may show as the letters BH on some platforms.",
  },
  {
    "web-scraper-order": "1666027356-1891",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇬 Flag: Bulgaria",
    "flags-href": "https://emojipedia.org/flag-bulgaria/",
    emoji: "🇧🇬",
    emojiName: "🇧🇬 Flag: Bulgaria",
    description:
      "The flag for Bulgaria, which may show as the letters BG on some platforms.",
  },
  {
    "web-scraper-order": "1666027359-1893",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇫 Flag: Burkina Faso",
    "flags-href": "https://emojipedia.org/flag-burkina-faso/",
    emoji: "🇧🇫",
    emojiName: "🇧🇫 Flag: Burkina Faso",
    description:
      "The flag for Burkina Faso, which may show as the letters BF on some platforms.",
  },
  {
    "web-scraper-order": "1666027362-1896",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇪 Flag: Belgium",
    "flags-href": "https://emojipedia.org/flag-belgium/",
    emoji: "🇧🇪",
    emojiName: "🇧🇪 Flag: Belgium",
    description:
      "The flag for Belgium, which may show as the letters BE on some platforms.",
  },
  {
    "web-scraper-order": "1666027364-1898",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇩 Flag: Bangladesh",
    "flags-href": "https://emojipedia.org/flag-bangladesh/",
    emoji: "🇧🇩",
    emojiName: "🇧🇩 Flag: Bangladesh",
    description:
      "The flag for Bangladesh, which may show as the letters BD on some platforms.",
  },
  {
    "web-scraper-order": "1666027367-1900",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇧 Flag: Barbados",
    "flags-href": "https://emojipedia.org/flag-barbados/",
    emoji: "🇧🇧",
    emojiName: "🇧🇧 Flag: Barbados",
    description:
      "The flag for Barbados, which may show as the letters BB on some platforms.",
  },
  {
    "web-scraper-order": "1666027370-1902",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇧🇦 Flag: Bosnia & Herzegovina",
    "flags-href": "https://emojipedia.org/flag-bosnia-herzegovina/",
    emoji: "🇧🇦",
    emojiName: "🇧🇦 Flag: Bosnia & Herzegovina",
    description:
      "The Flag: Bosnia & Herzegovina emoji is a flag sequence combining 🇧 Regional Indicator Symbol Letter B and 🇦 Regional Indicator Symbol Letter A.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027373-1905",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇿 Flag: Azerbaijan",
    "flags-href": "https://emojipedia.org/flag-azerbaijan/",
    emoji: "🇦🇿",
    emojiName: "🇦🇿 Flag: Azerbaijan",
    description:
      "The flag for Azerbaijan, which may show as the letters AZ on some platforms.",
  },
  {
    "web-scraper-order": "1666027376-1907",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇽 Flag: Åland Islands",
    "flags-href": "https://emojipedia.org/flag-aland-islands/",
    emoji: "🇦🇽",
    emojiName: "🇦🇽 Flag: Åland Islands",
    description:
      "The flag for Åland Islands, which may show as the letters AX on some platforms.",
  },
  {
    "web-scraper-order": "1666027379-1910",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇼 Flag: Aruba",
    "flags-href": "https://emojipedia.org/flag-aruba/",
    emoji: "🇦🇼",
    emojiName: "🇦🇼 Flag: Aruba",
    description:
      "The flag for Aruba, which may show as the letters AW on some platforms.",
  },
  {
    "web-scraper-order": "1666027381-1913",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇺 Flag: Australia",
    "flags-href": "https://emojipedia.org/flag-australia/",
    emoji: "🇦🇺",
    emojiName: "🇦🇺 Flag: Australia",
    description:
      "The flag for Australia, which may show as the letters AU on some platforms.",
  },
  {
    "web-scraper-order": "1666027384-1916",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇹 Flag: Austria",
    "flags-href": "https://emojipedia.org/flag-austria/",
    emoji: "🇦🇹",
    emojiName: "🇦🇹 Flag: Austria",
    description:
      "The flag for Austria, which may show as the letters AT on some platforms.",
  },
  {
    "web-scraper-order": "1666027386-1919",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇸 Flag: American Samoa",
    "flags-href": "https://emojipedia.org/flag-american-samoa/",
    emoji: "🇦🇸",
    emojiName: "🇦🇸 Flag: American Samoa",
    description:
      "The flag for American Samoa, which may show as the letters AS on some platforms.",
  },
  {
    "web-scraper-order": "1666027390-1922",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇷 Flag: Argentina",
    "flags-href": "https://emojipedia.org/flag-argentina/",
    emoji: "🇦🇷",
    emojiName: "🇦🇷 Flag: Argentina",
    description:
      "The flag for Argentina, which may show as the letters AR on some platforms.",
  },
  {
    "web-scraper-order": "1666027393-1924",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇶 Flag: Antarctica",
    "flags-href": "https://emojipedia.org/flag-antarctica/",
    emoji: "🇦🇶",
    emojiName: "🇦🇶 Flag: Antarctica",
    description:
      "The flag for Antarctica, which may show as the letters AQ on some platforms.",
  },
  {
    "web-scraper-order": "1666027395-1927",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇴 Flag: Angola",
    "flags-href": "https://emojipedia.org/flag-angola/",
    emoji: "🇦🇴",
    emojiName: "🇦🇴 Flag: Angola",
    description:
      "The flag for Angola, which may show as the letters A and O on some platforms.",
  },
  {
    "web-scraper-order": "1666027398-1931",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇲 Flag: Armenia",
    "flags-href": "https://emojipedia.org/flag-armenia/",
    emoji: "🇦🇲",
    emojiName: "🇦🇲 Flag: Armenia",
    description:
      "The flag for Armenia, which may show as the letters AM on some platforms.",
  },
  {
    "web-scraper-order": "1666027401-1933",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇱 Flag: Albania",
    "flags-href": "https://emojipedia.org/flag-albania/",
    emoji: "🇦🇱",
    emojiName: "🇦🇱 Flag: Albania",
    description:
      "The flag for Albania, which may show as the letters AL on some platforms.",
  },
  {
    "web-scraper-order": "1666027404-1936",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇮 Flag: Anguilla",
    "flags-href": "https://emojipedia.org/flag-anguilla/",
    emoji: "🇦🇮",
    emojiName: "🇦🇮 Flag: Anguilla",
    description:
      "The flag for Anguilla, which may show as the letters AI on some platforms.",
  },
  {
    "web-scraper-order": "1666027407-1940",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇬 Flag: Antigua & Barbuda",
    "flags-href": "https://emojipedia.org/flag-antigua-barbuda/",
    emoji: "🇦🇬",
    emojiName: "🇦🇬 Flag: Antigua & Barbuda",
    description:
      "The Flag: Antigua & Barbuda emoji is a flag sequence combining 🇦 Regional Indicator Symbol Letter A and 🇬 Regional Indicator Symbol Letter G.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666027409-1942",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇫 Flag: Afghanistan",
    "flags-href": "https://emojipedia.org/flag-afghanistan/",
    emoji: "🇦🇫",
    emojiName: "🇦🇫 Flag: Afghanistan",
    description:
      "The flag for Afghanistan, which may show as the letters AF on some platforms.",
  },
  {
    "web-scraper-order": "1666027411-1944",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇪 Flag: United Arab Emirates",
    "flags-href": "https://emojipedia.org/flag-united-arab-emirates/",
    emoji: "🇦🇪",
    emojiName: "🇦🇪 Flag: United Arab Emirates",
    description:
      "The flag for United Arab Emirates, which may show as the letters AE on some platforms.",
  },
  {
    "web-scraper-order": "1666027414-1947",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇩 Flag: Andorra",
    "flags-href": "https://emojipedia.org/flag-andorra/",
    emoji: "🇦🇩",
    emojiName: "🇦🇩 Flag: Andorra",
    description:
      "The flag for Andorra, which may show as the letters AD on some platforms.",
  },
  {
    "web-scraper-order": "1666027416-1949",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🇦🇨 Flag: Ascension Island",
    "flags-href": "https://emojipedia.org/flag-ascension-island/",
    emoji: "🇦🇨",
    emojiName: "🇦🇨 Flag: Ascension Island",
    description:
      "The flag for Ascension Island, which may show as the letters AC on some platforms. Apple devices show the St. Helena flag for both Ascension Island and Tristan Da Cunha.",
  },
  {
    "web-scraper-order": "1666027420-1952",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴‍☠️ Pirate Flag",
    "flags-href": "https://emojipedia.org/pirate-flag/",
    emoji: "🏴‍☠️",
    emojiName: "🏴‍☠️ Pirate Flag",
    description:
      "A skull and crossbones displayed on a black flag, used on pirate ships, also known as a Jolly Roger.",
  },
  {
    "web-scraper-order": "1666027422-1954",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️‍⚧️ Transgender Flag",
    "flags-href": "https://emojipedia.org/transgender-flag/",
    emoji: "🏳️‍⚧️",
    emojiName: "🏳️‍⚧️ Transgender Flag",
    description:
      "A flag with horizontal pale blue and pale pink stripes with a single white stripe in the middle, used as a Transgender or Transgender Pride flag and commonly seen at Pride events.",
  },
  {
    "web-scraper-order": "1666027425-1956",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️‍🌈 Rainbow Flag",
    "flags-href": "https://emojipedia.org/rainbow-flag/",
    emoji: "🏳️‍🌈",
    emojiName: "🏳️‍🌈 Rainbow Flag",
    description:
      "A flag with six colors of the rainbow, generally including red, orange, yellow, green, blue and purple. Commonly used by the LGBT movement as a gay pride flag, or simply pride flag and seen at Pride events.",
  },
  {
    "web-scraper-order": "1666027428-1959",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏳️ White Flag",
    "flags-href": "https://emojipedia.org/white-flag/",
    emoji: "🏳️",
    emojiName: "🏳️ White Flag",
    description:
      "A white flag, shown waving on a post. Traditionally used as a sign of surrender, the meaning of this flag as an emoji is less defined.",
  },
  {
    "web-scraper-order": "1666027431-1961",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏴 Black Flag",
    "flags-href": "https://emojipedia.org/black-flag/",
    emoji: "🏴",
    emojiName: "🏴 Black Flag",
    description:
      "Black Flag was approved as part of Unicode 7.0 in 2014 under the name “Waving Black Flag” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027435-1965",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🎌 Crossed Flags",
    "flags-href": "https://emojipedia.org/crossed-flags/",
    emoji: "🎌",
    emojiName: "🎌 Crossed Flags",
    description:
      "Two Japanese Flags, crossed at the base. Except on some Samsung devices, which have previously displayed two South Korean flags.",
  },
  {
    "web-scraper-order": "1666027438-1968",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🚩 Triangular Flag",
    "flags-href": "https://emojipedia.org/triangular-flag/",
    emoji: "🚩",
    emojiName: "🚩 Triangular Flag",
    description:
      "A triangular red flag on a post. Most commonly associated with golf, as shown in the flag in hole emoji. Can also be used to represent the term red flag, signaling a problem or issue.",
  },
  {
    "web-scraper-order": "1666027442-1972",
    "web-scraper-start-url": "https://emojipedia.org/flags/",
    flags: "🏁 Chequered Flag",
    "flags-href": "https://emojipedia.org/chequered-flag/",
    emoji: "🏁",
    emojiName: "🏁 Chequered Flag",
    description:
      "A flag with black and white squares shown in a checkerboard pattern, used to signal the start or end of a motor car race.",
  },
  {
    "web-scraper-order": "1666024507-692",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫙 Jar",
    "food-href": "https://emojipedia.org/jar/",
    emoji: "🫙",
    emojiName: "🫙 Jar",
    description: "An empty glass jar.",
  },
  {
    "web-scraper-order": "1666024510-693",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥄 Spoon",
    "food-href": "https://emojipedia.org/spoon/",
    emoji: "🥄",
    emojiName: "🥄 Spoon",
    description:
      "A silver spoon, as used to eat soup, cereal, or ice cream as well as serve food or stir drinks. Positioned at various angles across platforms. May be paired with Fork and Knife, Fork and Knife With Plate, and Bowl With Spoon.",
  },
  {
    "web-scraper-order": "1666024512-694",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍴 Fork and Knife",
    "food-href": "https://emojipedia.org/fork-and-knife/",
    emoji: "🍴",
    emojiName: "🍴 Fork and Knife",
    description:
      "A silver fork to the left of a knife, silverware or cutlery used to eat a meal. Often used more generally for eating and dining. May be paired with Spoon or used with Fork and Knife With Plate.",
  },
  {
    "web-scraper-order": "1666024514-695",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍽️ Fork and Knife with Plate",
    "food-href": "https://emojipedia.org/fork-and-knife-with-plate/",
    emoji: "🍽️",
    emojiName: "🍽️ Fork and Knife with Plate",
    description:
      "A silver fork and knife on either side of a white plate, as set for dinner or another meal. Often used more generally for eating and dining. May be paired with Spoon.",
  },
  {
    "web-scraper-order": "1666024517-696",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥢 Chopsticks",
    "food-href": "https://emojipedia.org/chopsticks/",
    emoji: "🥢",
    emojiName: "🥢 Chopsticks",
    description:
      "A pair of equal-length chopsticks, an eating utensil used throughout East Asia. Design and color vary widely by platform, though often red or wood-colored and with tips angled together. Featured in many platforms' Steaming Bowl of Food and Takeout Box. A counterpart to utensils such as Fork and Knife and Spoon.",
  },
  {
    "web-scraper-order": "1666024519-697",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧊 Ice",
    "food-href": "https://emojipedia.org/ice/",
    emoji: "🧊",
    emojiName: "🧊 Ice",
    description:
      "A blue cube of ice. Can be used to talk about ice or cold temperatures in general. This emoji can also be used metaphorically to talk about something that is cool or chill.",
  },
  {
    "web-scraper-order": "1666024521-698",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧉 Mate",
    "food-href": "https://emojipedia.org/mate/",
    emoji: "🧉",
    emojiName: "🧉 Mate",
    description:
      "Mate is a caffeinated beverage popular in many South American countries. Green in color (from a key ingredient: the dried leaves of yerba mate) and consumed via a metal straw.",
  },
  {
    "web-scraper-order": "1666024524-699",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧃 Beverage Box",
    "food-href": "https://emojipedia.org/beverage-box/",
    emoji: "🧃",
    emojiName: "🧃 Beverage Box",
    description:
      "Originally proposed as Juice, this emoji can be used to talk about juice or other liquids that come in boxes with straws. It can also be used metaphorically to talk about power, energy, respect, or an elusive quality that makes someone special.",
  },
  {
    "web-scraper-order": "1666024526-700",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧋 Bubble Tea",
    "food-href": "https://emojipedia.org/bubble-tea/",
    emoji: "🧋",
    emojiName: "🧋 Bubble Tea",
    description:
      "Bubble tea is a tea-based drink invented in Taiwan which typically contain tea, flavored milk, and sugar. Commonly served with tapioca pearls, also known as boba, in a plastic cup with a wide straw.",
  },
  {
    "web-scraper-order": "1666024528-701",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥤 Cup with Straw",
    "food-href": "https://emojipedia.org/cup-with-straw/",
    emoji: "🥤",
    emojiName: "🥤 Cup with Straw",
    description:
      "A drinking cup with a straw. Depicted on many platforms as a disposable cup with a lid and bendy straw, as used to serve soft drinks at fast-food restaurants. May be used for a range of non-alcoholic beverages, including milkshakes, smoothies, juice, and to-go beverages.",
  },
  {
    "web-scraper-order": "1666024531-702",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫗 Pouring Liquid",
    "food-href": "https://emojipedia.org/pouring-liquid/",
    emoji: "🫗",
    emojiName: "🫗 Pouring Liquid",
    description: "A glass pouring liquid.",
  },
  {
    "web-scraper-order": "1666024536-703",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥃 Tumbler Glass",
    "food-href": "https://emojipedia.org/tumbler-glass/",
    emoji: "🥃",
    emojiName: "🥃 Tumbler Glass",
    description:
      "A short, flat glass, as used for brown liquors like whiskey or Scotch whisky.",
  },
  {
    "web-scraper-order": "1666024539-704",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥂 Clinking Glasses",
    "food-href": "https://emojipedia.org/clinking-glasses/",
    emoji: "🥂",
    emojiName: "🥂 Clinking Glasses",
    description:
      "Two flutes of champagne or sparkling wine being clinked together, as done at a celebratory or convivial toast (“Cheers!”). Samsung’s design suggests two glasses of white wine. Some platforms include stylized links to mark the clinking. See also Clinking Beer Mugs—and Bottle With Popping Cork for a refill.",
  },
  {
    "web-scraper-order": "1666024547-705",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍻 Clinking Beer Mugs",
    "food-href": "https://emojipedia.org/clinking-beer-mugs/",
    emoji: "🍻",
    emojiName: "🍻 Clinking Beer Mugs",
    description:
      "Two frosty mugs of beer with frothy heads being clinked together, as done at a celebratory or convivial toast (“Cheers!”). Several platforms include stylized lines to mark the clinking. See also 🥂 Clinking Glasses.",
  },
  {
    "web-scraper-order": "1666024551-706",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍺 Beer Mug",
    "food-href": "https://emojipedia.org/beer-mug/",
    emoji: "🍺",
    emojiName: "🍺 Beer Mug",
    description:
      "A beer, as a golden-colored lager, in a frosty mug. Depicted with a frothy head spilling over the brim. 🍻 Clinking Beer Mugs is a variation that displays two such beer mugs.",
  },
  {
    "web-scraper-order": "1666024555-707",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍹 Tropical Drink",
    "food-href": "https://emojipedia.org/tropical-drink/",
    emoji: "🍹",
    emojiName: "🍹 Tropical Drink",
    description:
      "A sunset-orange-colored tropical beverage in a stemmed glass, as a rum punch or mai tai. Served with a straw and fruit garnish. Many platforms include a cocktail umbrella, hence umbrella drink. Samsung previously featured an electric-blue concoction. See also Cocktail Glass.",
  },
  {
    "web-scraper-order": "1666024557-708",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍸 Cocktail Glass",
    "food-href": "https://emojipedia.org/cocktail-glass/",
    emoji: "🍸",
    emojiName: "🍸 Cocktail Glass",
    description:
      "A stemmed glass with a cone-shaped bowl, used for serving cocktails. Depicted as a martini garnished with an olive. Might be gin or vodka, shaken or stirred. See also Tropical Drink.",
  },
  {
    "web-scraper-order": "1666024560-709",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍷 Wine Glass",
    "food-href": "https://emojipedia.org/wine-glass/",
    emoji: "🍷",
    emojiName: "🍷 Wine Glass",
    description:
      "Red wine served in a stemmed glass. Google previously displayed an orange-colored drink that resembled cognac.",
  },
  {
    "web-scraper-order": "1666024564-710",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍾 Bottle with Popping Cork",
    "food-href": "https://emojipedia.org/bottle-with-popping-cork/",
    emoji: "🍾",
    emojiName: "🍾 Bottle with Popping Cork",
    description:
      "A green bottle of champagne or sparkling wine with label, its cork popping to shoot out its bubbly contents. Used for a range of celebratory occasions, such as New Year's Eve, birthdays, weddings, or other life accomplishments.",
  },
  {
    "web-scraper-order": "1666024567-711",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍶 Sake",
    "food-href": "https://emojipedia.org/sake/",
    emoji: "🍶",
    emojiName: "🍶 Sake",
    description:
      "Japanese sake, an alcoholic beverage made from rice. Shown as a sake set with a carafe (tokkuri) and drinking cup (choko). Most platforms show a cream colored sake set with a blue or red stripe motif. Samsung's design used to show the Japanese script for 'sake' in red along the side of the carafe.",
  },
  {
    "web-scraper-order": "1666024569-712",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍵 Teacup Without Handle",
    "food-href": "https://emojipedia.org/teacup-without-handle/",
    emoji: "🍵",
    emojiName: "🍵 Teacup Without Handle",
    description:
      "A cup of green tea, as the minty-colored Japanese matcha, usually shown on a wooden mat. Matcha is traditionally served in a small bowl that resembles a cup without a handle. Often taken as a bowl of soup, such as a split pea.",
  },
  {
    "web-scraper-order": "1666024572-713",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫖 Teapot",
    "food-href": "https://emojipedia.org/teapot/",
    emoji: "🫖",
    emojiName: "🫖 Teapot",
    description:
      "A classic teapot with a wide bulbous body, a spout, a handle, and a lid. Can be used to talk about tea, tea time, or warm beverages in general.",
  },
  {
    "web-scraper-order": "1666024576-714",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "☕ Hot Beverage",
    "food-href": "https://emojipedia.org/hot-beverage/",
    emoji: "☕",
    emojiName: "☕ Hot Beverage",
    description:
      "A cup of a steaming-hot beverage, usually taken as coffee or tea. Sometimes shown on a saucer.",
  },
  {
    "web-scraper-order": "1666024578-715",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥛 Glass of Milk",
    "food-href": "https://emojipedia.org/glass-of-milk/",
    emoji: "🥛",
    emojiName: "🥛 Glass of Milk",
    description:
      "A tall glass of white milk, as from a cow but also other mammals, nuts, or plants. Most platforms depict a glass filled near to the brim, but some show a glass half-full—or half-empty.",
  },
  {
    "web-scraper-order": "1666024581-716",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍼 Baby Bottle",
    "food-href": "https://emojipedia.org/baby-bottle/",
    emoji: "🍼",
    emojiName: "🍼 Baby Bottle",
    description:
      "A bottle of milk or formula, as or fed to a baby, with a bluish cap and rubber nipple or teat. Positioned upright or at a 45° angle, and filled to various levels, sometimes showing fill lines. Often used for newborns and childrearing. See also Breast-Feeding.",
  },
  {
    "web-scraper-order": "1666024583-717",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍯 Honey Pot",
    "food-href": "https://emojipedia.org/honey-pot/",
    emoji: "🍯",
    emojiName: "🍯 Honey Pot",
    description:
      "A golden-yellow pot of honey, as made by bees and desired by bears. Shown with the sweet substance oozing down its sides, often with a honey dipper inside the small vessel.",
  },
  {
    "web-scraper-order": "1666024585-718",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍮 Custard",
    "food-href": "https://emojipedia.org/custard/",
    emoji: "🍮",
    emojiName: "🍮 Custard",
    description:
      "A golden-yellow custard dessert, as a crème caramel or flan, topped with a layer of caramel. Shown on a plate, molded in a ramekin-shape and often in a pool of caramel sauce.",
  },
  {
    "web-scraper-order": "1666024588-719",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍭 Lollipop",
    "food-href": "https://emojipedia.org/lollipop/",
    emoji: "🍭",
    emojiName: "🍭 Lollipop",
    description:
      "A colorful lollipop made of swirled hard candy attached to a stick. Colors vary by platform, though most designs show rainbow colors or pinks and reds.",
  },
  {
    "web-scraper-order": "1666024590-720",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍬 Candy",
    "food-href": "https://emojipedia.org/candy/",
    emoji: "🍬",
    emojiName: "🍬 Candy",
    description:
      "A small piece of candy wrapped in plastic or wax paper with twists on its ends. Shape and color vary widely by platform. Facebook’s design used to resemble a classic unwrapped red-and-white peppermint. May also be called sweets or lollies.",
  },
  {
    "web-scraper-order": "1666024593-721",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍫 Chocolate Bar",
    "food-href": "https://emojipedia.org/chocolate-bar/",
    emoji: "🍫",
    emojiName: "🍫 Chocolate Bar",
    description:
      "A block of dark chocolate, usually shown in a red foil wrapper peeled back to show squares of the candy. WhatsApp displays the wrapper in purple, a color commonly associated with Cadbury chocolate.",
  },
  {
    "web-scraper-order": "1666024595-722",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥧 Pie",
    "food-href": "https://emojipedia.org/pie/",
    emoji: "🥧",
    emojiName: "🥧 Pie",
    description:
      "A baked dish with a pastry crust, filled with sweet or savory ingredients. Appearance widely varies by platform.",
  },
  {
    "web-scraper-order": "1666024597-723",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧁 Cupcake",
    "food-href": "https://emojipedia.org/cupcake/",
    emoji: "🧁",
    emojiName: "🧁 Cupcake",
    description:
      "An individual cupcake in a liner topped with a swirl of frosting and sprinkles. The style of cupcake widely varies across platforms. The cake may be sponge or chocolate, the frosting pink or white, and the sprinkles rainbow or red.",
  },
  {
    "web-scraper-order": "1666024600-724",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍰 Shortcake",
    "food-href": "https://emojipedia.org/shortcake/",
    emoji: "🍰",
    emojiName: "🍰 Shortcake",
    description:
      "A slice of strawberry shortcake, layered with whipped cream and topped with a whole strawberry. Like the Birthday Cake, may be used to represent birthday celebrations or cake in general.",
  },
  {
    "web-scraper-order": "1666024604-725",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🎂 Birthday Cake",
    "food-href": "https://emojipedia.org/birthday-cake/",
    emoji: "🎂",
    emojiName: "🎂 Birthday Cake",
    description:
      "A frosted cake with lit candles, as presented for a birthday celebration. The style of cake widely varies across platforms. With white frosting and strawberries, Apple and Google’s designs suggest a Japanese Christmas cake. Other vendors depict a chocolate, pink, and/or sponge cake.",
  },
  {
    "web-scraper-order": "1666024607-726",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍪 Cookie",
    "food-href": "https://emojipedia.org/cookie/",
    emoji: "🍪",
    emojiName: "🍪 Cookie",
    description:
      "A golden-brown chocolate chip cookie or biscuit. Used to represent cookies or biscuits in general.",
  },
  {
    "web-scraper-order": "1666024609-727",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍩 Doughnut",
    "food-href": "https://emojipedia.org/doughnut/",
    emoji: "🍩",
    emojiName: "🍩 Doughnut",
    description:
      "A chocolate-glazed donut (or doughnut) with rainbow sprinkles. WhatsApp features a pink glaze associated with The Simpsons. May resemble the Bagel at small sizes.",
  },
  {
    "web-scraper-order": "1666024611-728",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍨 Ice Cream",
    "food-href": "https://emojipedia.org/ice-cream/",
    emoji: "🍨",
    emojiName: "🍨 Ice Cream",
    description:
      "One or more scoops of ice cream in a dessert bowl, variously topped with sprinkles, wafer rolls, or cherry and syrup. Flavors vary from vanilla, chocolate, and/or strawberry across platforms.",
  },
  {
    "web-scraper-order": "1666024614-729",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍧 Shaved Ice",
    "food-href": "https://emojipedia.org/shaved-ice/",
    emoji: "🍧",
    emojiName: "🍧 Shaved Ice",
    description:
      "A mound of shaved ice (snow cone) served in a dessert bowl with a short spoon, flavored with a cherry-red syrup on many platforms. Associated with Hawaiian shave ice or Japanese kakigori.",
  },
  {
    "web-scraper-order": "1666024617-730",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍦 Soft Ice Cream",
    "food-href": "https://emojipedia.org/soft-ice-cream/",
    emoji: "🍦",
    emojiName: "🍦 Soft Ice Cream",
    description:
      "A swirl of soft-serve ice cream atop a wafer-style cone, white or cream-colored, as vanilla, on most platforms. Facebook’s design suggests strawberry. May be used more generally for ice cream, frozen yogurt, and frozen treats.",
  },
  {
    "web-scraper-order": "1666024620-731",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🦪 Oyster",
    "food-href": "https://emojipedia.org/oyster/",
    emoji: "🦪",
    emojiName: "🦪 Oyster",
    description:
      "Half of an opened oyster shell with gray, pink, or orange flesh inside. Many platforms also include a pearl in the shell.",
  },
  {
    "web-scraper-order": "1666024623-732",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥡 Takeout Box",
    "food-href": "https://emojipedia.org/takeout-box/",
    emoji: "🥡",
    emojiName: "🥡 Takeout Box",
    description:
      "A tall, folded, paper carton, usually white, as used for takeout/takeaway food at Western Chinese restaurants. Most platforms depict chopsticks inside its open lid, labeled with a red, multi-tiered, traditional Chinese building. Also called an oyster pail.",
  },
  {
    "web-scraper-order": "1666024626-733",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥠 Fortune Cookie",
    "food-href": "https://emojipedia.org/fortune-cookie/",
    emoji: "🥠",
    emojiName: "🥠 Fortune Cookie",
    description:
      "A golden-brown, crescent-shaped, vanilla-flavored fortune cookie. Usually depicted with a strip of paper—on which a wise saying, lucky numbers, or Chinese vocabulary is written—peaking out of its hollow shell. Given at the end of meals at Chinese restaurants in the West.",
  },
  {
    "web-scraper-order": "1666024628-734",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥟 Dumpling",
    "food-href": "https://emojipedia.org/dumpling/",
    emoji: "🥟",
    emojiName: "🥟 Dumpling",
    description:
      "A dumpling of dough and filling, as folded and pinched closed for steaming or frying. Associated with cuisines around the world, including China (jiaozi), Japan (gyoza or dango), Poland (pierogi), and Spain and Latin America (empanada).",
  },
  {
    "web-scraper-order": "1666024631-735",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍡 Dango",
    "food-href": "https://emojipedia.org/dango/",
    emoji: "🍡",
    emojiName: "🍡 Dango",
    description:
      "A Japanese sweet dumpling made from rice flour and served on a skewer. Depicted as a botchan dango, comprising a pink, white or light yellow, and green ball, as colored by red beans, egg, and green tea. Resembles the Oden and featured in the Moon Viewing Ceremony, used in the Japanese festival to celebrate the full moon.",
  },
  {
    "web-scraper-order": "1666024633-736",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥮 Moon Cake",
    "food-href": "https://emojipedia.org/moon-cake/",
    emoji: "🥮",
    emojiName: "🥮 Moon Cake",
    description:
      "The round, golden-brown pastry of a Chinese mooncake, a traditional delicacy and lunar symbol of the Mid-Autumn Festival. Many platforms feature a design or character imprinted on the crust, and depict a slice cut out to show a brown paste with a duck egg yolk inside. Twitter displays the Chinese character for “fall/autumn” or “harvest” (秋) on top.",
  },
  {
    "web-scraper-order": "1666024636-737",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍥 Fish Cake with Swirl",
    "food-href": "https://emojipedia.org/fish-cake-with-swirl/",
    emoji: "🍥",
    emojiName: "🍥 Fish Cake with Swirl",
    description:
      "A slice of Japanese narutomaki, a ridged fishcake of processed whitefish with an iconic pink swirl, often served in ramen or oden. Thanks to its distinct swirl, may be used for flair.",
  },
  {
    "web-scraper-order": "1666024639-738",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍤 Fried Shrimp",
    "food-href": "https://emojipedia.org/fried-shrimp/",
    emoji: "🍤",
    emojiName: "🍤 Fried Shrimp",
    description:
      "A prawn or shrimp breaded and deep-fried golden-brown. Known as ebi furai in Japan but commonly called shrimp tempura and served in a bento box. Not to be confused with the Shrimp.",
  },
  {
    "web-scraper-order": "1666024642-739",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍣 Sushi",
    "food-href": "https://emojipedia.org/sushi/",
    emoji: "🍣",
    emojiName: "🍣 Sushi",
    description:
      "Japanese sushi, generally depicted as two pieces of raw pinkish-orange fish, as tuna or salmon, on white rice (nigiri). Some platforms show the cylindrical maki, a piece of seafood, vegetables, and white rice wrapped in seaweed (nori).",
  },
  {
    "web-scraper-order": "1666024645-740",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍢 Oden",
    "food-href": "https://emojipedia.org/oden/",
    emoji: "🍢",
    emojiName: "🍢 Oden",
    description:
      "A skewer of three bites of Japanese oden, a winter dish made with fishcakes, tofu, konnyaku, and a variety of other ingredients, including boiled eggs. Often served as a stew or skewered and dipped into soy sauce. Resembles the Dango and may be used for other skewered foods (e.g., shish kebab, roasting marshmallows) or spears.",
  },
  {
    "web-scraper-order": "1666024647-741",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍠 Roasted Sweet Potato",
    "food-href": "https://emojipedia.org/roasted-sweet-potato/",
    emoji: "🍠",
    emojiName: "🍠 Roasted Sweet Potato",
    description:
      "A sweet potato depicted with textured purple, orange, or brown skin and sliced in half to show its golden-brown flesh. Sometimes called a yam, though they are unrelated. Not to be confused with the Potato.",
  },
  {
    "web-scraper-order": "1666024649-742",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍝 Spaghetti",
    "food-href": "https://emojipedia.org/spaghetti/",
    emoji: "🍝",
    emojiName: "🍝 Spaghetti",
    description:
      "A plate of Italian spaghetti with tomato sauce, as a bolognese, with a fork twirling its long, thin noodles. Garnished with a green herb, as parsley, on some platforms.",
  },
  {
    "web-scraper-order": "1666024652-743",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍜 Steaming Bowl",
    "food-href": "https://emojipedia.org/steaming-bowl/",
    emoji: "🍜",
    emojiName: "🍜 Steaming Bowl",
    description:
      "A bowl of steaming-hot food. Depicted as Japanese ramen (noodles in broth) with chopsticks on most platforms, though it can represent a warm meal more generally.",
  },
  {
    "web-scraper-order": "1666024654-744",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍛 Curry Rice",
    "food-href": "https://emojipedia.org/curry-rice/",
    emoji: "🍛",
    emojiName: "🍛 Curry Rice",
    description:
      "A plate of orange-brown curry with vegetables or meat, served with a mound of white rice. May represent kare-raisu, or Japanese curry, though commonly associated with India and other Asian cuisines.",
  },
  {
    "web-scraper-order": "1666024657-745",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍚 Cooked Rice",
    "food-href": "https://emojipedia.org/cooked-rice/",
    emoji: "🍚",
    emojiName: "🍚 Cooked Rice",
    description:
      "A bowl of steamed white rice, a staple component of cuisine throughout Asia. Bowl color varies across platforms, though is often white.",
  },
  {
    "web-scraper-order": "1666024659-746",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍙 Rice Ball",
    "food-href": "https://emojipedia.org/rice-ball/",
    emoji: "🍙",
    emojiName: "🍙 Rice Ball",
    description:
      "A Japanese onigiri, a cone-shaped ball of white rice, a snack wrapped with a sheet of nori, or seaweed.",
  },
  {
    "web-scraper-order": "1666024661-747",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍘 Rice Cracker",
    "food-href": "https://emojipedia.org/rice-cracker/",
    emoji: "🍘",
    emojiName: "🍘 Rice Cracker",
    description:
      "A Japanese senbei, or rice cracker, wrapped with a sheet of nori, or seaweed, a snack commonly enjoyed with green tea.",
  },
  {
    "web-scraper-order": "1666024664-748",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍱 Bento Box",
    "food-href": "https://emojipedia.org/bento-box/",
    emoji: "🍱",
    emojiName: "🍱 Bento Box",
    description:
      "A Japanese bento, a lunch box divided into portions of rice, vegetables, and meat or seafood, such as sushi or fried shrimp.",
  },
  {
    "web-scraper-order": "1666024666-749",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥫 Canned Food",
    "food-href": "https://emojipedia.org/canned-food/",
    emoji: "🥫",
    emojiName: "🥫 Canned Food",
    description:
      "A can or tin of food, depicted as tomatoes or a generic green vegetable. May be also used to represent sauce or soup.",
  },
  {
    "web-scraper-order": "1666024669-750",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧂 Salt",
    "food-href": "https://emojipedia.org/salt/",
    emoji: "🧂",
    emojiName: "🧂 Salt",
    description:
      "A clear glass shaker of salt with a silver cap, as paired with pepper to season food when eating at a restaurant.",
  },
  {
    "web-scraper-order": "1666024671-751",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧈 Butter",
    "food-href": "https://emojipedia.org/butter/",
    emoji: "🧈",
    emojiName: "🧈 Butter",
    description:
      "A pale yellow stick of butter. Can be used to talk about cooking or eating. Might also be used in idioms or to reference something that is smooth.",
  },
  {
    "web-scraper-order": "1666024674-752",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍿 Popcorn",
    "food-href": "https://emojipedia.org/popcorn/",
    emoji: "🍿",
    emojiName: "🍿 Popcorn",
    description:
      "The buttery-white snack of popcorn brimming in a classic red-and-white-striped carton, as enjoyed at a movie theater.",
  },
  {
    "web-scraper-order": "1666024676-753",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥗 Green Salad",
    "food-href": "https://emojipedia.org/green-salad/",
    emoji: "🥗",
    emojiName: "🥗 Green Salad",
    description:
      "An undressed garden salad in a bowl with leafy-green lettuce and other ingredients such as tomato, red onion, and black olives. Commonly associated with healthy eating and living.",
  },
  {
    "web-scraper-order": "1666024678-754",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥣 Bowl with Spoon",
    "food-href": "https://emojipedia.org/bowl-with-spoon/",
    emoji: "🥣",
    emojiName: "🥣 Bowl with Spoon",
    description:
      "A bowl with a silver spoon inside, as used to eat cereal or soup. Bowl color varies across platforms, as do contents, though most are empty.",
  },
  {
    "web-scraper-order": "1666024681-755",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫕 Fondue",
    "food-href": "https://emojipedia.org/fondue/",
    emoji: "🫕",
    emojiName: "🫕 Fondue",
    description:
      "A red fondue pot. Most platforms show cheese fondue with fondue forks sticking out of the pot.",
  },
  {
    "web-scraper-order": "1666024683-756",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍲 Pot of Food",
    "food-href": "https://emojipedia.org/pot-of-food/",
    emoji: "🍲",
    emojiName: "🍲 Pot of Food",
    description:
      "A pot, as a casserole dish, filled with a warm and hearty beef or vegetable stew on most platforms. Generally used for eating and cooking (“a meal”), and commonly associated with soup or Japanese nabe.",
  },
  {
    "web-scraper-order": "1666024685-757",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥘 Shallow Pan of Food",
    "food-href": "https://emojipedia.org/shallow-pan-of-food/",
    emoji: "🥘",
    emojiName: "🥘 Shallow Pan of Food",
    description:
      "A flat, shallow, black pan with side handles, containing saffron-colored rice, vegetables, a leg of poultry, and/or shrimp and lemon slices. Commonly associated with paella, a traditional dish from Spain. May be used for eating, cooking, dining, and meals more generally.",
  },
  {
    "web-scraper-order": "1666024688-758",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍳 Cooking",
    "food-href": "https://emojipedia.org/cooking/",
    emoji: "🍳",
    emojiName: "🍳 Cooking",
    description:
      "An egg with yolk frying in a skillet, as prepared sunny-side up. Though associated with breakfast, the emoji represents the general action of cooking and related concepts.",
  },
  {
    "web-scraper-order": "1666024690-759",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥚 Egg",
    "food-href": "https://emojipedia.org/egg/",
    emoji: "🥚",
    emojiName: "🥚 Egg",
    description:
      "An egg, displayed as a chicken egg with a white or light brown shell. Commonly used at Easter time. See also: 🍳 Cooking.",
  },
  {
    "web-scraper-order": "1666024692-760",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧆 Falafel",
    "food-href": "https://emojipedia.org/falafel/",
    emoji: "🧆",
    emojiName: "🧆 Falafel",
    description:
      "Brown spheres depicting falafel, a food popular in Middle Eastern and North African cuisine, typically made of mashed chickpeas or fava beans. Most platforms include three or more falafel with one piece split open to reveal a green center. Can be used to talk about falafel and possibly other round brown food items like meatballs.",
  },
  {
    "web-scraper-order": "1666024695-761",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥙 Stuffed Flatbread",
    "food-href": "https://emojipedia.org/stuffed-flatbread/",
    emoji: "🥙",
    emojiName: "🥙 Stuffed Flatbread",
    description:
      "A flatbread, like pita, stuffed with lettuce, tomato, and/or meat. Resembles a doner kebab, falafel, shawarma, or gyro sandwich, popular in the Middle East and the Mediterranean. Some platforms have red onion and cucumber. Not to be confused with 🫓 Flatbread or 🌯 Burrito.",
  },
  {
    "web-scraper-order": "1666024698-762",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫔 Tamale",
    "food-href": "https://emojipedia.org/tamale/",
    emoji: "🫔",
    emojiName: "🫔 Tamale",
    description: "A single tamale wrapped in a corn husk.",
  },
  {
    "web-scraper-order": "1666024700-763",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌯 Burrito",
    "food-href": "https://emojipedia.org/burrito/",
    emoji: "🌯",
    emojiName: "🌯 Burrito",
    description:
      "A Mexican or Tex-Mex burrito, featuring a wrapped flour tortilla filled with such ingredients as beef, rice, beans, cheese, tomato, lettuce, and sour cream. Served in foil on several major platforms, suggesting a Mission burrito associated with San Francisco. Not to be confused with the Stuffed Flatbread.",
  },
  {
    "web-scraper-order": "1666024702-764",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌮 Taco",
    "food-href": "https://emojipedia.org/taco/",
    emoji: "🌮",
    emojiName: "🌮 Taco",
    description:
      "A Mexican or Tex-Mex taco on a hard or soft corn tortilla, filled with such ingredients as beef, lettuce, tomato, cheese, and onion. Apple’s design resembles a carne asada taco, with cilantro and white onion.",
  },
  {
    "web-scraper-order": "1666024705-765",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥪 Sandwich",
    "food-href": "https://emojipedia.org/sandwich/",
    emoji: "🥪",
    emojiName: "🥪 Sandwich",
    description:
      "A sandwich, as eaten at lunch, made with lettuce, tomato, and cheese on slices of white or wheat bread. Apple, Google, and WhatsApp add a deli meat that resembles ham.",
  },
  {
    "web-scraper-order": "1666024707-766",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌭 Hot Dog",
    "food-href": "https://emojipedia.org/hot-dog/",
    emoji: "🌭",
    emojiName: "🌭 Hot Dog",
    description:
      "The cooked sausage of a hot dog in a sliced bun and drizzled with yellow mustard, as eaten at a baseball game.",
  },
  {
    "web-scraper-order": "1666024709-767",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍕 Pizza",
    "food-href": "https://emojipedia.org/pizza/",
    emoji: "🍕",
    emojiName: "🍕 Pizza",
    description:
      "A slice of pepperoni pizza, previously also topped with black olives on Google. WhatsApp adds green pepper, Samsung white onion.",
  },
  {
    "web-scraper-order": "1666024712-768",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍟 French Fries",
    "food-href": "https://emojipedia.org/french-fries/",
    emoji: "🍟",
    emojiName: "🍟 French Fries",
    description:
      "Thin-cut, golden-brown French fries, served in a red carton, as at McDonald’s. Apple features Smiling Face With Smiling Eyes on its carton.",
  },
  {
    "web-scraper-order": "1666024714-769",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍔 Hamburger",
    "food-href": "https://emojipedia.org/hamburger/",
    emoji: "🍔",
    emojiName: "🍔 Hamburger",
    description:
      "A burger with a beef patty, usually depicted on a sesame bun with cheese, lettuce, and tomato—making it a cheeseburger, though officially called Hamburger by Unicode.",
  },
  {
    "web-scraper-order": "1666024717-770",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥓 Bacon",
    "food-href": "https://emojipedia.org/bacon/",
    emoji: "🥓",
    emojiName: "🥓 Bacon",
    description:
      "Strips of crispy, fatty, reddish-brown bacon, as fried for breakfast. Depicted as a pair on most platforms.",
  },
  {
    "web-scraper-order": "1666024719-771",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥩 Cut of Meat",
    "food-href": "https://emojipedia.org/cut-of-meat/",
    emoji: "🥩",
    emojiName: "🥩 Cut of Meat",
    description:
      "A cut of uncooked red meat, as a T-bone or rib-eye steak, with the light, white marbling of fat.",
  },
  {
    "web-scraper-order": "1666024721-772",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍗 Poultry Leg",
    "food-href": "https://emojipedia.org/poultry-leg/",
    emoji: "🍗",
    emojiName: "🍗 Poultry Leg",
    description:
      "A crispy brown leg (drumstick) of chicken, duck, turkey, or other poultry on the bone, as roasted at Thanksgiving or Christmas dinner or fried at fast-food restaurants.",
  },
  {
    "web-scraper-order": "1666024724-773",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍖 Meat on Bone",
    "food-href": "https://emojipedia.org/meat-on-bone/",
    emoji: "🍖",
    emojiName: "🍖 Meat on Bone",
    description:
      "A hunk of unspecified meat on a white bone, as associated with cartoon cavepersons or food in anime and manga (Japanese ano niku, “that meat”).",
  },
  {
    "web-scraper-order": "1666024726-774",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧀 Cheese Wedge",
    "food-href": "https://emojipedia.org/cheese-wedge/",
    emoji: "🧀",
    emojiName: "🧀 Cheese Wedge",
    description:
      "A wedge of yellow-orange cheese with holes, like a Swiss, but used for the food in general. May be used for various cheese-related slang expressions (e.g., “cheesy,” “say cheese,” “big cheese”).",
  },
  {
    "web-scraper-order": "1666024729-775",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧇 Waffle",
    "food-href": "https://emojipedia.org/waffle/",
    emoji: "🧇",
    emojiName: "🧇 Waffle",
    description:
      "A round or square Belgian waffle, baked to a golden brown. Most platforms depict this emoji topped with a pad of butter, and some include gooey syrup running down the sides.",
  },
  {
    "web-scraper-order": "1666024731-776",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥞 Pancakes",
    "food-href": "https://emojipedia.org/pancakes/",
    emoji: "🥞",
    emojiName: "🥞 Pancakes",
    description:
      "A stack of breakfast pancakes, topped with a pad of butter and maple syrup oozing down its golden-brown sides, onto a plate on some platforms.",
  },
  {
    "web-scraper-order": "1666024734-777",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥯 Bagel",
    "food-href": "https://emojipedia.org/bagel/",
    emoji: "🥯",
    emojiName: "🥯 Bagel",
    description:
      "The brown bread of a bagel, shown sliced in two halves. Some platforms depict seeds, as sesame or poppy, and a schmear of cream cheese, with the bagel assembled as a sandwich. May resemble the Doughnut at small sizes.",
  },
  {
    "web-scraper-order": "1666024736-778",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥨 Pretzel",
    "food-href": "https://emojipedia.org/pretzel/",
    emoji: "🥨",
    emojiName: "🥨 Pretzel",
    description:
      "The heart-shaped twist of a hard or soft golden-brown pretzel, seasoned with grains of salt. A snack commonly associated with Germany.",
  },
  {
    "web-scraper-order": "1666024739-779",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫓 Flatbread",
    "food-href": "https://emojipedia.org/flatbread/",
    emoji: "🫓",
    emojiName: "🫓 Flatbread",
    description:
      "A round piece of flatbread with grill marks. Used to represent any type of flatbread, soft or crunchy.",
  },
  {
    "web-scraper-order": "1666024741-780",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥖 Baguette Bread",
    "food-href": "https://emojipedia.org/baguette-bread/",
    emoji: "🥖",
    emojiName: "🥖 Baguette Bread",
    description:
      'The long, thin loaf of a baguette, with scoring on its golden-brown crust. A bread commonly associated with France. May also be used to denote financial success, as per the slang term "let\'s get this bread".',
  },
  {
    "web-scraper-order": "1666024743-781",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥐 Croissant",
    "food-href": "https://emojipedia.org/croissant/",
    emoji: "🥐",
    emojiName: "🥐 Croissant",
    description:
      "The flaky, golden-brown crescent of a croissant, a breakfast pastry associated with France and Austria.",
  },
  {
    "web-scraper-order": "1666024746-782",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍞 Bread",
    "food-href": "https://emojipedia.org/bread/",
    emoji: "🍞",
    emojiName: "🍞 Bread",
    description:
      'A loaf of white or wheat bread, as before it is sliced for toast or sandwiches. May also be used to denote financial success, as per the slang term "let\'s get this bread".',
  },
  {
    "web-scraper-order": "1666024749-783",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌰 Chestnut",
    "food-href": "https://emojipedia.org/chestnut/",
    emoji: "🌰",
    emojiName: "🌰 Chestnut",
    description:
      "The reddish-brown, acorn-shaped chestnut, tapering to a sharp tip from its light brown base on most platforms. A popular roasted snack associated with autumn and Christmas.",
  },
  {
    "web-scraper-order": "1666024751-784",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫘 Beans",
    "food-href": "https://emojipedia.org/beans/",
    emoji: "🫘",
    emojiName: "🫘 Beans",
    description: "Beans, as used in cuisines around the world.",
  },
  {
    "web-scraper-order": "1666024754-785",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥜 Peanuts",
    "food-href": "https://emojipedia.org/peanuts/",
    emoji: "🥜",
    emojiName: "🥜 Peanuts",
    description:
      "The pod of the peanut, shown in its rounded, grooved, light-brown shell. Apple depicts a pair.",
  },
  {
    "web-scraper-order": "1666024756-786",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍄 Mushroom",
    "food-href": "https://emojipedia.org/mushroom/",
    emoji: "🍄",
    emojiName: "🍄 Mushroom",
    description:
      "The edible fungus of the mushroom, depicted as a toadstool with a white-spotted red cap and stem.",
  },
  {
    "web-scraper-order": "1666024759-787",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧅 Onion",
    "food-href": "https://emojipedia.org/onion/",
    emoji: "🧅",
    emojiName: "🧅 Onion",
    description:
      "A round yellow onion. Can be used to talk about cooking, eating, or crying. Sometimes used in metaphors about layers. Might also be used in computing contexts in reference to onion routing.",
  },
  {
    "web-scraper-order": "1666024762-788",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🧄 Garlic",
    "food-href": "https://emojipedia.org/garlic/",
    emoji: "🧄",
    emojiName: "🧄 Garlic",
    description:
      "A single white or light brown bulb of garlic. Can be used to talk about cooking, eating, or vampire protection.",
  },
  {
    "web-scraper-order": "1666024764-789",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥦 Broccoli",
    "food-href": "https://emojipedia.org/broccoli/",
    emoji: "🥦",
    emojiName: "🥦 Broccoli",
    description: "A rich green, tree-like head or floret of broccoli.",
  },
  {
    "web-scraper-order": "1666024767-790",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥬 Leafy Green",
    "food-href": "https://emojipedia.org/leafy-green/",
    emoji: "🥬",
    emojiName: "🥬 Leafy Green",
    description:
      "A head of a rich green leaf vegetable, usually shown with white stalks. May be used to represent a variety of greens, including romaine lettuce, chard, and Chinese cabbage like bok choy, as commonly cooked in Asian cuisines.",
  },
  {
    "web-scraper-order": "1666024769-791",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥒 Cucumber",
    "food-href": "https://emojipedia.org/cucumber/",
    emoji: "🥒",
    emojiName: "🥒 Cucumber",
    description:
      "A long, green cucumber with bumpy skin. Resembles its derived product, a pickle or gherkin, on many platforms, except on Apple and WhatsApp, which depict it with light-green, seed-y slices.",
  },
  {
    "web-scraper-order": "1666024771-792",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫑 Bell Pepper",
    "food-href": "https://emojipedia.org/bell-pepper/",
    emoji: "🫑",
    emojiName: "🫑 Bell Pepper",
    description:
      "A perfectly ripe red or green bell pepper. Can be used to talk about bell peppers or food in general.",
  },
  {
    "web-scraper-order": "1666024774-793",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌶️ Hot Pepper",
    "food-href": "https://emojipedia.org/hot-pepper/",
    emoji: "🌶️",
    emojiName: "🌶️ Hot Pepper",
    description:
      "A bright red Mexican chili pepper, slightly curled and with a green stem. May be used to represent something “hot and spicy,” figuratively or literally, as a dish on a restaurant menu.",
  },
  {
    "web-scraper-order": "1666024776-794",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🌽 Ear of Corn",
    "food-href": "https://emojipedia.org/ear-of-corn/",
    emoji: "🌽",
    emojiName: "🌽 Ear of Corn",
    description:
      "An ear of corn, or maize, partially husked to show its buttery-yellow kernels.",
  },
  {
    "web-scraper-order": "1666024778-795",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥕 Carrot",
    "food-href": "https://emojipedia.org/carrot/",
    emoji: "🥕",
    emojiName: "🥕 Carrot",
    description:
      "A whole, bright orange carrot, topped with long green leaves, as if freshly plucked from the garden. Some platforms feature a longer, thinner carrot, others a shorter, more bulbous one.",
  },
  {
    "web-scraper-order": "1666024781-796",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥔 Potato",
    "food-href": "https://emojipedia.org/potato/",
    emoji: "🥔",
    emojiName: "🥔 Potato",
    description:
      "A whole potato—such as a russet, used for baking, mashing, or frying—shown with a few eyes on its golden-brown skin. Not to be confused with the roasted sweet potato.",
  },
  {
    "web-scraper-order": "1666024783-797",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍆 Eggplant",
    "food-href": "https://emojipedia.org/eggplant/",
    emoji: "🍆",
    emojiName: "🍆 Eggplant",
    description:
      "A long, bulbous, bright purple eggplant, or aubergine in British English, shown with a leafy stem. Considered lucky in Japan to dream of an eggplant the first night of the New Year.",
  },
  {
    "web-scraper-order": "1666024785-798",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥑 Avocado",
    "food-href": "https://emojipedia.org/avocado/",
    emoji: "🥑",
    emojiName: "🥑 Avocado",
    description:
      "A pear-shaped avocado, sliced in half to show its yellow-green flesh and large brown pit. Ready for toast, guacamole, or millennial jokes.",
  },
  {
    "web-scraper-order": "1666024788-799",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥥 Coconut",
    "food-href": "https://emojipedia.org/coconut/",
    emoji: "🥥",
    emojiName: "🥥 Coconut",
    description:
      "The hairy shell of a tropical coconut, cracked in a half to show its milky-white meat.",
  },
  {
    "web-scraper-order": "1666024790-800",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫒 Olive",
    "food-href": "https://emojipedia.org/olive/",
    emoji: "🫒",
    emojiName: "🫒 Olive",
    description:
      "One, two, or three green olives, either pitted or sprouting from a branch. Some platforms show a solitary pitted green olive stuffed with a piece of a pimento pepper.",
  },
  {
    "web-scraper-order": "1666024792-801",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍅 Tomato",
    "food-href": "https://emojipedia.org/tomato/",
    emoji: "🍅",
    emojiName: "🍅 Tomato",
    description:
      "A plump, red garden tomato topped with a leafy green stem. May resemble the red apple at small sizes.",
  },
  {
    "web-scraper-order": "1666024795-802",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥝 Kiwi Fruit",
    "food-href": "https://emojipedia.org/kiwi-fruit/",
    emoji: "🥝",
    emojiName: "🥝 Kiwi Fruit",
    description:
      "A kiwifruit, or Chinese gooseberry, with its fuzzy, brown skin sliced open to show its light-green flesh, white core, and black seeds.",
  },
  {
    "web-scraper-order": "1666024797-803",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🫐 Blueberries",
    "food-href": "https://emojipedia.org/blueberries/",
    emoji: "🫐",
    emojiName: "🫐 Blueberries",
    description:
      "A few ripe blueberries clustered together. Most platforms show three blueberries, and some show small green leaves coming out from behind the blueberries.",
  },
  {
    "web-scraper-order": "1666024799-804",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍓 Strawberry",
    "food-href": "https://emojipedia.org/strawberry/",
    emoji: "🍓",
    emojiName: "🍓 Strawberry",
    description:
      "The fruit of a rich red strawberry dotted with seeds and crowned with green leaves. Google previously depicted the fruit in orange.",
  },
  {
    "web-scraper-order": "1666024802-805",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍒 Cherries",
    "food-href": "https://emojipedia.org/cherries/",
    emoji: "🍒",
    emojiName: "🍒 Cherries",
    description:
      "Two rich red cherries with a green leaf and joined at their long stems. May be used to refer to breasts on TikTok and other social media platforms.",
  },
  {
    "web-scraper-order": "1666024804-806",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍑 Peach",
    "food-href": "https://emojipedia.org/peach/",
    emoji: "🍑",
    emojiName: "🍑 Peach",
    description:
      "The fleshy, pinkish-orange fruit of the fuzzy peach, shown with green leaves and sometimes a stem.",
  },
  {
    "web-scraper-order": "1666024807-807",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍐 Pear",
    "food-href": "https://emojipedia.org/pear/",
    emoji: "🍐",
    emojiName: "🍐 Pear",
    description:
      "A light-green variety of a common pear, shown with a stem and sometimes green leaf.",
  },
  {
    "web-scraper-order": "1666024809-808",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍏 Green Apple",
    "food-href": "https://emojipedia.org/green-apple/",
    emoji: "🍏",
    emojiName: "🍏 Green Apple",
    description:
      "A common green apple, tarter counterpart to the Red Apple. Displayed with a stem and single, green leaf on major platforms.",
  },
  {
    "web-scraper-order": "1666024812-809",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍎 Red Apple",
    "food-href": "https://emojipedia.org/red-apple/",
    emoji: "🍎",
    emojiName: "🍎 Red Apple",
    description:
      "A classic red apple, shown with a stem and single, green leaf on major platforms. Commonly associated with doctors, teachers, and New York.",
  },
  {
    "web-scraper-order": "1666024814-810",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🥭 Mango",
    "food-href": "https://emojipedia.org/mango/",
    emoji: "🥭",
    emojiName: "🥭 Mango",
    description:
      "The ripe fruit of a tropical mango. Variously depicted in shades of yellow, red, orange, and green with a single, green leaf and stem.",
  },
  {
    "web-scraper-order": "1666024816-811",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍍 Pineapple",
    "food-href": "https://emojipedia.org/pineapple/",
    emoji: "🍍",
    emojiName: "🍍 Pineapple",
    description:
      "The tropical fruit of a pineapple, shown in spiky, golden-brown skin and with a pointed, green crown. Positioned upright or at a 45° angle.",
  },
  {
    "web-scraper-order": "1666024819-812",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍌 Banana",
    "food-href": "https://emojipedia.org/banana/",
    emoji: "🍌",
    emojiName: "🍌 Banana",
    description:
      "A ripe banana, peeled and ready to eat on major platforms. Great snack for a child or monkey.",
  },
  {
    "web-scraper-order": "1666024821-813",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍋 Lemon",
    "food-href": "https://emojipedia.org/lemon/",
    emoji: "🍋",
    emojiName: "🍋 Lemon",
    description:
      "The sour, yellow-colored citrus fruit of the lemon, usually with a stem and green leaf or leaves.",
  },
  {
    "web-scraper-order": "1666024823-814",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍊 Tangerine",
    "food-href": "https://emojipedia.org/tangerine/",
    emoji: "🍊",
    emojiName: "🍊 Tangerine",
    description:
      "An orange-colored citrus fruit with a green leaf or leaves and stem. Officially depicting a tangerine, a type of mandarin (mikan in Japan). Often used as a garden-variety orange. Either way, a good source of vitamin C.",
  },
  {
    "web-scraper-order": "1666024825-815",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍉 Watermelon",
    "food-href": "https://emojipedia.org/watermelon/",
    emoji: "🍉",
    emojiName: "🍉 Watermelon",
    description:
      "A slice of watermelon, showing its rich pink flesh, black seeds, and green rind.",
  },
  {
    "web-scraper-order": "1666024828-816",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍈 Melon",
    "food-href": "https://emojipedia.org/melon/",
    emoji: "🍈",
    emojiName: "🍈 Melon",
    description:
      "A melon fruit in a light greenish-brown rind. Depicted as a cantaloupe by most platforms, but can resemble a honeydew at a distance.",
  },
  {
    "web-scraper-order": "1666024830-817",
    "web-scraper-start-url": "https://emojipedia.org/food-drink/",
    food: "🍇 Grapes",
    "food-href": "https://emojipedia.org/grapes/",
    emoji: "🍇",
    emojiName: "🍇 Grapes",
    description:
      "A grape bunch, as cut from the vine and used to make wine. Depicted as red (purple-colored) grapes.",
  },
  {
    "web-scraper-order": "1666025941-936",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚰 Potable Water",
    "objects-href": "https://emojipedia.org/potable-water/",
    emoji: "🚰",
    emojiName: "🚰 Potable Water",
    description:
      "A symbol for potable (drinkable) water, usually shown with a faucet filling a drinking glass. Commonly used for various content concerning water, drinking, thirst, and dripping.",
  },
  {
    "web-scraper-order": "1666025944-939",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪪 Identification Card",
    "objects-href": "https://emojipedia.org/identification-card/",
    emoji: "🪪",
    emojiName: "🪪 Identification Card",
    description:
      "An identification card with a portrait and words. May be used to remind people to bring or show an id. May also be used in the context of a fake id.",
  },
  {
    "web-scraper-order": "1666025947-941",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪧 Placard",
    "objects-href": "https://emojipedia.org/placard/",
    emoji: "🪧",
    emojiName: "🪧 Placard",
    description:
      "A sign on a post, commonly used to promote ideas, causes, or make announcements. Often used used in the context of politics to represent a lawn sign or a poster brought to a protest. Also seen in commercial advertising.",
  },
  {
    "web-scraper-order": "1666025949-942",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗿 Moai",
    "objects-href": "https://emojipedia.org/moai/",
    emoji: "🗿",
    emojiName: "🗿 Moai",
    description:
      "A moai, one of the famed, giant stone statues of human figures on Easter Island. Depicted as a gray stone carving of a stylized human head with a prominent brow and nose, most often facing left.",
  },
  {
    "web-scraper-order": "1666025955-945",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚱️ Funeral Urn",
    "objects-href": "https://emojipedia.org/funeral-urn/",
    emoji: "⚱️",
    emojiName: "⚱️ Funeral Urn",
    description:
      "An urn, as used to hold the cremated ashes of the dead. Appearance varies, but generally depicted as a covered, bronze container with a rounded body and tapered foot.",
  },
  {
    "web-scraper-order": "1666025959-948",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪦 Headstone",
    "objects-href": "https://emojipedia.org/headstone/",
    emoji: "🪦",
    emojiName: "🪦 Headstone",
    description:
      "A headstone or tombstone, used to mark graves. Appearance varies from platform to platform, with different shapes and inscriptions.",
  },
  {
    "web-scraper-order": "1666025961-950",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚰️ Coffin",
    "objects-href": "https://emojipedia.org/coffin/",
    emoji: "⚰️",
    emojiName: "⚰️ Coffin",
    description:
      "A traditional coffin, as used to bury the dead. Depicted at various angles as a closed, six-sided, wooden coffin, tapered at the head and foot with golden handles.",
  },
  {
    "web-scraper-order": "1666025964-953",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚬 Cigarette",
    "objects-href": "https://emojipedia.org/cigarette/",
    emoji: "🚬",
    emojiName: "🚬 Cigarette",
    description:
      "A lit, filtered cigarette, shown burning at different directions. Commonly used to represent various forms of smoking (e.g., tobacco, marijuana, vaping) as well as metaphorical senses of smoking.",
  },
  {
    "web-scraper-order": "1666025966-955",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛒 Shopping Cart",
    "objects-href": "https://emojipedia.org/shopping-cart/",
    emoji: "🛒",
    emojiName: "🛒 Shopping Cart",
    description:
      "Shopping Cart was approved as part of Unicode 9.0 in 2016 under the name “Shopping Trolley” and added to Emoji 3.0 in 2016.",
  },
  {
    "web-scraper-order": "1666025969-958",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧯 Fire Extinguisher",
    "objects-href": "https://emojipedia.org/fire-extinguisher/",
    emoji: "🧯",
    emojiName: "🧯 Fire Extinguisher",
    description:
      "A fire extinguisher, as used to put out small fires. Depicted as a red tank with a black hose and pressure gauge. Most platforms include an image of a flame on a white label.",
  },
  {
    "web-scraper-order": "1666025971-961",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧽 Sponge",
    "objects-href": "https://emojipedia.org/sponge/",
    emoji: "🧽",
    emojiName: "🧽 Sponge",
    description:
      "A peanut-shaped sponge, as used for cleaning or bathing. Generally depicted in yellow and at different angles across platforms. Commonly used for various content concerning bathing, washing, and cleaning.",
  },
  {
    "web-scraper-order": "1666025974-963",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪥 Toothbrush",
    "objects-href": "https://emojipedia.org/toothbrush/",
    emoji: "🪥",
    emojiName: "🪥 Toothbrush",
    description: "A brightly colored plastic toothbrush with white bristles.",
  },
  {
    "web-scraper-order": "1666025976-966",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧼 Soap",
    "objects-href": "https://emojipedia.org/soap/",
    emoji: "🧼",
    emojiName: "🧼 Soap",
    description:
      "A bar of soap, as used in the shower, bath or for hand washing. Generally shown with lathered bubbles. Depicted in various colors, often pink, and at different angles.",
  },
  {
    "web-scraper-order": "1666025978-968",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪣 Bucket",
    "objects-href": "https://emojipedia.org/bucket/",
    emoji: "🪣",
    emojiName: "🪣 Bucket",
    description:
      "A blue or green bucket or pail. Used to talk about real or metaphorical buckets.",
  },
  {
    "web-scraper-order": "1666025981-970",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧻 Roll of Paper",
    "objects-href": "https://emojipedia.org/roll-of-paper/",
    emoji: "🧻",
    emojiName: "🧻 Roll of Paper",
    description:
      "A roll of paper, as toilet paper (toilet tissue). May also be a roll of kitchen/paper towels. Depicted at various angles, with a sheet unfurling.",
  },
  {
    "web-scraper-order": "1666025983-973",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧺 Basket",
    "objects-href": "https://emojipedia.org/basket/",
    emoji: "🧺",
    emojiName: "🧺 Basket",
    description:
      "A basket, as used for storing or carrying such things as food or clothes. Appearance widely varies across platforms but generally depicted as woven from wicker with one or more handles. Commonly used to represent doing laundry or having a picnic.",
  },
  {
    "web-scraper-order": "1666025985-975",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧹 Broom",
    "objects-href": "https://emojipedia.org/broom/",
    emoji: "🧹",
    emojiName: "🧹 Broom",
    description:
      "A traditional broom, as used for sweeping—or ridden by a witch. Shown at a 45° angle, with a wooden handle and yellow bristles at the lower left.",
  },
  {
    "web-scraper-order": "1666025988-979",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧷 Safety Pin",
    "objects-href": "https://emojipedia.org/safety-pin/",
    emoji: "🧷",
    emojiName: "🧷 Safety Pin",
    description:
      "A silver safety pin or clip, as used to fasten fabric. Generally shown clasped at a 45° angle, with its spring at the lower left.",
  },
  {
    "web-scraper-order": "1666025991-981",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧴 Lotion Bottle",
    "objects-href": "https://emojipedia.org/lotion-bottle/",
    emoji: "🧴",
    emojiName: "🧴 Lotion Bottle",
    description:
      "A bottle of lotion for the skin, such as moisturizer or sunscreen (sunblock). May be used for other hygienic liquids, including shampoo and body wash, as well as beauty products.",
  },
  {
    "web-scraper-order": "1666025993-984",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪒 Razor",
    "objects-href": "https://emojipedia.org/razor/",
    emoji: "🪒",
    emojiName: "🪒 Razor",
    description: "A safety razor, depicted in various colors across platforms.",
  },
  {
    "web-scraper-order": "1666025996-986",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪤 Mouse Trap",
    "objects-href": "https://emojipedia.org/mouse-trap/",
    emoji: "🪤",
    emojiName: "🪤 Mouse Trap",
    description:
      "A trap used to catch a mouse, rat, or other unwanted rodent. Metaphorically used in emoji form to suggest any kind of trap or entrapment.",
  },
  {
    "web-scraper-order": "1666025998-989",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛁 Bathtub",
    "objects-href": "https://emojipedia.org/bathtub/",
    emoji: "🛁",
    emojiName: "🛁 Bathtub",
    description:
      "A white bathtub with a silver shower head. Often depicted as a cast-iron tub with claw-foot legs. Commonly used for various content concerning bathing, washing, cleaning, and bathrooms more generally.",
  },
  {
    "web-scraper-order": "1666026001-991",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚿 Shower",
    "objects-href": "https://emojipedia.org/shower/",
    emoji: "🚿",
    emojiName: "🚿 Shower",
    description:
      "A silver shower head, streaming water to the left. Pressure level varies across platforms. 🧼 Soap not provided.",
  },
  {
    "web-scraper-order": "1666026003-993",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪠 Plunger",
    "objects-href": "https://emojipedia.org/plunger/",
    emoji: "🪠",
    emojiName: "🪠 Plunger",
    description:
      "A toilet plunger with a wooden handle and red flange and cup.",
  },
  {
    "web-scraper-order": "1666026006-996",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚽 Toilet",
    "objects-href": "https://emojipedia.org/toilet/",
    emoji: "🚽",
    emojiName: "🚽 Toilet",
    description:
      "A white toilet, as used to deposit a 💩 Pile of Poo. (Don’t forget the 🧻 Roll of Paper.) Most platforms depict a porcelain toilet in profile, bowl facing to the left.",
  },
  {
    "web-scraper-order": "1666026008-998",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪑 Chair",
    "objects-href": "https://emojipedia.org/chair/",
    emoji: "🪑",
    emojiName: "🪑 Chair",
    description: "A simple wooden chair.",
  },
  {
    "web-scraper-order": "1666026010-1001",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛋️ Couch and Lamp",
    "objects-href": "https://emojipedia.org/couch-and-lamp/",
    emoji: "🛋️",
    emojiName: "🛋️ Couch and Lamp",
    description:
      "A couch (sofa) with a floor lamp on the right, as in the living room of a house. Color and style of the couch and lamp vary widely by platform. Used for various content concerning furniture and housing as well as resting and lounging.",
  },
  {
    "web-scraper-order": "1666026013-1003",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛏️ Bed",
    "objects-href": "https://emojipedia.org/bed/",
    emoji: "🛏️",
    emojiName: "🛏️ Bed",
    description:
      "A bed, made up for sleeping in a house, hotel, or other sleeping accommodation. Shown with a headboard at the left, footboard, mattress, pillow, and sheet. Most platforms suggest a wooden frame and feature blue or red sheets.",
  },
  {
    "web-scraper-order": "1666026015-1005",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪟 Window",
    "objects-href": "https://emojipedia.org/window/",
    emoji: "🪟",
    emojiName: "🪟 Window",
    description:
      "A square or rectangular window with glass panes. Most platforms show a wooden frame with two or four panels.",
  },
  {
    "web-scraper-order": "1666026017-1008",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪞 Mirror",
    "objects-href": "https://emojipedia.org/mirror/",
    emoji: "🪞",
    emojiName: "🪞 Mirror",
    description:
      "A mirror with an ornate gold or silver frame. The shape and style of the mirror varies from platform to platform.",
  },
  {
    "web-scraper-order": "1666026020-1010",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🚪 Door",
    "objects-href": "https://emojipedia.org/door/",
    emoji: "🚪",
    emojiName: "🚪 Door",
    description:
      "A door, as to the entrance of a room, house, or new opportunity. (We’ll see ourselves out 🚪🚶) Depicted in brown, as made of wood, with a gold handle.",
  },
  {
    "web-scraper-order": "1666026022-1012",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩺 Stethoscope",
    "objects-href": "https://emojipedia.org/stethoscope/",
    emoji: "🩺",
    emojiName: "🩺 Stethoscope",
    description:
      "A stethoscope with a round resonator and two earpieces. Shown in black, blue, green, or red, depending on the platform.",
  },
  {
    "web-scraper-order": "1666026025-1015",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩼 Crutch",
    "objects-href": "https://emojipedia.org/crutch/",
    emoji: "🩼",
    emojiName: "🩼 Crutch",
    description: "A basic crutch made of metal and rubber.",
  },
  {
    "web-scraper-order": "1666026028-1017",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩹 Adhesive Bandage",
    "objects-href": "https://emojipedia.org/adhesive-bandage/",
    emoji: "🩹",
    emojiName: "🩹 Adhesive Bandage",
    description:
      "An adhesive bandage used for first aid. Sometimes called a Band-Aid or band aid after the trademarked product. Sometimes called a plaster.",
  },
  {
    "web-scraper-order": "1666026031-1020",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💊 Pill",
    "objects-href": "https://emojipedia.org/pill/",
    emoji: "💊",
    emojiName: "💊 Pill",
    description:
      "A capsule of medicine. Generally depicted at a 45° angle, half red, half yellow. Commonly used for content concerning health, medicine, and related professions as well various types of drugs.",
  },
  {
    "web-scraper-order": "1666026033-1021",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🩸 Drop of Blood",
    "objects-href": "https://emojipedia.org/drop-of-blood/",
    emoji: "🩸",
    emojiName: "🩸 Drop of Blood",
    description:
      "A red drop of blood. May be used to talk about bleeding, injury, blood donation, or menstruation.",
  },
  {
    "web-scraper-order": "1666026035-1024",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💉 Syringe",
    "objects-href": "https://emojipedia.org/syringe/",
    emoji: "💉",
    emojiName: "💉 Syringe",
    description:
      "A medical syringe, as used to administer a vaccine or draw blood. Generally depicted at a 45° angle with a needle to the upper right.",
  },
  {
    "web-scraper-order": "1666026038-1026",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📡 Satellite Antenna",
    "objects-href": "https://emojipedia.org/satellite-antenna/",
    emoji: "📡",
    emojiName: "📡 Satellite Antenna",
    description:
      "A dish antenna, as used to send or receive information to or from a communication satellite—or 👽 Extraterrestrial Life. Generally depicted as a mounted, metal dish with its antenna positioned at 45° to the upper right.",
  },
  {
    "web-scraper-order": "1666026040-1029",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔭 Telescope",
    "objects-href": "https://emojipedia.org/telescope/",
    emoji: "🔭",
    emojiName: "🔭 Telescope",
    description:
      "A telescope, as used to gaze at stars and planets in the night sky. Shown with an optical tube mounted on a tripod, positioned at various angles and generally depicted as metal.",
  },
  {
    "web-scraper-order": "1666026043-1031",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔬 Microscope",
    "objects-href": "https://emojipedia.org/microscope/",
    emoji: "🔬",
    emojiName: "🔬 Microscope",
    description:
      "A microscope, as used in science laboratories to magnify small objects, such as cells or insects. Depicted as a compound opitical microscope with an adjustable eyepiece, lens, arm, and slide stage mounted on a base. Generally shown as metal with the viewing apparatus facing left.",
  },
  {
    "web-scraper-order": "1666026045-1033",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧬 DNA",
    "objects-href": "https://emojipedia.org/dna/",
    emoji: "🧬",
    emojiName: "🧬 DNA",
    description:
      "The double helix of DNA, the genetic blueprint for life. Color and orientation vary across platforms, but positioned at a 45° angle and in multiple, bright colors to represent the molecule’s spiraling, ladder-like structure.",
  },
  {
    "web-scraper-order": "1666026048-1035",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧫 Petri Dish",
    "objects-href": "https://emojipedia.org/petri-dish/",
    emoji: "🧫",
    emojiName: "🧫 Petri Dish",
    description:
      "A petri dish, as used to culture microbes. Depicted as a clear, shallow cylinder with a red, blue, or green growth medium, such as agar, with splotches of variously colored cells, like bacteria.",
  },
  {
    "web-scraper-order": "1666026050-1037",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧪 Test Tube",
    "objects-href": "https://emojipedia.org/test-tube/",
    emoji: "🧪",
    emojiName: "🧪 Test Tube",
    description:
      "A test tube, as used to conduct chemical experiments in a laboratory. Depicted as a clear cylinder, open at one end and containing a green liquid. Positioned at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026052-1038",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚗️ Alembic",
    "objects-href": "https://emojipedia.org/alembic/",
    emoji: "⚗️",
    emojiName: "⚗️ Alembic",
    description:
      "An apparatus for distilling, as used in medieval alchemy. Generally depicted as a round flask with a neck angled down to the right. Positioned on a short stand and containing a mysterious green, purple, or blue liquid.",
  },
  {
    "web-scraper-order": "1666026055-1040",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪜 Ladder",
    "objects-href": "https://emojipedia.org/ladder/",
    emoji: "🪜",
    emojiName: "🪜 Ladder",
    description: "A wooden ladder with four or five rungs.",
  },
  {
    "web-scraper-order": "1666026057-1042",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧲 Magnet",
    "objects-href": "https://emojipedia.org/magnet/",
    emoji: "🧲",
    emojiName: "🧲 Magnet",
    description:
      "A horseshoe magnet, as used to pick up iron. Depicted at various angles in red with silver-tipped poles.",
  },
  {
    "web-scraper-order": "1666026059-1043",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧰 Toolbox",
    "objects-href": "https://emojipedia.org/toolbox/",
    emoji: "🧰",
    emojiName: "🧰 Toolbox",
    description:
      "A red box for holding and transporting tools, such as a hammer and wrench. Generally depicted as latched shut with silver hardware and a black handle.",
  },
  {
    "web-scraper-order": "1666026062-1045",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪝 Hook",
    "objects-href": "https://emojipedia.org/hook/",
    emoji: "🪝",
    emojiName: "🪝 Hook",
    description:
      "A gold or silver hook. Can be used to represent literal hooks like the kinds you use to crochet or catch fish.",
  },
  {
    "web-scraper-order": "1666026064-1046",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛓️ Chains",
    "objects-href": "https://emojipedia.org/chains/",
    emoji: "⛓️",
    emojiName: "⛓️ Chains",
    description:
      "Two parallel lengths of silver chain. Occasionally used as an icon before a hyperlink or for metaphorical connections or chains, e.g., slang off the chains.",
  },
  {
    "web-scraper-order": "1666026067-1048",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔗 Link",
    "objects-href": "https://emojipedia.org/link/",
    emoji: "🔗",
    emojiName: "🔗 Link",
    description:
      "Two links of a silver chain, positioned at a 45° angle. Used as an icon for a hyperlink on computers and the internet. May also be used for metaphorical connections.",
  },
  {
    "web-scraper-order": "1666026070-1050",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦯 White Cane",
    "objects-href": "https://emojipedia.org/white-cane/",
    emoji: "🦯",
    emojiName: "🦯 White Cane",
    description:
      "A white cane, used by some people who are blind or visually impaired. The cane has a black or gray handle with a wrist loop, a white middle section, and a red end with a white cap. This cane differs from a support cane and is sometimes called a probing cane.",
  },
  {
    "web-scraper-order": "1666026072-1051",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚖️ Balance Scale",
    "objects-href": "https://emojipedia.org/balance-scale/",
    emoji: "⚖️",
    emojiName: "⚖️ Balance Scale",
    description:
      "A balance scale, as historically used to measure weight. A symbol of justice, as held by Lady Justice, and of the zodiac sign of Libra, the Scales. Depicted as two silver or gold pans suspended from a beam and supported on a base.",
  },
  {
    "web-scraper-order": "1666026075-1053",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗜️ Clamp",
    "objects-href": "https://emojipedia.org/clamp/",
    emoji: "🗜️",
    emojiName: "🗜️ Clamp",
    description:
      "A metal clamp or vice, as screwed to hold or compress materials like wood or metal. Depicted as a C-clamp or F-clamp, its screw in various positions.",
  },
  {
    "web-scraper-order": "1666026078-1055",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚙️ Gear",
    "objects-href": "https://emojipedia.org/gear/",
    emoji: "⚙️",
    emojiName: "⚙️ Gear",
    description: "A round metal gear with teeth.",
  },
  {
    "web-scraper-order": "1666026080-1056",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔩 Nut and Bolt",
    "objects-href": "https://emojipedia.org/nut-and-bolt/",
    emoji: "🔩",
    emojiName: "🔩 Nut and Bolt",
    description:
      "A metal bolt with a nut threaded around it, as by a wrench. Often positioned at a 45° angle, the head of the bolt at the upper left. Commonly used for various content concerning tools, building, and construction. May also be used for other hardware, including screws.",
  },
  {
    "web-scraper-order": "1666026083-1058",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪛 Screwdriver",
    "objects-href": "https://emojipedia.org/screwdriver/",
    emoji: "🪛",
    emojiName: "🪛 Screwdriver",
    description:
      "A silver Phillips-head or slotted-head screwdriver with a colorful handle. Most platforms show a red handle, though Apple's design has a green handle. Used to represent construction, building, carpentry, renovation, or tools in general.",
  },
  {
    "web-scraper-order": "1666026085-1060",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔧 Wrench",
    "objects-href": "https://emojipedia.org/wrench/",
    emoji: "🔧",
    emojiName: "🔧 Wrench",
    description:
      "A metal wrench (spanner), as used for turning nuts and bolts. Depicted with two open, crescent-shaped ends or one open end and a closed, ring-shaped end. Generally positioned at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026088-1062",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪚 Carpentry Saw",
    "objects-href": "https://emojipedia.org/carpentry-saw/",
    emoji: "🪚",
    emojiName: "🪚 Carpentry Saw",
    description:
      "A long silver saw with a wooden handle. Used to represent construction, carpentry, renovation, or tools in general.",
  },
  {
    "web-scraper-order": "1666026090-1064",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛡️ Shield",
    "objects-href": "https://emojipedia.org/shield/",
    emoji: "🛡️",
    emojiName: "🛡️ Shield",
    description:
      "A shield, as blocks swords in close combat. Color and style varies across platforms, but generally depicted in a kite shape with a metal border and simple pattern.",
  },
  {
    "web-scraper-order": "1666026093-1065",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪃 Boomerang",
    "objects-href": "https://emojipedia.org/boomerang/",
    emoji: "🪃",
    emojiName: "🪃 Boomerang",
    description:
      "A wooden boomerang with bright colors on its tips. Google and Twitter's designs show motion lines to illustrate the path of a boomerang.",
  },
  {
    "web-scraper-order": "1666026095-1067",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔫 Water Pistol",
    "objects-href": "https://emojipedia.org/pistol/",
    emoji: "🔫",
    emojiName: "🔫 Water Pistol",
    description: "A squirt gun (water pistol), as used to spray water for fun.",
  },
  {
    "web-scraper-order": "1666026097-1069",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚔️ Crossed Swords",
    "objects-href": "https://emojipedia.org/crossed-swords/",
    emoji: "⚔️",
    emojiName: "⚔️ Crossed Swords",
    description:
      "Two swords with steel blades in an X shape, as crossed for combat between two knights or warriors. Generally depicted as straight, double-edged blades with brown or black, cross-shaped hilts, points directed up. Commonly used as a symbol for battle, fighting, or a contest, as in sports.",
  },
  {
    "web-scraper-order": "1666026100-1071",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗡️ Dagger",
    "objects-href": "https://emojipedia.org/dagger/",
    emoji: "🗡️",
    emojiName: "🗡️ Dagger",
    description:
      "A pointed knife with a steel blade, as used for thrusting in close combat. Generally depicted as double-edged with a black, brown or gold cross-shaped hilt and positioned at 45° angle, often with its tip at the lower left.",
  },
  {
    "web-scraper-order": "1666026102-1073",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛠️ Hammer and Wrench",
    "objects-href": "https://emojipedia.org/hammer-and-wrench/",
    emoji: "🛠️",
    emojiName: "🛠️ Hammer and Wrench",
    description:
      "A hammer and wrench, as kept in a toolbox, crossed in an X shape. Depicted with metal tools facing up, the hammer positioned at the upper left. Most vendors implement the same design as for their 🔨 Hammer and 🔧 Wrench.",
  },
  {
    "web-scraper-order": "1666026106-1075",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⚒️ Hammer and Pick",
    "objects-href": "https://emojipedia.org/hammer-and-pick/",
    emoji: "⚒️",
    emojiName: "⚒️ Hammer and Pick",
    description:
      "A hammer and pick, as used for breaking up rocks in mining, crossed in an X shape. Generally depicted as metal, mallet- and chisel-styled hammers with wooden handles. The heads of the tools face up, with the pick usually at the right. Often used for various content concerning tools, building, and construction.",
  },
  {
    "web-scraper-order": "1666026108-1077",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛏️ Pick",
    "objects-href": "https://emojipedia.org/pick/",
    emoji: "⛏️",
    emojiName: "⛏️ Pick",
    description:
      "A pickaxe, a tool with a curved spike for breaking up rocks in mining. Generally depicted with a metal head and wooden handle, positioned at a 45° angle with the head at the upper left.",
  },
  {
    "web-scraper-order": "1666026111-1079",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪓 Axe",
    "objects-href": "https://emojipedia.org/axe/",
    emoji: "🪓",
    emojiName: "🪓 Axe",
    description:
      "An axe with a wooden handle and a metal blade. On many platforms the blade is red, like a fire axe.",
  },
  {
    "web-scraper-order": "1666026113-1080",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔨 Hammer",
    "objects-href": "https://emojipedia.org/hammer/",
    emoji: "🔨",
    emojiName: "🔨 Hammer",
    description:
      "A claw hammer, as used for driving or removing nails. Generally depicted with a metal head and wooden handle, positioned at a 45° angle with the head at the upper left.",
  },
  {
    "web-scraper-order": "1666026115-1082",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗝️ Old Key",
    "objects-href": "https://emojipedia.org/old-key/",
    emoji: "🗝️",
    emojiName: "🗝️ Old Key",
    description:
      "An old-fashioned key, as opens an antique chest or wardrobe. Generally depicted at a 45° angle as a tarnished, silver skeleton key with an ornate, bowed head and two-toothed bit at the bottom left.",
  },
  {
    "web-scraper-order": "1666026118-1083",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔑 Key",
    "objects-href": "https://emojipedia.org/key/",
    emoji: "🔑",
    emojiName: "🔑 Key",
    description:
      'A key, as opens a door or lock. Depicted at a 45° angle as a gold, bronze, or copper key with a round head and notched blade. Commonly used for figurative senses of key, e.g., the key to success, being key ("crucial").',
  },
  {
    "web-scraper-order": "1666026120-1085",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔐 Locked with Key",
    "objects-href": "https://emojipedia.org/locked-with-key/",
    emoji: "🔐",
    emojiName: "🔐 Locked with Key",
    description:
      "A locked (closed) padlock with an upright key at its right. Vendors implement the same designs as their 🔒 Locked and 🔑 Key.",
  },
  {
    "web-scraper-order": "1666026122-1087",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔏 Locked with Pen",
    "objects-href": "https://emojipedia.org/locked-with-pen/",
    emoji: "🔏",
    emojiName: "🔏 Locked with Pen",
    description:
      "A locked (closed) padlock with a fountain pen or nib positioned at various angles in front of it. Vendors implement the same design as their 🔒 Locked and the same or similar design as their 🖋️ Fountain Pen or ✒️ Black Nib.",
  },
  {
    "web-scraper-order": "1666026125-1089",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔓 Unlocked",
    "objects-href": "https://emojipedia.org/unlocked/",
    emoji: "🔓",
    emojiName: "🔓 Unlocked",
    description:
      "An unlocked padlock, as used to secure a latch or chain, or as an icon for a non-secure connection or open access online. Generally depicted with a gold base and silver shackle, as an open 🔒 Locked.",
  },
  {
    "web-scraper-order": "1666026127-1091",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔒 Locked",
    "objects-href": "https://emojipedia.org/locked/",
    emoji: "🔒",
    emojiName: "🔒 Locked",
    description:
      "A locked (closed) padlock, as used to secure a latch or chain, or as an icon for a secure internet connection, private account, or locked device. Generally depicted with a gold base and silver shackle. WhatsApp’s design is silver.",
  },
  {
    "web-scraper-order": "1666026130-1093",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗑️ Wastebasket",
    "objects-href": "https://emojipedia.org/wastebasket/",
    emoji: "🗑️",
    emojiName: "🗑️ Wastebasket",
    description:
      "A wastebasket, as used to discard trash in an office. Generally depicted as a silver, wire-mesh container. Also known as a wastepaper basket, trash/garbage can, or rubbish bin.",
  },
  {
    "web-scraper-order": "1666026132-1095",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗄️ File Cabinet",
    "objects-href": "https://emojipedia.org/file-cabinet/",
    emoji: "🗄️",
    emojiName: "🗄️ File Cabinet",
    description:
      "A metal filing cabinet, as used to organize and store file folders at an office. Depicted in black or gray with two drawers, handles, and label holders.",
  },
  {
    "web-scraper-order": "1666026134-1097",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗃️ Card File Box",
    "objects-href": "https://emojipedia.org/card-file-box/",
    emoji: "🗃️",
    emojiName: "🗃️ Card File Box",
    description:
      "A black or gray box with a label holder, containing card index dividers with multicolored tabs, as used to organize and store files. Apple and Facebook’s designs include a lid.",
  },
  {
    "web-scraper-order": "1666026137-1099",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✂️ Scissors",
    "objects-href": "https://emojipedia.org/scissors/",
    emoji: "✂️",
    emojiName: "✂️ Scissors",
    description:
      "A pair of scissors, as used to cut paper or hair. Generally shown open, blades down, with red handles. Commonly used for content concerning haircuts, fashion design, arts and crafts, and various senses of cutting.",
  },
  {
    "web-scraper-order": "1666026140-1101",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📐 Triangular Ruler",
    "objects-href": "https://emojipedia.org/triangular-ruler/",
    emoji: "📐",
    emojiName: "📐 Triangular Ruler",
    description:
      "A triangle or set square, as used by engineers or architects to draw straight lines at angles. Variously depicted as a metal, wood, or plastic right triangle with length markings, its hypotenuse to the right.",
  },
  {
    "web-scraper-order": "1666026142-1103",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📏 Straight Ruler",
    "objects-href": "https://emojipedia.org/straight-ruler/",
    emoji: "📏",
    emojiName: "📏 Straight Ruler",
    description:
      "A ruler, as used to draw straight lines and measure distances. Variously depicted as a metal, wood, or plastic straightedge with length markings at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026145-1105",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖇️ Linked Paperclips",
    "objects-href": "https://emojipedia.org/linked-paperclips/",
    emoji: "🖇️",
    emojiName: "🖇️ Linked Paperclips",
    description:
      "Two or more silver paper clips linked together, generally forming an inverted V. Microsoft’s design displays three paper clips.",
  },
  {
    "web-scraper-order": "1666026147-1107",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📎 Paperclip",
    "objects-href": "https://emojipedia.org/paperclip/",
    emoji: "📎",
    emojiName: "📎 Paperclip",
    description:
      "A silver paper clip, as used to hold together sheets of paper—or remove a SIM card from a mobile phone. Shown positioned at various angles.",
  },
  {
    "web-scraper-order": "1666026150-1109",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📍 Round Pushpin",
    "objects-href": "https://emojipedia.org/round-pushpin/",
    emoji: "📍",
    emojiName: "📍 Round Pushpin",
    description:
      "A pushpin, as used to indicate a location on a map. Generally depicted as an upright pin with a red, round head.",
  },
  {
    "web-scraper-order": "1666026152-1111",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📌 Pushpin",
    "objects-href": "https://emojipedia.org/pushpin/",
    emoji: "📌",
    emojiName: "📌 Pushpin",
    description:
      "A thumbtack (drawing pin), as used to pin documents on a bulletin (notice) board. Depicted at a 45° angle with its red, flat head to the upper right.",
  },
  {
    "web-scraper-order": "1666026154-1113",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📋 Clipboard",
    "objects-href": "https://emojipedia.org/clipboard/",
    emoji: "📋",
    emojiName: "📋 Clipboard",
    description:
      "A white piece of paper secured by a silver clip on a brown clipboard, as used as a writing surface when standing. Commonly used for content concerning various types of documents and writing, especially in sports.",
  },
  {
    "web-scraper-order": "1666026157-1115",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📊 Bar Chart",
    "objects-href": "https://emojipedia.org/bar-chart/",
    emoji: "📊",
    emojiName: "📊 Bar Chart",
    description:
      "A bar graph generally showing three different-colored, vertical rectangles at various heights, as compares values across a category. Commonly used to represent various types of data, information, facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026159-1117",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📉 Chart Decreasing",
    "objects-href": "https://emojipedia.org/chart-decreasing/",
    emoji: "📉",
    emojiName: "📉 Chart Decreasing",
    description:
      "A graph showing a colored trend line, often blue, decreasing over time, as stock prices or revenues. Commonly used to represent various types of decrease, from numeral data to being metaphorically down. May also represent facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026161-1119",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📈 Chart Increasing",
    "objects-href": "https://emojipedia.org/chart-increasing/",
    emoji: "📈",
    emojiName: "📈 Chart Increasing",
    description:
      "A graph showing a red (or sometimes green) trend line increasing over time, as stock prices or revenues. Commonly used to represent various types of increase, from numerical data to being metaphorically on the rise. May also represent trending content as well as facts, figures, and charts more generally.",
  },
  {
    "web-scraper-order": "1666026164-1121",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📇 Card Index",
    "objects-href": "https://emojipedia.org/card-index/",
    emoji: "📇",
    emojiName: "📇 Card Index",
    description:
      "A card index, as a Rolodex, once used to organize and access cards containing the information of personal or business contacts. Depicted as a black or gray rotating device with a contact card displayed, including a graphic and text.",
  },
  {
    "web-scraper-order": "1666026168-1123",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗓️ Spiral Calendar",
    "objects-href": "https://emojipedia.org/spiral-calendar/",
    emoji: "🗓️",
    emojiName: "🗓️ Spiral Calendar",
    description:
      "A spiral-bound calendar. Generally depicted as a monthly calendar, with a red or blue header. Apple and Samsung’s pages are curled up at the bottom right, as to flip for a new month.",
  },
  {
    "web-scraper-order": "1666026170-1125",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗒️ Spiral Notepad",
    "objects-href": "https://emojipedia.org/spiral-notepad/",
    emoji: "🗒️",
    emojiName: "🗒️ Spiral Notepad",
    description:
      "A spiral-bound, flip-style notepad or notebook of lined paper, as used for everyday note-taking. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026173-1127",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📆 Tear-Off Calendar",
    "objects-href": "https://emojipedia.org/tear-off-calendar/",
    emoji: "📆",
    emojiName: "📆 Tear-Off Calendar",
    description:
      "A single date on a calendar. Generally depicted as a page on a two-ringed, daily desk calendar, as flipped or torn off to change the date. Displays month and day on a white, square page, curled up at the bottom right.",
  },
  {
    "web-scraper-order": "1666026175-1129",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📅 Calendar",
    "objects-href": "https://emojipedia.org/calendar/",
    emoji: "📅",
    emojiName: "📅 Calendar",
    description:
      "A single date on a calendar. Generally depicted as a page torn off from a daily desk calendar, displaying month and day on a white, square page.",
  },
  {
    "web-scraper-order": "1666026177-1132",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗂️ Card Index Dividers",
    "objects-href": "https://emojipedia.org/card-index-dividers/",
    emoji: "🗂️",
    emojiName: "🗂️ Card Index Dividers",
    description:
      "A set of tabbed dividers or file guides, as used to organize a card index or file box. Depicted with three or more multicolored tabs on manila paper.",
  },
  {
    "web-scraper-order": "1666026180-1134",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📂 Open File Folder",
    "objects-href": "https://emojipedia.org/open-file-folder/",
    emoji: "📂",
    emojiName: "📂 Open File Folder",
    description:
      "A slightly open tabbed folder, as used to file papers in a cabinet or as an icon for an opened folder when using a computer. Most platforms depict a yellow folder, as manila, with the tab shown at the left.",
  },
  {
    "web-scraper-order": "1666026182-1136",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📁 File Folder",
    "objects-href": "https://emojipedia.org/file-folder/",
    emoji: "📁",
    emojiName: "📁 File Folder",
    description:
      "A tabbed folder, as used to file papers in a cabinet or as an icon for a file on a computer. Most platforms depict a yellow folder, as manila, with the tab shown at the left.",
  },
  {
    "web-scraper-order": "1666026185-1138",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📝 Memo",
    "objects-href": "https://emojipedia.org/memo/",
    emoji: "📝",
    emojiName: "📝 Memo",
    description:
      "A white piece of paper with text written on it by a yellow pencil, positioned over the sheet, tip down, at a 45° angle. Commonly used for content concerning various types of documents and writing, including signing (in sports).",
  },
  {
    "web-scraper-order": "1666026188-1140",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖍️ Crayon",
    "objects-href": "https://emojipedia.org/crayon/",
    emoji: "🖍️",
    emojiName: "🖍️ Crayon",
    description:
      "A crayon, as children use to color. Depicted as red on most platforms with two black stripes on its label, resembling a Crayola crayon. Positioned at a 45° angle, its tip at the lower left. Commonly used for various content concerning drawing, colors, arts and crafts, and schooling.",
  },
  {
    "web-scraper-order": "1666026190-1142",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖌️ Paintbrush",
    "objects-href": "https://emojipedia.org/paintbrush/",
    emoji: "🖌️",
    emojiName: "🖌️ Paintbrush",
    description:
      "A thin, artist's paintbrush, as used to paint a picture. Often depicted with reddish paint on its pointed bristles. Positioned at a 45° angle, its tip at the lower left.",
  },
  {
    "web-scraper-order": "1666026192-1144",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖊️ Pen",
    "objects-href": "https://emojipedia.org/pen/",
    emoji: "🖊️",
    emojiName: "🖊️ Pen",
    description:
      "A blue or black ballpoint pen, as used for everyday writing. Depicted with its cap removed onto its end or as retractable pen. Positioned at a 45° angle, its tip at the lower left. Commonly used for various content concerning writing (e.g., creative, professional) as well as signing (deals, laws, in sports).",
  },
  {
    "web-scraper-order": "1666026194-1146",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖋️ Fountain Pen",
    "objects-href": "https://emojipedia.org/fountain-pen/",
    emoji: "🖋️",
    emojiName: "🖋️ Fountain Pen",
    description:
      "A black fountain pen with a silver nib, as used for signing important documents. Often depicted with gold hardware. Positioned at a 45° angle with its tip at the lower left. Like ✒️ Black Nib, commonly used for various content concerning writing, drawing, and signing (e.g., laws, deals, in sports).",
  },
  {
    "web-scraper-order": "1666026197-1148",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✒️ Black Nib",
    "objects-href": "https://emojipedia.org/black-nib/",
    emoji: "✒️",
    emojiName: "✒️ Black Nib",
    description:
      "The silver nib of a fountain pen, which distributes ink onto a writing surface. Positioned at a 45° angle, with its tip at the lower left or right. Like 🖋️ Fountain Pen, commonly used for various content concerning writing, drawing, and signing (e.g., laws, deals, in sports).",
  },
  {
    "web-scraper-order": "1666026200-1150",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✏️ Pencil",
    "objects-href": "https://emojipedia.org/pencil/",
    emoji: "✏️",
    emojiName: "✏️ Pencil",
    description:
      "A classic yellow pencil. Depicted as a graphite pencil, like a U.S. #2 or European HB, with a sharpened tip and pink eraser. Positioned at a 45° angle, with its tip at the lower left or right. Commonly used for various content concerning writing, drawing, and schooling.",
  },
  {
    "web-scraper-order": "1666026202-1152",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗳️ Ballot Box with Ballot",
    "objects-href": "https://emojipedia.org/ballot-box-with-ballot/",
    emoji: "🗳️",
    emojiName: "🗳️ Ballot Box with Ballot",
    description:
      "A ballot box, as used to cast votes in an election. Depicted as a box, generally blue or gray, with a slot on top through which a paper ballot is being inserted. Many platforms display a cross mark or check mark on the ballot to indicate a vote, though Apple and Facebook leave theirs blank.",
  },
  {
    "web-scraper-order": "1666026206-1154",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📮 Postbox",
    "objects-href": "https://emojipedia.org/postbox/",
    emoji: "📮",
    emojiName: "📮 Postbox",
    description:
      "A postbox (mailbox, letterbox) with a letter in its slot for collection. Generally depicted in red with a white envelope, styled after public postboxes in Japan. May also evoke postboxes in the United Kingdom.",
  },
  {
    "web-scraper-order": "1666026208-1156",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📭 Open Mailbox with Lowered Flag",
    "objects-href": "https://emojipedia.org/open-mailbox-with-lowered-flag/",
    emoji: "📭",
    emojiName: "📭 Open Mailbox with Lowered Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its signal flag lowered and its slot empty. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026211-1158",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📬 Open Mailbox with Raised Flag",
    "objects-href": "https://emojipedia.org/open-mailbox-with-raised-flag/",
    emoji: "📬",
    emojiName: "📬 Open Mailbox with Raised Flag",
    description:
      "An open, curbside mailbox (letterbox, postbox) with its signal flag raised and a letter in its open slot. Generally depicted in blue or gray with a red flag and white envelope, though Google's envelope was previously yellow. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026214-1160",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📪 Closed Mailbox with Lowered Flag",
    "objects-href": "https://emojipedia.org/closed-mailbox-with-lowered-flag/",
    emoji: "📪",
    emojiName: "📪 Closed Mailbox with Lowered Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its door latched shut and signal flag lowered. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026216-1162",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📫 Closed Mailbox with Raised Flag",
    "objects-href": "https://emojipedia.org/closed-mailbox-with-raised-flag/",
    emoji: "📫",
    emojiName: "📫 Closed Mailbox with Raised Flag",
    description:
      "A curbside mailbox (letterbox, postbox) with its door latched shut and signal flag raised. Generally depicted in blue or gray with a red flag. Used for various content concerning postal deliveries and email.",
  },
  {
    "web-scraper-order": "1666026219-1164",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📦 Package",
    "objects-href": "https://emojipedia.org/package/",
    emoji: "📦",
    emojiName: "📦 Package",
    description:
      "A package (parcel), as contains items ordered online. Depicted at various angles as a light-brown, cardboard box, with a shipping label and its top taped shut.",
  },
  {
    "web-scraper-order": "1666026221-1166",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📥 Inbox Tray",
    "objects-href": "https://emojipedia.org/inbox-tray/",
    emoji: "📥",
    emojiName: "📥 Inbox Tray",
    description:
      "A paper tray with a down arrow on top, as a symbol for an email inbox. Generally depicted as a white or wooden try with a red arrow. Samsung and Twitter's arrows are green, WhatsApp's gray.",
  },
  {
    "web-scraper-order": "1666026223-1168",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📤 Outbox Tray",
    "objects-href": "https://emojipedia.org/outbox-tray/",
    emoji: "📤",
    emojiName: "📤 Outbox Tray",
    description:
      "A paper tray with an up arrow on top, as a symbol for an email outbox. Generally depicted as a white or wooden tray with a red arrow pointing upwards. Facebook's design contains paper.",
  },
  {
    "web-scraper-order": "1666026226-1170",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📩 Envelope with Arrow",
    "objects-href": "https://emojipedia.org/envelope-with-arrow/",
    emoji: "📩",
    emojiName: "📩 Envelope with Arrow",
    description:
      "The back of envelope with a down arrow on top. Generally depicted in white with a red or blue arrow.",
  },
  {
    "web-scraper-order": "1666026229-1172",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📨 Incoming Envelope",
    "objects-href": "https://emojipedia.org/incoming-envelope/",
    emoji: "📨",
    emojiName: "📨 Incoming Envelope",
    description:
      "The back of an envelope, shown coming into an inbox or arriving with motion lines.",
  },
  {
    "web-scraper-order": "1666026231-1174",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📧 E-Mail",
    "objects-href": "https://emojipedia.org/e-mail/",
    emoji: "📧",
    emojiName: "📧 E-Mail",
    description:
      "A symbol for email. Depicted as the back of an envelope imprinted with a capital letter E (for electronic) or @ (at) sign. Commonly used as an icon before an email address.",
  },
  {
    "web-scraper-order": "1666026233-1176",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "✉️ Envelope",
    "objects-href": "https://emojipedia.org/envelope/",
    emoji: "✉️",
    emojiName: "✉️ Envelope",
    description:
      "The back of a white envelope, as used to send a letter or card in the mail (post). Used for various content concerning mail and messages, including email.",
  },
  {
    "web-scraper-order": "1666026236-1178",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧾 Receipt",
    "objects-href": "https://emojipedia.org/receipt/",
    emoji: "🧾",
    emojiName: "🧾 Receipt",
    description:
      'A white paper receipt, as proof of payment, and shown flat or curled. May be used for other financial documents (e.g., invoice, tax form). May also be used for the slang receipts, or "evidence” or “confirmation” of some feat or controversy.',
  },
  {
    "web-scraper-order": "1666026238-1180",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💳 Credit Card",
    "objects-href": "https://emojipedia.org/credit-card/",
    emoji: "💳",
    emojiName: "💳 Credit Card",
    description:
      "The backside of a credit card, showing the magnetic strip and signature. Color and detail vary across platforms, but often shown as gold, silver, or blue. May be used for banking and other ID cards as well for various content concerning money, including payment.",
  },
  {
    "web-scraper-order": "1666026241-1182",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💸 Money with Wings",
    "objects-href": "https://emojipedia.org/money-with-wings/",
    emoji: "💸",
    emojiName: "💸 Money with Wings",
    description:
      "A banded stack of U.S. dollar bills with feather wings, as if flying. Its flight may represent losing, transferring, or earning money, but commonly used for wealth, money, and success more generally, often with a flourish or sense of flair.",
  },
  {
    "web-scraper-order": "1666026244-1184",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💷 Pound Banknote",
    "objects-href": "https://emojipedia.org/pound-banknote/",
    emoji: "💷",
    emojiName: "💷 Pound Banknote",
    description:
      "Quids in! A banded stack of pound banknotes, the paper currency of the United Kingdom (England, Wales, Northern Ireland, and Scotland). Color and detail vary across platforms, but widely depicted as purple £20 notes with the pound sign, £.",
  },
  {
    "web-scraper-order": "1666026246-1186",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💶 Euro Banknote",
    "objects-href": "https://emojipedia.org/euro-banknote/",
    emoji: "💶",
    emojiName: "💶 Euro Banknote",
    description:
      "A banded stack of euro banknotes, the paper currency of the European Union (EU). Color and detail vary across platforms, but shown with the euro sign, €. Commonly used for various content concerning wealth and money, not restricted to the EU.",
  },
  {
    "web-scraper-order": "1666026248-1188",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💵 Dollar Banknote",
    "objects-href": "https://emojipedia.org/dollar-banknote/",
    emoji: "💵",
    emojiName: "💵 Dollar Banknote",
    description:
      "Cash money! A banded stack of U.S. dollar banknotes, the paper currency of the United States of America. Green hue and detail vary across platforms, but shown with the dollar sign, $. Commonly used for various content concerning wealth and money, not restricted to the U.S.",
  },
  {
    "web-scraper-order": "1666026250-1190",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💴 Yen Banknote",
    "objects-href": "https://emojipedia.org/yen-banknote/",
    emoji: "💴",
    emojiName: "💴 Yen Banknote",
    description:
      "A banded stack of yen banknotes, the paper currency of Japan. Color and detail vary across platforms, but usually shown in green, yellow, or pink with the yen symbol, ¥. Commonly used for various content concerning money and wealth, not restricted to Japan.",
  },
  {
    "web-scraper-order": "1666026253-1191",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪙 Coin",
    "objects-href": "https://emojipedia.org/coin/",
    emoji: "🪙",
    emojiName: "🪙 Coin",
    description:
      "A coin shown in silver or gold. Design varies by platform, with Google and Twitter showing a 🏛️ Classical Building and Samsung showing the number one, similar to their 🥇 1st Place Medal design.",
  },
  {
    "web-scraper-order": "1666026255-1192",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💰 Money Bag",
    "objects-href": "https://emojipedia.org/money-bag/",
    emoji: "💰",
    emojiName: "💰 Money Bag",
    description:
      "A bag full of money. Depicted as a sack, usually tan, tied off and displaying a dollar sign. May be filled with coins, as most platforms show a rounded bag.",
  },
  {
    "web-scraper-order": "1666026257-1193",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏷️ Label",
    "objects-href": "https://emojipedia.org/label/",
    emoji: "🏷️",
    emojiName: "🏷️ Label",
    description:
      "A light-brown or yellow rectangular tag, as labelled and attached to a key. Depicted at various angles punched with a hole, generally with a metal ring or loop of string.",
  },
  {
    "web-scraper-order": "1666026260-1194",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔖 Bookmark",
    "objects-href": "https://emojipedia.org/bookmark/",
    emoji: "🔖",
    emojiName: "🔖 Bookmark",
    description:
      "A bookmark, as used to mark one's place in a book. May also represent bookmarks on an internet browser. Appearance varies across platforms, but generally depicted at a 45° angle as a thin, white or red strip with a decorative tie and design, such as flower or star.",
  },
  {
    "web-scraper-order": "1666026263-1195",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📑 Bookmark Tabs",
    "objects-href": "https://emojipedia.org/bookmark-tabs/",
    emoji: "📑",
    emojiName: "📑 Bookmark Tabs",
    description:
      "Sheets of white, printed paper with variously colored tabs to bookmark important sections or indicate signature lines. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026266-1196",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗞️ Rolled-Up Newspaper",
    "objects-href": "https://emojipedia.org/rolled-up-newspaper/",
    emoji: "🗞️",
    emojiName: "🗞️ Rolled-Up Newspaper",
    description:
      "A newspaper rolled up and bound, as for delivery to a house. Generally positioned at a 45° angle. Commonly used for various content concerning news, media, and journalism as well as personal news.",
  },
  {
    "web-scraper-order": "1666026268-1197",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📰 Newspaper",
    "objects-href": "https://emojipedia.org/newspaper/",
    emoji: "📰",
    emojiName: "📰 Newspaper",
    description:
      "The front page of a newspaper, as people once read the news before the internet. Commonly used for various content concerning news, media, and journalism as well as personal news.",
  },
  {
    "web-scraper-order": "1666026270-1198",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📄 Page Facing Up",
    "objects-href": "https://emojipedia.org/page-facing-up/",
    emoji: "📄",
    emojiName: "📄 Page Facing Up",
    description:
      "A white piece of paper, its top right corner curled or dog-eared, with text printed on it, as a business letter or icon for a document on a computer. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026273-1199",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📜 Scroll",
    "objects-href": "https://emojipedia.org/scroll/",
    emoji: "📜",
    emojiName: "📜 Scroll",
    description:
      "An ancient scroll, unrolled to reveal text on papyrus or parchment paper. May be used to represent the study of history or official documents, such as a diploma.",
  },
  {
    "web-scraper-order": "1666026275-1200",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📃 Page with Curl",
    "objects-href": "https://emojipedia.org/page-with-curl/",
    emoji: "📃",
    emojiName: "📃 Page with Curl",
    description:
      "A white piece of paper, curled up at the bottom to the left or right, with text printed on it, as a business letter. Commonly used for content concerning various types of documents and writing.",
  },
  {
    "web-scraper-order": "1666026278-1201",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📒 Ledger",
    "objects-href": "https://emojipedia.org/ledger/",
    emoji: "📒",
    emojiName: "📒 Ledger",
    description:
      "A spiral-bound, yellow, hardcover notebook. Intended to depict a financial ledger, as used in accounting.",
  },
  {
    "web-scraper-order": "1666026280-1202",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📓 Notebook",
    "objects-href": "https://emojipedia.org/notebook/",
    emoji: "📓",
    emojiName: "📓 Notebook",
    description:
      "A dark-colored, hardcover notebook, as used to write or take notes in school. Commonly used for various content concerning writing and schooling.",
  },
  {
    "web-scraper-order": "1666026282-1203",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📚 Books",
    "objects-href": "https://emojipedia.org/books/",
    emoji: "📚",
    emojiName: "📚 Books",
    description:
      "A loose stack of three of more different-colored, hardcover books. Commonly used for various content concerning reading and schooling. Color and orientation vary across platforms, but often shown with red, green, and blue covers.",
  },
  {
    "web-scraper-order": "1666026285-1204",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📙 Orange Book",
    "objects-href": "https://emojipedia.org/orange-book/",
    emoji: "📙",
    emojiName: "📙 Orange Book",
    description:
      "A closed, orange, hardcover book—similar to the Emojipedia logo 📙😃. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as an orange accent color.",
  },
  {
    "web-scraper-order": "1666026287-1205",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📘 Blue Book",
    "objects-href": "https://emojipedia.org/blue-book/",
    emoji: "📘",
    emojiName: "📘 Blue Book",
    description:
      "A closed, blue, hardcover book. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a blue accent color.",
  },
  {
    "web-scraper-order": "1666026289-1206",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📗 Green Book",
    "objects-href": "https://emojipedia.org/green-book/",
    emoji: "📗",
    emojiName: "📗 Green Book",
    description:
      "A closed, green, hardcover book. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a green accent color.",
  },
  {
    "web-scraper-order": "1666026292-1207",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📖 Open Book",
    "objects-href": "https://emojipedia.org/open-book/",
    emoji: "📖",
    emojiName: "📖 Open Book",
    description:
      "An open, hardcover book, depicted with a blue cover on most platforms. Some platforms include a bookmark. Commonly used for various content concerning reading, writing, learning, and schooling.",
  },
  {
    "web-scraper-order": "1666026294-1208",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📕 Closed Book",
    "objects-href": "https://emojipedia.org/closed-book/",
    emoji: "📕",
    emojiName: "📕 Closed Book",
    description:
      "A closed, hardcover book depicted with a red cover on most platforms. Commonly used for various content concerning reading, writing, learning, and schooling. May also be used as a red accent color.",
  },
  {
    "web-scraper-order": "1666026298-1209",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📔 Notebook with Decorative Cover",
    "objects-href": "https://emojipedia.org/notebook-with-decorative-cover/",
    emoji: "📔",
    emojiName: "📔 Notebook with Decorative Cover",
    description:
      "A closed, hardcover notebook, as used for journaling or sketching. Appearance varies across platforms, with most designs featuring relatively plain covers. Commonly used for content concerning writing and schooling.",
  },
  {
    "web-scraper-order": "1666026300-1210",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪔 Diya Lamp",
    "objects-href": "https://emojipedia.org/diya-lamp/",
    emoji: "🪔",
    emojiName: "🪔 Diya Lamp",
    description:
      "A lamp made of brass or clay, displayed with a lit wick leading into oil or ghee.",
  },
  {
    "web-scraper-order": "1666026303-1211",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏮 Red Paper Lantern",
    "objects-href": "https://emojipedia.org/red-paper-lantern/",
    emoji: "🏮",
    emojiName: "🏮 Red Paper Lantern",
    description:
      "A red paper lantern, as hangs outside an izakaya, a Japanese bar that serves drinks and casual food. Generally depicted as cylindrical with a black top and base and soft, orange glow.",
  },
  {
    "web-scraper-order": "1666026306-1212",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔦 Flashlight",
    "objects-href": "https://emojipedia.org/flashlight/",
    emoji: "🔦",
    emojiName: "🔦 Flashlight",
    description:
      "An everyday flashlight (electric torch), as used when the power goes out, camping, or telling scary stories. Generally depicted at a 45° angle as a gray and black device with a switch, shown illuminated on many platforms.",
  },
  {
    "web-scraper-order": "1666026317-1213",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💡 Light Bulb",
    "objects-href": "https://emojipedia.org/light-bulb/",
    emoji: "💡",
    emojiName: "💡 Light Bulb",
    description:
      "A light bulb, as screwed into a lamp to light a room. Depicted as an incandescent bulb with a silver base, often shown with filament and a soft, yellow-white glow.",
  },
  {
    "web-scraper-order": "1666026319-1214",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕯️ Candle",
    "objects-href": "https://emojipedia.org/candle/",
    emoji: "🕯️",
    emojiName: "🕯️ Candle",
    description:
      "A burning candle, as lit when taking a bath or the power is out. Depicted as a white, pillar-shaped candle with a flame and wax dripping down its sides.",
  },
  {
    "web-scraper-order": "1666026321-1215",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔎 Magnifying Glass Tilted Right",
    "objects-href": "https://emojipedia.org/magnifying-glass-tilted-right/",
    emoji: "🔎",
    emojiName: "🔎 Magnifying Glass Tilted Right",
    description:
      "A classic magnifying glass, as used to view small objects, with its lens pointed right. Generally depicted at a 45° angle with a black handle and a clear or blue, silver-framed lens titled to the upper right.",
  },
  {
    "web-scraper-order": "1666026323-1216",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔍 Magnifying Glass Tilted Left",
    "objects-href": "https://emojipedia.org/magnifying-glass-tilted-left/",
    emoji: "🔍",
    emojiName: "🔍 Magnifying Glass Tilted Left",
    description:
      "A classic magnifying glass, as used to view small objects, with its lens pointed left. Generally depicted at a 45° angle with a black handle and a clear or blue, silver-framed lens titled to the upper left.",
  },
  {
    "web-scraper-order": "1666026326-1217",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📼 Videocassette",
    "objects-href": "https://emojipedia.org/videocassette/",
    emoji: "📼",
    emojiName: "📼 Videocassette",
    description:
      "A videotape cassette, as a VHS tape used to watch movies or record TV on VCRs before DVDs , DVRs, and streaming. Generally depicted as a black cassette with a white label between its reels.",
  },
  {
    "web-scraper-order": "1666026328-1218",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📹 Video Camera",
    "objects-href": "https://emojipedia.org/video-camera/",
    emoji: "📹",
    emojiName: "📹 Video Camera",
    description:
      "A video camera, as a camcorder used to film home videos in the 1980–90s. Generally depicted as a gray or black video camera with viewfinder, control buttons, and lens pointed left.",
  },
  {
    "web-scraper-order": "1666026331-1219",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📸 Camera with Flash",
    "objects-href": "https://emojipedia.org/camera-with-flash/",
    emoji: "📸",
    emojiName: "📸 Camera with Flash",
    description:
      "A classic camera, shown with its flash going off, as to illuminate a darker scene. Vendors implement the same design as 📷 Camera with a burst of light, often resembling 💥 Collision.",
  },
  {
    "web-scraper-order": "1666026333-1220",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📷 Camera",
    "objects-href": "https://emojipedia.org/camera/",
    emoji: "📷",
    emojiName: "📷 Camera",
    description:
      "A classic camera, as an SLR used to take pictures before camera phones. Generally depicted with a black and silver casing with lens and operating controls.",
  },
  {
    "web-scraper-order": "1666026336-1221",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📺 Television",
    "objects-href": "https://emojipedia.org/television/",
    emoji: "📺",
    emojiName: "📺 Television",
    description:
      "A classic television set, as people watched before streaming on flatscreens. Depicted in various colors and styles with a screen, knobs, and, on many platforms, rabbit-ear antennae.",
  },
  {
    "web-scraper-order": "1666026338-1222",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📽️ Film Projector",
    "objects-href": "https://emojipedia.org/film-projector/",
    emoji: "📽️",
    emojiName: "📽️ Film Projector",
    description:
      "A classic film projector, as projects film onto a screen for viewing. Generally depicted as a black or gray projector with two mounted reels and lens pointed right.",
  },
  {
    "web-scraper-order": "1666026340-1223",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎞️ Film Frames",
    "objects-href": "https://emojipedia.org/film-frames/",
    emoji: "🎞️",
    emojiName: "🎞️ Film Frames",
    description:
      "A strip of film, as used in a movie camera or photography. Generally depicted as several horizontal frames of unexposed film with black trim and perforations.",
  },
  {
    "web-scraper-order": "1666026343-1224",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎥 Movie Camera",
    "objects-href": "https://emojipedia.org/movie-camera/",
    emoji: "🎥",
    emojiName: "🎥 Movie Camera",
    description:
      "A classic movie camera. Depicted as a black camera with two mounted reels of film, viewfinder, and lens pointed left or right.",
  },
  {
    "web-scraper-order": "1666026346-1225",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧮 Abacus",
    "objects-href": "https://emojipedia.org/abacus/",
    emoji: "🧮",
    emojiName: "🧮 Abacus",
    description:
      "An abacus, an ancient tool used to count and calculate by moving beads. Depicted as a wooden frame with four or more rows or columns of variously positioned and colored beads.",
  },
  {
    "web-scraper-order": "1666026349-1226",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📀 DVD",
    "objects-href": "https://emojipedia.org/dvd/",
    emoji: "📀",
    emojiName: "📀 DVD",
    description:
      "A digital versatile disc (DVD), a type of optical disc used to play movies before the rise of streaming technology. Generally depicted in gold, though Facebook’s is bluish gray, as a Blu-ray.",
  },
  {
    "web-scraper-order": "1666026351-1227",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💿 Optical Disk",
    "objects-href": "https://emojipedia.org/optical-disk/",
    emoji: "💿",
    emojiName: "💿 Optical Disk",
    description:
      "A silver optical disc, as a CD or DVD, used to play music or movies before the rise of streaming technology. Commonly used to represent CDs, DVDs, Blu-rays, and related film and music content, especially albums.",
  },
  {
    "web-scraper-order": "1666026355-1228",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💾 Floppy Disk",
    "objects-href": "https://emojipedia.org/floppy-disk/",
    emoji: "💾",
    emojiName: "💾 Floppy Disk",
    description:
      "A 3.5-inch floppy disk, a data storage format popular in the 1980–90s but largely preserved as a Save icon in computer programs. Shown with its silver shutter positioned up and in a black housing with a white label, accented with blue or red.",
  },
  {
    "web-scraper-order": "1666026357-1229",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💽 Computer Disk",
    "objects-href": "https://emojipedia.org/computer-disk/",
    emoji: "💽",
    emojiName: "💽 Computer Disk",
    description:
      "A minidisc, depicted as a small, silver or gold optical disc housed in a square cartridge, its shutter positioned to the right.",
  },
  {
    "web-scraper-order": "1666026360-1230",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖲️ Trackball",
    "objects-href": "https://emojipedia.org/trackball/",
    emoji: "🖲️",
    emojiName: "🖲️ Trackball",
    description:
      "A trackball, as rotated to control a cursor on a computer. An alternative or supplement to a computer mouse or touchpad. Generally depicted as a cordless device with a blue or red ball in a cylindrical, black or gray socket.",
  },
  {
    "web-scraper-order": "1666026362-1231",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖱️ Computer Mouse",
    "objects-href": "https://emojipedia.org/computer-mouse/",
    emoji: "🖱️",
    emojiName: "🖱️ Computer Mouse",
    description:
      "A mouse, as used to control a cursor on a computer. Generally depicted as a white or gray, cordless device with a scroll wheel between left- and right-click buttons.",
  },
  {
    "web-scraper-order": "1666026365-1232",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌨️ Keyboard",
    "objects-href": "https://emojipedia.org/keyboard/",
    emoji: "⌨️",
    emojiName: "⌨️ Keyboard",
    description:
      "A keyboard, as used to type on a computer. Generally depicted as a gray device with white or black keys. Used for various content concerning computers, typing, and writing.",
  },
  {
    "web-scraper-order": "1666026368-1233",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖨️ Printer",
    "objects-href": "https://emojipedia.org/printer/",
    emoji: "🖨️",
    emojiName: "🖨️ Printer",
    description:
      "A computer printer, as at a home office. Generally depicted as a grayish device with a power button and paper loaded in its tray, sometimes printing out a document. May be used for various content concerning printing, including as a Print icon, as well as for office work and technology more generally.",
  },
  {
    "web-scraper-order": "1666026371-1234",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖥️ Desktop Computer",
    "objects-href": "https://emojipedia.org/desktop-computer/",
    emoji: "🖥️",
    emojiName: "🖥️ Desktop Computer",
    description:
      "A desktop personal computer. Generally depicted as a black or gray monitor with a dark or blue screen.",
  },
  {
    "web-scraper-order": "1666026373-1235",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💻 Laptop",
    "objects-href": "https://emojipedia.org/laptop/",
    emoji: "💻",
    emojiName: "💻 Laptop",
    description:
      "A laptop personal computer. Depicted as a black or gray device, opened to show a dark or blue screen, keyboard, and touchpad.",
  },
  {
    "web-scraper-order": "1666026375-1236",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔌 Electric Plug",
    "objects-href": "https://emojipedia.org/electric-plug/",
    emoji: "🔌",
    emojiName: "🔌 Electric Plug",
    description:
      "An electric plug, as inserted into socket to power a device. Depicted as a black, two-pronged plug at various angles at the end of a cable. Prongs are silver or gold.",
  },
  {
    "web-scraper-order": "1666026378-1237",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔋 Battery",
    "objects-href": "https://emojipedia.org/battery/",
    emoji: "🔋",
    emojiName: "🔋 Battery",
    description:
      "An electric battery, as used to power such devices as a flashlight. Generally depicted as an upright, green cylinder, as a AA or D cell, with white indicators for its positive (facing up) and negative terminals.",
  },
  {
    "web-scraper-order": "1666026381-1238",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📠 Fax Machine",
    "objects-href": "https://emojipedia.org/fax-machine/",
    emoji: "📠",
    emojiName: "📠 Fax Machine",
    description:
      "A fax machine, as scans and transmits documents over a telephone line. Common in the 1980–90s before the internet. Depicted as a white or black machine with a telephone handset, keypad, display screen, and paper in its tray.",
  },
  {
    "web-scraper-order": "1666026385-1239",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📟 Pager",
    "objects-href": "https://emojipedia.org/pager/",
    emoji: "📟",
    emojiName: "📟 Pager",
    description:
      "A pager, as worn on the waist to alert a person to a phone call or short text message. Popular in the 1980–90s before mobile phones, though still used by some medical and emergency personnel. Very occasionally used to represent alerts, digital communication, or nostalgia for old technology.",
  },
  {
    "web-scraper-order": "1666026404-1240",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📞 Telephone Receiver",
    "objects-href": "https://emojipedia.org/telephone-receiver/",
    emoji: "📞",
    emojiName: "📞 Telephone Receiver",
    description:
      "The handset of a traditional telephone, with speaker and microphone. Generally depicted in black at a 45° angle.",
  },
  {
    "web-scraper-order": "1666026408-1241",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "☎️ Telephone",
    "objects-href": "https://emojipedia.org/telephone/",
    emoji: "☎️",
    emojiName: "☎️ Telephone",
    description:
      "A classic telephone, as a landline home phone. Most platforms depict a red, push-button phone with the handset on the base. Some platforms feature designs with rotary dials.",
  },
  {
    "web-scraper-order": "1666026411-1242",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📲 Mobile Phone with Arrow",
    "objects-href": "https://emojipedia.org/mobile-phone-with-arrow/",
    emoji: "📲",
    emojiName: "📲 Mobile Phone with Arrow",
    description:
      "A mobile phone (cell phone) with a rightward arrow pointed at it from the left. Intended to indicate an incoming call or message, but used to represent mobile phones, technology, and communication more generally.",
  },
  {
    "web-scraper-order": "1666026414-1243",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📱 Mobile Phone",
    "objects-href": "https://emojipedia.org/mobile-phone/",
    emoji: "📱",
    emojiName: "📱 Mobile Phone",
    description:
      "A mobile phone (cell phone), as used to text, check social media, or take selfies. Depicted as a black or gray smartphone with a generic blue screen or multicolored app icons. Commonly used for various content concerning mobile phones, technology, and communication.",
  },
  {
    "web-scraper-order": "1666026417-1244",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪕 Banjo",
    "objects-href": "https://emojipedia.org/banjo/",
    emoji: "🪕",
    emojiName: "🪕 Banjo",
    description:
      "A banjo with a round body and a long neck. Used to talk about banjos or music in general.",
  },
  {
    "web-scraper-order": "1666026443-1245",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📻 Radio",
    "objects-href": "https://emojipedia.org/radio/",
    emoji: "📻",
    emojiName: "📻 Radio",
    description:
      "A classic portable radio, as used to listen to music, news, or sports. Depicted in various colors and styles with a speaker, antenna, dial, and knobs.",
  },
  {
    "web-scraper-order": "1666026446-1246",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎛️ Control Knobs",
    "objects-href": "https://emojipedia.org/control-knobs/",
    emoji: "🎛️",
    emojiName: "🎛️ Control Knobs",
    description:
      "Four control knobs, as adjust audio levels on a mixing console. Generally depicted as a silver square with black knobs, turned to various levels as indicated by white pointers and scale markings.",
  },
  {
    "web-scraper-order": "1666026449-1247",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎚️ Level Slider",
    "objects-href": "https://emojipedia.org/level-slider/",
    emoji: "🎚️",
    emojiName: "🎚️ Level Slider",
    description:
      "A level slider, as adjusts volume on a mixing console. Most platforms depict a silver and black channel fader with scale markings, set to various levels. Apple and Google's go up to eleven.",
  },
  {
    "web-scraper-order": "1666026451-1248",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎙️ Studio Microphone",
    "objects-href": "https://emojipedia.org/studio-microphone/",
    emoji: "🎙️",
    emojiName: "🎙️ Studio Microphone",
    description:
      "A microphone, as used for radio broadcasting or studio recording. Most platforms depict a vintage, silver microphone, like the Shure Unidyne 55.",
  },
  {
    "web-scraper-order": "1666026454-1249",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📯 Postal Horn",
    "objects-href": "https://emojipedia.org/postal-horn/",
    emoji: "📯",
    emojiName: "📯 Postal Horn",
    description:
      "A postal horn (post horn). Depicted as a coiled, valveless, brass horn, like a bugle or trumpet, with two red tassels. Sometimes used to mark announcements as well as for various content concerning brass instruments, music, or mail.",
  },
  {
    "web-scraper-order": "1666026458-1250",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💎 Gem Stone",
    "objects-href": "https://emojipedia.org/gem-stone/",
    emoji: "💎",
    emojiName: "💎 Gem Stone",
    description:
      "A jewel or gem, as set into a ring. Depicted in the shape of a classic diamond but in the bright blue color of an aquamarine.",
  },
  {
    "web-scraper-order": "1666026460-1251",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "📿 Prayer Beads",
    "objects-href": "https://emojipedia.org/prayer-beads/",
    emoji: "📿",
    emojiName: "📿 Prayer Beads",
    description:
      "A string of beads, as used in prayer or meditation in many religious traditions. Generally depicted as red, wooden beads with a gold, decorative center bead and tassel.",
  },
  {
    "web-scraper-order": "1666026463-1252",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛍️ Shopping Bags",
    "objects-href": "https://emojipedia.org/shopping-bags/",
    emoji: "🛍️",
    emojiName: "🛍️ Shopping Bags",
    description:
      "Two colorful shopping bags, as contain consumer items bought at a department store. Depicted as gift bags in various bright colors, patterns, sizes, and positions across platforms. Apple's design, for instance, features a pink bag with light-pink dots in front of a gold bag with yellow stripes.",
  },
  {
    "web-scraper-order": "1666026466-1253",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪢 Knot",
    "objects-href": "https://emojipedia.org/knot/",
    emoji: "🪢",
    emojiName: "🪢 Knot",
    description:
      "Brightly colored rope forming a knot. Knot type varies across platform, with most designs showing a square knot, a figure eight knot, or a carrick bend. Samsung's design appears to be a carrick bend, but upon closer inspection, it is not correctly tied and would fall apart with a gentle tug.",
  },
  {
    "web-scraper-order": "1666026468-1254",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧶 Yarn",
    "objects-href": "https://emojipedia.org/yarn/",
    emoji: "🧶",
    emojiName: "🧶 Yarn",
    description:
      "A ball of yarn, as used to knit a scarf. Color varies across platforms, but often depicted in green, blue, or magenta and shown with an end unraveling. Sometimes depicted with a pair of knitting needles stuck in the ball.",
  },
  {
    "web-scraper-order": "1666026470-1255",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪡 Sewing Needle",
    "objects-href": "https://emojipedia.org/sewing-needle/",
    emoji: "🪡",
    emojiName: "🪡 Sewing Needle",
    description:
      "A threaded silver needle. Color of thread varies from platform to platform.",
  },
  {
    "web-scraper-order": "1666026473-1256",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧵 Thread",
    "objects-href": "https://emojipedia.org/thread/",
    emoji: "🧵",
    emojiName: "🧵 Thread",
    description:
      "A spool of thread, as used for sewing. Thread color varies across platforms, though often depicted in red or blue and on a wooden spool. Sometimes shown with an end unraveling.",
  },
  {
    "web-scraper-order": "1666026475-1257",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🖼️ Framed Picture",
    "objects-href": "https://emojipedia.org/framed-picture/",
    emoji: "🖼️",
    emojiName: "🖼️ Framed Picture",
    description:
      "A framed picture of a painting or photograph, as displayed in a gallery or on a household wall. Vendors feature various scenes, though generally a lush, sunny landscape of hills and mountains, in a gold frame.",
  },
  {
    "web-scraper-order": "1666026478-1258",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪆 Nesting Dolls",
    "objects-href": "https://emojipedia.org/nesting-dolls/",
    emoji: "🪆",
    emojiName: "🪆 Nesting Dolls",
    description:
      "Nesting dolls, also called matryoshka dolls or Russian dolls, decorated with bright colors including red, yellow, blue, and green. All platforms depict the nesting dolls as open, revealing smaller dolls within the bases of larger dolls. Dolls are all decorated with women wearing headscarfs. Some platforms show a flower motif on the women's dresses or aprons.",
  },
  {
    "web-scraper-order": "1666026480-1259",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪅 Piñata",
    "objects-href": "https://emojipedia.org/pinata/",
    emoji: "🪅",
    emojiName: "🪅 Piñata",
    description:
      "A colorful decorated container that comes in many shapes, a piñata is filled with candy or toys. Hit to break open for celebrations such as Cinco de Mayo, this is generally associated with Mexico.",
  },
  {
    "web-scraper-order": "1666026486-1260",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧸 Teddy Bear",
    "objects-href": "https://emojipedia.org/teddy-bear/",
    emoji: "🧸",
    emojiName: "🧸 Teddy Bear",
    description:
      "A classic teddy bear, as snuggled by a child when going to sleep.",
  },
  {
    "web-scraper-order": "1666026488-1261",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕹️ Joystick",
    "objects-href": "https://emojipedia.org/joystick/",
    emoji: "🕹️",
    emojiName: "🕹️ Joystick",
    description:
      "A joystick, as used in playing classic arcade, computer, or video games. Generally depicted with a black base, red-knobbed control stick, and one or more red buttons.",
  },
  {
    "web-scraper-order": "1666026491-1262",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪬 Hamsa",
    "objects-href": "https://emojipedia.org/hamsa/",
    emoji: "🪬",
    emojiName: "🪬 Hamsa",
    description: "A blue hand with an eye in the center of the palm.",
  },
  {
    "web-scraper-order": "1666026493-1263",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧿 Nazar Amulet",
    "objects-href": "https://emojipedia.org/nazar-amulet/",
    emoji: "🧿",
    emojiName: "🧿 Nazar Amulet",
    description:
      "A nazar, an eye-shaped amulet believed to protect against the evil eye, especially in Turkish culture. Depicted as a rich blue, circular bead with a black dot in the center ringed with white and light blue, resembling an eye.",
  },
  {
    "web-scraper-order": "1666026495-1264",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪄 Magic Wand",
    "objects-href": "https://emojipedia.org/magic-wand/",
    emoji: "🪄",
    emojiName: "🪄 Magic Wand",
    description:
      "A wand with sparkles (✨magic✨) coming out of its end. Most platforms show a classic magician-style magic wand that's black with white tips. WhatsApp shows a golden magic wand tipped with a star, similar to the wand that Glenda the Good Witch uses in the 1939 film The Wizard of Oz.",
  },
  {
    "web-scraper-order": "1666026499-1265",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔮 Crystal Ball",
    "objects-href": "https://emojipedia.org/crystal-ball/",
    emoji: "🔮",
    emojiName: "🔮 Crystal Ball",
    description:
      "A crystal ball, as a fortune teller or clairvoyant gazes into to tell the future. Depicted as a sparkling, purple or blue crystal orb resting on a stand.",
  },
  {
    "web-scraper-order": "1666026502-1266",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪁 Kite",
    "objects-href": "https://emojipedia.org/kite/",
    emoji: "🪁",
    emojiName: "🪁 Kite",
    description:
      "A diamond-shaped kite with a tail. This emoji appears in various colors across platforms.",
  },
  {
    "web-scraper-order": "1666026505-1267",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🪀 Yo-Yo",
    "objects-href": "https://emojipedia.org/yo-yo/",
    emoji: "🪀",
    emojiName: "🪀 Yo-Yo",
    description:
      "A round yo-yo with its string coming out. It appears in various colors and designs across platforms, occasionally with a ⭐ Star on its side.",
  },
  {
    "web-scraper-order": "1666026507-1268",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🤿 Diving Mask",
    "objects-href": "https://emojipedia.org/diving-mask/",
    emoji: "🤿",
    emojiName: "🤿 Diving Mask",
    description:
      "A diving mask with a snorkel, used for scuba diving or other underwater activities. Colors vary across platforms.",
  },
  {
    "web-scraper-order": "1666026510-1269",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎁 Wrapped Gift",
    "objects-href": "https://emojipedia.org/wrapped-gift/",
    emoji: "🎁",
    emojiName: "🎁 Wrapped Gift",
    description:
      "A present or gift in a box tied with a bow, as given on a birthday or Christmas. Box and ribbon color vary across platforms, but commonly depicted as a gold box with a lid wrapped with a red ribbon.",
  },
  {
    "web-scraper-order": "1666026513-1270",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎀 Ribbon",
    "objects-href": "https://emojipedia.org/ribbon/",
    emoji: "🎀",
    emojiName: "🎀 Ribbon",
    description:
      "A pink or red ribbon, as tied into a bow on a gift or woman's hat.",
  },
  {
    "web-scraper-order": "1666026516-1271",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧧 Red Envelope",
    "objects-href": "https://emojipedia.org/red-envelope/",
    emoji: "🧧",
    emojiName: "🧧 Red Envelope",
    description:
      "A red envelope, as gifted with money on Chinese New Year or on other joyous occasions, such as weddings, in Chinese and some other Asian cultures around the world.",
  },
  {
    "web-scraper-order": "1666026519-1272",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎐 Wind Chime",
    "objects-href": "https://emojipedia.org/wind-chime/",
    emoji: "🎐",
    emojiName: "🎐 Wind Chime",
    description:
      "A Japanese wind chime. Depicted as a glass bell with a strip of paper suspended from its clapper, often decorated with cherry blossom-like flowers.",
  },
  {
    "web-scraper-order": "1666026521-1273",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎏 Carp Streamer",
    "objects-href": "https://emojipedia.org/carp-streamer/",
    emoji: "🎏",
    emojiName: "🎏 Carp Streamer",
    description:
      "Japanese koinobori, decorative, carp-shaped windsocks flown in celebration of Children’s Day on May 5 in Japan. Generally depicted as a blue and red stylized carp fish on a golden pole.",
  },
  {
    "web-scraper-order": "1666026526-1274",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎎 Japanese Dolls",
    "objects-href": "https://emojipedia.org/japanese-dolls/",
    emoji: "🎎",
    emojiName: "🎎 Japanese Dolls",
    description:
      "Ornamental Japanese Emperor and Empress dolls, as displayed in celebration of Hinamatsuri on March 3 in Japan (Girls’ or Dolls’ Day).",
  },
  {
    "web-scraper-order": "1666026530-1275",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎊 Confetti Ball",
    "objects-href": "https://emojipedia.org/confetti-ball/",
    emoji: "🎊",
    emojiName: "🎊 Confetti Ball",
    description:
      "A golden ball, split in two halves in a shower of multicolored confetti and streamers.",
  },
  {
    "web-scraper-order": "1666026534-1276",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎉 Party Popper",
    "objects-href": "https://emojipedia.org/party-popper/",
    emoji: "🎉",
    emojiName: "🎉 Party Popper",
    description:
      "A party popper, as explodes in a shower of confetti and streamers at a celebration. Generally depicted as a gold party hat, striped on some platforms, at a 45° angle, with multicolored confetti and streamers coming from its opening at the upper right. Twitter’s cone is red.",
  },
  {
    "web-scraper-order": "1666026537-1277",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🎈 Balloon",
    "objects-href": "https://emojipedia.org/balloon/",
    emoji: "🎈",
    emojiName: "🎈 Balloon",
    description:
      "A balloon on a string, as decorates a birthday party. Generally depicted in red, though WhatsApp’s is pink and Google’s orangish-red.",
  },
  {
    "web-scraper-order": "1666026539-1278",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧨 Firecracker",
    "objects-href": "https://emojipedia.org/firecracker/",
    emoji: "🧨",
    emojiName: "🧨 Firecracker",
    description:
      "A firecracker, as lit on Chinese New Year, New Year's Eve, or Independence Day. Depicted as a red tube with a burning fuse, sometimes lined with gold rings at its top and base.",
  },
  {
    "web-scraper-order": "1666026542-1279",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⛱️ Umbrella on Ground",
    "objects-href": "https://emojipedia.org/umbrella-on-ground/",
    emoji: "⛱️",
    emojiName: "⛱️ Umbrella on Ground",
    description:
      "A large, open umbrella, as provides shade at a beach or patio. Generally depicted as a striped umbrella inserted into a patch of sand and tilted to the right.",
  },
  {
    "web-scraper-order": "1666026545-1280",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🌡️ Thermometer",
    "objects-href": "https://emojipedia.org/thermometer/",
    emoji: "🌡️",
    emojiName: "🌡️ Thermometer",
    description:
      "A liquid-in-glass thermometer, as used to measure temperature. Depicted at various angles with a red liquid risen from the bulb to various levels on the scale. Commonly used for content concerning high temperatures, including warm weather, illness (having a fever), and various slang senses of hot.",
  },
  {
    "web-scraper-order": "1666026550-1281",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕰️ Mantelpiece Clock",
    "objects-href": "https://emojipedia.org/mantelpiece-clock/",
    emoji: "🕰️",
    emojiName: "🕰️ Mantelpiece Clock",
    description:
      "An antique-styled mantel clock with a flat base and rounded case, as made of wood and brass and placed above a fireplace.",
  },
  {
    "web-scraper-order": "1666026555-1282",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏲️ Timer Clock",
    "objects-href": "https://emojipedia.org/timer-clock/",
    emoji: "⏲️",
    emojiName: "⏲️ Timer Clock",
    description:
      "Time’s up! A timer set to count down and sound an alarm after a designated amount of time, as used in the kitchen. Appearance varies by platform. Commonly used for various content concerning time, including countdowns and deadlines.",
  },
  {
    "web-scraper-order": "1666026560-1283",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏱️ Stopwatch",
    "objects-href": "https://emojipedia.org/stopwatch/",
    emoji: "⏱️",
    emojiName: "⏱️ Stopwatch",
    description:
      "An analog, handheld timepiece used to measure elapsed time, as for athletic sprints. Appearance varies across platforms, but depicted with two or more control buttons on its top.",
  },
  {
    "web-scraper-order": "1666026563-1285",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏰ Alarm Clock",
    "objects-href": "https://emojipedia.org/alarm-clock/",
    emoji: "⏰",
    emojiName: "⏰ Alarm Clock",
    description:
      "A timepiece set in advance to startle a person awake at the designated time with its two bells. That is, before hitting snooze. Appearance varies across platforms, but depicted as a classic, wind-up, bedside alarm clock, often red in color.",
  },
  {
    "web-scraper-order": "1666026567-1287",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌚ Watch",
    "objects-href": "https://emojipedia.org/watch/",
    emoji: "⌚",
    emojiName: "⌚ Watch",
    description:
      "A wristwatch, as used for telling time. Appearance varies across platforms, but widely depicted as an analog timepiece with a white face and brown or black straps.",
  },
  {
    "web-scraper-order": "1666026572-1290",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⏳ Hourglass Not Done",
    "objects-href": "https://emojipedia.org/hourglass-not-done/",
    emoji: "⏳",
    emojiName: "⏳ Hourglass Not Done",
    description:
      "A classic hourglass, its sand still flowing from the top to bottom bulb. Indicates time is still passing—but life is short. Color varies across platforms.",
  },
  {
    "web-scraper-order": "1666026576-1292",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "⌛ Hourglass Done",
    "objects-href": "https://emojipedia.org/hourglass-done/",
    emoji: "⌛",
    emojiName: "⌛ Hourglass Done",
    description:
      "A classic hourglass, all of its sand having flowed into the bottom bulb. Indicates time has passed. Color varies across platforms.",
  },
  {
    "web-scraper-order": "1666026579-1294",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧳 Luggage",
    "objects-href": "https://emojipedia.org/luggage/",
    emoji: "🧳",
    emojiName: "🧳 Luggage",
    description:
      "A suitcase or bag, as used for traveling. Most platforms depict gray or blue rolling luggage with an extended handle. Commonly used for various content concerning traveling or taking trips, whether for business or leisure.",
  },
  {
    "web-scraper-order": "1666026582-1296",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛎️ Bellhop Bell",
    "objects-href": "https://emojipedia.org/bellhop-bell/",
    emoji: "🛎️",
    emojiName: "🛎️ Bellhop Bell",
    description:
      "Ding! A call bell, as pressed at a front desk or reception to alert staff for service, such as from a concierge or bellhop (porter) to carry luggage at a hotel. Generally depicted as a golden bell on a wooden stand.",
  },
  {
    "web-scraper-order": "1666026585-1298",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛢️ Oil Drum",
    "objects-href": "https://emojipedia.org/oil-drum/",
    emoji: "🛢️",
    emojiName: "🛢️ Oil Drum",
    description:
      "A barrel for transporting bulk liquids, such as oil. Generally depicted as a red or blue metal drum with holes or a stopper on its lid. Commonly used for various content concerning petroleum or hazardous waste.",
  },
  {
    "web-scraper-order": "1666026589-1300",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦼 Motorized Wheelchair",
    "objects-href": "https://emojipedia.org/motorized-wheelchair/",
    emoji: "🦼",
    emojiName: "🦼 Motorized Wheelchair",
    description:
      "A motorized wheelchair. Most platforms show a red and black or blue and black wheelchair. Distinct from ♿ Wheelchair Symbol which is used as signage to indicate accessible facilities. See also 👩‍🦼Woman in Motorized Wheelchair or 👨‍🦼Man in Motorized Wheelchair.",
  },
  {
    "web-scraper-order": "1666026591-1302",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🦽 Manual Wheelchair",
    "objects-href": "https://emojipedia.org/manual-wheelchair/",
    emoji: "🦽",
    emojiName: "🦽 Manual Wheelchair",
    description:
      "A manual wheelchair. Most platforms show a red and black or blue and black wheelchair. Distinct from ♿ Wheelchair Symbol, which is used as signage to indicate accessible facilities. See also 👩‍🦽Woman in Manual Wheelchair or 👨‍🦽Man in Manual Wheelchair.",
  },
  {
    "web-scraper-order": "1666026596-1304",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💈 Barber Pole",
    "objects-href": "https://emojipedia.org/barber-pole/",
    emoji: "💈",
    emojiName: "💈 Barber Pole",
    description:
      "A pole spiraled with red, white, and blue stripes, as spins out front of a barbershop. Commonly used for various content concerning haircutting and hairstyling.",
  },
  {
    "web-scraper-order": "1666026598-1305",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧱 Brick",
    "objects-href": "https://emojipedia.org/brick/",
    emoji: "🧱",
    emojiName: "🧱 Brick",
    description:
      "A red brick or bricks. Depicted in a loose stack, a single object with holes, or as built into wall, as of a house, school, or other structure.",
  },
  {
    "web-scraper-order": "1666026604-1308",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🧭 Compass",
    "objects-href": "https://emojipedia.org/compass/",
    emoji: "🧭",
    emojiName: "🧭 Compass",
    description:
      "A magnetic compass, as used for navigation. Generally depicted in a silver or gold case with a compass rose and a red-tipped needle. Commonly used for various content concerning traveling and exploring as well as metaphorical compasses (e.g., moral compass).",
  },
  {
    "web-scraper-order": "1666026607-1310",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🗺️ World Map",
    "objects-href": "https://emojipedia.org/world-map/",
    emoji: "🗺️",
    emojiName: "🗺️ World Map",
    description:
      "A rectangular map of the world. Generally depicted as a paper map creased at its folds, Earth’s surface shown in green on blue ocean.",
  },
  {
    "web-scraper-order": "1666026610-1312",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🏺 Amphora",
    "objects-href": "https://emojipedia.org/amphora/",
    emoji: "🏺",
    emojiName: "🏺 Amphora",
    description:
      "A tall, ceramic jar with two handles and a narrow neck and foot. Represents an amphora, as used by ancient Greeks and Romans to hold water and wine.",
  },
  {
    "web-scraper-order": "1666026614-1314",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🔪 Kitchen Knife",
    "objects-href": "https://emojipedia.org/kitchen-knife/",
    emoji: "🔪",
    emojiName: "🔪 Kitchen Knife",
    description:
      "A knife with a long steel blade, as a chef uses to slice meat or vegetables. Depicted with a black or brown handle and positioned at a 45° angle, often with its point at the lower right.",
  },
  {
    "web-scraper-order": "1666026617-1316",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛌 Person in Bed",
    "objects-href": "https://emojipedia.org/person-in-bed/",
    emoji: "🛌",
    emojiName: "🛌 Person in Bed",
    description:
      "A bed with a gender-unspecified person sleeping in it, as at a house, hotel, hostel, or other sleeping accommodation. Used especially for various content concerning sleeping as well as beds, furniture, housing, relaxing, and other bedroom activities.",
  },
  {
    "web-scraper-order": "1666026622-1318",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🛀 Person Taking Bath",
    "objects-href": "https://emojipedia.org/person-taking-bath/",
    emoji: "🛀",
    emojiName: "🛀 Person Taking Bath",
    description:
      "A gender-unspecified person taking a soothing bath in a white tub with a shower head. Commonly used for various content concerning bathing, washing, cleaning, and bathrooms more generally. May also represent relaxation and self-care.",
  },
  {
    "web-scraper-order": "1666026626-1321",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💣 Bomb",
    "objects-href": "https://emojipedia.org/bomb/",
    emoji: "💣",
    emojiName: "💣 Bomb",
    description:
      "A cartoon-styled bomb, depicted as a black ball with a burning fuse.",
  },
  {
    "web-scraper-order": "1666026629-1323",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "🕳️ Hole",
    "objects-href": "https://emojipedia.org/hole/",
    emoji: "🕳️",
    emojiName: "🕳️ Hole",
    description:
      "A round, black, cartoon-styled hole, as a manhole or a hole (cup) in golf. May be used to represent various types of literal or figurative holes, e.g., black holes, rabbit holes.",
  },
  {
    "web-scraper-order": "1666026634-1326",
    "web-scraper-start-url": "https://emojipedia.org/objects/",
    objects: "💌 Love Letter",
    "objects-href": "https://emojipedia.org/love-letter/",
    emoji: "💌",
    emojiName: "💌 Love Letter",
    description:
      "The back of an envelope, generally shown in white and sealed with a red heart. Represents a love letter or note, valentine, or affectionate greeting card. Commonly used to convey various feelings or messages of love and happiness.",
  },
  {
    "web-scraper-order": "1666026561-1284",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔲 Black Square Button",
    "symbols-href": "https://emojipedia.org/black-square-button/",
    emoji: "🔲",
    emojiName: "🔲 Black Square Button",
    description:
      "Black Square Button was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026564-1286",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔳 White Square Button",
    "symbols-href": "https://emojipedia.org/white-square-button/",
    emoji: "🔳",
    emojiName: "🔳 White Square Button",
    description: "White Square Button.",
  },
  {
    "web-scraper-order": "1666026568-1288",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔘 Radio Button",
    "symbols-href": "https://emojipedia.org/radio-button/",
    emoji: "🔘",
    emojiName: "🔘 Radio Button",
    description:
      "A radio button user interface element, used in form fields with two or more choices. Differs from a checkbox, in that only one response can be selected.",
  },
  {
    "web-scraper-order": "1666026571-1289",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💠 Diamond with a Dot",
    "symbols-href": "https://emojipedia.org/diamond-with-a-dot/",
    emoji: "💠",
    emojiName: "💠 Diamond with a Dot",
    description:
      "A glyph that is used for kawaii in Japan, resembling the shape of a flower.",
  },
  {
    "web-scraper-order": "1666026574-1291",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔻 Red Triangle Pointed Down",
    "symbols-href": "https://emojipedia.org/red-triangle-pointed-down/",
    emoji: "🔻",
    emojiName: "🔻 Red Triangle Pointed Down",
    description:
      "Red Triangle Pointed Down was approved as part of Unicode 6.0 in 2010 under the name “Down-Pointing Red Triangle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026577-1293",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔺 Red Triangle Pointed Up",
    "symbols-href": "https://emojipedia.org/red-triangle-pointed-up/",
    emoji: "🔺",
    emojiName: "🔺 Red Triangle Pointed Up",
    description:
      "Red Triangle Pointed Up was approved as part of Unicode 6.0 in 2010 under the name “Up-Pointing Red Triangle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026580-1295",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔹 Small Blue Diamond",
    "symbols-href": "https://emojipedia.org/small-blue-diamond/",
    emoji: "🔹",
    emojiName: "🔹 Small Blue Diamond",
    description:
      "Small Blue Diamond was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026584-1297",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔸 Small Orange Diamond",
    "symbols-href": "https://emojipedia.org/small-orange-diamond/",
    emoji: "🔸",
    emojiName: "🔸 Small Orange Diamond",
    description: "A small version of the large orange diamond emoji.",
  },
  {
    "web-scraper-order": "1666026587-1299",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔷 Large Blue Diamond",
    "symbols-href": "https://emojipedia.org/large-blue-diamond/",
    emoji: "🔷",
    emojiName: "🔷 Large Blue Diamond",
    description:
      "Large Blue Diamond was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026591-1301",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔶 Large Orange Diamond",
    "symbols-href": "https://emojipedia.org/large-orange-diamond/",
    emoji: "🔶",
    emojiName: "🔶 Large Orange Diamond",
    description: "A larger version of the small orange diamond emoji.",
  },
  {
    "web-scraper-order": "1666026594-1303",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▫️ White Small Square",
    "symbols-href": "https://emojipedia.org/white-small-square/",
    emoji: "▫️",
    emojiName: "▫️ White Small Square",
    description:
      "White Small Square was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026599-1306",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▪️ Black Small Square",
    "symbols-href": "https://emojipedia.org/black-small-square/",
    emoji: "▪️",
    emojiName: "▪️ Black Small Square",
    description:
      "Black Small Square was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026602-1307",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◽ White Medium-Small Square",
    "symbols-href": "https://emojipedia.org/white-medium-small-square/",
    emoji: "◽",
    emojiName: "◽ White Medium-Small Square",
    description:
      "White Medium-Small Square was approved as part of Unicode 3.2 in 2002 under the name “White Medium Small Square” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026604-1309",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◾ Black Medium-Small Square",
    "symbols-href": "https://emojipedia.org/black-medium-small-square/",
    emoji: "◾",
    emojiName: "◾ Black Medium-Small Square",
    description:
      "Black Medium-Small Square was approved as part of Unicode 3.2 in 2002 under the name “Black Medium Small Square” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026609-1311",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◻️ White Medium Square",
    "symbols-href": "https://emojipedia.org/white-medium-square/",
    emoji: "◻️",
    emojiName: "◻️ White Medium Square",
    description:
      "White Medium Square was approved as part of Unicode 3.2 in 2002 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026613-1313",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◼️ Black Medium Square",
    "symbols-href": "https://emojipedia.org/black-medium-square/",
    emoji: "◼️",
    emojiName: "◼️ Black Medium Square",
    description:
      "Black Medium Square was approved as part of Unicode 3.2 in 2002 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026616-1315",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬜ White Large Square",
    "symbols-href": "https://emojipedia.org/white-large-square/",
    emoji: "⬜",
    emojiName: "⬜ White Large Square",
    description:
      "A square shown in the shade of white. May be used to represent anything white.",
  },
  {
    "web-scraper-order": "1666026619-1317",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬛ Black Large Square",
    "symbols-href": "https://emojipedia.org/black-large-square/",
    emoji: "⬛",
    emojiName: "⬛ Black Large Square",
    description:
      "A square shown in the shade of black. May be used to represent anything black.",
  },
  {
    "web-scraper-order": "1666026622-1319",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟫 Brown Square",
    "symbols-href": "https://emojipedia.org/large-brown-square/",
    emoji: "🟫",
    emojiName: "🟫 Brown Square",
    description:
      "A square shown in the color of brown. May be used to represent anything brown.",
  },
  {
    "web-scraper-order": "1666026625-1320",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟪 Purple Square",
    "symbols-href": "https://emojipedia.org/large-purple-square/",
    emoji: "🟪",
    emojiName: "🟪 Purple Square",
    description:
      "A square shown in the color of purple. May be used to represent anything purple.",
  },
  {
    "web-scraper-order": "1666026628-1322",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟦 Blue Square",
    "symbols-href": "https://emojipedia.org/large-blue-square/",
    emoji: "🟦",
    emojiName: "🟦 Blue Square",
    description:
      "A square shown in the color of blue. May be used to represent anything blue.",
  },
  {
    "web-scraper-order": "1666026630-1324",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟩 Green Square",
    "symbols-href": "https://emojipedia.org/large-green-square/",
    emoji: "🟩",
    emojiName: "🟩 Green Square",
    description:
      "A square shown in the color of green. May be used to represent anything green.",
  },
  {
    "web-scraper-order": "1666026633-1325",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟨 Yellow Square",
    "symbols-href": "https://emojipedia.org/large-yellow-square/",
    emoji: "🟨",
    emojiName: "🟨 Yellow Square",
    description:
      "A square shown in the color yellow. May be used to represent anything yellow, including a yellow penalty card in football (soccer).",
  },
  {
    "web-scraper-order": "1666026635-1327",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟧 Orange Square",
    "symbols-href": "https://emojipedia.org/large-orange-square/",
    emoji: "🟧",
    emojiName: "🟧 Orange Square",
    description:
      "A square shown in the color of orange. May be used to represent anything orange.",
  },
  {
    "web-scraper-order": "1666026638-1328",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟥 Red Square",
    "symbols-href": "https://emojipedia.org/large-red-square/",
    emoji: "🟥",
    emojiName: "🟥 Red Square",
    description:
      "A square shown in the color red. May be used to represent anything red, including a red penalty card in football (soccer).",
  },
  {
    "web-scraper-order": "1666026640-1329",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚪ White Circle",
    "symbols-href": "https://emojipedia.org/white-circle/",
    emoji: "⚪",
    emojiName: "⚪ White Circle",
    description:
      "White Circle was approved as part of Unicode 4.1 in 2005 under the name “Medium White Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026643-1330",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚫ Black Circle",
    "symbols-href": "https://emojipedia.org/black-circle/",
    emoji: "⚫",
    emojiName: "⚫ Black Circle",
    description:
      "Black Circle was approved as part of Unicode 4.1 in 2005 under the name “Medium Black Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026646-1331",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟤 Brown Circle",
    "symbols-href": "https://emojipedia.org/large-brown-circle/",
    emoji: "🟤",
    emojiName: "🟤 Brown Circle",
    description:
      "Brown Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Brown Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026648-1332",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟣 Purple Circle",
    "symbols-href": "https://emojipedia.org/large-purple-circle/",
    emoji: "🟣",
    emojiName: "🟣 Purple Circle",
    description:
      "Purple Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Purple Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026651-1333",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔵 Blue Circle",
    "symbols-href": "https://emojipedia.org/large-blue-circle/",
    emoji: "🔵",
    emojiName: "🔵 Blue Circle",
    description:
      "Blue Circle was approved as part of Unicode 6.0 in 2010 under the name “Large Blue Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026653-1334",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟢 Green Circle",
    "symbols-href": "https://emojipedia.org/large-green-circle/",
    emoji: "🟢",
    emojiName: "🟢 Green Circle",
    description:
      "Green Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Green Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026656-1335",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟡 Yellow Circle",
    "symbols-href": "https://emojipedia.org/large-yellow-circle/",
    emoji: "🟡",
    emojiName: "🟡 Yellow Circle",
    description:
      "Yellow Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Yellow Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026658-1336",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟠 Orange Circle",
    "symbols-href": "https://emojipedia.org/large-orange-circle/",
    emoji: "🟠",
    emojiName: "🟠 Orange Circle",
    description:
      "Orange Circle was approved as part of Unicode 12.0 in 2019 under the name “Large Orange Circle” and added to Emoji 12.0 in 2019.",
  },
  {
    "web-scraper-order": "1666026661-1337",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔴 Red Circle",
    "symbols-href": "https://emojipedia.org/large-red-circle/",
    emoji: "🔴",
    emojiName: "🔴 Red Circle",
    description:
      "Red Circle was approved as part of Unicode 6.0 in 2010 under the name “Large Red Circle” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026664-1338",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈵 Japanese “No Vacancy” Button",
    "symbols-href": "https://emojipedia.org/japanese-no-vacancy-button/",
    emoji: "🈵",
    emojiName: "🈵 Japanese “No Vacancy” Button",
    description:
      "This emoji means “full” in Japanese, usually used to denote “full capacity” such as a gas/petrol tank on a car or pre-paid phone card.",
  },
  {
    "web-scraper-order": "1666026668-1340",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈺 Japanese “Open for Business” Button",
    "symbols-href": "https://emojipedia.org/japanese-open-for-business-button/",
    emoji: "🈺",
    emojiName: "🈺 Japanese “Open for Business” Button",
    description:
      "Means “work” in Japanese.  This Emoji used to mean “open for business” and precedes business hours.",
  },
  {
    "web-scraper-order": "1666026671-1342",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "㊙️ Japanese “Secret” Button",
    "symbols-href": "https://emojipedia.org/japanese-secret-button/",
    emoji: "㊙️",
    emojiName: "㊙️ Japanese “Secret” Button",
    description:
      "Japanese “Secret” Button was approved as part of Unicode 1.1 in 1993 under the name “Circled Ideograph Secret” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026675-1345",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "㊗️ Japanese “Congratulations” Button",
    "symbols-href": "https://emojipedia.org/japanese-congratulations-button/",
    emoji: "㊗️",
    emojiName: "㊗️ Japanese “Congratulations” Button",
    description:
      'Translated from Japanese, this means "congratulations" or "pray for happiness".',
  },
  {
    "web-scraper-order": "1666026678-1347",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈳 Japanese “Vacancy” Button",
    "symbols-href": "https://emojipedia.org/japanese-vacancy-button/",
    emoji: "🈳",
    emojiName: "🈳 Japanese “Vacancy” Button",
    description:
      "This 空 character means empty and available in Japanese. This is used in the context of an empty parking space or a vacant hotel room.",
  },
  {
    "web-scraper-order": "1666026681-1349",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈴 Japanese “Passing Grade” Button",
    "symbols-href": "https://emojipedia.org/japanese-passing-grade-button/",
    emoji: "🈴",
    emojiName: "🈴 Japanese “Passing Grade” Button",
    description:
      "Means “agreement” in Japanese. More literally, it means to unite, or join together.",
  },
  {
    "web-scraper-order": "1666026684-1351",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈸 Japanese “Application” Button",
    "symbols-href": "https://emojipedia.org/japanese-application-button/",
    emoji: "🈸",
    emojiName: "🈸 Japanese “Application” Button",
    description: "This Emoji has two meanings.",
  },
  {
    "web-scraper-order": "1666026687-1354",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🉑 Japanese “Acceptable” Button",
    "symbols-href": "https://emojipedia.org/japanese-acceptable-button/",
    emoji: "🉑",
    emojiName: "🉑 Japanese “Acceptable” Button",
    description:
      "Japanese “Acceptable” Button was approved as part of Unicode 6.0 in 2010 under the name “Circled Ideograph Accept” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026692-1356",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈲 Japanese “Prohibited” Button",
    "symbols-href": "https://emojipedia.org/japanese-prohibited-button/",
    emoji: "🈲",
    emojiName: "🈲 Japanese “Prohibited” Button",
    description: "This Emoji means “prohibit, restrict or forbid” in Japanese.",
  },
  {
    "web-scraper-order": "1666026696-1359",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈚 Japanese “Free of Charge” Button",
    "symbols-href": "https://emojipedia.org/japanese-free-of-charge-button/",
    emoji: "🈚",
    emojiName: "🈚 Japanese “Free of Charge” Button",
    description: "This means to lack, or have none of something.",
  },
  {
    "web-scraper-order": "1666026700-1361",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈹 Japanese “Discount” Button",
    "symbols-href": "https://emojipedia.org/japanese-discount-button/",
    emoji: "🈹",
    emojiName: "🈹 Japanese “Discount” Button",
    description:
      "Symbol for a sale, or bargain prices in Japan (“cut prices”). Literally translated, this character means to cut or divide.",
  },
  {
    "web-scraper-order": "1666026704-1363",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🉐 Japanese “Bargain” Button",
    "symbols-href": "https://emojipedia.org/japanese-bargain-button/",
    emoji: "🉐",
    emojiName: "🉐 Japanese “Bargain” Button",
    description: "Denotes a “good bargain” in Japanese.",
  },
  {
    "web-scraper-order": "1666026708-1365",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈯 Japanese “Reserved” Button",
    "symbols-href": "https://emojipedia.org/japanese-reserved-button/",
    emoji: "🈯",
    emojiName: "🈯 Japanese “Reserved” Button",
    description:
      "This character translates as meaning a finger or toe pointing to indicate a certain direction.",
  },
  {
    "web-scraper-order": "1666026712-1367",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈶 Japanese “Not Free of Charge” Button",
    "symbols-href":
      "https://emojipedia.org/japanese-not-free-of-charge-button/",
    emoji: "🈶",
    emojiName: "🈶 Japanese “Not Free of Charge” Button",
    description: "This emoji means to own or posses.",
  },
  {
    "web-scraper-order": "1666026716-1370",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈷️ Japanese “Monthly Amount” Button",
    "symbols-href": "https://emojipedia.org/japanese-monthly-amount-button/",
    emoji: "🈷️",
    emojiName: "🈷️ Japanese “Monthly Amount” Button",
    description:
      "CJK Ideographs are characters used in Chinese, Japanese and Korean languages. Their writing systems all completely or partly use Chinese characters.",
  },
  {
    "web-scraper-order": "1666026719-1372",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈂️ Japanese “Service Charge” Button",
    "symbols-href": "https://emojipedia.org/japanese-service-charge-button/",
    emoji: "🈂️",
    emojiName: "🈂️ Japanese “Service Charge” Button",
    description:
      'Translates as meaning complimentary, or free of charge. For example, a drink that is given "on the house" to a regular customer.',
  },
  {
    "web-scraper-order": "1666026724-1375",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🈁 Japanese “Here” Button",
    "symbols-href": "https://emojipedia.org/japanese-here-button/",
    emoji: "🈁",
    emojiName: "🈁 Japanese “Here” Button",
    description: "Means “Here” in Japanese, referring to a destination.",
  },
  {
    "web-scraper-order": "1666026737-1376",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆚 Vs Button",
    "symbols-href": "https://emojipedia.org/vs-button/",
    emoji: "🆚",
    emojiName: "🆚 Vs Button",
    description:
      "Vs Button was approved as part of Unicode 6.0 in 2010 under the name “Squared Vs” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026740-1377",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆙 Up! Button",
    "symbols-href": "https://emojipedia.org/up-button/",
    emoji: "🆙",
    emojiName: "🆙 Up! Button",
    description:
      "The word up with an exclamation point after it, shown enclosed in a square. Originally intended to denote leveling up in a game.",
  },
  {
    "web-scraper-order": "1666026742-1379",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆘 SOS Button",
    "symbols-href": "https://emojipedia.org/sos-button/",
    emoji: "🆘",
    emojiName: "🆘 SOS Button",
    description:
      "SOS is the description for the distress signal in Morse Code. This emoji means SOS or “emergency”.",
  },
  {
    "web-scraper-order": "1666026745-1381",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅿️ P Button",
    "symbols-href": "https://emojipedia.org/p-button/",
    emoji: "🅿️",
    emojiName: "🅿️ P Button",
    description:
      "Depicted by major emoji vendors as blue square with a white letter 'P' contained within it. Most often to represent a parking space or parking lot.",
  },
  {
    "web-scraper-order": "1666026748-1383",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆗 OK Button",
    "symbols-href": "https://emojipedia.org/ok-button/",
    emoji: "🆗",
    emojiName: "🆗 OK Button",
    description:
      "The letters OK, shown enclosed in a square. Meaning Okay, denoting approval. The opposite of the Squared NG Emoji.",
  },
  {
    "web-scraper-order": "1666026751-1385",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅾️ O Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/o-button-blood-type/",
    emoji: "🅾️",
    emojiName: "🅾️ O Button (Blood Type)",
    description:
      "A symbol representing Blood Type O. Displayed as the letter O on a red background.",
  },
  {
    "web-scraper-order": "1666026753-1387",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆖 NG Button",
    "symbols-href": "https://emojipedia.org/ng-button/",
    emoji: "🆖",
    emojiName: "🆖 NG Button",
    description:
      "The letters NG, shown enclosed in a square, which are an acronym for the words No Good.",
  },
  {
    "web-scraper-order": "1666026755-1389",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆕 New Button",
    "symbols-href": "https://emojipedia.org/new-button/",
    emoji: "🆕",
    emojiName: "🆕 New Button",
    description: "The word new, shown enclosed in a square.",
  },
  {
    "web-scraper-order": "1666026758-1391",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "Ⓜ️ Circled M",
    "symbols-href": "https://emojipedia.org/circled-m/",
    emoji: "Ⓜ️",
    emojiName: "Ⓜ️ Circled M",
    description:
      "The letter M in a circle, commonly used in to identify a Metro (subway, underground train) station in a city area.",
  },
  {
    "web-scraper-order": "1666026761-1393",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆔 ID Button",
    "symbols-href": "https://emojipedia.org/id-button/",
    emoji: "🆔",
    emojiName: "🆔 ID Button",
    description: "The letters ID in a square.",
  },
  {
    "web-scraper-order": "1666026763-1395",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "ℹ️ Information",
    "symbols-href": "https://emojipedia.org/information/",
    emoji: "ℹ️",
    emojiName: "ℹ️ Information",
    description:
      "A lowercase letter i, enclosed in a rounded square or circle. Implemented in apps or websites to indicate that help or further information is available.",
  },
  {
    "web-scraper-order": "1666026765-1397",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆓 Free Button",
    "symbols-href": "https://emojipedia.org/free-button/",
    emoji: "🆓",
    emojiName: "🆓 Free Button",
    description: "The word free, shown enclosed in a square.",
  },
  {
    "web-scraper-order": "1666026770-1400",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆒 Cool Button",
    "symbols-href": "https://emojipedia.org/cool-button/",
    emoji: "🆒",
    emojiName: "🆒 Cool Button",
    description:
      "The word cool, shown enclosed in a square. This generally displays in a shade of blue, or blue-gray on most platforms. Used as a text decoration.",
  },
  {
    "web-scraper-order": "1666026773-1402",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆑 CL Button",
    "symbols-href": "https://emojipedia.org/cl-button/",
    emoji: "🆑",
    emojiName: "🆑 CL Button",
    description:
      "CL is what shows on the CLear button of some older mobile phones.",
  },
  {
    "web-scraper-order": "1666026776-1404",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅱️ B Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/b-button-blood-type/",
    emoji: "🅱️",
    emojiName: "🅱️ B Button (Blood Type)",
    description:
      "A symbol representing Blood Type B. Displayed as the letter B on a red background.",
  },
  {
    "web-scraper-order": "1666026778-1406",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🆎 AB Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/ab-button-blood-type/",
    emoji: "🆎",
    emojiName: "🆎 AB Button (Blood Type)",
    description:
      "A symbol representing Blood Type AB. Displayed as the letters AB on a red background.",
  },
  {
    "web-scraper-order": "1666026781-1408",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🅰️ A Button (Blood Type)",
    "symbols-href": "https://emojipedia.org/a-button-blood-type/",
    emoji: "🅰️",
    emojiName: "🅰️ A Button (Blood Type)",
    description:
      "A symbol representing Blood Type A. Displayed as the letter A on a red background.",
  },
  {
    "web-scraper-order": "1666026783-1410",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔤 Input Latin Letters",
    "symbols-href": "https://emojipedia.org/input-latin-letters/",
    emoji: "🔤",
    emojiName: "🔤 Input Latin Letters",
    description:
      "A symbol showing the lowercase letters a, b, c and d. Intended to be used on a software keyboard, or other input screen to enable alphabetical input, as opposed to numeric or symbol input.",
  },
  {
    "web-scraper-order": "1666026786-1412",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔣 Input Symbols",
    "symbols-href": "https://emojipedia.org/input-symbols/",
    emoji: "🔣",
    emojiName: "🔣 Input Symbols",
    description:
      "A symbol showing the following glyphs: 〒 (Japanese postal mark), 𝅘𝅥𝅮 (music note), & (ampersand, or sometimes an @ symbol) and % (percentage sign).",
  },
  {
    "web-scraper-order": "1666026789-1414",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔢 Input Numbers",
    "symbols-href": "https://emojipedia.org/input-numbers/",
    emoji: "🔢",
    emojiName: "🔢 Input Numbers",
    description:
      "A symbol showing the numbers 1, 2, 3 and 4. Intended to be used on a software keyboard, or other input screen to enable symbol input, as opposed to alphabetical or symbol input.",
  },
  {
    "web-scraper-order": "1666026791-1416",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔡 Input Latin Lowercase",
    "symbols-href": "https://emojipedia.org/input-latin-lowercase/",
    emoji: "🔡",
    emojiName: "🔡 Input Latin Lowercase",
    description:
      "A symbol showing the lowercase letters a, b, c and d. Intended to be used on a software keyboard, or other input screen to toggle lowercase letter input.",
  },
  {
    "web-scraper-order": "1666026794-1418",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔠 Input Latin Uppercase",
    "symbols-href": "https://emojipedia.org/input-latin-uppercase/",
    emoji: "🔠",
    emojiName: "🔠 Input Latin Uppercase",
    description:
      "A symbol showing the capital letters A, B, C and D. Intended to be used on a software keyboard, or other input screen to toggle capital letter input.",
  },
  {
    "web-scraper-order": "1666026796-1420",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔟 Keycap: 10",
    "symbols-href": "https://emojipedia.org/keycap-10/",
    emoji: "🔟",
    emojiName: "🔟 Keycap: 10",
    description:
      "The number 10 on a square with rounded corners, designed to look like a keycap.",
  },
  {
    "web-scraper-order": "1666026799-1422",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "9️⃣ Keycap Digit Nine",
    "symbols-href": "https://emojipedia.org/keycap-digit-nine/",
    emoji: "9️⃣",
    emojiName: "9️⃣ Keycap Digit Nine",
    description:
      "The Keycap Digit Nine emoji is a keycap sequence combining 9️ Digit Nine and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026802-1424",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "8️⃣ Keycap Digit Eight",
    "symbols-href": "https://emojipedia.org/keycap-digit-eight/",
    emoji: "8️⃣",
    emojiName: "8️⃣ Keycap Digit Eight",
    description:
      "The Keycap Digit Eight emoji is a keycap sequence combining 8️ Digit Eight and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026805-1426",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "7️⃣ Keycap Digit Seven",
    "symbols-href": "https://emojipedia.org/keycap-digit-seven/",
    emoji: "7️⃣",
    emojiName: "7️⃣ Keycap Digit Seven",
    description:
      "The Keycap Digit Seven emoji is a keycap sequence combining 7️ Digit Seven and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026808-1428",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "6️⃣ Keycap Digit Six",
    "symbols-href": "https://emojipedia.org/keycap-digit-six/",
    emoji: "6️⃣",
    emojiName: "6️⃣ Keycap Digit Six",
    description:
      "The Keycap Digit Six emoji is a keycap sequence combining 6️ Digit Six and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026810-1430",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "5️⃣ Keycap Digit Five",
    "symbols-href": "https://emojipedia.org/keycap-digit-five/",
    emoji: "5️⃣",
    emojiName: "5️⃣ Keycap Digit Five",
    description:
      "The Keycap Digit Five emoji is a keycap sequence combining 5️ Digit Five and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026812-1432",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "4️⃣ Keycap Digit Four",
    "symbols-href": "https://emojipedia.org/keycap-digit-four/",
    emoji: "4️⃣",
    emojiName: "4️⃣ Keycap Digit Four",
    description:
      "The Keycap Digit Four emoji is a keycap sequence combining 4️ Digit Four and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026815-1433",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "3️⃣ Keycap Digit Three",
    "symbols-href": "https://emojipedia.org/keycap-digit-three/",
    emoji: "3️⃣",
    emojiName: "3️⃣ Keycap Digit Three",
    description:
      "The Keycap Digit Three emoji is a keycap sequence combining 3️ Digit Three and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026817-1435",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "2️⃣ Keycap Digit Two",
    "symbols-href": "https://emojipedia.org/keycap-digit-two/",
    emoji: "2️⃣",
    emojiName: "2️⃣ Keycap Digit Two",
    description:
      "The Keycap Digit Two emoji is a keycap sequence combining 2️ Digit Two and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026819-1437",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "1️⃣ Keycap Digit One",
    "symbols-href": "https://emojipedia.org/keycap-digit-one/",
    emoji: "1️⃣",
    emojiName: "1️⃣ Keycap Digit One",
    description:
      "The Keycap Digit One emoji is a keycap sequence combining 1️ Digit One and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026822-1439",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "0️⃣ Keycap Digit Zero",
    "symbols-href": "https://emojipedia.org/keycap-digit-zero/",
    emoji: "0️⃣",
    emojiName: "0️⃣ Keycap Digit Zero",
    description:
      "The Keycap Digit Zero emoji is a keycap sequence combining 0️ Digit Zero and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026825-1441",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "*️⃣ Keycap Asterisk",
    "symbols-href": "https://emojipedia.org/keycap-asterisk/",
    emoji: "*️⃣",
    emojiName: "*️⃣ Keycap Asterisk",
    description:
      "The Keycap Asterisk emoji is a keycap sequence combining *️ Asterisk and ⃣ Combining Enclosing Keycap.\nThese display as a single emoji on supported platforms.",
  },
  {
    "web-scraper-order": "1666026828-1443",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "#️⃣ Keycap Number Sign",
    "symbols-href": "https://emojipedia.org/keycap-number-sign/",
    emoji: "#️⃣",
    emojiName: "#️⃣ Keycap Number Sign",
    description:
      "A hash key, sometimes referred to as a pound key in the United States. Most commonly used online to make a hashtag (or hash flag) on social media sites.",
  },
  {
    "web-scraper-order": "1666026830-1445",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "™️ Trade Mark",
    "symbols-href": "https://emojipedia.org/trade-mark/",
    emoji: "™️",
    emojiName: "™️ Trade Mark",
    description:
      "A trademark symbol, the letters TM displayed after a word that is trademarked.",
  },
  {
    "web-scraper-order": "1666026832-1447",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "®️ Registered",
    "symbols-href": "https://emojipedia.org/registered/",
    emoji: "®️",
    emojiName: "®️ Registered",
    description:
      "Registered was approved as part of Unicode 1.1 in 1993 under the name “Registered Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026835-1449",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "©️ Copyright",
    "symbols-href": "https://emojipedia.org/copyright/",
    emoji: "©️",
    emojiName: "©️ Copyright",
    description:
      "Copyright was approved as part of Unicode 1.1 in 1993 under the name “Copyright Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026837-1451",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❇️ Sparkle",
    "symbols-href": "https://emojipedia.org/sparkle/",
    emoji: "❇️",
    emojiName: "❇️ Sparkle",
    description:
      "Used a decorative bullet-point, the sparkle has both a ❇︎ text and ❇️ emoji presentation available on most platforms.",
  },
  {
    "web-scraper-order": "1666026840-1453",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✴️ Eight-Pointed Star",
    "symbols-href": "https://emojipedia.org/eight-pointed-star/",
    emoji: "✴️",
    emojiName: "✴️ Eight-Pointed Star",
    description:
      "A star with eight points, that is commonly shown in orange, and for some reason, with only four points.",
  },
  {
    "web-scraper-order": "1666026842-1455",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✳️ Eight-Spoked Asterisk",
    "symbols-href": "https://emojipedia.org/eight-spoked-asterisk/",
    emoji: "✳️",
    emojiName: "✳️ Eight-Spoked Asterisk",
    description:
      "Used in a similar manner to a regular * asterisk character but tends to be shown in a similar vertical alignment to a • bullet point. The eight spoked asterisk has both a ✳︎ text and ✳️ emoji presentation available on most platforms.",
  },
  {
    "web-scraper-order": "1666026845-1457",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "〽️ Part Alternation Mark",
    "symbols-href": "https://emojipedia.org/part-alternation-mark/",
    emoji: "〽️",
    emojiName: "〽️ Part Alternation Mark",
    description:
      "Used in traditional Japanese music such as Noh or Renga, to indicate the start of a song. More specifically, the part alternation mark is displayed where the singer’s part begins.",
  },
  {
    "web-scraper-order": "1666026848-1459",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➿ Double Curly Loop",
    "symbols-href": "https://emojipedia.org/double-curly-loop/",
    emoji: "➿",
    emojiName: "➿ Double Curly Loop",
    description:
      "Two curly loops, which represent a reel-to-reel tape recorder. Used as a symbol for voicemail on many phones.",
  },
  {
    "web-scraper-order": "1666026851-1461",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➰ Curly Loop",
    "symbols-href": "https://emojipedia.org/curly-loop/",
    emoji: "➰",
    emojiName: "➰ Curly Loop",
    description:
      "A curled loop, which is shown in black on most platforms. Previously displayed as a blue ribbon on Samsung devices.",
  },
  {
    "web-scraper-order": "1666026853-1463",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❎ Cross Mark Button",
    "symbols-href": "https://emojipedia.org/cross-mark-button/",
    emoji: "❎",
    emojiName: "❎ Cross Mark Button",
    description:
      "Cross Mark Button was approved as part of Unicode 6.0 in 2010 under the name “Negative Squared Cross Mark” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026855-1465",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❌ Cross Mark",
    "symbols-href": "https://emojipedia.org/cross-mark/",
    emoji: "❌",
    emojiName: "❌ Cross Mark",
    description:
      "A large red cross mark, displayed in the shape of a letter X and similar to a multiplication sign.",
  },
  {
    "web-scraper-order": "1666026857-1467",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✔️ Check Mark",
    "symbols-href": "https://emojipedia.org/check-mark/",
    emoji: "✔️",
    emojiName: "✔️ Check Mark",
    description:
      "A thick check mark / tick displayed on some platforms in a handwritten style. Generally displayed in black. Commonly used in lists to signify completed tasks or verification of a statement of fact.",
  },
  {
    "web-scraper-order": "1666026860-1469",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☑️ Check Box with Check",
    "symbols-href": "https://emojipedia.org/check-box-with-check/",
    emoji: "☑️",
    emojiName: "☑️ Check Box with Check",
    description:
      "A checkbox showing a check mark inside the box. Not to be confused with the similarly named Ballot Box With Ballot emoji.",
  },
  {
    "web-scraper-order": "1666026862-1471",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✅ Check Mark Button",
    "symbols-href": "https://emojipedia.org/check-mark-button/",
    emoji: "✅",
    emojiName: "✅ Check Mark Button",
    description:
      "A check mark that displays with a white outlined appearance. Shows on most platforms with a bright green rounded rectangle or circle surrounding it.",
  },
  {
    "web-scraper-order": "1666026865-1473",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⭕ Hollow Red Circle",
    "symbols-href": "https://emojipedia.org/hollow-red-circle/",
    emoji: "⭕",
    emojiName: "⭕ Hollow Red Circle",
    description:
      "Used as an alternative to a check (tick) in Japan for a something that is correct. The opposite of an X (cross mark) for something wrong.",
  },
  {
    "web-scraper-order": "1666026867-1475",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔰 Japanese Symbol for Beginner",
    "symbols-href": "https://emojipedia.org/japanese-symbol-for-beginner/",
    emoji: "🔰",
    emojiName: "🔰 Japanese Symbol for Beginner",
    description:
      "A yellow and green shield symbol, called a Shoshinsha Mark. Must be displayed by drivers in Japan for one year after they receive their drivers licence.",
  },
  {
    "web-scraper-order": "1666026870-1477",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📛 Name Badge",
    "symbols-href": "https://emojipedia.org/name-badge/",
    emoji: "📛",
    emojiName: "📛 Name Badge",
    description:
      "A name badge, used to identify oneself in a location that others may not know your name, such as a school trip, or a work conference.",
  },
  {
    "web-scraper-order": "1666026872-1479",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔱 Trident Emblem",
    "symbols-href": "https://emojipedia.org/trident-emblem/",
    emoji: "🔱",
    emojiName: "🔱 Trident Emblem",
    description:
      "A trident is a three-pronged spear, that appears similar to a pitchfork. Often held by Greek or Roman Gods in statues.",
  },
  {
    "web-scraper-order": "1666026875-1481",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚜️ Fleur-de-lis",
    "symbols-href": "https://emojipedia.org/fleur-de-lis/",
    emoji: "⚜️",
    emojiName: "⚜️ Fleur-de-lis",
    description:
      "A decorative symbol that appears like a golden flower, but found in all manner of logos, symbols, and patterns. This symbol forms part of the World Scout Emblem, amongst other uses.",
  },
  {
    "web-scraper-order": "1666026878-1483",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♻️ Recycling Symbol",
    "symbols-href": "https://emojipedia.org/recycling-symbol/",
    emoji: "♻️",
    emojiName: "♻️ Recycling Symbol",
    description:
      "The universal recycling symbol, featuring three arrows pointing clockwise in a triangular formation.",
  },
  {
    "web-scraper-order": "1666026881-1485",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚕️ Medical Symbol",
    "symbols-href": "https://emojipedia.org/medical-symbol/",
    emoji: "⚕️",
    emojiName: "⚕️ Medical Symbol",
    description:
      "A symbol displaying of a rod with a snake entwined around the outside in a downward-spiral shape.",
  },
  {
    "web-scraper-order": "1666026884-1487",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💲 Heavy Dollar Sign",
    "symbols-href": "https://emojipedia.org/heavy-dollar-sign/",
    emoji: "💲",
    emojiName: "💲 Heavy Dollar Sign",
    description:
      "Heavy Dollar Sign was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026887-1489",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💱 Currency Exchange",
    "symbols-href": "https://emojipedia.org/currency-exchange/",
    emoji: "💱",
    emojiName: "💱 Currency Exchange",
    description:
      "A symbol for exchanging of two currencies. Most commonly displayed as a dollar symbol, with arrows to and from a yen symbol.",
  },
  {
    "web-scraper-order": "1666026891-1491",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "〰️ Wavy Dash",
    "symbols-href": "https://emojipedia.org/wavy-dash/",
    emoji: "〰️",
    emojiName: "〰️ Wavy Dash",
    description:
      "Just like a regular dash (hyphen), sometimes used in Asian character sets in the same way a – or — is used in latin character sets.",
  },
  {
    "web-scraper-order": "1666026895-1493",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❗ Red Exclamation Mark",
    "symbols-href": "https://emojipedia.org/exclamation-mark/",
    emoji: "❗",
    emojiName: "❗ Red Exclamation Mark",
    description:
      "Red Exclamation Mark was approved as part of Unicode 5.2 in 2009 under the name “Heavy Exclamation Mark Symbol” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026899-1496",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❕ White Exclamation Mark",
    "symbols-href": "https://emojipedia.org/white-exclamation-mark/",
    emoji: "❕",
    emojiName: "❕ White Exclamation Mark",
    description:
      "White Exclamation Mark was approved as part of Unicode 6.0 in 2010 under the name “White Exclamation Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026902-1498",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❔ White Question Mark",
    "symbols-href": "https://emojipedia.org/white-question-mark/",
    emoji: "❔",
    emojiName: "❔ White Question Mark",
    description:
      "White Question Mark was approved as part of Unicode 6.0 in 2010 under the name “White Question Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026906-1500",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❓ Red Question Mark",
    "symbols-href": "https://emojipedia.org/question-mark/",
    emoji: "❓",
    emojiName: "❓ Red Question Mark",
    description:
      "Red Question Mark was approved as part of Unicode 6.0 in 2010 under the name “Black Question Mark Ornament” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026909-1502",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⁉️ Exclamation Question Mark",
    "symbols-href": "https://emojipedia.org/exclamation-question-mark/",
    emoji: "⁉️",
    emojiName: "⁉️ Exclamation Question Mark",
    description:
      "Exclamation Question Mark was approved as part of Unicode 3.0 in 1999 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026913-1504",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "‼️ Double Exclamation Mark",
    "symbols-href": "https://emojipedia.org/double-exclamation-mark/",
    emoji: "‼️",
    emojiName: "‼️ Double Exclamation Mark",
    description:
      "Double Exclamation Mark was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026915-1506",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♾️ Infinity",
    "symbols-href": "https://emojipedia.org/infinity/",
    emoji: "♾️",
    emojiName: "♾️ Infinity",
    description: "The symbol for infinity enclosed within a circle or square.",
  },
  {
    "web-scraper-order": "1666026918-1508",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🟰 Heavy Equals Sign",
    "symbols-href": "https://emojipedia.org/heavy-equals-sign/",
    emoji: "🟰",
    emojiName: "🟰 Heavy Equals Sign",
    description:
      "An equals sign in the style of the already existing set of mathematical symbols ✖️ Multiply, ➕ Plus, ➖ Minus, and ➗ Divide.",
  },
  {
    "web-scraper-order": "1666026921-1510",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➗ Divide",
    "symbols-href": "https://emojipedia.org/divide/",
    emoji: "➗",
    emojiName: "➗ Divide",
    description:
      "Divide was approved as part of Unicode 6.0 in 2010 under the name “Heavy Division Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026925-1513",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➖ Minus",
    "symbols-href": "https://emojipedia.org/minus/",
    emoji: "➖",
    emojiName: "➖ Minus",
    description:
      "Minus was approved as part of Unicode 6.0 in 2010 under the name “Heavy Minus Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026929-1515",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➕ Plus",
    "symbols-href": "https://emojipedia.org/plus/",
    emoji: "➕",
    emojiName: "➕ Plus",
    description:
      "Plus was approved as part of Unicode 6.0 in 2010 under the name “Heavy Plus Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026933-1518",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✖️ Multiply",
    "symbols-href": "https://emojipedia.org/multiply/",
    emoji: "✖️",
    emojiName: "✖️ Multiply",
    description:
      "Multiply was approved as part of Unicode 1.1 in 1993 under the name “Heavy Multiplication X” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026936-1520",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♂️ Male Sign",
    "symbols-href": "https://emojipedia.org/male-sign/",
    emoji: "♂️",
    emojiName: "♂️ Male Sign",
    description:
      "A circle shown with a diagonal arrow pointing out the top-right, used as a representation for men.",
  },
  {
    "web-scraper-order": "1666026938-1521",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♀️ Female Sign",
    "symbols-href": "https://emojipedia.org/female-sign/",
    emoji: "♀️",
    emojiName: "♀️ Female Sign",
    description:
      "A circle shown with a crossed vertical line beneath it, used as a representation for women. Often used on International Women's Day.",
  },
  {
    "web-scraper-order": "1666026942-1524",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📴 Mobile Phone Off",
    "symbols-href": "https://emojipedia.org/mobile-phone-off/",
    emoji: "📴",
    emojiName: "📴 Mobile Phone Off",
    description:
      "A sign indicating that mobile phones should be turned off. Used in situations such as a cinema or live performance.",
  },
  {
    "web-scraper-order": "1666026946-1527",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📳 Vibration Mode",
    "symbols-href": "https://emojipedia.org/vibration-mode/",
    emoji: "📳",
    emojiName: "📳 Vibration Mode",
    description:
      "An icon representing vibration mode on a mobile phone, indicating that a phone should be switched to silent and/or vibrate mode.",
  },
  {
    "web-scraper-order": "1666026950-1529",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📶 Antenna Bars",
    "symbols-href": "https://emojipedia.org/antenna-bars/",
    emoji: "📶",
    emojiName: "📶 Antenna Bars",
    description:
      "Bars increasing in height, showing the strength of the mobile (cellular) phone signal. More bars signifies better reception.",
  },
  {
    "web-scraper-order": "1666026953-1531",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔆 Bright Button",
    "symbols-href": "https://emojipedia.org/bright-button/",
    emoji: "🔆",
    emojiName: "🔆 Bright Button",
    description:
      "An icon of a outlined sun, used when increasing the brightness of a screen. Appears larger than the Low Brightness Symbol.",
  },
  {
    "web-scraper-order": "1666026956-1533",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔅 Dim Button",
    "symbols-href": "https://emojipedia.org/dim-button/",
    emoji: "🔅",
    emojiName: "🔅 Dim Button",
    description:
      "An icon of a outlined sun, used when decreasing the brightness of a screen. Appears smaller than the High Brightness Symbol.",
  },
  {
    "web-scraper-order": "1666026959-1535",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎦 Cinema",
    "symbols-href": "https://emojipedia.org/cinema/",
    emoji: "🎦",
    emojiName: "🎦 Cinema",
    description:
      "An emoji representing the cinema: a large screen showing the latest movies, available to the public. Displayed by most platforms as a film projector symbol, and previously by Google and Microsoft as a cinema screen with curtains.",
  },
  {
    "web-scraper-order": "1666026963-1538",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏏️ Eject Button",
    "symbols-href": "https://emojipedia.org/eject-button/",
    emoji: "⏏️",
    emojiName: "⏏️ Eject Button",
    description:
      "An eject symbol, displayed as an upward-pointing triangle above a horiztonal bar. May be used as a physical button or an icon in a user interface. Represents the action of ejecting physical media such as a floppy disk, videocasette or DVD on a computer or media player.",
  },
  {
    "web-scraper-order": "1666026966-1540",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏺️ Record Button",
    "symbols-href": "https://emojipedia.org/record-button/",
    emoji: "⏺️",
    emojiName: "⏺️ Record Button",
    description: "A record icon, displayed as a circle.",
  },
  {
    "web-scraper-order": "1666026970-1542",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏹️ Stop Button",
    "symbols-href": "https://emojipedia.org/stop-button/",
    emoji: "⏹️",
    emojiName: "⏹️ Stop Button",
    description: "A stop icon, displayed as a square.",
  },
  {
    "web-scraper-order": "1666026972-1544",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏸️ Pause Button",
    "symbols-href": "https://emojipedia.org/pause-button/",
    emoji: "⏸️",
    emojiName: "⏸️ Pause Button",
    description: "A pause icon, displayed as two vertical bars.",
  },
  {
    "web-scraper-order": "1666026991-1547",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏬ Fast Down Button",
    "symbols-href": "https://emojipedia.org/fast-down-button/",
    emoji: "⏬",
    emojiName: "⏬ Fast Down Button",
    description:
      "Two triangles pointing down. Similar to rewind icon, rotated 90° counter-clockwise.",
  },
  {
    "web-scraper-order": "1666026994-1550",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔽 Downwards Button",
    "symbols-href": "https://emojipedia.org/downwards-button/",
    emoji: "🔽",
    emojiName: "🔽 Downwards Button",
    description:
      "A triangle-shaped arrow, pointing down. Styled similarly to the left and right pointing triangles and colored as either gray or blue, but shown in orange on Android.",
  },
  {
    "web-scraper-order": "1666026997-1553",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏫ Fast Up Button",
    "symbols-href": "https://emojipedia.org/fast-up-button/",
    emoji: "⏫",
    emojiName: "⏫ Fast Up Button",
    description:
      "Two triangles pointing up. Similar to rewind icon, rotated 90° clockwise.",
  },
  {
    "web-scraper-order": "1666026999-1556",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔼 Upwards Button",
    "symbols-href": "https://emojipedia.org/upwards-button/",
    emoji: "🔼",
    emojiName: "🔼 Upwards Button",
    description:
      "A triangle-shaped arrow, pointing up. Styled similarly to the left and right triangles and colored as either gray or blue, but shown in orange on Android.",
  },
  {
    "web-scraper-order": "1666027003-1559",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏮️ Last Track Button",
    "symbols-href": "https://emojipedia.org/last-track-button/",
    emoji: "⏮️",
    emojiName: "⏮️ Last Track Button",
    description:
      "A symbol used in media players to indicate skipping to the first or previous track (or scene). Shown as a vertical bar followed by two triangles pointing left.",
  },
  {
    "web-scraper-order": "1666027006-1562",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏪ Fast Reverse Button",
    "symbols-href": "https://emojipedia.org/fast-reverse-button/",
    emoji: "⏪",
    emojiName: "⏪ Fast Reverse Button",
    description:
      "Two triangles pointing to the left. Most commonly used as a symbol for rewinding media such as video tapes, CDs, or digital audio and video.",
  },
  {
    "web-scraper-order": "1666027009-1565",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "◀️ Reverse Button",
    "symbols-href": "https://emojipedia.org/reverse-button/",
    emoji: "◀️",
    emojiName: "◀️ Reverse Button",
    description: "A triangle-shaped arrow, pointing left.",
  },
  {
    "web-scraper-order": "1666027012-1569",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏯️ Play or Pause Button",
    "symbols-href": "https://emojipedia.org/play-or-pause-button/",
    emoji: "⏯️",
    emojiName: "⏯️ Play or Pause Button",
    description:
      "A play-pause icon, showing a right-pointing triangle (play) next to a double vertical bar (pause).",
  },
  {
    "web-scraper-order": "1666027015-1572",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏭️ Next Track Button",
    "symbols-href": "https://emojipedia.org/next-track-button/",
    emoji: "⏭️",
    emojiName: "⏭️ Next Track Button",
    description:
      "A symbol used in media players to indicate skipping to the next track (or scene). Shown as two triangles pointing right followed by a vertical bar.",
  },
  {
    "web-scraper-order": "1666027018-1575",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⏩ Fast-Forward Button",
    "symbols-href": "https://emojipedia.org/fast-forward-button/",
    emoji: "⏩",
    emojiName: "⏩ Fast-Forward Button",
    description:
      "Two triangles pointing to the right. Most commonly used as a symbol for fast forwarding media such as video tapes, CDs, or digital audio and video.",
  },
  {
    "web-scraper-order": "1666027021-1578",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "▶️ Play Button",
    "symbols-href": "https://emojipedia.org/play-button/",
    emoji: "▶️",
    emojiName: "▶️ Play Button",
    description:
      "A triangle-shaped arrow, pointing right. Commonly used as a symbol for play.",
  },
  {
    "web-scraper-order": "1666027024-1581",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔂 Repeat Single Button",
    "symbols-href": "https://emojipedia.org/repeat-single-button/",
    emoji: "🔂",
    emojiName: "🔂 Repeat Single Button",
    description:
      "Arrows pointing in a clockwise direction, with a number 1 badge in the lower corner.  Used in music player applications to loop a track or album once.",
  },
  {
    "web-scraper-order": "1666027026-1584",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔁 Repeat Button",
    "symbols-href": "https://emojipedia.org/repeat-button/",
    emoji: "🔁",
    emojiName: "🔁 Repeat Button",
    description:
      "Circular arrows pointing in a clockwise direction. Used in music player applications to loop a track or album continuously. Commonly used to repesent a retweet on Twitter.",
  },
  {
    "web-scraper-order": "1666027028-1587",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔀 Shuffle Tracks Button",
    "symbols-href": "https://emojipedia.org/shuffle-tracks-button/",
    emoji: "🔀",
    emojiName: "🔀 Shuffle Tracks Button",
    description:
      "Two arrows pointing right while crossing over one another. Used to indicate putting music on shuffle: randomizing the order of tracks in the upcoming playlist. May also be used to indicate two items switching places.",
  },
  {
    "web-scraper-order": "1666027031-1590",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⛎ Ophiuchus",
    "symbols-href": "https://emojipedia.org/ophiuchus/",
    emoji: "⛎",
    emojiName: "⛎ Ophiuchus",
    description:
      "Ophiuchus is used by some as a 13th sign in the Zodiac. The symbol for ophiuchus appears a U shape with a wavy line through it.",
  },
  {
    "web-scraper-order": "1666027034-1593",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♓ Pisces",
    "symbols-href": "https://emojipedia.org/pisces/",
    emoji: "♓",
    emojiName: "♓ Pisces",
    description:
      "The Pisces astrological sign in the Zodiac. This Zodiac Symbol represents a Fish.",
  },
  {
    "web-scraper-order": "1666027036-1596",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♒ Aquarius",
    "symbols-href": "https://emojipedia.org/aquarius/",
    emoji: "♒",
    emojiName: "♒ Aquarius",
    description:
      "The Aquarius astrological sign in the Zodiac. This Zodiac Symbol represents a Water-bearer.",
  },
  {
    "web-scraper-order": "1666027039-1599",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♑ Capricorn",
    "symbols-href": "https://emojipedia.org/capricorn/",
    emoji: "♑",
    emojiName: "♑ Capricorn",
    description:
      "The Capricorn astrological sign in the Zodiac. This Zodiac Symbol represents a Goat.",
  },
  {
    "web-scraper-order": "1666027042-1602",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♐ Sagittarius",
    "symbols-href": "https://emojipedia.org/sagittarius/",
    emoji: "♐",
    emojiName: "♐ Sagittarius",
    description:
      "The Sagittarius astrological sign in the Zodiac. This Zodiac Symbol represents an Archer.",
  },
  {
    "web-scraper-order": "1666027044-1605",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♏ Scorpio",
    "symbols-href": "https://emojipedia.org/scorpio/",
    emoji: "♏",
    emojiName: "♏ Scorpio",
    description:
      "The Scorpius astrological sign in the Zodiac. This Zodiac Symbol represents a Scorpion.",
  },
  {
    "web-scraper-order": "1666027047-1608",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♎ Libra",
    "symbols-href": "https://emojipedia.org/libra/",
    emoji: "♎",
    emojiName: "♎ Libra",
    description:
      "The Libra astrological sign in the Zodiac. This Zodiac Symbol represents weighing scales.",
  },
  {
    "web-scraper-order": "1666027049-1610",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♍ Virgo",
    "symbols-href": "https://emojipedia.org/virgo/",
    emoji: "♍",
    emojiName: "♍ Virgo",
    description:
      "The Virgo astrological sign in the Zodiac. This Zodiac Symbol represents a Maiden.",
  },
  {
    "web-scraper-order": "1666027051-1613",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♌ Leo",
    "symbols-href": "https://emojipedia.org/leo/",
    emoji: "♌",
    emojiName: "♌ Leo",
    description:
      "The Leo astrological sign in the Zodiac. This Zodiac Symbol represents a Lion.",
  },
  {
    "web-scraper-order": "1666027054-1616",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♋ Cancer",
    "symbols-href": "https://emojipedia.org/cancer/",
    emoji: "♋",
    emojiName: "♋ Cancer",
    description:
      "The Cancer astrological sign in the Zodiac. This Zodiac Symbol represents a Crab.",
  },
  {
    "web-scraper-order": "1666027057-1619",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♊ Gemini",
    "symbols-href": "https://emojipedia.org/gemini/",
    emoji: "♊",
    emojiName: "♊ Gemini",
    description:
      "The Gemini astrological sign in the Zodiac. This Zodiac Symbol represents Twins.",
  },
  {
    "web-scraper-order": "1666027059-1622",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♉ Taurus",
    "symbols-href": "https://emojipedia.org/taurus/",
    emoji: "♉",
    emojiName: "♉ Taurus",
    description:
      "The Taurus astrological sign in the Zodiac. This Zodiac Symbol represents a Bull.",
  },
  {
    "web-scraper-order": "1666027061-1625",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♈ Aries",
    "symbols-href": "https://emojipedia.org/aries/",
    emoji: "♈",
    emojiName: "♈ Aries",
    description:
      "The Aries astrological sign in the Zodiac. This Zodiac Symbol represents a Ram.",
  },
  {
    "web-scraper-order": "1666027064-1628",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔯 Dotted Six-Pointed Star",
    "symbols-href": "https://emojipedia.org/dotted-six-pointed-star/",
    emoji: "🔯",
    emojiName: "🔯 Dotted Six-Pointed Star",
    description:
      "A star with six points, and a dot in the center. Similar to the Star of David emoji.",
  },
  {
    "web-scraper-order": "1666027066-1631",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕎 Menorah",
    "symbols-href": "https://emojipedia.org/menorah/",
    emoji: "🕎",
    emojiName: "🕎 Menorah",
    description:
      "A menorah showing nine lit candles, used on the Jewish holiday of Hanukkah.",
  },
  {
    "web-scraper-order": "1666027068-1634",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☮️ Peace Symbol",
    "symbols-href": "https://emojipedia.org/peace-symbol/",
    emoji: "☮️",
    emojiName: "☮️ Peace Symbol",
    description:
      "A circular symbol, commonly used as a representation of peace. Alternatives include the Victory Hand, or the Dove of Peace.",
  },
  {
    "web-scraper-order": "1666027071-1637",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☪️ Star and Crescent",
    "symbols-href": "https://emojipedia.org/star-and-crescent/",
    emoji: "☪️",
    emojiName: "☪️ Star and Crescent",
    description:
      "The crescent moon and star is a symbol often associated with the religion of Islam. This symbol can be found on the flags of many countries, such as Algeria, Azerbaijan, Malaysia, Pakistan and Turkey.",
  },
  {
    "web-scraper-order": "1666027074-1640",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☦️ Orthodox Cross",
    "symbols-href": "https://emojipedia.org/orthodox-cross/",
    emoji: "☦️",
    emojiName: "☦️ Orthodox Cross",
    description:
      "Orthodox Cross was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027076-1643",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✝️ Latin Cross",
    "symbols-href": "https://emojipedia.org/latin-cross/",
    emoji: "✝️",
    emojiName: "✝️ Latin Cross",
    description:
      "A latin cross, otherwise known as a Christian cross. This cross symbol is often used as a symbol of Christianity. Similar in appearance to the Orthodox cross.",
  },
  {
    "web-scraper-order": "1666027078-1646",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☯️ Yin Yang",
    "symbols-href": "https://emojipedia.org/yin-yang/",
    emoji: "☯️",
    emojiName: "☯️ Yin Yang",
    description:
      "Yin Yang was approved as part of Unicode 1.1 in 1993 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027081-1649",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☸️ Wheel of Dharma",
    "symbols-href": "https://emojipedia.org/wheel-of-dharma/",
    emoji: "☸️",
    emojiName: "☸️ Wheel of Dharma",
    description:
      "A symbol often used in relation to the Indian religions of Hinduism, Buddhism, Sikhism and Jainism.",
  },
  {
    "web-scraper-order": "1666027083-1652",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "✡️ Star of David",
    "symbols-href": "https://emojipedia.org/star-of-david/",
    emoji: "✡️",
    emojiName: "✡️ Star of David",
    description:
      "A symbol often used in relation to the religion of Judaism. Not to be confused with the Six Pointed Star With Middle Dot emoji.",
  },
  {
    "web-scraper-order": "1666027085-1655",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕉️ Om",
    "symbols-href": "https://emojipedia.org/om/",
    emoji: "🕉️",
    emojiName: "🕉️ Om",
    description:
      "A symbol often used in relation to the religions of Hinduism, Buddhism, Sikhism and Jainism.",
  },
  {
    "web-scraper-order": "1666027089-1657",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚛️ Atom Symbol",
    "symbols-href": "https://emojipedia.org/atom-symbol/",
    emoji: "⚛️",
    emojiName: "⚛️ Atom Symbol",
    description:
      "Atom Symbol was approved as part of Unicode 4.1 in 2005 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027091-1660",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛐 Place of Worship",
    "symbols-href": "https://emojipedia.org/place-of-worship/",
    emoji: "🛐",
    emojiName: "🛐 Place of Worship",
    description:
      "A building used for worship by people of any faith or religion. Examples include a church, mosque, or synagogue. A person is shown on their knees praying, in this symbol.",
  },
  {
    "web-scraper-order": "1666027094-1662",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔝 Top Arrow",
    "symbols-href": "https://emojipedia.org/top-arrow/",
    emoji: "🔝",
    emojiName: "🔝 Top Arrow",
    description: 'The word "top" with an arrow pointing up above it.',
  },
  {
    "web-scraper-order": "1666027096-1665",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔜 Soon Arrow",
    "symbols-href": "https://emojipedia.org/soon-arrow/",
    emoji: "🔜",
    emojiName: "🔜 Soon Arrow",
    description:
      'The word "soon" with an arrow above it, pointing to the right.',
  },
  {
    "web-scraper-order": "1666027099-1669",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔛 On! Arrow",
    "symbols-href": "https://emojipedia.org/on-arrow/",
    emoji: "🔛",
    emojiName: "🔛 On! Arrow",
    description:
      "On! Arrow was approved as part of Unicode 6.0 in 2010 under the name “On with Exclamation Mark with Left Right Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027101-1671",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔚 End Arrow",
    "symbols-href": "https://emojipedia.org/end-arrow/",
    emoji: "🔚",
    emojiName: "🔚 End Arrow",
    description:
      "End Arrow was approved as part of Unicode 6.0 in 2010 under the name “End with Leftwards Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027104-1674",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔙 Back Arrow",
    "symbols-href": "https://emojipedia.org/back-arrow/",
    emoji: "🔙",
    emojiName: "🔙 Back Arrow",
    description:
      "Back Arrow was approved as part of Unicode 6.0 in 2010 under the name “Back with Leftwards Arrow Above” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027106-1677",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔄 Counterclockwise Arrows Button",
    "symbols-href": "https://emojipedia.org/counterclockwise-arrows-button/",
    emoji: "🔄",
    emojiName: "🔄 Counterclockwise Arrows Button",
    description:
      "Two arrows forming a circle, pointing in an anticlockwise direction. Similar to symbols sometimes used for refresh or rotate. May also be used to indicate a task is in progress.",
  },
  {
    "web-scraper-order": "1666027109-1681",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔃 Clockwise Vertical Arrows",
    "symbols-href": "https://emojipedia.org/clockwise-vertical-arrows/",
    emoji: "🔃",
    emojiName: "🔃 Clockwise Vertical Arrows",
    description:
      "Clockwise Vertical Arrows was approved as part of Unicode 6.0 in 2010 under the name “Clockwise Downwards and Upwards Open Circle Arrows” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027111-1683",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⤵️ Right Arrow Curving Down",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-down/",
    emoji: "⤵️",
    emojiName: "⤵️ Right Arrow Curving Down",
    description: "A curved arrow pointing down.",
  },
  {
    "web-scraper-order": "1666027115-1686",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⤴️ Right Arrow Curving Up",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-up/",
    emoji: "⤴️",
    emojiName: "⤴️ Right Arrow Curving Up",
    description: "A curved arrow pointing up.",
  },
  {
    "web-scraper-order": "1666027118-1690",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↪️ Left Arrow Curving Right",
    "symbols-href": "https://emojipedia.org/left-arrow-curving-right/",
    emoji: "↪️",
    emojiName: "↪️ Left Arrow Curving Right",
    description:
      "An arrow pointing to the right, with a curved hook at the other end. Similar in appearance to a sideways U Turn symbol, or a forward icon in an email application.",
  },
  {
    "web-scraper-order": "1666027121-1693",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↩️ Right Arrow Curving Left",
    "symbols-href": "https://emojipedia.org/right-arrow-curving-left/",
    emoji: "↩️",
    emojiName: "↩️ Right Arrow Curving Left",
    description:
      "An arrow pointing to the left, with a curved hook at the other end. Similar in appearance to a sideways U Turn symbol, or a reply icon in an email application.",
  },
  {
    "web-scraper-order": "1666027123-1696",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↔️ Left-Right Arrow",
    "symbols-href": "https://emojipedia.org/left-right-arrow/",
    emoji: "↔️",
    emojiName: "↔️ Left-Right Arrow",
    description:
      "A horizontal line with arrowheads on both ends, pointing left and right.",
  },
  {
    "web-scraper-order": "1666027126-1699",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↕️ Up-Down Arrow",
    "symbols-href": "https://emojipedia.org/up-down-arrow/",
    emoji: "↕️",
    emojiName: "↕️ Up-Down Arrow",
    description:
      "A vertical line with arrowheads on both ends, pointing up and down.",
  },
  {
    "web-scraper-order": "1666027129-1701",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↖️ Up-Left Arrow",
    "symbols-href": "https://emojipedia.org/up-left-arrow/",
    emoji: "↖️",
    emojiName: "↖️ Up-Left Arrow",
    description:
      "An arrow pointing diagonally in an up-left, or north-west direction.",
  },
  {
    "web-scraper-order": "1666027131-1704",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬅️ Left Arrow",
    "symbols-href": "https://emojipedia.org/left-arrow/",
    emoji: "⬅️",
    emojiName: "⬅️ Left Arrow",
    description: "An arrow, pointing left.",
  },
  {
    "web-scraper-order": "1666027134-1706",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↙️ Down-Left Arrow",
    "symbols-href": "https://emojipedia.org/down-left-arrow/",
    emoji: "↙️",
    emojiName: "↙️ Down-Left Arrow",
    description:
      "An arrow pointing diagonally in an down-left, or south-west direction.",
  },
  {
    "web-scraper-order": "1666027136-1709",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬇️ Down Arrow",
    "symbols-href": "https://emojipedia.org/down-arrow/",
    emoji: "⬇️",
    emojiName: "⬇️ Down Arrow",
    description: "An arrow, pointing down.",
  },
  {
    "web-scraper-order": "1666027140-1712",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↘️ Down-Right Arrow",
    "symbols-href": "https://emojipedia.org/down-right-arrow/",
    emoji: "↘️",
    emojiName: "↘️ Down-Right Arrow",
    description:
      "An arrow pointing diagonally in an down-right, or south-east direction.",
  },
  {
    "web-scraper-order": "1666027142-1715",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "➡️ Right Arrow",
    "symbols-href": "https://emojipedia.org/right-arrow/",
    emoji: "➡️",
    emojiName: "➡️ Right Arrow",
    description: "An arrow, pointing right.",
  },
  {
    "web-scraper-order": "1666027145-1717",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "↗️ Up-Right Arrow",
    "symbols-href": "https://emojipedia.org/up-right-arrow/",
    emoji: "↗️",
    emojiName: "↗️ Up-Right Arrow",
    description:
      "An arrow pointing diagonally in an up-right, or north-east direction.",
  },
  {
    "web-scraper-order": "1666027147-1720",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⬆️ Up Arrow",
    "symbols-href": "https://emojipedia.org/up-arrow/",
    emoji: "⬆️",
    emojiName: "⬆️ Up Arrow",
    description: "An arrow, pointing up.",
  },
  {
    "web-scraper-order": "1666027150-1722",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☣️ Biohazard",
    "symbols-href": "https://emojipedia.org/biohazard/",
    emoji: "☣️",
    emojiName: "☣️ Biohazard",
    description:
      "Biohazard was approved as part of Unicode 1.1 in 1993 under the name “Biohazard Sign” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027152-1725",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "☢️ Radioactive",
    "symbols-href": "https://emojipedia.org/radioactive/",
    emoji: "☢️",
    emojiName: "☢️ Radioactive",
    description:
      "A hazard symbol for radiation or radioactivity. May appear similar to a three-pronged fan at small sizes.",
  },
  {
    "web-scraper-order": "1666027155-1727",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔞 No One Under Eighteen",
    "symbols-href": "https://emojipedia.org/no-one-under-eighteen/",
    emoji: "🔞",
    emojiName: "🔞 No One Under Eighteen",
    description:
      "The number eighteen with a red stroke through it, indicating a location where a person must be aged 18 or above to enter. Often used online to indicate adult or NSFW content.",
  },
  {
    "web-scraper-order": "1666027157-1730",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📵 No Mobile Phones",
    "symbols-href": "https://emojipedia.org/no-mobile-phones/",
    emoji: "📵",
    emojiName: "📵 No Mobile Phones",
    description:
      "A mobile phone with a red stroke through it, indicating that mobile phones should not be present. Often seen in restricted areas, such as Customs or Passport Control.",
  },
  {
    "web-scraper-order": "1666027159-1731",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚷 No Pedestrians",
    "symbols-href": "https://emojipedia.org/no-pedestrians/",
    emoji: "🚷",
    emojiName: "🚷 No Pedestrians",
    description:
      "A pedestrian symbol with a red stroke through it, indicating that pedestrians are prohibited from this location.",
  },
  {
    "web-scraper-order": "1666027163-1735",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚱 Non-Potable Water",
    "symbols-href": "https://emojipedia.org/non-potable-water/",
    emoji: "🚱",
    emojiName: "🚱 Non-Potable Water",
    description:
      "A water tap with a red stroke through it, indicating that water is not safe for drinking (non-potable).",
  },
  {
    "web-scraper-order": "1666027166-1737",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚯 No Littering",
    "symbols-href": "https://emojipedia.org/no-littering/",
    emoji: "🚯",
    emojiName: "🚯 No Littering",
    description:
      "A person dropping litter (rubbish, trash) with a red stroke through it, indicating that littering is prohibited in this area.",
  },
  {
    "web-scraper-order": "1666027168-1740",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚭 No Smoking",
    "symbols-href": "https://emojipedia.org/no-smoking/",
    emoji: "🚭",
    emojiName: "🚭 No Smoking",
    description:
      "No Smoking was approved as part of Unicode 6.0 in 2010 under the name “No Smoking Symbol” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027171-1742",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚳 No Bicycles",
    "symbols-href": "https://emojipedia.org/no-bicycles/",
    emoji: "🚳",
    emojiName: "🚳 No Bicycles",
    description:
      "A bicycle with a red stroke through it, indicating that bikes are prohibited from this location.",
  },
  {
    "web-scraper-order": "1666027173-1744",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚫 Prohibited",
    "symbols-href": "https://emojipedia.org/prohibited/",
    emoji: "🚫",
    emojiName: "🚫 Prohibited",
    description:
      "A red circle with a diagonal line through the middle, from top-left to bottom right, used to indicate that something is not permitted",
  },
  {
    "web-scraper-order": "1666027176-1746",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⛔ No Entry",
    "symbols-href": "https://emojipedia.org/no-entry/",
    emoji: "⛔",
    emojiName: "⛔ No Entry",
    description:
      "No Entry was approved as part of Unicode 5.2 in 2009 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027181-1749",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚸 Children Crossing",
    "symbols-href": "https://emojipedia.org/children-crossing/",
    emoji: "🚸",
    emojiName: "🚸 Children Crossing",
    description:
      "A crossing sign for children, usually positioned near schools or other areas that drivers should be cautious of young children in the area.",
  },
  {
    "web-scraper-order": "1666027183-1750",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "⚠️ Warning",
    "symbols-href": "https://emojipedia.org/warning/",
    emoji: "⚠️",
    emojiName: "⚠️ Warning",
    description:
      "A triangle with an exclamation mark inside, used as a warning or alert.",
  },
  {
    "web-scraper-order": "1666027187-1753",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚾 Water Closet",
    "symbols-href": "https://emojipedia.org/water-closet/",
    emoji: "🚾",
    emojiName: "🚾 Water Closet",
    description:
      "A water closet is a name used for public toilet, bathroom or restroom used in some countries. Typically abbreviated to the letters WC, this may be found on signage in public buildings, as an alternative to the restroom symbol.",
  },
  {
    "web-scraper-order": "1666027190-1755",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚼 Baby Symbol",
    "symbols-href": "https://emojipedia.org/baby-symbol/",
    emoji: "🚼",
    emojiName: "🚼 Baby Symbol",
    description:
      "The symbol for a baby, usually used to indicate a room that is suitable to change a baby in. Often located in or near public restrooms.",
  },
  {
    "web-scraper-order": "1666027192-1759",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚻 Restroom",
    "symbols-href": "https://emojipedia.org/restroom/",
    emoji: "🚻",
    emojiName: "🚻 Restroom",
    description:
      "A restroom symbol, depicting a iconography of a man and woman. Used to indicate the location of public bathrooms / toilets / restrooms.",
  },
  {
    "web-scraper-order": "1666027196-1761",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚺 Women’s Room",
    "symbols-href": "https://emojipedia.org/womens-room/",
    emoji: "🚺",
    emojiName: "🚺 Women’s Room",
    description:
      "A stick-figure icon of a woman, generally used to indicate a female restroom. The male equivalent is the Mens Symbol emoji.",
  },
  {
    "web-scraper-order": "1666027200-1763",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚹 Men’s Room",
    "symbols-href": "https://emojipedia.org/mens-room/",
    emoji: "🚹",
    emojiName: "🚹 Men’s Room",
    description:
      "A stick-figure icon of a man, generally used to indicate a male restroom. The female equivalent is the Womens Symbol emoji.",
  },
  {
    "web-scraper-order": "1666027202-1764",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♿ Wheelchair Symbol",
    "symbols-href": "https://emojipedia.org/wheelchair-symbol/",
    emoji: "♿",
    emojiName: "♿ Wheelchair Symbol",
    description:
      "The international symbol of access, used to denote a facility which has been designed with accessibility or people in wheelchairs in mind. Appears as a blue sign, with a white graphic of a person sitting in a wheelchair.",
  },
  {
    "web-scraper-order": "1666027206-1767",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚰 Potable Water",
    "symbols-href": "https://emojipedia.org/potable-water/",
    emoji: "🚰",
    emojiName: "🚰 Potable Water",
    description:
      "A symbol for potable (drinkable) water, usually shown with a faucet filling a drinking glass. Commonly used for various content concerning water, drinking, thirst, and dripping.",
  },
  {
    "web-scraper-order": "1666027209-1769",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🚮 Litter in Bin Sign",
    "symbols-href": "https://emojipedia.org/litter-in-bin-sign/",
    emoji: "🚮",
    emojiName: "🚮 Litter in Bin Sign",
    description:
      "A symbol showing a person putting litter (rubbish) in the trash (rubbish bin). A more positive version of the Do Not Litter Symbol.",
  },
  {
    "web-scraper-order": "1666027212-1771",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🏧 ATM Sign",
    "symbols-href": "https://emojipedia.org/atm-sign/",
    emoji: "🏧",
    emojiName: "🏧 ATM Sign",
    description:
      "ATM Sign was approved as part of Unicode 6.0 in 2010 under the name “Automated Teller Machine” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027214-1774",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛗 Elevator",
    "symbols-href": "https://emojipedia.org/elevator/",
    emoji: "🛗",
    emojiName: "🛗 Elevator",
    description:
      "A symbol showing two or three people standing in a square with up and down arrows above them. Most platforms feature a simple blue and white design.",
  },
  {
    "web-scraper-order": "1666027217-1776",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💹 Chart Increasing with Yen",
    "symbols-href": "https://emojipedia.org/chart-increasing-with-yen/",
    emoji: "💹",
    emojiName: "💹 Chart Increasing with Yen",
    description: "A graph showing the value of the Japanese Yen rising.",
  },
  {
    "web-scraper-order": "1666027221-1780",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎶 Musical Notes",
    "symbols-href": "https://emojipedia.org/musical-notes/",
    emoji: "🎶",
    emojiName: "🎶 Musical Notes",
    description:
      "Three eighth notes (quavers in British English), used to represent music or singing. Sometimes inserted next to quoted lyrics, to make it clear that they are part of a song.",
  },
  {
    "web-scraper-order": "1666027223-1781",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎵 Musical Note",
    "symbols-href": "https://emojipedia.org/musical-note/",
    emoji: "🎵",
    emojiName: "🎵 Musical Note",
    description:
      "A music note emoji, which can denote song lyrics, or other music related topics.",
  },
  {
    "web-scraper-order": "1666027226-1785",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔕 Bell with Slash",
    "symbols-href": "https://emojipedia.org/bell-with-slash/",
    emoji: "🔕",
    emojiName: "🔕 Bell with Slash",
    description:
      "A gold or yellow bell with a red line through it, which is commonly used on mobile phones as an icon for the silencing of notifications or ringing sounds. A mute, or silent mode.",
  },
  {
    "web-scraper-order": "1666027229-1787",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔔 Bell",
    "symbols-href": "https://emojipedia.org/bell/",
    emoji: "🔔",
    emojiName: "🔔 Bell",
    description:
      "A gold or yellow bell, which is commonly used on mobile phones as an icon for notifications or ringing sounds.",
  },
  {
    "web-scraper-order": "1666027231-1789",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📯 Postal Horn",
    "symbols-href": "https://emojipedia.org/postal-horn/",
    emoji: "📯",
    emojiName: "📯 Postal Horn",
    description:
      "A postal horn (post horn). Depicted as a coiled, valveless, brass horn, like a bugle or trumpet, with two red tassels. Sometimes used to mark announcements as well as for various content concerning brass instruments, music, or mail.",
  },
  {
    "web-scraper-order": "1666027233-1791",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📣 Megaphone",
    "symbols-href": "https://emojipedia.org/megaphone/",
    emoji: "📣",
    emojiName: "📣 Megaphone",
    description:
      "Megaphone was approved as part of Unicode 6.0 in 2010 under the name “Cheering Megaphone” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027236-1793",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "📢 Loudspeaker",
    "symbols-href": "https://emojipedia.org/loudspeaker/",
    emoji: "📢",
    emojiName: "📢 Loudspeaker",
    description:
      "A loudspeaker used to make announcements in public areas such as schools, or sporting grounds.",
  },
  {
    "web-scraper-order": "1666027238-1796",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔊 Speaker High Volume",
    "symbols-href": "https://emojipedia.org/speaker-high-volume/",
    emoji: "🔊",
    emojiName: "🔊 Speaker High Volume",
    description:
      "A speaker cone displayed with three sound waves, generally used as an icon to indicate the increasing of volume on a phone or computer.",
  },
  {
    "web-scraper-order": "1666027241-1798",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔉 Speaker Medium Volume",
    "symbols-href": "https://emojipedia.org/speaker-medium-volume/",
    emoji: "🔉",
    emojiName: "🔉 Speaker Medium Volume",
    description:
      "A speaker cone displayed with one sound wave, generally used as an icon to indicate the decreasing of volume on a phone or computer.",
  },
  {
    "web-scraper-order": "1666027244-1800",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔈 Speaker Low Volume",
    "symbols-href": "https://emojipedia.org/speaker-low-volume/",
    emoji: "🔈",
    emojiName: "🔈 Speaker Low Volume",
    description: "A speaker cone displayed without any sound waves.",
  },
  {
    "web-scraper-order": "1666027246-1803",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🔇 Muted Speaker",
    "symbols-href": "https://emojipedia.org/muted-speaker/",
    emoji: "🔇",
    emojiName: "🔇 Muted Speaker",
    description:
      "A speaker with a red line through it, indicating muted volume or silencing of audio.",
  },
  {
    "web-scraper-order": "1666027249-1806",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🎴 Flower Playing Cards",
    "symbols-href": "https://emojipedia.org/flower-playing-cards/",
    emoji: "🎴",
    emojiName: "🎴 Flower Playing Cards",
    description:
      "A type of cards known as hanafuda cards in Japan which are used for a range of different games that require associating pictures (there are no numbers on the cards).",
  },
  {
    "web-scraper-order": "1666027252-1809",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🀄 Mahjong Red Dragon",
    "symbols-href": "https://emojipedia.org/mahjong-red-dragon/",
    emoji: "🀄",
    emojiName: "🀄 Mahjong Red Dragon",
    description:
      "The red dragon tile in the game of Japanese Mahjong. White, with red 中 character printed on it.",
  },
  {
    "web-scraper-order": "1666027255-1810",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🃏 Joker",
    "symbols-href": "https://emojipedia.org/joker/",
    emoji: "🃏",
    emojiName: "🃏 Joker",
    description:
      "The joker in a deck of cards, usually appearing like a court jester.",
  },
  {
    "web-scraper-order": "1666027257-1813",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♣️ Club Suit",
    "symbols-href": "https://emojipedia.org/club-suit/",
    emoji: "♣️",
    emojiName: "♣️ Club Suit",
    description:
      "A club symbol emoji, which is used in card games for the clubs suit.",
  },
  {
    "web-scraper-order": "1666027260-1816",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♦️ Diamond Suit",
    "symbols-href": "https://emojipedia.org/diamond-suit/",
    emoji: "♦️",
    emojiName: "♦️ Diamond Suit",
    description:
      "A diamond symbol emoji, which is used in card games for the diamonds suit.",
  },
  {
    "web-scraper-order": "1666027262-1818",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♥️ Heart Suit",
    "symbols-href": "https://emojipedia.org/heart-suit/",
    emoji: "♥️",
    emojiName: "♥️ Heart Suit",
    description:
      "A heart symbol emoji, used in card games for the hearts suit. In emoji form, this is most commonly used for love, affectiction, romance and positive intentions. Sometimes shown in a slightly darker shade of red than ❤️ Red Heart.",
  },
  {
    "web-scraper-order": "1666027265-1821",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♠️ Spade Suit",
    "symbols-href": "https://emojipedia.org/spade-suit/",
    emoji: "♠️",
    emojiName: "♠️ Spade Suit",
    description:
      "A spade symbol emoji, which is used in card games for the spades suit.",
  },
  {
    "web-scraper-order": "1666027270-1824",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🌀 Cyclone",
    "symbols-href": "https://emojipedia.org/cyclone/",
    emoji: "🌀",
    emojiName: "🌀 Cyclone",
    description:
      "An icon used to represent a cyclone. Some versions of this emoji show a spiral shape, which may be used for decorative purposes.",
  },
  {
    "web-scraper-order": "1666027275-1827",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕦 Eleven-Thirty",
    "symbols-href": "https://emojipedia.org/eleven-thirty/",
    emoji: "🕦",
    emojiName: "🕦 Eleven-Thirty",
    description:
      "Eleven-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eleven-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027280-1831",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕚 Eleven O’Clock",
    "symbols-href": "https://emojipedia.org/eleven-oclock/",
    emoji: "🕚",
    emojiName: "🕚 Eleven O’Clock",
    description:
      "Eleven O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eleven O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027284-1833",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕥 Ten-Thirty",
    "symbols-href": "https://emojipedia.org/ten-thirty/",
    emoji: "🕥",
    emojiName: "🕥 Ten-Thirty",
    description:
      "Ten-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Ten-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027288-1837",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕙 Ten O’Clock",
    "symbols-href": "https://emojipedia.org/ten-oclock/",
    emoji: "🕙",
    emojiName: "🕙 Ten O’Clock",
    description:
      "Ten O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Ten O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027293-1841",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕤 Nine-Thirty",
    "symbols-href": "https://emojipedia.org/nine-thirty/",
    emoji: "🕤",
    emojiName: "🕤 Nine-Thirty",
    description:
      "Nine-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Nine-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027298-1845",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕘 Nine O’Clock",
    "symbols-href": "https://emojipedia.org/nine-oclock/",
    emoji: "🕘",
    emojiName: "🕘 Nine O’Clock",
    description:
      "Nine O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Nine O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027303-1849",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕣 Eight-Thirty",
    "symbols-href": "https://emojipedia.org/eight-thirty/",
    emoji: "🕣",
    emojiName: "🕣 Eight-Thirty",
    description:
      "Eight-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eight-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027310-1852",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕗 Eight O’Clock",
    "symbols-href": "https://emojipedia.org/eight-oclock/",
    emoji: "🕗",
    emojiName: "🕗 Eight O’Clock",
    description:
      "Eight O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Eight O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027315-1856",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕢 Seven-Thirty",
    "symbols-href": "https://emojipedia.org/seven-thirty/",
    emoji: "🕢",
    emojiName: "🕢 Seven-Thirty",
    description:
      "Seven-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Seven-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027319-1860",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕖 Seven O’Clock",
    "symbols-href": "https://emojipedia.org/seven-oclock/",
    emoji: "🕖",
    emojiName: "🕖 Seven O’Clock",
    description:
      "Seven O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Seven O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027323-1864",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕡 Six-Thirty",
    "symbols-href": "https://emojipedia.org/six-thirty/",
    emoji: "🕡",
    emojiName: "🕡 Six-Thirty",
    description:
      "Six-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Six-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027328-1867",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕕 Six O’Clock",
    "symbols-href": "https://emojipedia.org/six-oclock/",
    emoji: "🕕",
    emojiName: "🕕 Six O’Clock",
    description:
      "Six O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Six O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027332-1871",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕠 Five-Thirty",
    "symbols-href": "https://emojipedia.org/five-thirty/",
    emoji: "🕠",
    emojiName: "🕠 Five-Thirty",
    description:
      "Five-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Five-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027337-1876",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕔 Five O’Clock",
    "symbols-href": "https://emojipedia.org/five-oclock/",
    emoji: "🕔",
    emojiName: "🕔 Five O’Clock",
    description:
      "Five O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Five O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027341-1878",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕟 Four-Thirty",
    "symbols-href": "https://emojipedia.org/four-thirty/",
    emoji: "🕟",
    emojiName: "🕟 Four-Thirty",
    description:
      "Four-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Four-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027347-1883",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕓 Four O’Clock",
    "symbols-href": "https://emojipedia.org/four-oclock/",
    emoji: "🕓",
    emojiName: "🕓 Four O’Clock",
    description:
      "Four O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Four O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027352-1887",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕞 Three-Thirty",
    "symbols-href": "https://emojipedia.org/three-thirty/",
    emoji: "🕞",
    emojiName: "🕞 Three-Thirty",
    description:
      "Three-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Three-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027356-1890",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕒 Three O’Clock",
    "symbols-href": "https://emojipedia.org/three-oclock/",
    emoji: "🕒",
    emojiName: "🕒 Three O’Clock",
    description:
      "Three O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Three O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027360-1894",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕝 Two-Thirty",
    "symbols-href": "https://emojipedia.org/two-thirty/",
    emoji: "🕝",
    emojiName: "🕝 Two-Thirty",
    description:
      "Two-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Two-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027363-1897",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕑 Two O’Clock",
    "symbols-href": "https://emojipedia.org/two-oclocktime/",
    emoji: "🕑",
    emojiName: "🕑 Two O’Clock",
    description:
      "Two O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Two O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027368-1901",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕜 One-Thirty",
    "symbols-href": "https://emojipedia.org/one-thirty/",
    emoji: "🕜",
    emojiName: "🕜 One-Thirty",
    description:
      "One-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face One-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027372-1904",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕐 One O’Clock",
    "symbols-href": "https://emojipedia.org/one-oclock/",
    emoji: "🕐",
    emojiName: "🕐 One O’Clock",
    description:
      "One O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face One O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027377-1908",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕧 Twelve-Thirty",
    "symbols-href": "https://emojipedia.org/twelve-thirty/",
    emoji: "🕧",
    emojiName: "🕧 Twelve-Thirty",
    description:
      "Twelve-Thirty was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Twelve-Thirty” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027381-1912",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🕛 Twelve O’Clock",
    "symbols-href": "https://emojipedia.org/twelve-oclock/",
    emoji: "🕛",
    emojiName: "🕛 Twelve O’Clock",
    description:
      "Twelve O’Clock was approved as part of Unicode 6.0 in 2010 under the name “Clock Face Twelve O’Clock” and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666027383-1914",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🛑 Stop Sign",
    "symbols-href": "https://emojipedia.org/stop-sign/",
    emoji: "🛑",
    emojiName: "🛑 Stop Sign",
    description:
      "A red, octagonal sign. Used in many countries as a stop sign.",
  },
  {
    "web-scraper-order": "1666027386-1917",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💈 Barber Pole",
    "symbols-href": "https://emojipedia.org/barber-pole/",
    emoji: "💈",
    emojiName: "💈 Barber Pole",
    description:
      "A pole spiraled with red, white, and blue stripes, as spins out front of a barbershop. Commonly used for various content concerning haircutting and hairstyling.",
  },
  {
    "web-scraper-order": "1666027389-1920",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "♨️ Hot Springs",
    "symbols-href": "https://emojipedia.org/hot-springs/",
    emoji: "♨️",
    emojiName: "♨️ Hot Springs",
    description:
      "Representation of hot springs with steam rising from a circular tub. This is the common symbol used to represent an onsen on maps in Japan.",
  },
  {
    "web-scraper-order": "1666027391-1923",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💮 White Flower",
    "symbols-href": "https://emojipedia.org/white-flower/",
    emoji: "💮",
    emojiName: "💮 White Flower",
    description:
      "A stylized white flower. Generally depicted as a rosette-shaped cherry blossom in pink or red outline, often with a white fill.",
  },
  {
    "web-scraper-order": "1666027393-1925",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💤 Zzz",
    "symbols-href": "https://emojipedia.org/zzz/",
    emoji: "💤",
    emojiName: "💤 Zzz",
    description:
      "A series of three Zs making a Zzz. Represents sleeping, snoring, dreaming, or any sleep-related state. Can also be used in some contexts to represent something that is boring.",
  },
  {
    "web-scraper-order": "1666027396-1928",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💭 Thought Balloon",
    "symbols-href": "https://emojipedia.org/thought-balloon/",
    emoji: "💭",
    emojiName: "💭 Thought Balloon",
    description:
      "A large cloud-like shape more commonly known as a thought bubble.",
  },
  {
    "web-scraper-order": "1666027398-1930",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🗯️ Right Anger Bubble",
    "symbols-href": "https://emojipedia.org/right-anger-bubble/",
    emoji: "🗯️",
    emojiName: "🗯️ Right Anger Bubble",
    description:
      "A form of speech balloon used with angular edges, used to denote angry speech in comics.",
  },
  {
    "web-scraper-order": "1666027401-1934",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🗨️ Left Speech Bubble",
    "symbols-href": "https://emojipedia.org/left-speech-bubble/",
    emoji: "🗨️",
    emojiName: "🗨️ Left Speech Bubble",
    description:
      "A left-facing speech bubble, which was included in Unicode 7.0, but not considered a standard addition for the purposes of emoji presentation.",
  },
  {
    "web-scraper-order": "1666027404-1937",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "👁️‍🗨️ Eye in Speech Bubble",
    "symbols-href": "https://emojipedia.org/eye-in-speech-bubble/",
    emoji: "👁️‍🗨️",
    emojiName: "👁️‍🗨️ Eye in Speech Bubble",
    description:
      'A speech bubble showing an eye inside. When using text-to-speech on Apple platforms, this emoji is read aloud as: "Eye in speech bubble representing anti-bullying campaign". This emoji was released in conjunction with the Ad Council for the I Am A Witness campaign.',
  },
  {
    "web-scraper-order": "1666027406-1939",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💬 Speech Balloon",
    "symbols-href": "https://emojipedia.org/speech-balloon/",
    emoji: "💬",
    emojiName: "💬 Speech Balloon",
    description:
      "A cartoon-style balloon used to represent spoken word in comics. Sometimes  used in communication apps to indicate that another person is typing a message.",
  },
  {
    "web-scraper-order": "1666027409-1941",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💢 Anger Symbol",
    "symbols-href": "https://emojipedia.org/anger-symbol/",
    emoji: "💢",
    emojiName: "💢 Anger Symbol",
    description:
      "A red symbol found in Anime/Manga and used to represent the veins popping on a very angry person.",
  },
  {
    "web-scraper-order": "1666027412-1945",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💯 Hundred Points",
    "symbols-href": "https://emojipedia.org/hundred-points/",
    emoji: "💯",
    emojiName: "💯 Hundred Points",
    description:
      "100 emoji: the number one-hundred, written in red, underlined twice for emphasis.",
  },
  {
    "web-scraper-order": "1666027416-1948",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🤍 White Heart",
    "symbols-href": "https://emojipedia.org/white-heart/",
    emoji: "🤍",
    emojiName: "🤍 White Heart",
    description:
      "A white heart emoji, used for love and affection. Also commonly used to discuss someone passing away.",
  },
  {
    "web-scraper-order": "1666027419-1951",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🖤 Black Heart",
    "symbols-href": "https://emojipedia.org/black-heart/",
    emoji: "🖤",
    emojiName: "🖤 Black Heart",
    description:
      "A heart shaded completely black. May be used to express morbidity, sorrow, or a form of dark humor, but despite the color remains most commonly used for love and affection.",
  },
  {
    "web-scraper-order": "1666027424-1955",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🤎 Brown Heart",
    "symbols-href": "https://emojipedia.org/brown-heart/",
    emoji: "🤎",
    emojiName: "🤎 Brown Heart",
    description:
      "A brown heart, often used discuss topics related to racial identity 🧑🏽🧑🏾🧑🏿",
  },
  {
    "web-scraper-order": "1666027428-1958",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💜 Purple Heart",
    "symbols-href": "https://emojipedia.org/purple-heart/",
    emoji: "💜",
    emojiName: "💜 Purple Heart",
    description:
      "A purple heart emoji, often used alongside other colored hearts. Frequently used on Twitter in reference to Korean boy band Bangtan Sonyeondan, more commonly known as BTS.",
  },
  {
    "web-scraper-order": "1666027432-1963",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💙 Blue Heart",
    "symbols-href": "https://emojipedia.org/blue-heart/",
    emoji: "💙",
    emojiName: "💙 Blue Heart",
    description:
      "A blue heart emoji, commonly used by brands as a neutral heart color.",
  },
  {
    "web-scraper-order": "1666027436-1966",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💚 Green Heart",
    "symbols-href": "https://emojipedia.org/green-heart/",
    emoji: "💚",
    emojiName: "💚 Green Heart",
    description:
      "A green heart emoji, often used alongside other colored hearts. Frequently used on Twitter in reference to Korean boy band NCT.",
  },
  {
    "web-scraper-order": "1666027440-1970",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💛 Yellow Heart",
    "symbols-href": "https://emojipedia.org/yellow-heart/",
    emoji: "💛",
    emojiName: "💛 Yellow Heart",
    description:
      "A yellow or gold colored love-heart, frequently used alongside other colored hearts. This displayed as a pink hairy heart on Android 4.4.",
  },
  {
    "web-scraper-order": "1666027444-1974",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "🧡 Orange Heart",
    "symbols-href": "https://emojipedia.org/orange-heart/",
    emoji: "🧡",
    emojiName: "🧡 Orange Heart",
    description:
      "Orange Heart was approved as part of Unicode 10.0 in 2017 and added to Emoji 5.0 in 2017.",
  },
  {
    "web-scraper-order": "1666027448-1976",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️ Red Heart",
    "symbols-href": "https://emojipedia.org/red-heart/",
    emoji: "❤️",
    emojiName: "❤️ Red Heart",
    description:
      "A classic red love heart emoji, used for expressions of love and romance. This is the most popular heart emoji A similar emoji exists for the heart suit in a deck of playing cards.",
  },
  {
    "web-scraper-order": "1666027453-1979",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️‍🩹 Mending Heart",
    "symbols-href": "https://emojipedia.org/mending-heart/",
    emoji: "❤️‍🩹",
    emojiName: "❤️‍🩹 Mending Heart",
    description:
      "A heart shown with a bandage across one side; the opposite of a broken heart. May be used to indicate the process of healing, recovery, or to express sympathy for someone going through a difficult time.",
  },
  {
    "web-scraper-order": "1666027458-1982",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❤️‍🔥 Heart on Fire",
    "symbols-href": "https://emojipedia.org/heart-on-fire/",
    emoji: "❤️‍🔥",
    emojiName: "❤️‍🔥 Heart on Fire",
    description:
      "A heart shown on fire, for extreme or passionate forms of love or lust. Most representative of desire or lust, this emoji may also indicate a sense of burning a past love and moving on.",
  },
  {
    "web-scraper-order": "1666027464-1984",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💔 Broken Heart",
    "symbols-href": "https://emojipedia.org/broken-heart/",
    emoji: "💔",
    emojiName: "💔 Broken Heart",
    description:
      "A love heart, broken in two. This emoji represents the aching one feels when they are missing the person they love.",
  },
  {
    "web-scraper-order": "1666027468-1986",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "❣️ Heart Exclamation",
    "symbols-href": "https://emojipedia.org/heart-exclamation/",
    emoji: "❣️",
    emojiName: "❣️ Heart Exclamation",
    description:
      "A decorative exclamation mark, where a heart forms the top part of the symbol, and a circle the lower part. Similar to the way to the man in business suit levitating also creates a similar shape.",
  },
  {
    "web-scraper-order": "1666027471-1988",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💟 Heart Decoration",
    "symbols-href": "https://emojipedia.org/heart-decoration/",
    emoji: "💟",
    emojiName: "💟 Heart Decoration",
    description:
      "A decorative heart that generally displays as a white heart-shaped cutout in a pink or purple roundrect.",
  },
  {
    "web-scraper-order": "1666027474-1990",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💕 Two Hearts",
    "symbols-href": "https://emojipedia.org/two-hearts/",
    emoji: "💕",
    emojiName: "💕 Two Hearts",
    description:
      "Two pink love hearts. One larger than the other. Can be used to display that “love is in the air”.",
  },
  {
    "web-scraper-order": "1666027477-1992",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💞 Revolving Hearts",
    "symbols-href": "https://emojipedia.org/revolving-hearts/",
    emoji: "💞",
    emojiName: "💞 Revolving Hearts",
    description:
      "Hearts revolving around one or more other hearts. This emoji was originally animated on a number of Japanese devices.",
  },
  {
    "web-scraper-order": "1666027480-1993",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💓 Beating Heart",
    "symbols-href": "https://emojipedia.org/beating-heart/",
    emoji: "💓",
    emojiName: "💓 Beating Heart",
    description:
      "A heart with vibration/movement lines above it or around it, indicating it is beating. Displayed in pink or red on most platforms.",
  },
  {
    "web-scraper-order": "1666027484-1996",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💗 Growing Heart",
    "symbols-href": "https://emojipedia.org/growing-heart/",
    emoji: "💗",
    emojiName: "💗 Growing Heart",
    description:
      "A pink heart, inside a slightly larger pink heart, inside a larger-again pink heart. Intended to give the impression of a heart increasing in size.",
  },
  {
    "web-scraper-order": "1666027487-1997",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💖 Sparkling Heart",
    "symbols-href": "https://emojipedia.org/sparkling-heart/",
    emoji: "💖",
    emojiName: "💖 Sparkling Heart",
    description:
      "A pink love heart with stars around it, making it look like it is sparkling or shimmering.",
  },
  {
    "web-scraper-order": "1666027490-1999",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💝 Heart with Ribbon",
    "symbols-href": "https://emojipedia.org/heart-with-ribbon/",
    emoji: "💝",
    emojiName: "💝 Heart with Ribbon",
    description:
      "A heart-shaped box, tied with a ribbon. May be a gift box, box of chocolates, or a jewellery box.",
  },
  {
    "web-scraper-order": "1666027493-2001",
    "web-scraper-start-url": "https://emojipedia.org/symbols/",
    symbols: "💘 Heart with Arrow",
    "symbols-href": "https://emojipedia.org/heart-with-arrow/",
    emoji: "💘",
    emojiName: "💘 Heart with Arrow",
    description:
      "A heart emoji with an arrow through the center, like the arrow that cupid shoots for love.",
  },
  {
    "web-scraper-order": "1666025813-880",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛅 Left Luggage",
    "travel-href": "https://emojipedia.org/left-luggage/",
    emoji: "🛅",
    emojiName: "🛅 Left Luggage",
    description:
      "An icon representing a place to leave luggage. Most commonly found at Japanese train stations to signify coin lockers where bags can be stored for a daily fee.",
  },
  {
    "web-scraper-order": "1666025817-882",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛄 Baggage Claim",
    "travel-href": "https://emojipedia.org/baggage-claim/",
    emoji: "🛄",
    emojiName: "🛄 Baggage Claim",
    description:
      "Baggage Claim was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025820-884",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛃 Customs",
    "travel-href": "https://emojipedia.org/customs/",
    emoji: "🛃",
    emojiName: "🛃 Customs",
    description:
      "A customs officer inspecting luggage. May be shown on signage at airports or other border crossings.",
  },
  {
    "web-scraper-order": "1666025823-886",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛂 Passport Control",
    "travel-href": "https://emojipedia.org/passport-control/",
    emoji: "🛂",
    emojiName: "🛂 Passport Control",
    description: "A person checking passports at an international border.",
  },
  {
    "web-scraper-order": "1666025826-887",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗿 Moai",
    "travel-href": "https://emojipedia.org/moai/",
    emoji: "🗿",
    emojiName: "🗿 Moai",
    description:
      "A moai, one of the famed, giant stone statues of human figures on Easter Island. Depicted as a gray stone carving of a stylized human head with a prominent brow and nose, most often facing left.",
  },
  {
    "web-scraper-order": "1666025830-889",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💷 Pound Banknote",
    "travel-href": "https://emojipedia.org/pound-banknote/",
    emoji: "💷",
    emojiName: "💷 Pound Banknote",
    description:
      "Quids in! A banded stack of pound banknotes, the paper currency of the United Kingdom (England, Wales, Northern Ireland, and Scotland). Color and detail vary across platforms, but widely depicted as purple £20 notes with the pound sign, £.",
  },
  {
    "web-scraper-order": "1666025833-891",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💶 Euro Banknote",
    "travel-href": "https://emojipedia.org/euro-banknote/",
    emoji: "💶",
    emojiName: "💶 Euro Banknote",
    description:
      "A banded stack of euro banknotes, the paper currency of the European Union (EU). Color and detail vary across platforms, but shown with the euro sign, €. Commonly used for various content concerning wealth and money, not restricted to the EU.",
  },
  {
    "web-scraper-order": "1666025836-892",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💵 Dollar Banknote",
    "travel-href": "https://emojipedia.org/dollar-banknote/",
    emoji: "💵",
    emojiName: "💵 Dollar Banknote",
    description:
      "Cash money! A banded stack of U.S. dollar banknotes, the paper currency of the United States of America. Green hue and detail vary across platforms, but shown with the dollar sign, $. Commonly used for various content concerning wealth and money, not restricted to the U.S.",
  },
  {
    "web-scraper-order": "1666025839-893",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💴 Yen Banknote",
    "travel-href": "https://emojipedia.org/yen-banknote/",
    emoji: "💴",
    emojiName: "💴 Yen Banknote",
    description:
      "A banded stack of yen banknotes, the paper currency of Japan. Color and detail vary across platforms, but usually shown in green, yellow, or pink with the yen symbol, ¥. Commonly used for various content concerning money and wealth, not restricted to Japan.",
  },
  {
    "web-scraper-order": "1666025842-895",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎑 Moon Viewing Ceremony",
    "travel-href": "https://emojipedia.org/moon-viewing-ceremony/",
    emoji: "🎑",
    emojiName: "🎑 Moon Viewing Ceremony",
    description:
      "Moon Viewing Ceremonies (called Tsukimi in Japan) are held each year in autumn to celebrate the full moon and waxing moon in Japan.",
  },
  {
    "web-scraper-order": "1666025844-896",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎇 Sparkler",
    "travel-href": "https://emojipedia.org/sparkler/",
    emoji: "🎇",
    emojiName: "🎇 Sparkler",
    description:
      "A  sparkler: a form of hand-held firework often used at parties and celebrations. The sparkler is lit at one end, and held at the other.",
  },
  {
    "web-scraper-order": "1666025861-901",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎆 Fireworks",
    "travel-href": "https://emojipedia.org/fireworks/",
    emoji: "🎆",
    emojiName: "🎆 Fireworks",
    description:
      "Firework emoji, showing a explosion of colored light in the night sky, used for any number of celebrations such as New Year's Eve.",
  },
  {
    "web-scraper-order": "1666025864-903",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛱️ Umbrella on Ground",
    "travel-href": "https://emojipedia.org/umbrella-on-ground/",
    emoji: "⛱️",
    emojiName: "⛱️ Umbrella on Ground",
    description:
      "A large, open umbrella, as provides shade at a beach or patio. Generally depicted as a striped umbrella inserted into a patch of sand and tilted to the right.",
  },
  {
    "web-scraper-order": "1666025867-904",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌌 Milky Way",
    "travel-href": "https://emojipedia.org/milky-way/",
    emoji: "🌌",
    emojiName: "🌌 Milky Way",
    description:
      "The Milky Way – a galaxy of billions of stars that includes our own solar system and planet earth.",
  },
  {
    "web-scraper-order": "1666025873-906",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌠 Shooting Star",
    "travel-href": "https://emojipedia.org/shooting-star/",
    emoji: "🌠",
    emojiName: "🌠 Shooting Star",
    description:
      "A stylized representation of a shooting star, a small, fast meteor that burns up in the atmosphere. Generally depicted as a gold, five-point star trailing yellow motion lines against a night sky, as if moving down to the left.",
  },
  {
    "web-scraper-order": "1666025877-908",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🪐 Ringed Planet",
    "travel-href": "https://emojipedia.org/ringed-planet/",
    emoji: "🪐",
    emojiName: "🪐 Ringed Planet",
    description:
      "A ringed planet that appears with various number of rings, tilt angles, and colors across platforms. This vaguely Saturn-like orb was proposed as a stand-alone planet emoji to represent all planets.",
  },
  {
    "web-scraper-order": "1666025881-910",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛸 Flying Saucer",
    "travel-href": "https://emojipedia.org/flying-saucer/",
    emoji: "🛸",
    emojiName: "🛸 Flying Saucer",
    description:
      "A flying saucer, sometimes referred to as an Unidentified Flying Object (UFO). Previously shown on some platforms with an alien at the controls and/or a beam of light emitting from the base.",
  },
  {
    "web-scraper-order": "1666025887-912",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚀 Rocket",
    "travel-href": "https://emojipedia.org/rocket/",
    emoji: "🚀",
    emojiName: "🚀 Rocket",
    description:
      "A rocket being propelled into space. Sometimes used to indicate a fast increase, for instance when referring to stocks going to the moon 🚀 (rising quickly in price).",
  },
  {
    "web-scraper-order": "1666025889-914",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛰️ Satellite",
    "travel-href": "https://emojipedia.org/satellite/",
    emoji: "🛰️",
    emojiName: "🛰️ Satellite",
    description:
      "A satellite which orbits the earth, and is generally used for communications, weather, and GPS.",
  },
  {
    "web-scraper-order": "1666025893-915",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚡 Aerial Tramway",
    "travel-href": "https://emojipedia.org/aerial-tramway/",
    emoji: "🚡",
    emojiName: "🚡 Aerial Tramway",
    description:
      "An Aerial Tramway, most commonly seen at ski resorts, for transport between locations on a mountain. Can also be used as a tourist attraction, or as a form of public transport.",
  },
  {
    "web-scraper-order": "1666025899-918",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚠 Mountain Cableway",
    "travel-href": "https://emojipedia.org/mountain-cableway/",
    emoji: "🚠",
    emojiName: "🚠 Mountain Cableway",
    description:
      "Mountain Cableway was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025904-920",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚟 Suspension Railway",
    "travel-href": "https://emojipedia.org/suspension-railway/",
    emoji: "🚟",
    emojiName: "🚟 Suspension Railway",
    description:
      "Similar to a monorail, a suspension railway is elevated, but the vehicle is suspended under the track.",
  },
  {
    "web-scraper-order": "1666025908-922",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚁 Helicopter",
    "travel-href": "https://emojipedia.org/helicopter/",
    emoji: "🚁",
    emojiName: "🚁 Helicopter",
    description:
      "A helicopter, which can hover in the air. Often seen in emergency circumstances such as transporting patients to a hospital, or for police or fire-fighting activity.",
  },
  {
    "web-scraper-order": "1666025912-924",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💺 Seat",
    "travel-href": "https://emojipedia.org/seat/",
    emoji: "💺",
    emojiName: "💺 Seat",
    description:
      "A seat, which could refer to any form of place to sit, with the distinction that a seat is generally fixed, and is not a chair which can be moved.",
  },
  {
    "web-scraper-order": "1666025916-925",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🪂 Parachute",
    "travel-href": "https://emojipedia.org/parachute/",
    emoji: "🪂",
    emojiName: "🪂 Parachute",
    description:
      "An open parachute floating through the air with a human steering. Most platforms feature a ram-air design. Colors vary across platforms.",
  },
  {
    "web-scraper-order": "1666025920-927",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛬 Airplane Arrival",
    "travel-href": "https://emojipedia.org/airplane-arrival/",
    emoji: "🛬",
    emojiName: "🛬 Airplane Arrival",
    description:
      "A plane approaching a runway for landing. Generally displayed left-right, with the front of the plane facing toward the ground in a position that may result in a crash if attempted in the real world.",
  },
  {
    "web-scraper-order": "1666025924-929",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛫 Airplane Departure",
    "travel-href": "https://emojipedia.org/airplane-departure/",
    emoji: "🛫",
    emojiName: "🛫 Airplane Departure",
    description:
      "A plane taking off from a runway. Generally displayed left-right, with the front of the plane elevated.",
  },
  {
    "web-scraper-order": "1666025929-931",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛩️ Small Airplane",
    "travel-href": "https://emojipedia.org/small-airplane/",
    emoji: "🛩️",
    emojiName: "🛩️ Small Airplane",
    description:
      "A light aircraft which is shown with propellers on some platforms.",
  },
  {
    "web-scraper-order": "1666025934-933",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "✈️ Airplane",
    "travel-href": "https://emojipedia.org/airplane/",
    emoji: "✈️",
    emojiName: "✈️ Airplane",
    description:
      "Used either as a literal airplane, to represent an overseas vacation, or sometimes as a proxy for airplane mode on a phone or tablet.",
  },
  {
    "web-scraper-order": "1666025939-935",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚢 Ship",
    "travel-href": "https://emojipedia.org/ship/",
    emoji: "🚢",
    emojiName: "🚢 Ship",
    description:
      "A large ship, used for transport of people or cargo across the ocean. May be a cruise ship, commonly found around tropical locations.",
  },
  {
    "web-scraper-order": "1666025943-938",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛥️ Motor Boat",
    "travel-href": "https://emojipedia.org/motor-boat/",
    emoji: "🛥️",
    emojiName: "🛥️ Motor Boat",
    description:
      "Motor Boat was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025949-943",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛴️ Ferry",
    "travel-href": "https://emojipedia.org/ferry/",
    emoji: "⛴️",
    emojiName: "⛴️ Ferry",
    description:
      "Ferry was approved as part of Unicode 5.2 in 2009 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025955-946",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛳️ Passenger Ship",
    "travel-href": "https://emojipedia.org/passenger-ship/",
    emoji: "🛳️",
    emojiName: "🛳️ Passenger Ship",
    description:
      "Passenger Ship was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025959-949",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚤 Speedboat",
    "travel-href": "https://emojipedia.org/speedboat/",
    emoji: "🚤",
    emojiName: "🚤 Speedboat",
    description:
      "A motorized speedboat used for recreation on lakes, or other bodies of water.",
  },
  {
    "web-scraper-order": "1666025962-951",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛵ Sailboat",
    "travel-href": "https://emojipedia.org/sailboat/",
    emoji: "⛵",
    emojiName: "⛵ Sailboat",
    description:
      "A sailboat, otherwise known as a sailing boat or yacht.  Uses wind as the source of propulsion to move around a body of water.",
  },
  {
    "web-scraper-order": "1666025965-954",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛟 Ring Buoy",
    "travel-href": "https://emojipedia.org/ring-buoy/",
    emoji: "🛟",
    emojiName: "🛟 Ring Buoy",
    description:
      "A round white and orange or red ring buoy with string laced through its perimeter. Also called a life preserver.",
  },
  {
    "web-scraper-order": "1666025967-957",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⚓ Anchor",
    "travel-href": "https://emojipedia.org/anchor/",
    emoji: "⚓",
    emojiName: "⚓ Anchor",
    description:
      "A metal device, dropped out of a boat to prevent it drifting away from the current location.",
  },
  {
    "web-scraper-order": "1666025969-959",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚧 Construction",
    "travel-href": "https://emojipedia.org/construction/",
    emoji: "🚧",
    emojiName: "🚧 Construction",
    description:
      "A sign used to indicate roadwork or construction. Generally shown as yellow and black diagonal stripes, and often used to physically block access to a road or area. May be used to imply a website or project in progress or under construction.",
  },
  {
    "web-scraper-order": "1666025971-962",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚦 Vertical Traffic Light",
    "travel-href": "https://emojipedia.org/vertical-traffic-light/",
    emoji: "🚦",
    emojiName: "🚦 Vertical Traffic Light",
    description:
      "A set of red, orange (amber) and green traffic lights, used at intersections. More common than the horizontal traffic light.",
  },
  {
    "web-scraper-order": "1666025974-964",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚥 Horizontal Traffic Light",
    "travel-href": "https://emojipedia.org/horizontal-traffic-light/",
    emoji: "🚥",
    emojiName: "🚥 Horizontal Traffic Light",
    description:
      "A set of red, orange (amber) and green traffic lights, used at intersections. Less common than the vertical traffic light.",
  },
  {
    "web-scraper-order": "1666025980-969",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚨 Police Car Light",
    "travel-href": "https://emojipedia.org/police-car-light/",
    emoji: "🚨",
    emojiName: "🚨 Police Car Light",
    description:
      "A revolving red light seen on top of a police car. Often used in emergency circumstances in addition to a siren making a loud warning sound.",
  },
  {
    "web-scraper-order": "1666025982-972",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛞 Wheel",
    "travel-href": "https://emojipedia.org/wheel/",
    emoji: "🛞",
    emojiName: "🛞 Wheel",
    description: "A wheel with a rubber tire.",
  },
  {
    "web-scraper-order": "1666025985-976",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛽ Fuel Pump",
    "travel-href": "https://emojipedia.org/fuel-pump/",
    emoji: "⛽",
    emojiName: "⛽ Fuel Pump",
    description: "A fuel pump, used to fill up a vehicle with gas / petrol.",
  },
  {
    "web-scraper-order": "1666025988-978",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛤️ Railway Track",
    "travel-href": "https://emojipedia.org/railway-track/",
    emoji: "🛤️",
    emojiName: "🛤️ Railway Track",
    description:
      "Railway Track was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666025990-980",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛣️ Motorway",
    "travel-href": "https://emojipedia.org/motorway/",
    emoji: "🛣️",
    emojiName: "🛣️ Motorway",
    description:
      "A wide road shown from a first person perspective. Apple's artwork displays a road sign to Curpertino.",
  },
  {
    "web-scraper-order": "1666025993-983",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚏 Bus Stop",
    "travel-href": "https://emojipedia.org/bus-stop/",
    emoji: "🚏",
    emojiName: "🚏 Bus Stop",
    description:
      "A sign indicating the location of a bus stop by the side of a road.",
  },
  {
    "web-scraper-order": "1666025996-987",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛴 Kick Scooter",
    "travel-href": "https://emojipedia.org/kick-scooter/",
    emoji: "🛴",
    emojiName: "🛴 Kick Scooter",
    description: "A non-motorized scooter, with two wheels and handles.",
  },
  {
    "web-scraper-order": "1666026000-990",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚲 Bicycle",
    "travel-href": "https://emojipedia.org/bicycle/",
    emoji: "🚲",
    emojiName: "🚲 Bicycle",
    description:
      "A bicycle, sometimes called a push bike, used for transport or sport.",
  },
  {
    "web-scraper-order": "1666026003-994",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛺 Auto Rickshaw",
    "travel-href": "https://emojipedia.org/auto-rickshaw/",
    emoji: "🛺",
    emojiName: "🛺 Auto Rickshaw",
    description:
      "An auto rickshaw, often referred to as a tuk tuk. This motorized version of a cycle rickshaw is used for transport in many regions of the world. Generally this emoji has three wheels and open sides without doors.",
  },
  {
    "web-scraper-order": "1666026006-997",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛵 Motor Scooter",
    "travel-href": "https://emojipedia.org/motor-scooter/",
    emoji: "🛵",
    emojiName: "🛵 Motor Scooter",
    description:
      "A motor scooter, which may be displayed as any type of motorbike with or without a step-through frame. Distinct from the racing motorcycle, which is used for sport, not transport.",
  },
  {
    "web-scraper-order": "1666026009-999",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏍️ Motorcycle",
    "travel-href": "https://emojipedia.org/motorcycle/",
    emoji: "🏍️",
    emojiName: "🏍️ Motorcycle",
    description:
      "A motorcycle, otherwise known as a motorbike used for sport/racing purposes. For a transport-based motorcycle, use a motor scooter.",
  },
  {
    "web-scraper-order": "1666026011-1002",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏎️ Racing Car",
    "travel-href": "https://emojipedia.org/racing-car/",
    emoji: "🏎️",
    emojiName: "🏎️ Racing Car",
    description:
      "A racing car which appears as a formula one vehicle or rally car on most platforms. Generally displayed in red.",
  },
  {
    "web-scraper-order": "1666026015-1006",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚜 Tractor",
    "travel-href": "https://emojipedia.org/tractor/",
    emoji: "🚜",
    emojiName: "🚜 Tractor",
    description:
      "A tractor, may be used by a farmer or other occupation on the land.",
  },
  {
    "web-scraper-order": "1666026019-1009",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚛 Articulated Lorry",
    "travel-href": "https://emojipedia.org/articulated-lorry/",
    emoji: "🚛",
    emojiName: "🚛 Articulated Lorry",
    description:
      "Articulated Lorry was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026023-1013",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚚 Delivery Truck",
    "travel-href": "https://emojipedia.org/delivery-truck/",
    emoji: "🚚",
    emojiName: "🚚 Delivery Truck",
    description:
      "Delivery Truck was approved as part of Unicode 6.0 in 2010 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026026-1016",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛻 Pickup Truck",
    "travel-href": "https://emojipedia.org/pickup-truck/",
    emoji: "🛻",
    emojiName: "🛻 Pickup Truck",
    description:
      "A red or turquoise pickup truck. Used to talk about trucks or modes of transportation in general.",
  },
  {
    "web-scraper-order": "1666026030-1019",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚙 Sport Utility Vehicle",
    "travel-href": "https://emojipedia.org/sport-utility-vehicle/",
    emoji: "🚙",
    emojiName: "🚙 Sport Utility Vehicle",
    description:
      "A blue or green Sport Utility Vehicle or station wagon, often with a spare tire on the back. Commonly used as a generic blue or green car.",
  },
  {
    "web-scraper-order": "1666026033-1022",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚘 Oncoming Automobile",
    "travel-href": "https://emojipedia.org/oncoming-automobile/",
    emoji: "🚘",
    emojiName: "🚘 Oncoming Automobile",
    description:
      "A car being shown from the front. The windscreen and hood (bonnet in British English) of the car can be seen facing forward.",
  },
  {
    "web-scraper-order": "1666026036-1025",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚗 Automobile",
    "travel-href": "https://emojipedia.org/automobile/",
    emoji: "🚗",
    emojiName: "🚗 Automobile",
    description:
      "A car shown from the side, facing right-to-left. Appears as a red car on almost all platforms (which goes faster), though earlier Google designs displayed the vehicle as either silver or blue.",
  },
  {
    "web-scraper-order": "1666026040-1028",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚖 Oncoming Taxi",
    "travel-href": "https://emojipedia.org/oncoming-taxi/",
    emoji: "🚖",
    emojiName: "🚖 Oncoming Taxi",
    description:
      "A yellow taxicab, iconically seen in New York City. Shown from the front, as opposed to the taxi emoji which displays the side of the vehicle.",
  },
  {
    "web-scraper-order": "1666026043-1032",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚕 Taxi",
    "travel-href": "https://emojipedia.org/taxi/",
    emoji: "🚕",
    emojiName: "🚕 Taxi",
    description:
      "A yellow taxicab, iconically seen in New York City. Shown from the side, as opposed to the oncoming taxi emoji.",
  },
  {
    "web-scraper-order": "1666026047-1034",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚔 Oncoming Police Car",
    "travel-href": "https://emojipedia.org/oncoming-police-car/",
    emoji: "🚔",
    emojiName: "🚔 Oncoming Police Car",
    description: "A police car, shown with an emergency light on the top.",
  },
  {
    "web-scraper-order": "1666026050-1036",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚓 Police Car",
    "travel-href": "https://emojipedia.org/police-car/",
    emoji: "🚓",
    emojiName: "🚓 Police Car",
    description: "A police car, shown with an emergency light on the top.",
  },
  {
    "web-scraper-order": "1666026053-1039",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚒 Fire Engine",
    "travel-href": "https://emojipedia.org/fire-engine/",
    emoji: "🚒",
    emojiName: "🚒 Fire Engine",
    description:
      "A red fire truck, an essential part of emergency services along with a police car or ambulance.",
  },
  {
    "web-scraper-order": "1666026057-1041",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚑 Ambulance",
    "travel-href": "https://emojipedia.org/ambulance/",
    emoji: "🚑",
    emojiName: "🚑 Ambulance",
    description:
      "An ambulance, used to transport patients between their home and the hospital.",
  },
  {
    "web-scraper-order": "1666026061-1044",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚐 Minibus",
    "travel-href": "https://emojipedia.org/minibus/",
    emoji: "🚐",
    emojiName: "🚐 Minibus",
    description:
      "A small bus or minivan designed to carry fewer people than a full-sized bus. Displayed in white on most platforms (green on Facebook).",
  },
  {
    "web-scraper-order": "1666026065-1047",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚎 Trolleybus",
    "travel-href": "https://emojipedia.org/trolleybus/",
    emoji: "🚎",
    emojiName: "🚎 Trolleybus",
    description:
      "A type of bus that uses overhead electrical wires for power. Appears similar to a cross between a bus and a tram car.",
  },
  {
    "web-scraper-order": "1666026068-1049",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚍 Oncoming Bus",
    "travel-href": "https://emojipedia.org/oncoming-bus/",
    emoji: "🚍",
    emojiName: "🚍 Oncoming Bus",
    description:
      "The front of a bus, showing the windscreen, as well as wing mirrors in some versions of this emoji.",
  },
  {
    "web-scraper-order": "1666026072-1052",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚌 Bus",
    "travel-href": "https://emojipedia.org/bus/",
    emoji: "🚌",
    emojiName: "🚌 Bus",
    description:
      "A bus used for public transport in cities and towns. Could also be used as a school bus.",
  },
  {
    "web-scraper-order": "1666026077-1054",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚋 Tram Car",
    "travel-href": "https://emojipedia.org/tram-car/",
    emoji: "🚋",
    emojiName: "🚋 Tram Car",
    description:
      "A form of public transport on rails, usually found on streets in cities or other urban areas. For short or medium-length journeys.",
  },
  {
    "web-scraper-order": "1666026080-1057",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚞 Mountain Railway",
    "travel-href": "https://emojipedia.org/mountain-railway/",
    emoji: "🚞",
    emojiName: "🚞 Mountain Railway",
    description: "A train and railway in the mountains.",
  },
  {
    "web-scraper-order": "1666026084-1059",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚝 Monorail",
    "travel-href": "https://emojipedia.org/monorail/",
    emoji: "🚝",
    emojiName: "🚝 Monorail",
    description:
      "Similar to a train, but running on a single track. Monorails are often found at theme parks, or other tourist destinations.",
  },
  {
    "web-scraper-order": "1666026087-1061",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚊 Tram",
    "travel-href": "https://emojipedia.org/tram/",
    emoji: "🚊",
    emojiName: "🚊 Tram",
    description:
      "A form of public transport on rails, usually found on streets in cities or other urban areas. For short or medium-length journeys.",
  },
  {
    "web-scraper-order": "1666026089-1063",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚉 Station",
    "travel-href": "https://emojipedia.org/station/",
    emoji: "🚉",
    emojiName: "🚉 Station",
    description:
      "A station, presumed to be a train station. Displays a train alongside a platform, where passengers can board.",
  },
  {
    "web-scraper-order": "1666026093-1066",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚈 Light Rail",
    "travel-href": "https://emojipedia.org/light-rail/",
    emoji: "🚈",
    emojiName: "🚈 Light Rail",
    description:
      "A form of public transport similar to a tram, but running on a track or network separated from cars and other types of traffic.",
  },
  {
    "web-scraper-order": "1666026095-1068",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚇 Metro",
    "travel-href": "https://emojipedia.org/metro/",
    emoji: "🚇",
    emojiName: "🚇 Metro",
    description:
      "A metro: frequent underground train found in built-up areas with high populations.",
  },
  {
    "web-scraper-order": "1666026097-1070",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚆 Train",
    "travel-href": "https://emojipedia.org/train/",
    emoji: "🚆",
    emojiName: "🚆 Train",
    description:
      "A train, of no specified type. Due to the presence of a steam train and fast train emoji, this is likely to be a regular electrified or diesel passenger train.",
  },
  {
    "web-scraper-order": "1666026101-1072",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚅 Bullet Train",
    "travel-href": "https://emojipedia.org/bullet-train/",
    emoji: "🚅",
    emojiName: "🚅 Bullet Train",
    description:
      "A high speed train, designed to cover long distances at high speed. Also features a streamlined bullet nose, often used in reference to the Shinkansen in Japan.",
  },
  {
    "web-scraper-order": "1666026103-1074",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚄 High-Speed Train",
    "travel-href": "https://emojipedia.org/high-speed-train/",
    emoji: "🚄",
    emojiName: "🚄 High-Speed Train",
    description:
      "A high speed train, designed to cover long distances at high speed.",
  },
  {
    "web-scraper-order": "1666026106-1076",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚃 Railway Car",
    "travel-href": "https://emojipedia.org/railway-car/",
    emoji: "🚃",
    emojiName: "🚃 Railway Car",
    description:
      "A railway (railroad) car (carriage) that is generally pulled along a railway line by a locomotive. Shown with a pantograph above the carriage on many platforms which makes it look more like a tram car.",
  },
  {
    "web-scraper-order": "1666026110-1078",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚂 Locomotive",
    "travel-href": "https://emojipedia.org/locomotive/",
    emoji: "🚂",
    emojiName: "🚂 Locomotive",
    description:
      "A steam train, powered by coal or wood. An early type of locomotive, now mostly replaced by electric or diesel trains.",
  },
  {
    "web-scraper-order": "1666026113-1081",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎢 Roller Coaster",
    "travel-href": "https://emojipedia.org/roller-coaster/",
    emoji: "🎢",
    emojiName: "🎢 Roller Coaster",
    description:
      "A roller coaster in a theme park going down a dip in the ride. Three carriages can be seen with two people in each red carriage.",
  },
  {
    "web-scraper-order": "1666026118-1084",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎡 Ferris Wheel",
    "travel-href": "https://emojipedia.org/ferris-wheel/",
    emoji: "🎡",
    emojiName: "🎡 Ferris Wheel",
    description: "A large rotating wheel, often found at a carnival or fair.",
  },
  {
    "web-scraper-order": "1666026120-1086",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛝 Playground Slide",
    "travel-href": "https://emojipedia.org/playground-slide/",
    emoji: "🛝",
    emojiName: "🛝 Playground Slide",
    description: "A slide with a ladder, as seen in children's playgrounds.",
  },
  {
    "web-scraper-order": "1666026123-1088",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🎠 Carousel Horse",
    "travel-href": "https://emojipedia.org/carousel-horse/",
    emoji: "🎠",
    emojiName: "🎠 Carousel Horse",
    description:
      "A wooden painted horse, found on the carousel at a carnival. Faces to the left-of screen.",
  },
  {
    "web-scraper-order": "1666026126-1090",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌉 Bridge at Night",
    "travel-href": "https://emojipedia.org/bridge-at-night/",
    emoji: "🌉",
    emojiName: "🌉 Bridge at Night",
    description: "A lit-up bridge, shown at night.",
  },
  {
    "web-scraper-order": "1666026128-1092",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌇 Sunset",
    "travel-href": "https://emojipedia.org/sunset/",
    emoji: "🌇",
    emojiName: "🌇 Sunset",
    description:
      "A beautiful view, featuring an orange sky, with the sun setting over the buildings of a city skyline.",
  },
  {
    "web-scraper-order": "1666026130-1094",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌆 Cityscape at Dusk",
    "travel-href": "https://emojipedia.org/cityscape-at-dusk/",
    emoji: "🌆",
    emojiName: "🌆 Cityscape at Dusk",
    description:
      "A view of city buildings as the last light disappears from the sky. An orange (or blue) glow lingers, before the stars of the night sky become visible.",
  },
  {
    "web-scraper-order": "1666026133-1096",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌅 Sunrise",
    "travel-href": "https://emojipedia.org/sunrise/",
    emoji: "🌅",
    emojiName: "🌅 Sunrise",
    description:
      "A sun rising, early in the morning. Can be difficult to distinguish from a sunset in some versions of this artwork.",
  },
  {
    "web-scraper-order": "1666026135-1098",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌄 Sunrise Over Mountains",
    "travel-href": "https://emojipedia.org/sunrise-over-mountains/",
    emoji: "🌄",
    emojiName: "🌄 Sunrise Over Mountains",
    description: "The sun rising over a mountain range, early in the morning.",
  },
  {
    "web-scraper-order": "1666026138-1100",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏙️ Cityscape",
    "travel-href": "https://emojipedia.org/cityscape/",
    emoji: "🏙️",
    emojiName: "🏙️ Cityscape",
    description:
      "Cityscape was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026140-1102",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌃 Night with Stars",
    "travel-href": "https://emojipedia.org/night-with-stars/",
    emoji: "🌃",
    emojiName: "🌃 Night with Stars",
    description:
      "A night sky with stars, depicted on major platforms as a cityscape at night.",
  },
  {
    "web-scraper-order": "1666026143-1104",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌁 Foggy",
    "travel-href": "https://emojipedia.org/foggy/",
    emoji: "🌁",
    emojiName: "🌁 Foggy",
    description:
      "Foggy weather displayed as fog covering a bridge or cityscape, depending on the platform. For platforms that show a bridge, the red Golden Gate Bridge is generally displayed.",
  },
  {
    "web-scraper-order": "1666026145-1106",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛺ Tent",
    "travel-href": "https://emojipedia.org/tent/",
    emoji: "⛺",
    emojiName: "⛺ Tent",
    description: "A tent, used for protection from wind and rain when camping.",
  },
  {
    "web-scraper-order": "1666026148-1108",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛲ Fountain",
    "travel-href": "https://emojipedia.org/fountain/",
    emoji: "⛲",
    emojiName: "⛲ Fountain",
    description:
      "A water fountain, found in a park or other public space. Used for decorative purposes. A variety of styles of fountain are shown across different platforms.",
  },
  {
    "web-scraper-order": "1666026151-1110",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕋 Kaaba",
    "travel-href": "https://emojipedia.org/kaaba/",
    emoji: "🕋",
    emojiName: "🕋 Kaaba",
    description:
      "A cube-shaped building located at the centre of the Al-Masjid al-Haram Mosque in Mecca.",
  },
  {
    "web-scraper-order": "1666026154-1112",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛩️ Shinto Shrine",
    "travel-href": "https://emojipedia.org/shinto-shrine/",
    emoji: "⛩️",
    emojiName: "⛩️ Shinto Shrine",
    description:
      "A shrine used for the Japanese Shinto religion. This emoji generally displays the torii, which is the gate to the Shinto Shrine. The torii is generally a red colored structure, with a curved roof section above two posts.",
  },
  {
    "web-scraper-order": "1666026156-1114",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕍 Synagogue",
    "travel-href": "https://emojipedia.org/synagogue/",
    emoji: "🕍",
    emojiName: "🕍 Synagogue",
    description:
      "A synague; a place of worship for followers of Judaism. Displayed with a Star of David on the front.",
  },
  {
    "web-scraper-order": "1666026159-1116",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛕 Hindu Temple",
    "travel-href": "https://emojipedia.org/hindu-temple/",
    emoji: "🛕",
    emojiName: "🛕 Hindu Temple",
    description:
      "A Hindu temple or mandir; a place of worship for followers of Hinduism. Depicted on most platforms as a red, orange, or golden building with a tall spire.",
  },
  {
    "web-scraper-order": "1666026161-1118",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🕌 Mosque",
    "travel-href": "https://emojipedia.org/mosque/",
    emoji: "🕌",
    emojiName: "🕌 Mosque",
    description:
      "A mosque building, a place of worship for followers of Islam. Shown with a domed roof and a minaret.",
  },
  {
    "web-scraper-order": "1666026163-1120",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛪ Church",
    "travel-href": "https://emojipedia.org/church/",
    emoji: "⛪",
    emojiName: "⛪ Church",
    description:
      "A church building, generally associated with Christian denominations. In addition quiet prayer, churches hold regular worship services, weddings, baptisms and funerals.",
  },
  {
    "web-scraper-order": "1666026166-1122",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗽 Statue of Liberty",
    "travel-href": "https://emojipedia.org/statue-of-liberty/",
    emoji: "🗽",
    emojiName: "🗽 Statue of Liberty",
    description:
      "The Statue of Liberty, often used as a depiction of New York City.",
  },
  {
    "web-scraper-order": "1666026168-1124",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗼 Tokyo Tower",
    "travel-href": "https://emojipedia.org/tokyo-tower/",
    emoji: "🗼",
    emojiName: "🗼 Tokyo Tower",
    description:
      "The Tokyo Tower is the second-tallest building in Japan, located in Minato, Tokyo.",
  },
  {
    "web-scraper-order": "1666026170-1126",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "💒 Wedding",
    "travel-href": "https://emojipedia.org/wedding/",
    emoji: "💒",
    emojiName: "💒 Wedding",
    description:
      "An emoji to depict a wedding, displayed by most vendors as a Christian church and love hearts. Some platforms display a cross or bell on the building.",
  },
  {
    "web-scraper-order": "1666026173-1128",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏰 Castle",
    "travel-href": "https://emojipedia.org/castle/",
    emoji: "🏰",
    emojiName: "🏰 Castle",
    description:
      "A castle, in a style that can be found in France and other parts of Europe.",
  },
  {
    "web-scraper-order": "1666026175-1130",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏯 Japanese Castle",
    "travel-href": "https://emojipedia.org/japanese-castle/",
    emoji: "🏯",
    emojiName: "🏯 Japanese Castle",
    description:
      "A traditional Japanese Castle (城, shiro or jō), usually made from stone and wood.",
  },
  {
    "web-scraper-order": "1666026177-1131",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏭 Factory",
    "travel-href": "https://emojipedia.org/factory/",
    emoji: "🏭",
    emojiName: "🏭 Factory",
    description:
      "An industrial factory, with flue-gas stacks releasing exhaust into the air.",
  },
  {
    "web-scraper-order": "1666026180-1133",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏬 Department Store",
    "travel-href": "https://emojipedia.org/department-store/",
    emoji: "🏬",
    emojiName: "🏬 Department Store",
    description:
      "A large department store, selling a range of products to the general public. Shown as a large building with a billboard.",
  },
  {
    "web-scraper-order": "1666026182-1135",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏫 School",
    "travel-href": "https://emojipedia.org/school/",
    emoji: "🏫",
    emojiName: "🏫 School",
    description:
      "A school building with multiple storeys, and a clock on the front. A place that children, or teenagers attend for their education.",
  },
  {
    "web-scraper-order": "1666026184-1137",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏪 Convenience Store",
    "travel-href": "https://emojipedia.org/convenience-store/",
    emoji: "🏪",
    emojiName: "🏪 Convenience Store",
    description:
      "A shop that is generally open for longer hours than a regular supermarket, sometimes 24 hours per day.",
  },
  {
    "web-scraper-order": "1666026186-1139",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏩 Love Hotel",
    "travel-href": "https://emojipedia.org/love-hotel/",
    emoji: "🏩",
    emojiName: "🏩 Love Hotel",
    description:
      "A love hotel is a hotel that can be hired by the hour instead of as accommodation for the evening.",
  },
  {
    "web-scraper-order": "1666026189-1141",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏨 Hotel",
    "travel-href": "https://emojipedia.org/hotel/",
    emoji: "🏨",
    emojiName: "🏨 Hotel",
    description:
      "A hotel building, displayed on most platforms as a building with many windows and a letter H on the front.",
  },
  {
    "web-scraper-order": "1666026191-1143",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏦 Bank",
    "travel-href": "https://emojipedia.org/bank/",
    emoji: "🏦",
    emojiName: "🏦 Bank",
    description:
      "A retail bank branch, where people can perform money-related tasks. Also a common location to find an ATM.",
  },
  {
    "web-scraper-order": "1666026193-1145",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏥 Hospital",
    "travel-href": "https://emojipedia.org/hospital/",
    emoji: "🏥",
    emojiName: "🏥 Hospital",
    description:
      "A place where people are taken to receive medical care. This hospital has a large red cross on the front, often used as a symbol for health care.",
  },
  {
    "web-scraper-order": "1666026197-1147",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏤 Post Office",
    "travel-href": "https://emojipedia.org/post-office/",
    emoji: "🏤",
    emojiName: "🏤 Post Office",
    description:
      "A European-style post office. A postal horn can be seen on the front, which is commonly found in the logos of European Postal Services.",
  },
  {
    "web-scraper-order": "1666026200-1149",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏣 Japanese Post Office",
    "travel-href": "https://emojipedia.org/japanese-post-office/",
    emoji: "🏣",
    emojiName: "🏣 Japanese Post Office",
    description:
      "A Japanese post office, featuring the 〒 Japanese postal mark on the front of the building.",
  },
  {
    "web-scraper-order": "1666026202-1151",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏢 Office Building",
    "travel-href": "https://emojipedia.org/office-building/",
    emoji: "🏢",
    emojiName: "🏢 Office Building",
    description:
      "A generic, high-rise office building. Generally found in cities, and most active during business hours.",
  },
  {
    "web-scraper-order": "1666026204-1153",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏡 House with Garden",
    "travel-href": "https://emojipedia.org/house-with-garden/",
    emoji: "🏡",
    emojiName: "🏡 House with Garden",
    description:
      "A suburban-looking house, with a tree, flower, or shrubs around it in the garden.",
  },
  {
    "web-scraper-order": "1666026207-1155",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏠 House",
    "travel-href": "https://emojipedia.org/house/",
    emoji: "🏠",
    emojiName: "🏠 House",
    description:
      "A house, otherwise known as a home when someone is living in it. Suitable for a couple or larger family, other perhaps housemates.",
  },
  {
    "web-scraper-order": "1666026209-1157",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏚️ Derelict House",
    "travel-href": "https://emojipedia.org/derelict-house/",
    emoji: "🏚️",
    emojiName: "🏚️ Derelict House",
    description:
      "A house which is unoccupied, and has become derelict. In a state of disrepair.",
  },
  {
    "web-scraper-order": "1666026211-1159",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏘️ Houses",
    "travel-href": "https://emojipedia.org/houses/",
    emoji: "🏘️",
    emojiName: "🏘️ Houses",
    description: "Multiple houses.",
  },
  {
    "web-scraper-order": "1666026215-1161",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🛖 Hut",
    "travel-href": "https://emojipedia.org/hut/",
    emoji: "🛖",
    emojiName: "🛖 Hut",
    description:
      "A round hut with a thatched roof. Used to talk about huts, cottages, yurts, or homes in general.",
  },
  {
    "web-scraper-order": "1666026218-1163",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏗️ Building Construction",
    "travel-href": "https://emojipedia.org/building-construction/",
    emoji: "🏗️",
    emojiName: "🏗️ Building Construction",
    description:
      "A construction site generally depicted as a tower crane shown lifting steel or other building materials.",
  },
  {
    "web-scraper-order": "1666026220-1165",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏛️ Classical Building",
    "travel-href": "https://emojipedia.org/classical-building/",
    emoji: "🏛️",
    emojiName: "🏛️ Classical Building",
    description:
      "A building shown with columns in a classical style, sometimes used to represent a courthouse, town hall, post office or stock exchange.",
  },
  {
    "web-scraper-order": "1666026222-1167",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏟️ Stadium",
    "travel-href": "https://emojipedia.org/stadium/",
    emoji: "🏟️",
    emojiName: "🏟️ Stadium",
    description:
      "A large capacity stadium, featuring a large amount of seating for sporting fans, or people attending other shows hosted by the stadium.",
  },
  {
    "web-scraper-order": "1666026225-1169",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏞️ National Park",
    "travel-href": "https://emojipedia.org/national-park/",
    emoji: "🏞️",
    emojiName: "🏞️ National Park",
    description:
      "A national park, generally displayed with mountains, a river or stream, and trees.",
  },
  {
    "web-scraper-order": "1666026227-1171",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏝️ Desert Island",
    "travel-href": "https://emojipedia.org/desert-island/",
    emoji: "🏝️",
    emojiName: "🏝️ Desert Island",
    description:
      "Desert Island was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026230-1173",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏜️ Desert",
    "travel-href": "https://emojipedia.org/desert/",
    emoji: "🏜️",
    emojiName: "🏜️ Desert",
    description:
      "Desert was approved as part of Unicode 7.0 in 2014 and added to Emoji 1.0 in 2015.",
  },
  {
    "web-scraper-order": "1666026232-1175",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏖️ Beach with Umbrella",
    "travel-href": "https://emojipedia.org/beach-with-umbrella/",
    emoji: "🏖️",
    emojiName: "🏖️ Beach with Umbrella",
    description:
      "A beach showing sand, and an umbrella for protection from the sun.",
  },
  {
    "web-scraper-order": "1666026235-1177",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏕️ Camping",
    "travel-href": "https://emojipedia.org/camping/",
    emoji: "🏕️",
    emojiName: "🏕️ Camping",
    description:
      "A campsite featuring a tent and a tree, and perhaps a campfire. Similar to the tent emoji.",
  },
  {
    "web-scraper-order": "1666026237-1179",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗻 Mount Fuji",
    "travel-href": "https://emojipedia.org/mount-fuji/",
    emoji: "🗻",
    emojiName: "🗻 Mount Fuji",
    description:
      "Mount Fuji (called Fuji-san in Japan) is the largest mountain in Japan. Often seen with snow on the peak in colder months of the year.",
  },
  {
    "web-scraper-order": "1666026239-1181",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🌋 Volcano",
    "travel-href": "https://emojipedia.org/volcano/",
    emoji: "🌋",
    emojiName: "🌋 Volcano",
    description: "A volcano, erupting with smoke and lava.",
  },
  {
    "web-scraper-order": "1666026242-1183",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "⛰️ Mountain",
    "travel-href": "https://emojipedia.org/mountain/",
    emoji: "⛰️",
    emojiName: "⛰️ Mountain",
    description:
      "A mountain shown with two peaks and blue sky. Similar to the snow capped mountain emoji.",
  },
  {
    "web-scraper-order": "1666026244-1185",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🏔️ Snow-Capped Mountain",
    "travel-href": "https://emojipedia.org/snow-capped-mountain/",
    emoji: "🏔️",
    emojiName: "🏔️ Snow-Capped Mountain",
    description:
      "A mountain with snow resting at higher altitudes. Similar in appearance to the Mount Fuji emoji.",
  },
  {
    "web-scraper-order": "1666026247-1187",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🗾 Map of Japan",
    "travel-href": "https://emojipedia.org/map-of-japan/",
    emoji: "🗾",
    emojiName: "🗾 Map of Japan",
    description:
      "Shows a map of the country of Japan, which is the only country to have its own emoji map. Other countries can be found on the various globe emojis, or the world map emoji.",
  },
  {
    "web-scraper-order": "1666026249-1189",
    "web-scraper-start-url": "https://emojipedia.org/travel-places/",
    travel: "🚣 Person Rowing Boat",
    "travel-href": "https://emojipedia.org/person-rowing-boat/",
    emoji: "🚣",
    emojiName: "🚣 Person Rowing Boat",
    description:
      "A small rowboat suitable for a small number of people. Couples or families sometimes hire these as an activity on calm waters.",
  },
];

export default allEmoji;
